import gql from 'graphql-tag';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  EmailAddress: { input: string; output: string; }
  FilterableValueScalar: { input: string | string[] | number | boolean; output: string | string[] | number | boolean; }
  JSON: { input: object; output: object; }
  JSONObject: { input: object; output: object; }
  Long: { input: number; output: number; }
  Object: { input: any; output: any; }
  ObjectId: { input: any; output: any; }
  PhoneNumber: { input: string; output: string; }
  PostalCode: { input: unknown; output: unknown; }
  TaxCode: { input: any; output: any; }
  Timestamp: { input: number; output: number; }
  Timezone: { input: unknown; output: unknown; }
  URL: { input: string; output: string; }
  UnsignedInt: { input: number; output: number; }
  Upload: { input: any; output: any; }
  Username: { input: string; output: string; }
  Void: { input: any; output: any; }
};

export type ApInteractionsPaginateResult = {
  __typename?: 'APInteractionsPaginateResult';
  nodes: Array<Maybe<FarmadatiActivePrincipleInteraction>>;
  pageInfo: PageInfo;
};

export type AcceptedRelatedObjectTypes = DataExportRequest | DiaryMonitoring | DrugReservation | NullableNodeType | Relationship | Reservation | User | UserbackFeedback;

export enum ActionToClose {
  CreateCoupon = 'CREATE_COUPON',
  Report = 'REPORT',
  ResultTestCovid = 'RESULT_TEST_COVID'
}

export enum ActiveIngredientAifa100 {
  Alogliptin = 'ALOGLIPTIN',
  AlogliptinMetformin = 'ALOGLIPTIN_METFORMIN',
  AlogliptinPioglitazone = 'ALOGLIPTIN_PIOGLITAZONE',
  Canagliflozin = 'CANAGLIFLOZIN',
  CanagliflozinMetformin = 'CANAGLIFLOZIN_METFORMIN',
  Dapagliflozin = 'DAPAGLIFLOZIN',
  DapagliflozinMetformin = 'DAPAGLIFLOZIN_METFORMIN',
  Dulaglutide = 'DULAGLUTIDE',
  Empagliflozin = 'EMPAGLIFLOZIN',
  EmpagliflozinLinagliptin = 'EMPAGLIFLOZIN_LINAGLIPTIN',
  EmpagliflozinMetformin = 'EMPAGLIFLOZIN_METFORMIN',
  Ertugliflozin = 'ERTUGLIFLOZIN',
  ErtugliflozinMetformin = 'ERTUGLIFLOZIN_METFORMIN',
  ErtugliflozinSitagliptin = 'ERTUGLIFLOZIN_SITAGLIPTIN',
  ExenatideExtendedRelease = 'EXENATIDE_EXTENDED_RELEASE',
  ExenatideImmediateRelease = 'EXENATIDE_IMMEDIATE_RELEASE',
  InsulinDegludecLiraglutide = 'INSULIN_DEGLUDEC_LIRAGLUTIDE',
  InsulinGlargineLixisenatide_10_40 = 'INSULIN_GLARGINE_LIXISENATIDE_10_40',
  InsulinGlargineLixisenatide_30_60 = 'INSULIN_GLARGINE_LIXISENATIDE_30_60',
  Linagliptin = 'LINAGLIPTIN',
  LinagliptinMetformin = 'LINAGLIPTIN_METFORMIN',
  Liraglutide = 'LIRAGLUTIDE',
  Lixisenatide = 'LIXISENATIDE',
  Saxagliptin = 'SAXAGLIPTIN',
  SaxagliptinDapagliflozin = 'SAXAGLIPTIN_DAPAGLIFLOZIN',
  SaxagliptinMetformin = 'SAXAGLIPTIN_METFORMIN',
  SemaglutideOral = 'SEMAGLUTIDE_ORAL',
  SemaglutideSubcutaneous = 'SEMAGLUTIDE_SUBCUTANEOUS',
  Sitagliptin = 'SITAGLIPTIN',
  SitagliptinMetformin = 'SITAGLIPTIN_METFORMIN',
  Tirzepatide = 'TIRZEPATIDE',
  Vildagliptin = 'VILDAGLIPTIN',
  VildagliptinMetformin = 'VILDAGLIPTIN_METFORMIN'
}

export type ActivePrincipleInteractionsResult = {
  __typename?: 'ActivePrincipleInteractionsResult';
  interactions?: Maybe<Array<FarmadatiActivePrincipleInteractionPartial>>;
};

export type ActivePrinciplesPaginateResult = {
  __typename?: 'ActivePrinciplesPaginateResult';
  nodes?: Maybe<Array<FarmadatiActivePrinciple>>;
  pageInfo: PageInfo;
};

export type AddCardToPatientResult = {
  __typename?: 'AddCardToPatientResult';
  card?: Maybe<CreditCard>;
  user: User;
};

export type AddClinicGroupInput = {
  address: StructuredAddressInput;
  availablePayments?: InputMaybe<Array<InclinicPayment>>;
  clinicEmail?: InputMaybe<Scalars['Boolean']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  inclinicFee?: InputMaybe<Scalars['Float']['input']>;
  license: License;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  owners?: InputMaybe<Array<Scalars['ID']['input']>>;
  patientEmail?: InputMaybe<Scalars['Boolean']['input']>;
  showOnPrivate: Scalars['Boolean']['input'];
  showOnSearch: Scalars['Boolean']['input'];
  type: ClinicType;
};

export type AddOns = {
  __typename?: 'AddOns';
  videoconsulti?: Maybe<VirtualCarePlanPriceDetail>;
};

export type AddRelativeInput = {
  birthCity?: InputMaybe<Scalars['String']['input']>;
  birthCountry: Scalars['String']['input'];
  birthDate: Scalars['Timestamp']['input'];
  birthDistrict?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sex: Sex;
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
};

export type AddRelativeResult = {
  __typename?: 'AddRelativeResult';
  relative: Relative;
};

export type AddVideocallLogResult = {
  __typename?: 'AddVideocallLogResult';
  log: VideocallLog;
};

export type AdditionalInformation = {
  __typename?: 'AdditionalInformation';
  chronicPatient?: Maybe<Scalars['Boolean']['output']>;
  createRelationshipWithDoctor?: Maybe<User>;
  note?: Maybe<Scalars['String']['output']>;
  patientBirth?: Maybe<Scalars['Timestamp']['output']>;
  patientBirthCity?: Maybe<Scalars['String']['output']>;
  patientBirthDistrict?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  patientSex?: Maybe<Sex>;
  patientSurname?: Maybe<Scalars['String']['output']>;
  patientTaxCode?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']['output']>;
  cap?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cap?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AgendaSettings = {
  __typename?: 'AgendaSettings';
  closingTime?: Maybe<Scalars['String']['output']>;
  hiddenDays: Array<Scalars['Int']['output']>;
  openingTime?: Maybe<Scalars['String']['output']>;
  slotDuration?: Maybe<Scalars['Int']['output']>;
};

export type AgendaSettingsInput = {
  closingTime?: InputMaybe<Scalars['String']['input']>;
  hiddenDays: Array<Scalars['Int']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
  slotDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type Aifa100Drug = {
  __typename?: 'Aifa100Drug';
  activeIngredient: ActiveIngredientAifa100;
  posology?: Maybe<PosologyAifa100>;
  posologyValue?: Maybe<Scalars['Float']['output']>;
};

export type Aifa100DrugInput = {
  activeIngredient: ActiveIngredientAifa100;
  posology?: InputMaybe<PosologyAifa100>;
  posologyValue?: InputMaybe<Scalars['Float']['input']>;
};

export enum AlbuminuriaEnum {
  Absent = 'ABSENT',
  MacroAlbuminuriaOrProteinuria = 'MACRO_ALBUMINURIA_OR_PROTEINURIA',
  MicroAlbuminuria = 'MICRO_ALBUMINURIA',
  NotMeasured = 'NOT_MEASURED'
}

export type Alert = {
  __typename?: 'Alert';
  expression: Scalars['String']['output'];
  userParam: Scalars['String']['output'];
};

export type AlertInput = {
  /** expression is a array of string, that must contain variable 'value' for working fine. Example  35 < value < 38 or value > 38 || value < 35 etc */
  expression: Array<Scalars['String']['input']>;
  userParam: Scalars['String']['input'];
};

export type AllergiesInput = {
  activePrincipleDescription?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  ignoredDrugsInteractions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  importedFromFreenet?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AllergiesType>;
  value: Scalars['String']['input'];
};

export type AllergiesInputArray = {
  values?: InputMaybe<Array<AllergiesInput>>;
};

export type AllergiesParam = Node & UserParamInterface & {
  __typename?: 'AllergiesParam';
  _id: Scalars['ID']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: AllergiesPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type AllergiesPayload = {
  __typename?: 'AllergiesPayload';
  activePrincipleDescription?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  drug?: Maybe<FarmadatiDrug>;
  ignoredDrugsInteractions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated plaese use intolerancesPayload */
  isDairyAllergy?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated plaese use CeliacDiseaseIssuesPayload */
  isGlutenAllergy?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  reaction?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AllergiesType>;
  value: Scalars['String']['output'];
};

export type AllergiesPayloadArray = {
  __typename?: 'AllergiesPayloadArray';
  values?: Maybe<Array<AllergiesPayload>>;
};

export enum AllergiesType {
  ByContact = 'BY_CONTACT',
  Drugs = 'DRUGS',
  Environment = 'ENVIRONMENT',
  Foodallergy = 'FOODALLERGY',
  Other = 'OTHER'
}

export type AmbulatoryTest = Node & {
  __typename?: 'AmbulatoryTest';
  _id: Scalars['ID']['output'];
  doctor: User;
  executionDate: Scalars['Timestamp']['output'];
  patient: User;
  result: Scalars['Boolean']['output'];
  resultDate: Scalars['Timestamp']['output'];
  status: AmbulatoryTestStatus;
  testCategory: AmbulatoryTestCategory;
  testCode: Scalars['String']['output'];
  testType: AmbulatoryTestType;
  transactionCode?: Maybe<Scalars['String']['output']>;
};

export type AmbulatoryTestCategory = CovidTestCategory;

export type AmbulatoryTestCategoryInput = {
  covidTestValue?: InputMaybe<CovidTestCategoryValues>;
};

export type AmbulatoryTestInput = {
  doctorId: Scalars['ID']['input'];
  executionDate: Scalars['Timestamp']['input'];
  patientId: Scalars['ID']['input'];
  result: Scalars['Boolean']['input'];
  resultDate: Scalars['Timestamp']['input'];
  testCategory: AmbulatoryTestCategoryInput;
  testCode: Scalars['String']['input'];
  testType: AmbulatoryTestType;
};

export type AmbulatoryTestStatus = CovidTestStatus;

export enum AmbulatoryTestType {
  CovidTest = 'COVID_TEST'
}

export type AmbulatoryTestsResult = ComplexQueryReturn & {
  __typename?: 'AmbulatoryTestsResult';
  nodes: Array<AmbulatoryTest>;
  pageInfo: PageInfo;
};

export type AmtCsvPatient = {
  __typename?: 'AmtCsvPatient';
  address?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AnamnesesResult = ComplexQueryReturn & {
  __typename?: 'AnamnesesResult';
  nodes?: Maybe<Array<Anamnesis>>;
  pageInfo: PageInfo;
};

export type Anamnesis = Node & {
  __typename?: 'Anamnesis';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  importInfo?: Maybe<ImportInfo>;
  patient: User;
  type: AnamnesisRecordType;
  updatedAt: Scalars['Timestamp']['output'];
  value: Scalars['String']['output'];
};

export enum AnamnesisRecordType {
  Family = 'FAMILY',
  General = 'GENERAL'
}

export type AnnotateTranscriptionInput = {
  jobId: Scalars['ID']['input'];
  patientInfo?: InputMaybe<PatientInfoInput>;
  visitDate?: InputMaybe<Scalars['String']['input']>;
};

export type AnonymizedEvent = {
  __typename?: 'AnonymizedEvent';
  endTime: Scalars['Timestamp']['output'];
  startTime: Scalars['Timestamp']['output'];
  string: AnonymizedEventType;
};

export enum AnonymizedEventType {
  Busy = 'BUSY',
  Vacation = 'VACATION'
}

export enum AppClient {
  Android = 'android',
  Ios = 'ios'
}

export type AppleEcgInput = {
  algorithmVersion?: InputMaybe<Scalars['UnsignedInt']['input']>;
  averageHeartRate?: InputMaybe<Scalars['UnsignedInt']['input']>;
  classification?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  samplingFrequency?: InputMaybe<Scalars['UnsignedInt']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  voltageMeasurements?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>>>;
};

export type AppleEcgParam = Node & UserParamInterface & {
  __typename?: 'AppleEcgParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: AppleEcgPayload;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type AppleEcgPayload = {
  __typename?: 'AppleEcgPayload';
  algorithmVersion?: Maybe<Scalars['UnsignedInt']['output']>;
  averageHeartRate?: Maybe<Scalars['UnsignedInt']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  samplingFrequency?: Maybe<Scalars['UnsignedInt']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  voltageMeasurements?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
};

export type ArchivedPrescriptionsResult = {
  __typename?: 'ArchivedPrescriptionsResult';
  archivedPrescriptions: Array<Prescription>;
};

export type AslData = {
  __typename?: 'AslData';
  aslCode?: Maybe<Scalars['String']['output']>;
  districtCode?: Maybe<Scalars['String']['output']>;
  importedFromFreenet?: Maybe<Scalars['Boolean']['output']>;
  region?: Maybe<Region>;
};

export type AslDataInput = {
  aslCode?: InputMaybe<Scalars['String']['input']>;
  districtCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region>;
};

export type AssistedUser = Node & {
  __typename?: 'AssistedUser';
  _id: Scalars['ID']['output'];
  birthCity?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['Timestamp']['output']>;
  birthDistrict?: Maybe<Scalars['String']['output']>;
  caregiver: User;
  createdAt: Scalars['Timestamp']['output'];
  documents?: Maybe<Array<Document>>;
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Scalars['UnsignedInt']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  relationshipType: RelationshipType;
  sex: Sex;
  surname: Scalars['String']['output'];
  taxCode: Scalars['String']['output'];
  user?: Maybe<User>;
  verified: AssistedUserVerifiedStatus;
};

export type AssistedUserDashboard = Node & {
  __typename?: 'AssistedUserDashboard';
  _id: Scalars['ID']['output'];
  action: AssistedUserVerifiedStatus;
  assistedUser: AssistedUser;
  createdBy: User;
};

export enum AssistedUserVerifiedStatus {
  Denied = 'DENIED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type AssistedUsersReturn = ComplexQueryReturn & {
  __typename?: 'AssistedUsersReturn';
  nodes?: Maybe<Array<AssistedUser>>;
  pageInfo: PageInfo;
};

export enum Ats {
  Bergamo = 'BERGAMO',
  Brescia = 'BRESCIA',
  Brianza = 'BRIANZA',
  Insubria = 'INSUBRIA',
  Milano = 'MILANO',
  Montagna = 'MONTAGNA',
  Valpadana = 'VALPADANA'
}

export type AuthData = {
  __typename?: 'AuthData';
  auth: Authentication;
  refreshToken?: Maybe<Scalars['String']['output']>;
  temporary?: Maybe<Scalars['Boolean']['output']>;
  token: Scalars['String']['output'];
  tokenExpiration: Scalars['Int']['output'];
  user: User;
};

export enum AuthEventTypes {
  VerifyOtpDeleteAccount = 'VERIFY_OTP_DELETE_ACCOUNT',
  VerifyOtpLogin = 'VERIFY_OTP_LOGIN',
  VerifyOtpRegisterAccount = 'VERIFY_OTP_REGISTER_ACCOUNT',
  VerifyOtpResetPassword = 'VERIFY_OTP_RESET_PASSWORD'
}

export type AuthExistsReturn = {
  __typename?: 'AuthExistsReturn';
  user?: Maybe<AuthExistsUser>;
};

export type AuthExistsUser = {
  __typename?: 'AuthExistsUser';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  role: Role;
};

export type AuthInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AuthLog = Node & {
  __typename?: 'AuthLog';
  _id: Scalars['ID']['output'];
  authMode: Scalars['Int']['output'];
  createdAt: Scalars['Timestamp']['output'];
};

export type AuthLogsReturn = ComplexQueryReturn & {
  __typename?: 'AuthLogsReturn';
  nodes?: Maybe<Array<AuthLog>>;
  pageInfo: PageInfo;
};

export enum AuthTab {
  AutomaticVerified = 'AUTOMATIC_VERIFIED',
  Blocked = 'BLOCKED',
  Mmg = 'MMG',
  NotVerified = 'NOT_VERIFIED',
  Standby = 'STANDBY',
  Verified = 'VERIFIED'
}

export enum AuthType {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Spid = 'SPID'
}

export type AuthUsersReturn = ComplexQueryReturn & {
  __typename?: 'AuthUsersReturn';
  nodes: Array<FreenetAuthUser>;
  pageInfo: PageInfo;
};

export type Authentication = Node & {
  __typename?: 'Authentication';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Timestamp']['output']>;
  deletedBy?: Maybe<User>;
  deletionMessage?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Document>>;
  fullName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  type: AuthType;
  updatedAt: Scalars['Timestamp']['output'];
  user?: Maybe<User>;
  username: Scalars['Username']['output'];
  verified: VerifiedAuth;
  verifiedMode?: Maybe<VerifiedMode>;
  verifiedUsername: Scalars['Boolean']['output'];
};

export type AuthenticationDashboard = Node & {
  __typename?: 'AuthenticationDashboard';
  _id: Scalars['ID']['output'];
  action: AuthenticationDashboardAction;
  assistedUser?: Maybe<AssistedUser>;
  createdBy: User;
  type: AuthenticationDashboardType;
  user?: Maybe<User>;
};

export enum AuthenticationDashboardAction {
  Denied = 'DENIED',
  Verified = 'VERIFIED'
}

export enum AuthenticationDashboardType {
  Caregiver = 'CAREGIVER',
  Standard = 'STANDARD'
}

export enum AuthenticationDocumentsType {
  DrivingLicense = 'DRIVING_LICENSE',
  Id = 'ID',
  Passport = 'PASSPORT'
}

export type AuthenticationsReturn = ComplexQueryReturn & {
  __typename?: 'AuthenticationsReturn';
  nodes?: Maybe<Array<Authentication>>;
  pageInfo: PageInfo;
};

export type AuthorizedDoctor = {
  __typename?: 'AuthorizedDoctor';
  fullName: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  taxCode: Scalars['String']['output'];
};

export type AutoAcceptSettings = {
  __typename?: 'AutoAcceptSettings';
  aiReservations?: Maybe<Scalars['Boolean']['output']>;
  onlineReservations?: Maybe<Scalars['Boolean']['output']>;
  reservations?: Maybe<Scalars['Boolean']['output']>;
};

export type AutoAcceptSettingsInput = {
  aiReservations?: InputMaybe<Scalars['Boolean']['input']>;
  onlineReservations?: InputMaybe<Scalars['Boolean']['input']>;
  reservations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomaticAuthentication = {
  __typename?: 'AutomaticAuthentication';
  verified: VerifiedAuth;
};

export type AutoreDocumento = {
  __typename?: 'AutoreDocumento';
  codiceFiscale?: Maybe<Scalars['String']['output']>;
  cognome?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  ruolo?: Maybe<Scalars['String']['output']>;
};

export type AvailabilitySlotsForDay = {
  __typename?: 'AvailabilitySlotsForDay';
  workgroups: Array<Maybe<WorkgroupSlot>>;
};

export enum AvailabilityStatus {
  Available = 'AVAILABLE',
  Full = 'FULL',
  Holiday = 'HOLIDAY',
  None = 'NONE'
}

export type BasicPrescription = {
  _id: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy?: Maybe<User>;
  creationMode: CreationMode;
  darkeningReason?: Maybe<DarkeningReason>;
  date: Scalars['Timestamp']['output'];
  doctorData?: Maybe<DoctorData>;
  downgradeReasons?: Maybe<Array<DowngradeReasons>>;
  enlistingIdPai?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  exceptions?: Maybe<Array<Exceptions>>;
  exemption?: Maybe<Exemption>;
  exemptionForPrint?: Maybe<Scalars['String']['output']>;
  flagOther?: Maybe<Scalars['Boolean']['output']>;
  incomeSelfCertificationNumber?: Maybe<Scalars['String']['output']>;
  iupCode?: Maybe<Scalars['String']['output']>;
  mefCode?: Maybe<Scalars['String']['output']>;
  owner: User;
  paiLotNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  patient: User;
  personalDataSiss?: Maybe<PersonalDataSiss>;
  pinNrbe?: Maybe<Scalars['String']['output']>;
  prescriptionCode?: Maybe<Scalars['String']['output']>;
  printPdf?: Maybe<Document>;
  processingDate?: Maybe<Scalars['Timestamp']['output']>;
  progressiveNumber: Scalars['UnsignedInt']['output'];
  regionalCodedMotivation?: Maybe<OptionType>;
  regionalCommunication?: Maybe<Array<Maybe<PrescriptionRegionalCommunication>>>;
  regionalOptions?: Maybe<PrescriptionRegionalOptions>;
  regionalStatus?: Maybe<RegionalPrescriptionStatus>;
  relatedRequests?: Maybe<Array<PatientRequestInstance>>;
  showPatientInformation?: Maybe<ShowPatientInformation>;
  sissCounterPai?: Maybe<Scalars['String']['output']>;
  /** @deprecated use regionalStatus */
  sissPrescriptionStatus?: Maybe<SissPrescriptionStatus>;
  status: PrescriptionStatus;
  suggested?: Maybe<Scalars['Boolean']['output']>;
  suggestedCode?: Maybe<Scalars['String']['output']>;
  therapeuticPlanCode?: Maybe<Scalars['String']['output']>;
  type: PrescriptionType;
  urgency?: Maybe<Scalars['Boolean']['output']>;
  withdrawalData?: Maybe<Array<WithdrawalData>>;
};

export type Billing = {
  __typename?: 'Billing';
  _id: Scalars['ID']['output'];
  additionalNotes?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  device: Scalars['Int']['output'];
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  externalSentDate?: Maybe<Scalars['Timestamp']['output']>;
  hideAdditionalNotesInInvoice: Scalars['Boolean']['output'];
  isOpposed?: Maybe<Scalars['Boolean']['output']>;
  isRefund?: Maybe<Scalars['Boolean']['output']>;
  isTraced?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<BillingItem>>;
  number: Scalars['String']['output'];
  owner: User;
  patient: User;
  paymentDate: Scalars['Timestamp']['output'];
  paymentMethod: PaymentMethod;
  previousBilling?: Maybe<Billing>;
  processingDate?: Maybe<Scalars['Timestamp']['output']>;
  protocolId?: Maybe<Scalars['String']['output']>;
  sentToExternal?: Maybe<Scalars['Boolean']['output']>;
  status: BillingStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

export type BillingAuthor = {
  vatCode: Scalars['String']['input'];
};

export type BillingCode = {
  device: Scalars['Int']['input'];
  number: Scalars['String']['input'];
};

export type BillingData = {
  author: BillingAuthor;
  code: BillingCode;
  date: Scalars['Timestamp']['input'];
  items: Array<BillingItemInput>;
  patient: BillingPatient;
  payment: BillingPayment;
};

export type BillingDetailsInput = {
  companyName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pec?: InputMaybe<Scalars['String']['input']>;
  sdiCode?: InputMaybe<Scalars['String']['input']>;
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

export type BillingError = {
  __typename?: 'BillingError';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type BillingInformation = {
  __typename?: 'BillingInformation';
  address?: Maybe<Scalars['String']['output']>;
  cap?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type BillingInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  code: BillingCode;
  hideAdditionalNotesInInvoice: Scalars['Boolean']['input'];
  isOpposed: Scalars['Boolean']['input'];
  isTraced: Scalars['Boolean']['input'];
  items: Array<BillingItemInput>;
  paymentDate: Scalars['Timestamp']['input'];
  paymentMethod: PaymentMethod;
};

export type BillingItem = {
  __typename?: 'BillingItem';
  amount: Scalars['Float']['output'];
  billingTemplate?: Maybe<BillingItemTemplate>;
  description: Scalars['String']['output'];
  nature?: Maybe<Scalars['String']['output']>;
  type: ExpenseType;
  vatRate?: Maybe<Scalars['String']['output']>;
};

export type BillingItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  nature?: InputMaybe<Scalars['String']['input']>;
  type: ExpenseType;
  vatRate?: InputMaybe<Scalars['String']['input']>;
};

export type BillingItemTemplate = {
  __typename?: 'BillingItemTemplate';
  _id: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  nature?: Maybe<Scalars['String']['output']>;
  owner: User;
  type: ExpenseType;
  updatedAt: Scalars['Timestamp']['output'];
  vatRate?: Maybe<Scalars['String']['output']>;
};

export type BillingItemTemplateInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  type: ExpenseType;
  vatRate?: InputMaybe<Scalars['String']['input']>;
};

export type BillingItemTemplatesResponse = {
  __typename?: 'BillingItemTemplatesResponse';
  nodes: Array<BillingItemTemplate>;
  pageInfo: PageInfo;
};

export type BillingMessage = {
  __typename?: 'BillingMessage';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BillingPatient = {
  fiscalCode: Scalars['String']['input'];
  isOpposed: Scalars['Boolean']['input'];
};

export type BillingPayment = {
  date: Scalars['Timestamp']['input'];
  isTraced: Scalars['Boolean']['input'];
};

export enum BillingStatus {
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  Error = 'ERROR',
  Refunded = 'REFUNDED',
  Sent = 'SENT'
}

export type BillingsByOwnerResponse = {
  __typename?: 'BillingsByOwnerResponse';
  nodes: Array<Billing>;
  pageInfo: PageInfo;
};

export type BillingsByPatientResponse = {
  __typename?: 'BillingsByPatientResponse';
  nodes: Array<Billing>;
  pageInfo: PageInfo;
};

export type Birth = {
  __typename?: 'Birth';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Long']['output']>;
};

export type BirthInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum BirthType {
  Caesarean = 'CAESAREAN',
  Dystocial = 'DYSTOCIAL',
  Normal = 'NORMAL'
}

export enum BlacklistArea {
  Agenda = 'AGENDA',
  Chat = 'CHAT',
  MedicalDocument = 'MEDICAL_DOCUMENT',
  PatientRequests = 'PATIENT_REQUESTS'
}

export type BlacklistEntriesResult = ComplexQueryReturn & {
  __typename?: 'BlacklistEntriesResult';
  nodes: Array<BlacklistEntry>;
  pageInfo: PageInfo;
};

export type BlacklistEntry = Node & {
  __typename?: 'BlacklistEntry';
  _id: Scalars['ID']['output'];
  areas: Array<BlacklistArea>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  doctor: User;
  patient: User;
  reason?: Maybe<Scalars['String']['output']>;
};

export type BlacklistMutationResponse = {
  __typename?: 'BlacklistMutationResponse';
  entry?: Maybe<BlacklistEntry>;
  success: Scalars['Boolean']['output'];
};

export type BookNreOutput = {
  __typename?: 'BookNreOutput';
  id?: Maybe<Scalars['String']['output']>;
  nre: Scalars['String']['output'];
};

export type BookReservationResult = {
  __typename?: 'BookReservationResult';
  paymentTransaction?: Maybe<Array<Maybe<PaymentTransaction>>>;
  relationships?: Maybe<Array<Maybe<Relationship>>>;
  reservation: Reservation;
};

export type BookingInformations = {
  address?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
};

export type BookingWorkgroupGeolocationResult = {
  __typename?: 'BookingWorkgroupGeolocationResult';
  _id?: Maybe<Scalars['String']['output']>;
  geocodedCity?: Maybe<Scalars['String']['output']>;
  match?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  worgkroupCity?: Maybe<Scalars['String']['output']>;
};

export type BooleanInput = {
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BooleanParam = Node & UserParamInterface & {
  __typename?: 'BooleanParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: BooleanPayload;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type BooleanPayload = {
  __typename?: 'BooleanPayload';
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type BrandingConfig = {
  __typename?: 'BrandingConfig';
  appName: Scalars['String']['output'];
  companyAddress: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  fiscalCode?: Maybe<Scalars['String']['output']>;
  fromEmail: Scalars['String']['output'];
  inclinicFooterLogoUrl: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  mobileAppName: Scalars['String']['output'];
  piva: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  showRegisteredTrademarkSection: Scalars['Boolean']['output'];
  showSponsorSection: Scalars['Boolean']['output'];
  showUnipolSection: Scalars['Boolean']['output'];
  unipolHRFooterLogoUrl: Scalars['String']['output'];
};

export type BulkAddUsersToWorkgroupsResult = {
  __typename?: 'BulkAddUsersToWorkgroupsResult';
  addedCount: Scalars['Int']['output'];
  notFoundTaxCodes: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  workgroupsUpdated: Scalars['Int']['output'];
};

export type BulkSendBillingResult = {
  __typename?: 'BulkSendBillingResult';
  billingId: Scalars['ID']['output'];
  error?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BulkSendBillingsInput = {
  auth?: InputMaybe<RegionalSystemLogin>;
  ids: Array<Scalars['ID']['input']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CalendarEvent = Node & {
  __typename?: 'CalendarEvent';
  _id: Scalars['ID']['output'];
  category?: Maybe<EventCategory>;
  clinicClosureId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['Timestamp']['output'];
  owner?: Maybe<User>;
  recurrence?: Maybe<EventRecurrence>;
  recurringId?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['Timestamp']['output'];
  title?: Maybe<Scalars['String']['output']>;
  workgroup?: Maybe<Workgroup>;
};

export type CalendarEventUpdated = {
  __typename?: 'CalendarEventUpdated';
  calendarEvent: CalendarEvent;
  removed: Scalars['Boolean']['output'];
};

export type CanSeePatientResult = {
  __typename?: 'CanSeePatientResult';
  blockReason?: Maybe<CannotSeePatientReason>;
  canSee: Scalars['Boolean']['output'];
};

export type CancelBillingInput = {
  auth?: InputMaybe<RegionalSystemLogin>;
  id: Scalars['ID']['input'];
};

export type CancelCalendarEventResult = {
  __typename?: 'CancelCalendarEventResult';
  calendarEvent: CalendarEvent;
};

export type CancelPatientSummaryInput = {
  otp: Scalars['String']['input'];
  patientSummaryId: Scalars['ID']['input'];
};

export enum CannotSeePatientReason {
  PatientIsHidden = 'PATIENT_IS_HIDDEN',
  PatientIsPrivate = 'PATIENT_IS_PRIVATE'
}

export type CeliacDiseaseIssuesArrayInput = {
  values?: InputMaybe<Array<CeliacDiseaseIssuesInput>>;
};

export type CeliacDiseaseIssuesArrayParam = Node & UserParamInterface & {
  __typename?: 'CeliacDiseaseIssuesArrayParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: CeliacDiseaseIssuesPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type CeliacDiseaseIssuesInput = {
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  isCeliacDisease?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CeliacDiseaseIssuesPayload = {
  __typename?: 'CeliacDiseaseIssuesPayload';
  date?: Maybe<Scalars['Timestamp']['output']>;
  isCeliacDisease?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CeliacDiseaseIssuesPayloadArray = {
  __typename?: 'CeliacDiseaseIssuesPayloadArray';
  values?: Maybe<Array<CeliacDiseaseIssuesPayload>>;
};

export type Certificate = Node & {
  __typename?: 'Certificate';
  _id: Scalars['ID']['output'];
  certificateStatus: CertificateStatus;
  certificateType: CertificateType;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy?: Maybe<User>;
  diseaseCertificateAddress?: Maybe<StructuredAddress>;
  diseaseCertificateAvailabilityAddress?: Maybe<StructuredAddressWithSurname>;
  diseaseCertificateOptions?: Maybe<DiseaseCertificateOptions>;
  document?: Maybe<Document>;
  nextVersion?: Maybe<Certificate>;
  owner: User;
  patient: User;
  templateCertificateOptions?: Maybe<TemplateCertificateOptions>;
};

export type CertificateDeleteInput = {
  certificateId: Scalars['ID']['input'];
};

export type CertificateEditInput = {
  certificateId: Scalars['ID']['input'];
  validityEndDate: Scalars['Timestamp']['input'];
};

export enum CertificateNotificationType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export enum CertificateStatus {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Rectified = 'RECTIFIED'
}

export type CertificateTemplate = Node & {
  __typename?: 'CertificateTemplate';
  _id: Scalars['ID']['output'];
  certificateType: CertificateType;
  content: Scalars['String']['output'];
  fields: Array<CertificateTemplateField>;
  owner?: Maybe<User>;
  section: CertificateTemplateSection;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type CertificateTemplateField = {
  __typename?: 'CertificateTemplateField';
  followingText?: Maybe<Scalars['String']['output']>;
  isGroupedByReferKey?: Maybe<Scalars['Boolean']['output']>;
  isHelperNoteField?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  previousText?: Maybe<Scalars['String']['output']>;
  referKey?: Maybe<Array<Scalars['String']['output']>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: CertificateTemplateFieldType;
};

export enum CertificateTemplateFieldType {
  BinaryChoice = 'BINARY_CHOICE',
  Boolean = 'BOOLEAN',
  ConditionStatus = 'CONDITION_STATUS',
  Date = 'DATE',
  DeathBodyDisposition = 'DEATH_BODY_DISPOSITION',
  DeathRecognitionMethod = 'DEATH_RECOGNITION_METHOD',
  DeathType = 'DEATH_TYPE',
  Diagnosis = 'DIAGNOSIS',
  Drugs = 'DRUGS',
  DurationChoice = 'DURATION_CHOICE',
  Email = 'EMAIL',
  InputMeasureUnit = 'INPUT_MEASURE_UNIT',
  MedicalRiskFactors = 'MEDICAL_RISK_FACTORS',
  Notes = 'NOTES',
  Number = 'NUMBER',
  PacemakerCarrierChoice = 'PACEMAKER_CARRIER_CHOICE',
  Pathology = 'PATHOLOGY',
  PatientCertificateAddress = 'PATIENT_CERTIFICATE_ADDRESS',
  PeriodDurationOptions = 'PERIOD_DURATION_OPTIONS',
  Phone = 'PHONE',
  PregnancyOptions = 'PREGNANCY_OPTIONS',
  PregnancyStopChoice = 'PREGNANCY_STOP_CHOICE',
  PresentOptional = 'PRESENT_OPTIONAL',
  RecoveryChoice = 'RECOVERY_CHOICE',
  SchoolNoFoodChoice = 'SCHOOL_NO_FOOD_CHOICE',
  Text = 'TEXT',
  Therapy = 'THERAPY',
  Time = 'TIME'
}

export type CertificateTemplateFieldsValues = {
  __typename?: 'CertificateTemplateFieldsValues';
  absenceEndDate?: Maybe<Scalars['Timestamp']['output']>;
  absenceStartDate?: Maybe<Scalars['Timestamp']['output']>;
  additionalInformation?: Maybe<Scalars['String']['output']>;
  additionalNotes?: Maybe<Scalars['String']['output']>;
  additionalPrognosisDays?: Maybe<Scalars['Int']['output']>;
  alcoholAbuse?: Maybe<Scalars['String']['output']>;
  alcoholDependence?: Maybe<Scalars['String']['output']>;
  ambulatoryAddress?: Maybe<Scalars['String']['output']>;
  ambulatoryAverageWaitingTime?: Maybe<Scalars['String']['output']>;
  ambulatoryCity?: Maybe<Scalars['String']['output']>;
  assistedPatientPhone?: Maybe<Scalars['String']['output']>;
  attendanceDate?: Maybe<Scalars['Timestamp']['output']>;
  attendanceTime?: Maybe<Scalars['Timestamp']['output']>;
  bloodPressure?: Maybe<Scalars['String']['output']>;
  bodyDisposition?: Maybe<Scalars['String']['output']>;
  bodyFoundLocation?: Maybe<Scalars['String']['output']>;
  bodyTransportStructure?: Maybe<Scalars['String']['output']>;
  cardiovascularSystem?: Maybe<Scalars['Boolean']['output']>;
  cardiovascularSystemNote?: Maybe<Scalars['String']['output']>;
  centralCondition?: Maybe<Scalars['String']['output']>;
  certificateDate?: Maybe<Scalars['Timestamp']['output']>;
  certificateTime?: Maybe<Scalars['Timestamp']['output']>;
  certificateValidityPeriod?: Maybe<Scalars['String']['output']>;
  childBirthDate?: Maybe<Scalars['Timestamp']['output']>;
  childFullName?: Maybe<Scalars['String']['output']>;
  covidClinicalCondition?: Maybe<Scalars['String']['output']>;
  currentMedication?: Maybe<Scalars['String']['output']>;
  currentTherapy?: Maybe<Scalars['String']['output']>;
  deathDate?: Maybe<Scalars['Timestamp']['output']>;
  deathType?: Maybe<Scalars['String']['output']>;
  diabetesMellitus?: Maybe<Scalars['Boolean']['output']>;
  diabetesMellitusNote?: Maybe<Scalars['String']['output']>;
  diagnosis?: Maybe<Scalars['String']['output']>;
  disablingSequelae?: Maybe<Scalars['String']['output']>;
  drugDependence?: Maybe<Scalars['String']['output']>;
  drugUse?: Maybe<Scalars['String']['output']>;
  drugsToPreserve?: Maybe<Scalars['String']['output']>;
  ecgDate?: Maybe<Scalars['Timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Timestamp']['output']>;
  endocrineSystem?: Maybe<Scalars['Boolean']['output']>;
  endocrineSystemNote?: Maybe<Scalars['String']['output']>;
  epilepsy?: Maybe<Scalars['Boolean']['output']>;
  epilepsyCondition?: Maybe<Scalars['String']['output']>;
  epilepsyNote?: Maybe<Scalars['String']['output']>;
  examDate?: Maybe<Scalars['Timestamp']['output']>;
  examName?: Maybe<Scalars['String']['output']>;
  exemptionEndDate?: Maybe<Scalars['Timestamp']['output']>;
  exemptionReason?: Maybe<Scalars['String']['output']>;
  hcgValue?: Maybe<Scalars['Int']['output']>;
  hematologicSystem?: Maybe<Scalars['Boolean']['output']>;
  hematologicSystemNote?: Maybe<Scalars['String']['output']>;
  homeSetting?: Maybe<Scalars['String']['output']>;
  hospitalizationReason?: Maybe<Scalars['String']['output']>;
  injuryDate?: Maybe<Scalars['Timestamp']['output']>;
  lastMenstruationDate?: Maybe<Scalars['Timestamp']['output']>;
  lastOxygenSaturationDate?: Maybe<Scalars['Timestamp']['output']>;
  mainPathology?: Maybe<Scalars['String']['output']>;
  membershipCardNumber?: Maybe<Scalars['String']['output']>;
  musculoskeletalSystem?: Maybe<Scalars['Boolean']['output']>;
  musculoskeletalSystemNote?: Maybe<Scalars['String']['output']>;
  nervousSystemConditions?: Maybe<Scalars['String']['output']>;
  neurologicalSystem?: Maybe<Scalars['Boolean']['output']>;
  neurologicalSystemNote?: Maybe<Scalars['String']['output']>;
  noSchoolGymReason?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  numberOfDays?: Maybe<Scalars['Int']['output']>;
  numberOfExemptionDays?: Maybe<Scalars['Int']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  otherAssessments?: Maybe<Scalars['String']['output']>;
  otherNervousConditions?: Maybe<Scalars['String']['output']>;
  oxygenSaturation?: Maybe<Scalars['String']['output']>;
  pacemakerCarrier?: Maybe<Scalars['String']['output']>;
  parentBirthDate?: Maybe<Scalars['Timestamp']['output']>;
  parentCity?: Maybe<Scalars['String']['output']>;
  parentName?: Maybe<Scalars['String']['output']>;
  pathology?: Maybe<Scalars['String']['output']>;
  patientBirthCity?: Maybe<Scalars['String']['output']>;
  patientBirthDate?: Maybe<Scalars['Timestamp']['output']>;
  patientDomicileAddress?: Maybe<Scalars['String']['output']>;
  patientMobile?: Maybe<Scalars['String']['output']>;
  patientResidenceAddress?: Maybe<StructuredAddress>;
  performedInvestigations?: Maybe<Scalars['String']['output']>;
  periodDurationOptions?: Maybe<Scalars['String']['output']>;
  peripheralCondition?: Maybe<Scalars['String']['output']>;
  pregnancyAge?: Maybe<Scalars['String']['output']>;
  pregnancyOptions?: Maybe<Scalars['String']['output']>;
  pregnancyStopReason?: Maybe<Scalars['String']['output']>;
  previousMorbidConditions?: Maybe<Scalars['String']['output']>;
  prognosisDays?: Maybe<Scalars['Int']['output']>;
  prognosisNotes?: Maybe<Scalars['String']['output']>;
  psychiatricConditions?: Maybe<Scalars['Boolean']['output']>;
  psychiatricConditionsNote?: Maybe<Scalars['String']['output']>;
  psychiatricDisorders?: Maybe<Scalars['String']['output']>;
  psychoFromDiseases?: Maybe<Scalars['String']['output']>;
  psychoFromTrauma?: Maybe<Scalars['String']['output']>;
  psychoPersonalityDisorders?: Maybe<Scalars['String']['output']>;
  psychoPostOperative?: Maybe<Scalars['String']['output']>;
  psychoPsychosis?: Maybe<Scalars['String']['output']>;
  psychoSevereMentalRetardation?: Maybe<Scalars['String']['output']>;
  psychoactiveSubstances?: Maybe<Scalars['String']['output']>;
  psychotropicDependence?: Maybe<Scalars['String']['output']>;
  psychotropicUse?: Maybe<Scalars['String']['output']>;
  recentClinicalProgress?: Maybe<Scalars['String']['output']>;
  recognitionDocumentNumber?: Maybe<Scalars['String']['output']>;
  recognitionDocumentType?: Maybe<Scalars['String']['output']>;
  recognitionMethod?: Maybe<Scalars['String']['output']>;
  recoveryChoice?: Maybe<Scalars['String']['output']>;
  recoveryDate?: Maybe<Scalars['Timestamp']['output']>;
  resumptionDate?: Maybe<Scalars['Timestamp']['output']>;
  returnDate?: Maybe<Scalars['Timestamp']['output']>;
  riskFactors?: Maybe<Array<Scalars['String']['output']>>;
  schoolClass?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  schoolNoFoodChoice?: Maybe<Scalars['String']['output']>;
  schoolNoFoodNotes?: Maybe<Scalars['String']['output']>;
  sensoryOrgans?: Maybe<Scalars['Boolean']['output']>;
  sensoryOrgansNote?: Maybe<Scalars['String']['output']>;
  specifyTherapy?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Timestamp']['output']>;
  stepTest?: Maybe<Scalars['Timestamp']['output']>;
  substanceDependence?: Maybe<Scalars['Boolean']['output']>;
  substanceDependenceNote?: Maybe<Scalars['String']['output']>;
  swab?: Maybe<Scalars['String']['output']>;
  symptomOnsetDate?: Maybe<Scalars['Timestamp']['output']>;
  therapiesAdministered?: Maybe<Scalars['String']['output']>;
  therapy?: Maybe<Scalars['String']['output']>;
  treatmentDuration?: Maybe<Scalars['String']['output']>;
  urogenitalSystem?: Maybe<Scalars['Boolean']['output']>;
  urogenitalSystemNote?: Maybe<Scalars['String']['output']>;
};

export type CertificateTemplateFieldsValuesInput = {
  absenceEndDate?: InputMaybe<Scalars['Timestamp']['input']>;
  absenceStartDate?: InputMaybe<Scalars['Timestamp']['input']>;
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  additionalPrognosisDays?: InputMaybe<Scalars['Int']['input']>;
  alcoholAbuse?: InputMaybe<Scalars['String']['input']>;
  alcoholDependence?: InputMaybe<Scalars['String']['input']>;
  ambulatoryAddress?: InputMaybe<Scalars['String']['input']>;
  ambulatoryAverageWaitingTime?: InputMaybe<Scalars['String']['input']>;
  ambulatoryCity?: InputMaybe<Scalars['String']['input']>;
  assistedPatientPhone?: InputMaybe<Scalars['String']['input']>;
  attendanceDate?: InputMaybe<Scalars['Timestamp']['input']>;
  attendanceTime?: InputMaybe<Scalars['Timestamp']['input']>;
  bloodPressure?: InputMaybe<Scalars['String']['input']>;
  bodyDisposition?: InputMaybe<Scalars['String']['input']>;
  bodyFoundLocation?: InputMaybe<Scalars['String']['input']>;
  bodyTransportStructure?: InputMaybe<Scalars['String']['input']>;
  cardiovascularSystem?: InputMaybe<Scalars['Boolean']['input']>;
  cardiovascularSystemNote?: InputMaybe<Scalars['String']['input']>;
  centralCondition?: InputMaybe<Scalars['String']['input']>;
  certificateDate?: InputMaybe<Scalars['Timestamp']['input']>;
  certificateTime?: InputMaybe<Scalars['Timestamp']['input']>;
  certificateValidityPeriod?: InputMaybe<Scalars['String']['input']>;
  childBirthDate?: InputMaybe<Scalars['Timestamp']['input']>;
  childFullName?: InputMaybe<Scalars['String']['input']>;
  covidClinicalCondition?: InputMaybe<Scalars['String']['input']>;
  currentMedication?: InputMaybe<Scalars['String']['input']>;
  currentTherapy?: InputMaybe<Scalars['String']['input']>;
  deathDate?: InputMaybe<Scalars['Timestamp']['input']>;
  deathType?: InputMaybe<Scalars['String']['input']>;
  diabetesMellitus?: InputMaybe<Scalars['Boolean']['input']>;
  diabetesMellitusNote?: InputMaybe<Scalars['String']['input']>;
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  disablingSequelae?: InputMaybe<Scalars['String']['input']>;
  drugDependence?: InputMaybe<Scalars['String']['input']>;
  drugUse?: InputMaybe<Scalars['String']['input']>;
  drugsToPreserve?: InputMaybe<Scalars['String']['input']>;
  ecgDate?: InputMaybe<Scalars['Timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  endocrineSystem?: InputMaybe<Scalars['Boolean']['input']>;
  endocrineSystemNote?: InputMaybe<Scalars['String']['input']>;
  epilepsy?: InputMaybe<Scalars['Boolean']['input']>;
  epilepsyCondition?: InputMaybe<Scalars['String']['input']>;
  epilepsyNote?: InputMaybe<Scalars['String']['input']>;
  examDate?: InputMaybe<Scalars['Timestamp']['input']>;
  examName?: InputMaybe<Scalars['String']['input']>;
  exemptionEndDate?: InputMaybe<Scalars['Timestamp']['input']>;
  exemptionReason?: InputMaybe<Scalars['String']['input']>;
  hcgValue?: InputMaybe<Scalars['Int']['input']>;
  hematologicSystem?: InputMaybe<Scalars['Boolean']['input']>;
  hematologicSystemNote?: InputMaybe<Scalars['String']['input']>;
  homeSetting?: InputMaybe<Scalars['String']['input']>;
  hospitalizationReason?: InputMaybe<Scalars['String']['input']>;
  injuryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  lastMenstruationDate?: InputMaybe<Scalars['Timestamp']['input']>;
  lastOxygenSaturationDate?: InputMaybe<Scalars['Timestamp']['input']>;
  mainPathology?: InputMaybe<Scalars['String']['input']>;
  membershipCardNumber?: InputMaybe<Scalars['String']['input']>;
  musculoskeletalSystem?: InputMaybe<Scalars['Boolean']['input']>;
  musculoskeletalSystemNote?: InputMaybe<Scalars['String']['input']>;
  nervousSystemConditions?: InputMaybe<Scalars['String']['input']>;
  neurologicalSystem?: InputMaybe<Scalars['Boolean']['input']>;
  neurologicalSystemNote?: InputMaybe<Scalars['String']['input']>;
  noSchoolGymReason?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfDays?: InputMaybe<Scalars['Int']['input']>;
  numberOfExemptionDays?: InputMaybe<Scalars['Int']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  otherAssessments?: InputMaybe<Scalars['String']['input']>;
  otherNervousConditions?: InputMaybe<Scalars['String']['input']>;
  oxygenSaturation?: InputMaybe<Scalars['String']['input']>;
  pacemakerCarrier?: InputMaybe<Scalars['String']['input']>;
  parentBirthDate?: InputMaybe<Scalars['Timestamp']['input']>;
  parentCity?: InputMaybe<Scalars['String']['input']>;
  parentName?: InputMaybe<Scalars['String']['input']>;
  pathology?: InputMaybe<Scalars['String']['input']>;
  patientBirthCity?: InputMaybe<Scalars['String']['input']>;
  patientBirthDate?: InputMaybe<Scalars['Timestamp']['input']>;
  patientDomicileAddress?: InputMaybe<Scalars['String']['input']>;
  patientMobile?: InputMaybe<Scalars['String']['input']>;
  patientResidenceAddress?: InputMaybe<StructuredAddressInput>;
  performedInvestigations?: InputMaybe<Scalars['String']['input']>;
  periodDurationOptions?: InputMaybe<Scalars['String']['input']>;
  peripheralCondition?: InputMaybe<Scalars['String']['input']>;
  pregnancyAge?: InputMaybe<Scalars['String']['input']>;
  pregnancyOptions?: InputMaybe<Scalars['String']['input']>;
  pregnancyStopReason?: InputMaybe<Scalars['String']['input']>;
  previousMorbidConditions?: InputMaybe<Scalars['String']['input']>;
  prognosisDays?: InputMaybe<Scalars['Int']['input']>;
  prognosisNotes?: InputMaybe<Scalars['String']['input']>;
  psychiatricConditions?: InputMaybe<Scalars['Boolean']['input']>;
  psychiatricConditionsNote?: InputMaybe<Scalars['String']['input']>;
  psychiatricDisorders?: InputMaybe<Scalars['String']['input']>;
  psychoFromDiseases?: InputMaybe<Scalars['String']['input']>;
  psychoFromTrauma?: InputMaybe<Scalars['String']['input']>;
  psychoPersonalityDisorders?: InputMaybe<Scalars['String']['input']>;
  psychoPostOperative?: InputMaybe<Scalars['String']['input']>;
  psychoPsychosis?: InputMaybe<Scalars['String']['input']>;
  psychoSevereMentalRetardation?: InputMaybe<Scalars['String']['input']>;
  psychoactiveSubstances?: InputMaybe<Scalars['String']['input']>;
  psychotropicDependence?: InputMaybe<Scalars['String']['input']>;
  psychotropicUse?: InputMaybe<Scalars['String']['input']>;
  recentClinicalProgress?: InputMaybe<Scalars['String']['input']>;
  recognitionDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  recognitionDocumentType?: InputMaybe<Scalars['String']['input']>;
  recognitionMethod?: InputMaybe<Scalars['String']['input']>;
  recoveryChoice?: InputMaybe<Scalars['String']['input']>;
  recoveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  resumptionDate?: InputMaybe<Scalars['Timestamp']['input']>;
  returnDate?: InputMaybe<Scalars['Timestamp']['input']>;
  riskFactors?: InputMaybe<Array<Scalars['String']['input']>>;
  schoolClass?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  schoolNoFoodChoice?: InputMaybe<Scalars['String']['input']>;
  schoolNoFoodNotes?: InputMaybe<Scalars['String']['input']>;
  sensoryOrgans?: InputMaybe<Scalars['Boolean']['input']>;
  sensoryOrgansNote?: InputMaybe<Scalars['String']['input']>;
  specifyTherapy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  stepTest?: InputMaybe<Scalars['Timestamp']['input']>;
  substanceDependence?: InputMaybe<Scalars['Boolean']['input']>;
  substanceDependenceNote?: InputMaybe<Scalars['String']['input']>;
  swab?: InputMaybe<Scalars['String']['input']>;
  symptomOnsetDate?: InputMaybe<Scalars['Timestamp']['input']>;
  therapiesAdministered?: InputMaybe<Scalars['String']['input']>;
  therapy?: InputMaybe<Scalars['String']['input']>;
  treatmentDuration?: InputMaybe<Scalars['String']['input']>;
  urogenitalSystem?: InputMaybe<Scalars['Boolean']['input']>;
  urogenitalSystemNote?: InputMaybe<Scalars['String']['input']>;
};

export enum CertificateTemplateSection {
  Anamnesis = 'ANAMNESIS',
  Assurance = 'ASSURANCE',
  Custom = 'CUSTOM',
  Death = 'DEATH',
  Other = 'OTHER',
  Pregnancy = 'PREGNANCY',
  School = 'SCHOOL',
  Sport = 'SPORT',
  Work = 'WORK'
}

export enum CertificateType {
  AnamnesisDrivingLicense = 'ANAMNESIS_DRIVING_LICENSE',
  AnamnesisDrugs = 'ANAMNESIS_DRUGS',
  AnamnesisFirearmsLicense = 'ANAMNESIS_FIREARMS_LICENSE',
  AnamnesisInsulin = 'ANAMNESIS_INSULIN',
  AnamnesisOncologicalOblivion = 'ANAMNESIS_ONCOLOGICAL_OBLIVION',
  AssuranceContinue = 'ASSURANCE_CONTINUE',
  AssuranceEndAfter = 'ASSURANCE_END_AFTER',
  AssuranceEndNoAfter = 'ASSURANCE_END_NO_AFTER',
  /** @deprecated not used anymore */
  AssurancePresence = 'ASSURANCE_PRESENCE',
  AssuranceStart = 'ASSURANCE_START',
  Covid19 = 'COVID19',
  Custom = 'CUSTOM',
  DeathCertificate = 'DEATH_CERTIFICATE',
  Disease = 'DISEASE',
  Hospitalization = 'HOSPITALIZATION',
  PregnancyStop = 'PREGNANCY_STOP',
  RsaAdmission = 'RSA_ADMISSION',
  SchoolNoFood = 'SCHOOL_NO_FOOD',
  SchoolNoGym = 'SCHOOL_NO_GYM',
  SchoolReadmissionDate = 'SCHOOL_READMISSION_DATE',
  /** @deprecated not used anymore */
  SchoolReadmissionNoDate = 'SCHOOL_READMISSION_NO_DATE',
  SportHighCardio = 'SPORT_HIGH_CARDIO',
  /** @deprecated not used anymore */
  SportLudic = 'SPORT_LUDIC',
  SportNonCompetitive = 'SPORT_NON_COMPETITIVE',
  SportNoGym = 'SPORT_NO_GYM',
  WorkAbsenceJustification = 'WORK_ABSENCE_JUSTIFICATION',
  WorkCapacityRecoveryNaspi = 'WORK_CAPACITY_RECOVERY_NASPI',
  WorkChildDisease = 'WORK_CHILD_DISEASE',
  WorkInvalidityVisit = 'WORK_INVALIDITY_VISIT',
  WorkLawEnforcementIllness = 'WORK_LAW_ENFORCEMENT_ILLNESS',
  WorkReadmission = 'WORK_READMISSION'
}

/**
 * Composite key for identifying a changed chronic drug in a PSS diff.
 * Drugs have no unique per-element ID; they are identified by drug code.
 */
export type ChangedDrugKey = {
  __typename?: 'ChangedDrugKey';
  drugCode: Scalars['String']['output'];
};

export type Chat = Node & {
  __typename?: 'Chat';
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  busy: Array<AnonymizedEvent>;
  chatOrigin?: Maybe<ChatOrigin>;
  createdAt: Scalars['Timestamp']['output'];
  dedicatedHealthlineDoctorId?: Maybe<Scalars['String']['output']>;
  healthlineState?: Maybe<HealthlineState>;
  lastMessage?: Maybe<ChatMessage>;
  tenants?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unreadCount: Scalars['Int']['output'];
  users: Array<User>;
  videoSessionId?: Maybe<Scalars['String']['output']>;
};

export type ChatAnalysis = {
  __typename?: 'ChatAnalysis';
  summary: Scalars['String']['output'];
};

export type ChatMessage = Node & {
  __typename?: 'ChatMessage';
  _id: Scalars['ID']['output'];
  attachments?: Maybe<Array<Document>>;
  chat: Chat;
  createdAt: Scalars['Timestamp']['output'];
  isAutoReply?: Maybe<Scalars['Boolean']['output']>;
  isInviteForCall?: Maybe<Scalars['Boolean']['output']>;
  moderation?: Maybe<Moderation>;
  seenBy: Array<Scalars['ID']['output']>;
  text: Scalars['String']['output'];
  user: User;
};

export type ChatMessageReturn = ComplexQueryReturn & {
  __typename?: 'ChatMessageReturn';
  nodes?: Maybe<Array<ChatMessage>>;
  pageInfo: PageInfo;
};

export type ChatModerationAiConfig = {
  __typename?: 'ChatModerationAiConfig';
  prompt?: Maybe<Scalars['String']['output']>;
};

export enum ChatOrigin {
  Acuore = 'ACUORE',
  Altro = 'ALTRO',
  Argento = 'ARGENTO',
  Cassalombarda = 'CASSALOMBARDA',
  Chatbots = 'CHATBOTS',
  Davinci = 'DAVINCI',
  Inclinic = 'INCLINIC',
  Morato = 'MORATO',
  Sisalute = 'SISALUTE',
  TantoSvago = 'TANTO_SVAGO',
  Unisalute = 'UNISALUTE',
  VirtualCare = 'VIRTUAL_CARE',
  Welfare = 'WELFARE'
}

export type ChatSettings = {
  __typename?: 'ChatSettings';
  autoMessage?: Maybe<Scalars['String']['output']>;
  autoMessageEnabled?: Maybe<Scalars['Boolean']['output']>;
  chatForSubstituteEnabled?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatSettingsInput = {
  autoMessage?: InputMaybe<Scalars['String']['input']>;
  autoMessageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  chatForSubstituteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckBookingWorkgroupGeolocationResult = {
  __typename?: 'CheckBookingWorkgroupGeolocationResult';
  matchingClinicWorkgroups?: Maybe<Scalars['Int']['output']>;
  notMatchingClinicWorkgroups?: Maybe<Scalars['Int']['output']>;
  result: Array<Maybe<BookingWorkgroupGeolocationResult>>;
  totalClinicWorkgroups?: Maybe<Scalars['Int']['output']>;
};

export type City = {
  __typename?: 'City';
  cfCode: Scalars['String']['output'];
  city: Scalars['String']['output'];
  cityCode: Scalars['String']['output'];
  districtCode: Scalars['String']['output'];
};

export enum ClientType {
  App = 'APP',
  WebApp = 'WEB_APP'
}

export type ClinicCharacterization = {
  __typename?: 'ClinicCharacterization';
  code: Scalars['String']['output'];
  dictionary: Scalars['String']['output'];
};

export type ClinicGroup = {
  __typename?: 'ClinicGroup';
  _id: Scalars['ID']['output'];
  address: StructuredAddress;
  ambulatories: Array<Workgroup>;
  availablePayments?: Maybe<Array<InclinicPayment>>;
  /** @deprecated moved to workgroup */
  description?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  inclinicFee?: Maybe<Scalars['Float']['output']>;
  /** @deprecated not used anymore */
  insurances?: Maybe<Array<Scalars['String']['output']>>;
  license: License;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owners: Array<User>;
  showOnPrivate: Scalars['Boolean']['output'];
  showOnSearch: Scalars['Boolean']['output'];
  /** @deprecated not used anymore */
  stripeConnectId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ClinicType>;
};

export enum ClinicType {
  Clinic = 'CLINIC',
  Specialist = 'SPECIALIST'
}

export type ClinicWorkgroupClosure = {
  __typename?: 'ClinicWorkgroupClosure';
  category: EventCategory;
  clinicClosureId: Scalars['String']['output'];
  endTime: Scalars['Timestamp']['output'];
  startTime: Scalars['Timestamp']['output'];
  title: Scalars['String']['output'];
  workgroups: Array<Scalars['ID']['output']>;
};

export type CodedDiagnosticQuestion = {
  __typename?: 'CodedDiagnosticQuestion';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type Communication = Node & {
  __typename?: 'Communication';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  description: Scalars['String']['output'];
  filteringMethod?: Maybe<FilteringMethod>;
  gender?: Maybe<Sex>;
  maxAge?: Maybe<Scalars['Int']['output']>;
  minAge?: Maybe<Scalars['Int']['output']>;
  problemStatuses?: Maybe<Array<PatientProblemStatus>>;
  problems?: Maybe<Array<SissValue>>;
  recipientsCount?: Maybe<Scalars['Int']['output']>;
  recipientsDevicesCount?: Maybe<Scalars['Int']['output']>;
  recipientsEmailsCount?: Maybe<Scalars['Int']['output']>;
  recipientsSmsCount?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Tag>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
};

export type CommunicationInput = {
  description: Scalars['String']['input'];
  filteringMethod?: InputMaybe<FilteringMethod>;
  gender?: InputMaybe<Sex>;
  includeSms?: InputMaybe<Scalars['Boolean']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  problemStatuses?: InputMaybe<Array<PatientProblemStatus>>;
  problems?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
};

export type CommunicationSettings = {
  __typename?: 'CommunicationSettings';
  topics: Array<Scalars['String']['output']>;
};

export type CommunicationSettingsInput = {
  topics: Array<Scalars['String']['input']>;
};

export type CommunicationsResult = ComplexQueryReturn & {
  __typename?: 'CommunicationsResult';
  nodes?: Maybe<Array<Communication>>;
  pageInfo: PageInfo;
};

export enum Company {
  Davinci = 'DAVINCI',
  Italsalute = 'ITALSALUTE'
}

export enum Comparison {
  BetweenWithoutEqual = 'BETWEEN_WITHOUT_EQUAL',
  BetweenWithEqual = 'BETWEEN_WITH_EQUAL',
  Equivalent = 'EQUIVALENT',
  EquivalentObjectId = 'EQUIVALENT_OBJECT_ID',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  InObjectIds = 'IN_OBJECT_IDS',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL'
}

export type CompleteReservationDeferredPaymentInput = {
  paymentId: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  reservationId: Scalars['String']['input'];
  stripeClinicId: Scalars['String']['input'];
};

export type CompleteReservationDeferredPaymentResult = {
  __typename?: 'CompleteReservationDeferredPaymentResult';
  error?: Maybe<InclinicError>;
  result: Scalars['Boolean']['output'];
};

export type ComplexOutpatientServiceGroupsResult = {
  __typename?: 'ComplexOutpatientServiceGroupsResult';
  nodes: Array<OutpatientServiceGroup>;
  pageInfo: PageInfo;
};

export type ComplexOutpatientServiceOutcomeParametersResult = {
  __typename?: 'ComplexOutpatientServiceOutcomeParametersResult';
  nodes?: Maybe<Array<OutpatientServiceOutcomeParameter>>;
  pageInfo: PageInfo;
};

export type ComplexOutpatientServiceOutcomeServiceExamParametersResult = {
  __typename?: 'ComplexOutpatientServiceOutcomeServiceExamParametersResult';
  nodes?: Maybe<Array<OutpatientServiceOutcomeServiceExamParameter>>;
  pageInfo: PageInfo;
};

export type ComplexPrescriptionsResult = {
  __typename?: 'ComplexPrescriptionsResult';
  nodes?: Maybe<Array<Prescription>>;
  pageInfo: PageInfo;
};

export type ComplexQueryInput = {
  countCap?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filters?: InputMaybe<Array<QueryFilters>>;
  pagination?: InputMaybe<QueryPagination>;
  query?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<QuerySorting>;
};

export type ComplexQueryReturn = {
  nodes?: Maybe<Array<Node>>;
  pageInfo: PageInfo;
};

export type ComplexTherapeuticPlansResult = {
  __typename?: 'ComplexTherapeuticPlansResult';
  nodes?: Maybe<Array<TherapeuticPlan>>;
  pageInfo: PageInfo;
};

export type ConflictingInvoice = Invoice | InvoiceOnlyId;

export type Consent = {
  __typename?: 'Consent';
  approval: Scalars['Boolean']['output'];
  consentType: ConsentType;
};

export type ConsentInput = {
  approval: Scalars['Boolean']['input'];
  consentType: ConsentType;
};

export enum ConsentType {
  PianiSperimentazioni = 'PIANI_SPERIMENTAZIONI',
  PianiTerapeutici = 'PIANI_TERAPEUTICI',
  RegistrazioneVisita = 'REGISTRAZIONE_VISITA',
  TrattamentoDatiDottore = 'TRATTAMENTO_DATI_DOTTORE',
  TrattamentoDatiPersonale = 'TRATTAMENTO_DATI_PERSONALE'
}

export type Consents = {
  __typename?: 'Consents';
  ip?: Maybe<Scalars['String']['output']>;
  lastUpdate: Scalars['Timestamp']['output'];
  newsletter: Scalars['Boolean']['output'];
  privacyDavinci: Scalars['Boolean']['output'];
};

export type ConsultaEsenzioniPrescrittoreResult = {
  __typename?: 'ConsultaEsenzioniPrescrittoreResult';
  sissExemptions?: Maybe<Array<ExemptionsPayload>>;
};

export enum ConsultationStatus {
  Completed = 'COMPLETED',
  NoShow = 'NO_SHOW'
}

export enum ContactType {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type CountCommunicationRecipientsResult = {
  __typename?: 'CountCommunicationRecipientsResult';
  devicesCount: Scalars['Int']['output'];
  emailsCount: Scalars['Int']['output'];
  phonesCount: Scalars['Int']['output'];
  smsLimitExceeded: Scalars['Boolean']['output'];
  usersIdsCount: Scalars['Int']['output'];
};

export type CountMedicalReportV2 = {
  __typename?: 'CountMedicalReportV2';
  APP: Scalars['UnsignedInt']['output'];
  FSE: Scalars['UnsignedInt']['output'];
  MANUAL: Scalars['UnsignedInt']['output'];
};

export type Coupon = Node & {
  __typename?: 'Coupon';
  _id: Scalars['ID']['output'];
  available: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  expiration?: Maybe<Scalars['Timestamp']['output']>;
  fixed: Scalars['Int']['output'];
  macroSpecialities?: Maybe<Array<Maybe<MacroSpeciality>>>;
  partner?: Maybe<Scalars['ID']['output']>;
  percentage: Scalars['Int']['output'];
  specialityTemplates?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  type: CouponType;
  unlimited: Scalars['Boolean']['output'];
  user?: Maybe<Scalars['ID']['output']>;
  userTaxCode?: Maybe<Scalars['String']['output']>;
};

export type CouponInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
};

export enum CouponType {
  Acuore = 'ACUORE',
  Argento = 'ARGENTO',
  Cassalombarda = 'CASSALOMBARDA',
  Morato = 'MORATO',
  Refund = 'REFUND',
  RefundWelfare = 'REFUND_WELFARE',
  Sisalute = 'SISALUTE',
  Standard = 'STANDARD'
}

export enum CovidRiskFactors {
  Bpco = 'BPCO',
  DiabetesMellitus = 'DIABETES_MELLITUS',
  Hemoglobinopathies = 'HEMOGLOBINOPATHIES',
  Immunodeficiency = 'IMMUNODEFICIENCY',
  KidneyFailure = 'KIDNEY_FAILURE',
  LiverDisease = 'LIVER_DISEASE',
  MoreThan_65Years = 'MORE_THAN_65_YEARS',
  NeurodegenerativeDiseases = 'NEURODEGENERATIVE_DISEASES',
  Obesity = 'OBESITY',
  OncologicalPathology = 'ONCOLOGICAL_PATHOLOGY',
  SevereCardiovascularDisease = 'SEVERE_CARDIOVASCULAR_DISEASE'
}

export type CovidTestCategory = {
  __typename?: 'CovidTestCategory';
  value?: Maybe<CovidTestCategoryValues>;
};

export enum CovidTestCategoryValues {
  Lp6464_4 = 'LP6464_4',
  Lp217198_3 = 'LP217198_3'
}

export type CovidTestCode = {
  __typename?: 'CovidTestCode';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type CovidTestStatus = {
  __typename?: 'CovidTestStatus';
  value?: Maybe<CovidTestStatusValues>;
};

export enum CovidTestStatusValues {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type CreateAnamnesisInput = {
  date: Scalars['Timestamp']['input'];
  type: AnamnesisRecordType;
  value: Scalars['String']['input'];
};

export type CreateAssistedUserAuthenticationResponse = {
  __typename?: 'CreateAssistedUserAuthenticationResponse';
  assistedUserAuthenticationHasBeenCreated: Scalars['Boolean']['output'];
};

export type CreateBlacklistEntryInput = {
  areas: Array<BlacklistArea>;
  doctorId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCalendarEventResult = {
  __typename?: 'CreateCalendarEventResult';
  calendarEvents: Array<CalendarEvent>;
};

export type CreateCancellationPaiResult = {
  __typename?: 'CreateCancellationPaiResult';
  current: Pai;
};

export type CreateCertificateTemplateInput = {
  certificateType: CertificateType;
  content: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateClinicWorkgroupInput = {
  address: StructuredAddressInput;
  clinic: Scalars['ID']['input'];
  color: WorkgroupColor;
  description: Scalars['String']['input'];
  domiciliaryCare?: InputMaybe<Scalars['Boolean']['input']>;
  emails?: InputMaybe<Array<Scalars['EmailAddress']['input']>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['URL']['input']>>>;
  inclinicSlug: Scalars['String']['input'];
  isWorkgroupHiddenInApp?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  openingHours?: InputMaybe<Array<OpeningHoursInput>>;
  operators?: InputMaybe<Array<Scalars['ID']['input']>>;
  phones?: InputMaybe<Array<Scalars['PhoneNumber']['input']>>;
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type CreateLeadResult = {
  __typename?: 'CreateLeadResult';
  lead: Lead;
};

export type CreateMedicalReportV2Input = {
  attributes?: InputMaybe<Array<InputMaybe<OptionTypeInput>>>;
  author?: InputMaybe<MedicalReportAuthorInput>;
  creationDate: Scalars['Timestamp']['input'];
  creationStructure?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['String']['input']>;
  disciplineName?: InputMaybe<Scalars['String']['input']>;
  documentType: Scalars['String']['input'];
  documents?: InputMaybe<Array<MedicalReportDocumentInput>>;
  followUp?: InputMaybe<MedicalReportsFollowUp>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  isTranscribedByAI?: InputMaybe<Scalars['Boolean']['input']>;
  operationalContext?: InputMaybe<MultiregionOperationalContext>;
  patient: Scalars['String']['input'];
  patientNotes?: InputMaybe<Scalars['String']['input']>;
  reportName?: InputMaybe<Scalars['String']['input']>;
  sharedNotes?: InputMaybe<Scalars['String']['input']>;
  source: MedicalReportsSourceType;
  takenInCharge?: InputMaybe<Scalars['Boolean']['input']>;
  textualDiagnosis?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMultipartUploadResponse = {
  __typename?: 'CreateMultipartUploadResponse';
  key?: Maybe<Scalars['String']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  url: Array<Scalars['String']['output']>;
};

export type CreatePatientMedicalDeviceInput = {
  deviceCategory?: InputMaybe<Scalars['String']['input']>;
  deviceDescription?: InputMaybe<Scalars['String']['input']>;
  devicePlantDate?: InputMaybe<Scalars['Timestamp']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePatientRequest = {
  __typename?: 'CreatePatientRequest';
  patientRequests: Array<PatientRequestInstance>;
};

export type CreatePatientSummaryInput = {
  citizenConsent?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  selectedParams: SelectedUserParamsInput;
  specialLaws?: InputMaybe<Array<ReasonForObscuration>>;
  summaryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  voluntaryObscuration?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatePatientSummaryResult = {
  __typename?: 'CreatePatientSummaryResult';
  patientSummary: PatientSummary;
};

export type CreateQuickAnswerInput = {
  keyword: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type CreateQuickAnswerResult = {
  __typename?: 'CreateQuickAnswerResult';
  quickAnswer: QuickAnswer;
};

export type CreateRequestByCodeInput = {
  code: Scalars['String']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  patientNote?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRequestByDescriptionInput = {
  patientNote?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type CreateRequestInput = {
  drugs?: InputMaybe<Array<CreateRequestByCodeInput>>;
  freeDrugs?: InputMaybe<Array<CreateRequestByDescriptionInput>>;
  freeServices?: InputMaybe<Array<CreateRequestByDescriptionInput>>;
  services?: InputMaybe<Array<CreateRequestByCodeInput>>;
};

export type CreateSpecialityInput = {
  channel: ReservationChannel;
  duration: Scalars['UnsignedInt']['input'];
  label: Scalars['String']['input'];
  price: Scalars['UnsignedInt']['input'];
  priceFirstVisit: Scalars['UnsignedInt']['input'];
  showCase?: InputMaybe<SpecialityShowcase>;
  specialityID?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateStripeSubscriptionResponse = {
  __typename?: 'CreateStripeSubscriptionResponse';
  clientSecret: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
};

export type CreateSubscriptionPlanUserInput = {
  activationDate: Scalars['Timestamp']['input'];
  expirationDate: Scalars['Timestamp']['input'];
  planTypeDuration: PlanTypeDuration;
  stripeData?: InputMaybe<SubscriptionPlanUserStripeDataInput>;
  subscriptionPlan: SubscriptionPlan;
};

export type CreateVirtualCarePlanSubscriptionInput = {
  interval: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  trialDays?: InputMaybe<Scalars['Int']['input']>;
  user: VirtualCareUserInput;
};

export type CreateVirtualCarePlanSubscriptionResponse = {
  __typename?: 'CreateVirtualCarePlanSubscriptionResponse';
  clientSecret?: Maybe<Scalars['String']['output']>;
  davinciSubscriptionId: Scalars['String']['output'];
  davinciUserId: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
};

export enum CreationMode {
  Davinci = 'DAVINCI',
  Manual = 'MANUAL'
}

export type Credential = {
  __typename?: 'Credential';
  aslCode: Scalars['String']['output'];
  districtCode: Scalars['String']['output'];
  l1?: Maybe<Scalars['String']['output']>;
  l1Description?: Maybe<Scalars['String']['output']>;
  l2?: Maybe<Scalars['String']['output']>;
  l3?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  regCode: Scalars['String']['output'];
  role: Scalars['String']['output'];
  surname: Scalars['String']['output'];
  taxCode: Scalars['String']['output'];
};

export type CreditCard = {
  __typename?: 'CreditCard';
  brand: Scalars['String']['output'];
  default: Scalars['Boolean']['output'];
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CronJob = Node & {
  __typename?: 'CronJob';
  _id: Scalars['ID']['output'];
  endedAt?: Maybe<Scalars['Timestamp']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  jobName: Scalars['String']['output'];
  startedAt: Scalars['Timestamp']['output'];
  status: CronJobStatus;
};

export enum CronJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export type CronJobs = ComplexQueryReturn & {
  __typename?: 'CronJobs';
  nodes?: Maybe<Array<CronJob>>;
  pageInfo: PageInfo;
};

export type CurrentPaiInfo = {
  __typename?: 'CurrentPaiInfo';
  counter?: Maybe<Scalars['String']['output']>;
  enlistingId?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<CurrentPaiService>>;
};

export type CurrentPaiService = {
  __typename?: 'CurrentPaiService';
  categoryCode: Scalars['String']['output'];
  outpatientService: Scalars['String']['output'];
};

export enum DarkeningReason {
  Hiv = 'HIV',
  InterruzioneGravidanza = 'INTERRUZIONE_GRAVIDANZA',
  OscuramentoVolontario = 'OSCURAMENTO_VOLONTARIO',
  Tossicodipendenza = 'TOSSICODIPENDENZA',
  ViolenzeSubite = 'VIOLENZE_SUBITE'
}

export enum DataExportDataSetType {
  Extended = 'EXTENDED',
  Minimal = 'MINIMAL'
}

export enum DataExportPatientsType {
  All = 'ALL',
  Selected = 'SELECTED'
}

export type DataExportRequest = Node & {
  __typename?: 'DataExportRequest';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  datasetType: DataExportDataSetType;
  doctor: User;
  from: Scalars['Timestamp']['output'];
  patients: Array<User>;
  result: DataExportRequestResult;
  to: Scalars['Timestamp']['output'];
};

export type DataExportRequestInput = {
  datasetType: DataExportDataSetType;
  patients: Array<Scalars['ID']['input']>;
  patientsType: DataExportPatientsType;
};

export type DataExportRequestResult = DataExportRequestResultError | DataExportRequestResultProcessing | DataExportRequestResultSuccess;

export type DataExportRequestResultError = {
  __typename?: 'DataExportRequestResultError';
  error: Scalars['String']['output'];
};

export type DataExportRequestResultProcessing = {
  __typename?: 'DataExportRequestResultProcessing';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type DataExportRequestResultSuccess = {
  __typename?: 'DataExportRequestResultSuccess';
  xml: Document;
};

export type DataExportRequests = ComplexQueryReturn & {
  __typename?: 'DataExportRequests';
  nodes?: Maybe<Array<DataExportRequest>>;
  pageInfo: PageInfo;
};

export type DataImportRequest = Node & {
  __typename?: 'DataImportRequest';
  _id: Scalars['ID']['output'];
  attachments?: Maybe<Document>;
  createdAt: Scalars['Timestamp']['output'];
  dataTemplate: DataImportTemplates;
  doctor: User;
  document: Document;
  importedCount: Scalars['Int']['output'];
  result: DataImportRequestResult;
  totalPatients: Scalars['Int']['output'];
};

export type DataImportRequestProgressPayload = {
  __typename?: 'DataImportRequestProgressPayload';
  dataImportRequest: DataImportRequest;
  importInProgress: Scalars['Boolean']['output'];
  importStatusChanged?: Maybe<Scalars['Boolean']['output']>;
};

export type DataImportRequestResult = {
  __typename?: 'DataImportRequestResult';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  status: DataImportRequestStatus;
};

export enum DataImportRequestStatus {
  Error = 'ERROR',
  Processing = 'PROCESSING',
  Queued = 'QUEUED',
  Success = 'SUCCESS'
}

export type DataImportRequests = ComplexQueryReturn & {
  __typename?: 'DataImportRequests';
  nodes?: Maybe<Array<DataImportRequest>>;
  pageInfo: PageInfo;
};

export enum DataImportTemplates {
  Advmednet = 'ADVMEDNET',
  Asclepius = 'ASCLEPIUS',
  CgmCcbasic = 'CGM_CCBASIC',
  Fastamb = 'FASTAMB',
  FpfV5 = 'FPF_V5',
  Hippocrates = 'HIPPOCRATES',
  Iatros = 'IATROS',
  Mdb2000 = 'MDB2000',
  Medea = 'MEDEA',
  MedicalLive = 'MEDICAL_LIVE',
  Medico2000 = 'MEDICO2000',
  Millewin = 'MILLEWIN',
  PatientContacts = 'PATIENT_CONTACTS',
  PatientContactsWithAnagraphics = 'PATIENT_CONTACTS_WITH_ANAGRAPHICS',
  PersonalDataSiss = 'PERSONAL_DATA_SISS',
  Phronesis = 'PHRONESIS',
  Profim = 'PROFIM',
  Tserve = 'TSERVE'
}

export type DataMigration = Node & {
  __typename?: 'DataMigration';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: DataMigrationStatus;
};

export enum DataMigrationStatus {
  Down = 'DOWN',
  Processing = 'PROCESSING',
  Up = 'UP'
}

export type DatiRefertoLaboratorio = {
  __typename?: 'DatiRefertoLaboratorio';
  rows?: Maybe<Array<DatiRefertoLaboratorioRow>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DatiRefertoLaboratorioRow = {
  __typename?: 'DatiRefertoLaboratorioRow';
  field: Scalars['String']['output'];
  lowUnit: Scalars['String']['output'];
  lowValue: Scalars['String']['output'];
  maxUnit: Scalars['String']['output'];
  maxValue: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum DeleteAppointmentReason {
  AlreadyInserted = 'ALREADY_INSERTED',
  Duplicated = 'DUPLICATED',
  NotNeeded = 'NOT_NEEDED',
  NoReason = 'NO_REASON',
  Other = 'OTHER'
}

export type DeleteBillingInput = {
  auth?: InputMaybe<RegionalSystemLogin>;
  id: Scalars['ID']['input'];
};

export type DeleteBillingItemTemplateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCommunicationResult = {
  __typename?: 'DeleteCommunicationResult';
  deleted: Scalars['Boolean']['output'];
};

export type DeleteCovidTestResponse = {
  __typename?: 'DeleteCovidTestResponse';
  error?: Maybe<Scalars['String']['output']>;
};

export type DeleteDocumentResponse = {
  __typename?: 'DeleteDocumentResponse';
  document?: Maybe<Document>;
};

export type DeleteMedicalReportV2Input = {
  followUp?: InputMaybe<MedicalReportsFollowUp>;
  id: Scalars['String']['input'];
  sharedNotes?: InputMaybe<Scalars['String']['input']>;
};

export type DeletePatientRequestInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  patientRequestIds: Array<Scalars['ID']['input']>;
  reason?: InputMaybe<DeleteReason>;
};

export type DeleteQuickAnswerResult = {
  __typename?: 'DeleteQuickAnswerResult';
  quickAnswer?: Maybe<QuickAnswer>;
};

export enum DeleteReason {
  Duplicated = 'DUPLICATED',
  IncorrectRequest = 'INCORRECT_REQUEST',
  MissingInformation = 'MISSING_INFORMATION',
  NoReason = 'NO_REASON',
  Other = 'OTHER'
}

export type DeleteResult = {
  __typename?: 'DeleteResult';
  deletedCount: Scalars['Int']['output'];
};

export type DeleteSpecialityTemplateInput = {
  specialityTemplateId: Scalars['ID']['input'];
};

export type DeleteVaccinationResponse = {
  __typename?: 'DeleteVaccinationResponse';
  error?: Maybe<Scalars['String']['output']>;
};

export type DeletedOutpatientService = {
  __typename?: 'DeletedOutpatientService';
  categoryCode: Scalars['String']['output'];
  outpatientService?: Maybe<OutpatientService>;
  quantity?: Maybe<Scalars['UnsignedInt']['output']>;
  region: Region;
  regionalCode: Scalars['String']['output'];
};

export type DeletedOutpatientServiceInput = {
  categoryCode: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['UnsignedInt']['input']>;
  region: Region;
  regionalCode: Scalars['String']['input'];
};

export type DeletedPrescriptionsResult = {
  __typename?: 'DeletedPrescriptionsResult';
  deletedPrescriptions: Array<Prescription>;
};

export enum DeliveryMethod {
  Contracted = 'CONTRACTED',
  Direct = 'DIRECT',
  Dpc = 'DPC'
}

export type DeliveryRegime = {
  __typename?: 'DeliveryRegime';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type DeliveryRegimeInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type DeviceInput = {
  delivery?: InputMaybe<Scalars['String']['input']>;
  package?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceParam = Node & UserParamInterface & {
  __typename?: 'DeviceParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: DevicePayload;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type DevicePayload = {
  __typename?: 'DevicePayload';
  delivery?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['String']['output']>;
};

export type DiariesResult = {
  __typename?: 'DiariesResult';
  nodes: Array<Diary>;
};

export type Diary = Node & {
  __typename?: 'Diary';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy?: Maybe<User>;
  document?: Maybe<Scalars['ID']['output']>;
  imported?: Maybe<Scalars['Boolean']['output']>;
  owner?: Maybe<User>;
  patient: User;
  privacyDoctorId?: Maybe<User>;
  secondaryText?: Maybe<Scalars['String']['output']>;
  secondaryType?: Maybe<DiaryType>;
  text: Scalars['String']['output'];
  transcriptionResult?: Maybe<TranscriptionDiary>;
  type: DiaryType;
};

export type DiaryLog = Node & {
  __typename?: 'DiaryLog';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hidden: Scalars['Boolean']['output'];
  text: DiaryLogText;
  type: DiaryLogType;
  user: Scalars['ID']['output'];
};

export type DiaryLogResult = {
  __typename?: 'DiaryLogResult';
  nodes?: Maybe<Array<DiaryLog>>;
  pageInfo: PageInfo;
};

export type DiaryLogText = {
  __typename?: 'DiaryLogText';
  mainText: Scalars['String']['output'];
  subText?: Maybe<Scalars['String']['output']>;
  subText2?: Maybe<Scalars['String']['output']>;
};

export enum DiaryLogType {
  CreateEntity = 'CREATE_ENTITY',
  CreateUserParam = 'CREATE_USER_PARAM',
  UpdateEntity = 'UPDATE_ENTITY',
  UpdateUserParam = 'UPDATE_USER_PARAM'
}

export type DiaryMonitoring = Node & {
  __typename?: 'DiaryMonitoring';
  _id: Scalars['ID']['output'];
  alerts: Array<Alert>;
  anamnesis?: Maybe<Scalars['String']['output']>;
  closedBy?: Maybe<Owner>;
  endDate: Scalars['Timestamp']['output'];
  frequency?: Maybe<FrequencyMonitoring>;
  monitorUserParams?: Maybe<Array<Scalars['String']['output']>>;
  motivation?: Maybe<DiaryMonitoringMotivation>;
  notified?: Maybe<Array<Scalars['ID']['output']>>;
  owner: Owner;
  patient: User;
  reason?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Timestamp']['output'];
  status: MonitoringStatus;
};

export enum DiaryMonitoringMotivation {
  Artemisia = 'ARTEMISIA',
  Covid = 'COVID',
  Generic = 'GENERIC',
  Pic = 'PIC'
}

export enum DiaryType {
  AutomaticallyGenerated = 'AutomaticallyGenerated',
  HomeVisit = 'HomeVisit',
  /** Fixed */
  MedicalDocumentInternal = 'MedicalDocumentInternal',
  MedicalDocumentShared = 'MedicalDocumentShared',
  Other = 'Other',
  StudioVisit = 'StudioVisit',
  StudioVisitInternal = 'StudioVisitInternal',
  StudioVisitShared = 'StudioVisitShared',
  /** Manual */
  TelephoneContact = 'TelephoneContact'
}

export type DiseaseCertificateNotificationInput = {
  certificateId: Scalars['ID']['input'];
  certificateNotificationType: CertificateNotificationType;
  doctorId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  mefId: Scalars['String']['input'];
  patientHasApp: Scalars['Boolean']['input'];
  patientHasEmail: Scalars['Boolean']['input'];
  patientId: Scalars['ID']['input'];
  validityEndDate: Scalars['Timestamp']['input'];
  validityStartDate: Scalars['Timestamp']['input'];
};

export type DiseaseCertificateOptions = {
  __typename?: 'DiseaseCertificateOptions';
  concessions?: Maybe<Scalars['String']['output']>;
  diagnosisCode: Scalars['String']['output'];
  diagnosisNote: Scalars['String']['output'];
  diseaseCertificateType: Scalars['String']['output'];
  mefDate?: Maybe<Scalars['Timestamp']['output']>;
  mefId?: Maybe<Scalars['String']['output']>;
  traumatic?: Maybe<Scalars['Boolean']['output']>;
  validityEndDate: Scalars['Timestamp']['output'];
  validityStartDate: Scalars['Timestamp']['output'];
  visitType: Scalars['String']['output'];
  workedDay?: Maybe<Scalars['Boolean']['output']>;
};

export type DiseaseCertificateOptionsInput = {
  concessions?: InputMaybe<Scalars['String']['input']>;
  diagnosisCode: Scalars['String']['input'];
  diagnosisNote: Scalars['String']['input'];
  diseaseCertificateType: Scalars['String']['input'];
  mefDate: Scalars['Timestamp']['input'];
  traumatic?: InputMaybe<Scalars['Boolean']['input']>;
  validityEndDate: Scalars['Timestamp']['input'];
  validityStartDate: Scalars['Timestamp']['input'];
  visitType: Scalars['String']['input'];
  workedDay?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DiseasesReturn = ComplexQueryReturn & {
  __typename?: 'DiseasesReturn';
  nodes?: Maybe<Array<SissValue>>;
  pageInfo: PageInfo;
};

export type District = {
  __typename?: 'District';
  acronym: Scalars['String']['output'];
  district: Scalars['String']['output'];
  districtCode: Scalars['String']['output'];
  regionId: Scalars['Int']['output'];
};

export type DoctorAvailabilities = Node & {
  __typename?: 'DoctorAvailabilities';
  _id: Scalars['ID']['output'];
  doctorId?: Maybe<Scalars['ID']['output']>;
  isAvailableToMyPatient: Scalars['Boolean']['output'];
  isAvailableToWorkgroupPatient?: Maybe<Scalars['Boolean']['output']>;
  slots?: Maybe<Array<Maybe<Slot>>>;
};

export type DoctorData = {
  __typename?: 'DoctorData';
  codASLAoTitolare?: Maybe<Scalars['String']['output']>;
  codSpecializzazioneTitolare?: Maybe<Scalars['String']['output']>;
  codStrutturaTitolare?: Maybe<Scalars['String']['output']>;
  codiceFiscaleTitolare?: Maybe<Scalars['String']['output']>;
  doctorName?: Maybe<Scalars['String']['output']>;
  doctorSurname?: Maybe<Scalars['String']['output']>;
};

export type DoctorDataSiss = {
  __typename?: 'DoctorDataSiss';
  capAmbulatorio?: Maybe<Scalars['String']['output']>;
  civicoAmbulatorio?: Maybe<Scalars['String']['output']>;
  codiceComuneAmbulatorio?: Maybe<Scalars['String']['output']>;
  codiceFiscaleMedico?: Maybe<Scalars['String']['output']>;
  codiceMedico?: Maybe<Scalars['String']['output']>;
  cognomeMedico?: Maybe<Scalars['String']['output']>;
  dataFineScelta?: Maybe<Scalars['String']['output']>;
  dataInizioScelta?: Maybe<Scalars['String']['output']>;
  denominazioneComuneAmbulatorio?: Maybe<Scalars['String']['output']>;
  frazioneAmbulatorio?: Maybe<Scalars['String']['output']>;
  indirizzoAmbulatorio?: Maybe<Scalars['String']['output']>;
  nomeMedico?: Maybe<Scalars['String']['output']>;
  provinciaAmbulatorio?: Maybe<Scalars['String']['output']>;
  telefoniMedico?: Maybe<Scalars['String']['output']>;
  tipoAssistenza?: Maybe<Scalars['String']['output']>;
};

export type DoctorNotes = {
  __typename?: 'DoctorNotes';
  clinicalNotes?: Maybe<Scalars['String']['output']>;
  diagnosis?: Maybe<Scalars['String']['output']>;
  followUp?: Maybe<Scalars['String']['output']>;
  requestedExams?: Maybe<Array<Scalars['String']['output']>>;
  summary?: Maybe<Scalars['String']['output']>;
  symptoms?: Maybe<Array<Scalars['String']['output']>>;
  therapy?: Maybe<Array<Scalars['String']['output']>>;
};

export type DoctorPatientSetting = {
  __typename?: 'DoctorPatientSetting';
  favoriteUserParams?: Maybe<Array<Scalars['String']['output']>>;
  owner: Scalars['ID']['output'];
  patient: Scalars['ID']['output'];
};

export type DoctorPatientSettingInput = {
  favoriteUserParams?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DoctorSlots = {
  __typename?: 'DoctorSlots';
  doctor: User;
  slots?: Maybe<Array<Slot>>;
};

export type DoctorSpecialityPairInput = {
  doctorId: Scalars['ID']['input'];
  specialityTemplateId: Scalars['ID']['input'];
};

export enum DoctorStepOptions {
  Disable = 'DISABLE',
  EnableAndShow = 'ENABLE_AND_SHOW',
  EnableWithSearch = 'ENABLE_WITH_SEARCH'
}

export enum DoctorType {
  Asl = 'ASL',
  EmergencyMedicalService = 'EMERGENCY_MEDICAL_SERVICE',
  FreelanceWithProject = 'FREELANCE_WITH_PROJECT',
  HeadTeacher = 'HEAD_TEACHER',
  HealthcareServices = 'HEALTHCARE_SERVICES',
  Hospital = 'HOSPITAL',
  InailDoctor = 'INAIL_DOCTOR',
  MedicalConsultant = 'MEDICAL_CONSULTANT',
  Midwife = 'MIDWIFE',
  Mmg = 'MMG',
  NoSsr = 'NO_SSR',
  Other = 'OTHER',
  OtherSpecialization = 'OTHER_SPECIALIZATION',
  OutpatientSpecialist = 'OUTPATIENT_SPECIALIST',
  Pls = 'PLS',
  PrivateFacility = 'PRIVATE_FACILITY',
  ReplacementMmg = 'REPLACEMENT_MMG',
  ReplacementPls = 'REPLACEMENT_PLS',
  ReplacementSpecialist = 'REPLACEMENT_SPECIALIST',
  TerritorialHealthEmergency = 'TERRITORIAL_HEALTH_EMERGENCY',
  TouristMedicalGuard = 'TOURIST_MEDICAL_GUARD',
  UniversityHospitalDoctor = 'UNIVERSITY_HOSPITAL_DOCTOR'
}

export type Document = Node & {
  __typename?: 'Document';
  _id: Scalars['ID']['output'];
  base64?: Maybe<Scalars['String']['output']>;
  category: DocumentCategory;
  createdAt: Scalars['Timestamp']['output'];
  datiRefertoLaboratorio?: Maybe<DatiRefertoLaboratorio>;
  label?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reservationId?: Maybe<Scalars['ID']['output']>;
  sissUri?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uploadedBy?: Maybe<User>;
  url: Scalars['String']['output'];
  user?: Maybe<User>;
};

export enum DocumentCategory {
  AfterMedicalInstruction = 'AFTER_MEDICAL_INSTRUCTION',
  Avatar = 'AVATAR',
  BeforeMedicalInstruction = 'BEFORE_MEDICAL_INSTRUCTION',
  BulkImportClinic = 'BULK_IMPORT_CLINIC',
  Certificate = 'CERTIFICATE',
  Chat = 'CHAT',
  FirstAidReport = 'FIRST_AID_REPORT',
  LaboratorySpecialistReport = 'LABORATORY_SPECIALIST_REPORT',
  MedicalCertificate = 'MEDICAL_CERTIFICATE',
  Other = 'OTHER',
  Pai = 'PAI',
  Passport = 'PASSPORT',
  PathTakenInCharge = 'PATH_TAKEN_IN_CHARGE',
  Prescription = 'PRESCRIPTION',
  ProfileCiBack = 'PROFILE_CI_BACK',
  ProfileCiFront = 'PROFILE_CI_FRONT',
  ProfileResidence = 'PROFILE_RESIDENCE',
  Report = 'REPORT',
  SsiDataExport = 'SSI_DATA_EXPORT',
  SsiDataImport = 'SSI_DATA_IMPORT',
  SsiDataImportAttachments = 'SSI_DATA_IMPORT_ATTACHMENTS',
  TherapeuticPlan = 'THERAPEUTIC_PLAN'
}

export type DocumentInput = {
  encoding: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mimetype: Scalars['String']['input'];
};

export type DocumentsResult = ComplexQueryReturn & {
  __typename?: 'DocumentsResult';
  nodes?: Maybe<Array<Document>>;
  pageInfo: PageInfo;
};

export type Dosage = {
  __typename?: 'Dosage';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type DosageInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type DowngradeReasons = {
  __typename?: 'DowngradeReasons';
  descrizioneMotivazione: Scalars['String']['output'];
  nomeCampoDowngradeRE?: Maybe<Scalars['String']['output']>;
  valoreCampoDowngradeRE?: Maybe<Scalars['String']['output']>;
};

export type DownloadDiseaseCertificatesResponse = {
  __typename?: 'DownloadDiseaseCertificatesResponse';
  downloadedCertificatesCount?: Maybe<Scalars['Int']['output']>;
};

export type DownloadExemptionsResponse = {
  __typename?: 'DownloadExemptionsResponse';
  downloadedExemptionsCount?: Maybe<Scalars['Int']['output']>;
};

export type DownloadMedicalReportDocumentsInput = {
  auth?: InputMaybe<RegionalSystemLogin>;
  forceDownloadAgain?: InputMaybe<Scalars['Boolean']['input']>;
  operationalContext?: InputMaybe<MultiregionOperationalContext>;
  reportId: Scalars['ID']['input'];
  takenInCharge?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DownloadPatientCovidTestsResponse = {
  __typename?: 'DownloadPatientCovidTestsResponse';
  downloadedCovidTestsCount?: Maybe<Scalars['Int']['output']>;
};

export type DownloadPatientExemptionsResponse = {
  __typename?: 'DownloadPatientExemptionsResponse';
  code: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Int']['output']>;
};

export type DownloadPatientResponse = {
  __typename?: 'DownloadPatientResponse';
  personalData?: Maybe<PersonalDataType>;
};

export type DownloadPatientsResponse = {
  __typename?: 'DownloadPatientsResponse';
  downloadedPatientsCount?: Maybe<Scalars['Int']['output']>;
};

export type DownloadSantagostinoReportData = {
  __typename?: 'DownloadSantagostinoReportData';
  dataBase64: Scalars['String']['output'];
};

export type DownloadSantagostinoReportInput = {
  doctorId: Scalars['ObjectId']['input'];
  documentId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  userTaxCode: Scalars['String']['input'];
};

export type DownloadSantagostinoReportResult = {
  __typename?: 'DownloadSantagostinoReportResult';
  downloadReportFile: DownloadSantagostinoReportData;
};

export type DownloadVaccinationsResponse = {
  __typename?: 'DownloadVaccinationsResponse';
  downloadedVaccinationsCount?: Maybe<Scalars['Int']['output']>;
};

export enum DrugAddictionValues {
  DepressingDrugs = 'DEPRESSING_DRUGS',
  HallucinogenicDrugs = 'HALLUCINOGENIC_DRUGS',
  NoAddiction = 'NO_ADDICTION',
  Other = 'OTHER',
  StimulantDrugs = 'STIMULANT_DRUGS'
}

export type DrugDeliverySpecialCode = {
  __typename?: 'DrugDeliverySpecialCode';
  code?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
};

export enum DrugDurationMeasures {
  Giorni = 'GIORNI',
  Mesi = 'MESI',
  Settimane = 'SETTIMANE'
}

export type DrugParamInput = {
  drug: Scalars['String']['input'];
  exemption?: InputMaybe<Scalars['String']['input']>;
  ignoredInteractions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  importedFromFreenet?: InputMaybe<Scalars['Boolean']['input']>;
  lastPrescriptionDate?: InputMaybe<Scalars['Timestamp']['input']>;
  lastPrescriptionId?: InputMaybe<Scalars['ID']['input']>;
  notaCuf?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientNote?: InputMaybe<Scalars['String']['input']>;
  posology: Scalars['String']['input'];
  prescribePA?: InputMaybe<Scalars['Boolean']['input']>;
  prescriptionType?: InputMaybe<PrescriptionType>;
  quantity?: InputMaybe<Scalars['UnsignedInt']['input']>;
  regionalOptions?: InputMaybe<DrugRegionalOptionsInput>;
  structuredPosology?: InputMaybe<StructuredPosologyInput>;
  substitutability: Substitutability;
  therapeuticPlanCode?: InputMaybe<Scalars['String']['input']>;
  therapyEndDate?: InputMaybe<Scalars['Timestamp']['input']>;
  therapyStatus?: InputMaybe<DrugTherapyStatus>;
};

export type DrugParamInputArray = {
  values?: InputMaybe<Array<DrugParamInput>>;
};

export type DrugParamPayload = {
  __typename?: 'DrugParamPayload';
  drug: FarmadatiDrug;
  exemption?: Maybe<Scalars['String']['output']>;
  exemptionForPrint?: Maybe<Scalars['String']['output']>;
  icd9Description?: Maybe<Scalars['String']['output']>;
  icd9Status?: Maybe<PatientProblemStatus>;
  ignoredInteractions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastPrescriptionDate?: Maybe<Scalars['Timestamp']['output']>;
  lastPrescriptionId?: Maybe<Scalars['ID']['output']>;
  notaCuf?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientNote?: Maybe<Scalars['String']['output']>;
  posology: Scalars['String']['output'];
  prescribePA?: Maybe<Scalars['Boolean']['output']>;
  prescriptionType?: Maybe<PrescriptionType>;
  quantity?: Maybe<Scalars['UnsignedInt']['output']>;
  regionalOptions?: Maybe<DrugRegionalOptions>;
  structuredPosology?: Maybe<StructuredPosology>;
  substitutability?: Maybe<Substitutability>;
  therapeuticPlanCode?: Maybe<Scalars['String']['output']>;
  therapyEndDate?: Maybe<Scalars['Timestamp']['output']>;
  therapyStatus?: Maybe<DrugTherapyStatus>;
};

export type DrugParamPayloadArray = {
  __typename?: 'DrugParamPayloadArray';
  values?: Maybe<Array<DrugParamPayload>>;
};

export type DrugParamPayloadArrayRequired = {
  __typename?: 'DrugParamPayloadArrayRequired';
  values: Array<DrugParamPayload>;
};

export type DrugPrescriptionsInteractions = {
  __typename?: 'DrugPrescriptionsInteractions';
  cardNumber: Scalars['UnsignedInt']['output'];
  messages?: Maybe<Array<Scalars['String']['output']>>;
};

export type DrugPrescriptionsInteractionsInput = {
  cardNumber: Scalars['UnsignedInt']['input'];
  drugCodes: Array<Scalars['String']['input']>;
};

export type DrugPrescriptionsInteractionsResult = {
  __typename?: 'DrugPrescriptionsInteractionsResult';
  result?: Maybe<Array<DrugPrescriptionsInteractions>>;
};

export type DrugPrice = {
  __typename?: 'DrugPrice';
  codeVat?: Maybe<Scalars['Int']['output']>;
  dl78_2010Discount?: Maybe<Scalars['String']['output']>;
  exFactoryInfo?: Maybe<DrugPriceExFactoryInfo>;
  flagNoPrice?: Maybe<NoPriceFlag>;
  includeVAT: Scalars['Boolean']['output'];
  industriaDiscount?: Maybe<Scalars['String']['output']>;
  l662_1996Discount?: Maybe<Scalars['String']['output']>;
  nationalInfo?: Maybe<DrugPriceNationalInfo>;
  paybackDiscount?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  ssnInfo?: Maybe<DrugPriceSsnInfo>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type DrugPriceExFactoryInfo = {
  __typename?: 'DrugPriceExFactoryInfo';
  date?: Maybe<Scalars['Timestamp']['output']>;
  guNumber?: Maybe<Scalars['Int']['output']>;
  guYear?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type DrugPriceNationalInfo = {
  __typename?: 'DrugPriceNationalInfo';
  date?: Maybe<Scalars['Timestamp']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  refundPriceSSN?: Maybe<Scalars['Float']['output']>;
};

export type DrugPriceSsnInfo = {
  __typename?: 'DrugPriceSsnInfo';
  mandatoryDiscount?: Maybe<Scalars['Float']['output']>;
  maxPriceCessione?: Maybe<Scalars['Float']['output']>;
  nProvvedimentoCessione?: Maybe<Scalars['Int']['output']>;
  nProvvedimentoDiscount?: Maybe<Scalars['Int']['output']>;
  yearProvvedimentoCessione?: Maybe<Scalars['Int']['output']>;
  yearProvvedimentoDiscount?: Maybe<Scalars['Int']['output']>;
};

export type DrugRegionalOptions = {
  __typename?: 'DrugRegionalOptions';
  isTdl?: Maybe<Scalars['Boolean']['output']>;
  prescriptionReason?: Maybe<PrescriptionReason>;
  sartaniCode?: Maybe<Scalars['String']['output']>;
};

export type DrugRegionalOptionsInput = {
  isTdl?: InputMaybe<Scalars['Boolean']['input']>;
  prescriptionReason?: InputMaybe<PrescriptionReason>;
  sartaniCode?: InputMaybe<Scalars['String']['input']>;
  vitamineDCode?: InputMaybe<Scalars['String']['input']>;
};

export type DrugReservation = Node & {
  __typename?: 'DrugReservation';
  _id: Scalars['ID']['output'];
  canceledBy?: Maybe<User>;
  canceledNote?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  drugstore: Drugstore;
  patient: User;
  patientNote?: Maybe<Scalars['String']['output']>;
  pharmacistNote?: Maybe<Scalars['String']['output']>;
  prescription: Prescription;
  status?: Maybe<DrugReservationStatus>;
};

export enum DrugReservationStatus {
  Canceled = 'CANCELED',
  Deleted = 'DELETED',
  Delivered = 'DELIVERED',
  ToBeDelivered = 'TO_BE_DELIVERED',
  WaitingPatient = 'WAITING_PATIENT',
  WaitingPharmacist = 'WAITING_PHARMACIST'
}

export type DrugReservationsResult = ComplexQueryReturn & {
  __typename?: 'DrugReservationsResult';
  nodes: Array<DrugReservation>;
  pageInfo: PageInfo;
};

export enum DrugReservationsTab {
  Archived = 'ARCHIVED',
  ToBeAccepted = 'TO_BE_ACCEPTED',
  ToBeDelivered = 'TO_BE_DELIVERED'
}

export enum DrugSheetType {
  Information = 'INFORMATION',
  Technical = 'TECHNICAL'
}

export enum DrugTherapyStatus {
  Aborted = 'ABORTED',
  Active = 'ACTIVE',
  Cancellato = 'CANCELLATO',
  Completed = 'COMPLETED',
  Suspended = 'SUSPENDED'
}

export enum DrugTimeMeasures {
  AlBisogno = 'AL_BISOGNO',
  Giorni = 'GIORNI',
  Mesi = 'MESI',
  Ore = 'ORE',
  Settimane = 'SETTIMANE'
}

export enum DrugUnitMeasures {
  Amp = 'AMP',
  App = 'APP',
  Bar = 'BAR',
  Bas = 'BAS',
  Bom = 'BOM',
  Bus = 'BUS',
  Car = 'CAR',
  Cc = 'CC',
  Cer = 'CER',
  Cli = 'CLI',
  Cmo = 'CMO',
  Cpr = 'CPR',
  Cps = 'CPS',
  Cro = 'CRO',
  Div = 'DIV',
  Dos = 'DOS',
  Ero = 'ERO',
  Fia = 'FIA',
  Fil = 'FIL',
  Fla = 'FLA',
  G = 'G',
  Gar = 'GAR',
  Gra = 'GRA',
  Grn = 'GRN',
  Gtt = 'GTT',
  Imp = 'IMP',
  Inp = 'INP',
  Ins = 'INS',
  Iud = 'IUD',
  Lio = 'LIO',
  Mc = 'MC',
  Mcg = 'MCG',
  Meq = 'MEQ',
  Mg = 'MG',
  Ml = 'ML',
  Mtr = 'MTR',
  Neb = 'NEB',
  Ovu = 'OVU',
  Pas = 'PAS',
  Pen = 'PEN',
  Sac = 'SAC',
  Sir = 'SIR',
  Spu = 'SPU',
  Sup = 'SUP',
  Tam = 'TAM',
  Tub = 'TUB',
  U = 'U',
  Ual = 'UAL',
  Ui = 'UI',
  Vas = 'VAS'
}

export type DrugsPaginateResult = {
  __typename?: 'DrugsPaginateResult';
  nodes?: Maybe<Array<FarmadatiDrug>>;
  pageInfo: PageInfo;
};

export type DrugsParam = Node & UserParamInterface & {
  __typename?: 'DrugsParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: DrugParamPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type DrugsPrescription = BasicPrescription & Node & {
  __typename?: 'DrugsPrescription';
  _id: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy?: Maybe<User>;
  creationMode: CreationMode;
  darkeningReason?: Maybe<DarkeningReason>;
  date: Scalars['Timestamp']['output'];
  doctorData?: Maybe<DoctorData>;
  downgradeReasons?: Maybe<Array<DowngradeReasons>>;
  enlistingIdPai?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  exceptions?: Maybe<Array<Exceptions>>;
  exemption?: Maybe<Exemption>;
  exemptionForPrint?: Maybe<Scalars['String']['output']>;
  flagOther?: Maybe<Scalars['Boolean']['output']>;
  icd9Description?: Maybe<Scalars['String']['output']>;
  icd9Status?: Maybe<PatientProblemStatus>;
  incomeSelfCertificationNumber?: Maybe<Scalars['String']['output']>;
  iupCode?: Maybe<Scalars['String']['output']>;
  mefCode?: Maybe<Scalars['String']['output']>;
  owner: User;
  paiLotNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  patient: User;
  personalDataSiss?: Maybe<PersonalDataSiss>;
  pinNrbe?: Maybe<Scalars['String']['output']>;
  prescriptionCode?: Maybe<Scalars['String']['output']>;
  prescriptionDrugs: Array<PrescriptionDrug>;
  printPdf?: Maybe<Document>;
  problemIcd9?: Maybe<Scalars['String']['output']>;
  processingDate?: Maybe<Scalars['Timestamp']['output']>;
  progressiveNumber: Scalars['UnsignedInt']['output'];
  regionalCodedMotivation?: Maybe<OptionType>;
  regionalCommunication?: Maybe<Array<Maybe<PrescriptionRegionalCommunication>>>;
  regionalOptions?: Maybe<PrescriptionRegionalOptions>;
  regionalStatus?: Maybe<RegionalPrescriptionStatus>;
  relatedRequests?: Maybe<Array<PatientRequestInstance>>;
  repeatable: Scalars['Boolean']['output'];
  showPatientInformation?: Maybe<ShowPatientInformation>;
  sissCounterPai?: Maybe<Scalars['String']['output']>;
  /** @deprecated use regionalStatus */
  sissPrescriptionStatus?: Maybe<SissPrescriptionStatus>;
  status: PrescriptionStatus;
  suggested?: Maybe<Scalars['Boolean']['output']>;
  suggestedCode?: Maybe<Scalars['String']['output']>;
  textualDiagnosis?: Maybe<Scalars['String']['output']>;
  therapeuticPlanCode?: Maybe<Scalars['String']['output']>;
  type: PrescriptionType;
  urgency?: Maybe<Scalars['Boolean']['output']>;
  visitType?: Maybe<VisitType>;
  withdrawalData?: Maybe<Array<WithdrawalData>>;
};

export type DrugsRequest = Node & PatientRequestInterface & {
  __typename?: 'DrugsRequest';
  _id: Scalars['ID']['output'];
  action: PatientRequestAction;
  createdAt: Scalars['Timestamp']['output'];
  deleteReason?: Maybe<DeleteReason>;
  deleteReasonNote?: Maybe<Scalars['String']['output']>;
  doctor: User;
  internalNote?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteToPatient?: Maybe<Scalars['String']['output']>;
  noteToPatientAttachment?: Maybe<Document>;
  patient: User;
  payload: DrugParamPayloadArrayRequired;
  processingDate?: Maybe<Scalars['Timestamp']['output']>;
  /** @deprecated Use relatedPrescriptions instead */
  relatedPrescription?: Maybe<Prescription>;
  relatedPrescriptions?: Maybe<Array<Prescription>>;
  requestedBy?: Maybe<User>;
  requestedByAI?: Maybe<Scalars['Boolean']['output']>;
  status: PatientRequestStatus;
  type: PatientRequestType;
};

export type Drugstore = Node & {
  __typename?: 'Drugstore';
  _id: Scalars['ID']['output'];
  address: StructuredAddress;
  code: Scalars['String']['output'];
  distance?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  vat: Scalars['String']['output'];
  workgroup?: Maybe<Workgroup>;
};

export type DrugstoresResult = ComplexQueryReturn & {
  __typename?: 'DrugstoresResult';
  enabledDrugstores: Scalars['Int']['output'];
  nodes: Array<Drugstore>;
  pageInfo: PageInfo;
};

export type EditableSpeciality = {
  __typename?: 'EditableSpeciality';
  _id?: Maybe<Scalars['ID']['output']>;
  /** This value is expressed as seconds */
  allowBookingAfter?: Maybe<Scalars['UnsignedInt']['output']>;
  channel: ReservationChannel;
  /** This value is expressed as seconds */
  denyBookingAfter?: Maybe<Scalars['UnsignedInt']['output']>;
  duration: Scalars['UnsignedInt']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<Scalars['ID']['output']>;
  /** This price is an integer without any decimal digits */
  price: Scalars['UnsignedInt']['output'];
  priceFirstVisit: Scalars['UnsignedInt']['output'];
  /** This is the price as an integer with the last digits as the decimals */
  priceWithDecimals: Scalars['UnsignedInt']['output'];
  selected: Scalars['Boolean']['output'];
  showcase: SpecialityShowcase;
  specialityTemplateId: Scalars['ID']['output'];
};

export type EltyAuthResponse = {
  __typename?: 'EltyAuthResponse';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  requiresPasswordChange: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type EnabledSetting = {
  __typename?: 'EnabledSetting';
  date?: Maybe<Scalars['Timestamp']['output']>;
  enabled: Scalars['Boolean']['output'];
  ip?: Maybe<Scalars['String']['output']>;
};

export type Error = {
  __typename?: 'Error';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type Esenzione = {
  codice: Scalars['String']['input'];
  decorrenza: Scalars['String']['input'];
  scadenza?: InputMaybe<Scalars['String']['input']>;
};

export enum EsenzioniTipoAnagraficaSiss {
  A = 'A',
  Ae = 'AE',
  Aem = 'AEM',
  Am = 'AM',
  Ame = 'AME',
  E = 'E',
  Ea = 'EA',
  Eam = 'EAM',
  Em = 'EM',
  Ema = 'EMA',
  M = 'M',
  Ma = 'MA',
  Mae = 'MAE',
  Me = 'ME',
  Mea = 'MEA'
}

export enum EventCategory {
  Closed = 'CLOSED',
  Other = 'OTHER',
  ScientificInformant = 'SCIENTIFIC_INFORMANT',
  Vacation = 'VACATION'
}

export type EventDayCounter = {
  __typename?: 'EventDayCounter';
  date: Scalars['Int']['output'];
  day: Scalars['String']['output'];
  holidayName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AvailabilityStatus>;
};

export enum EventRecurrence {
  EveryWeek = 'EVERY_WEEK',
  One = 'ONE',
  Two = 'TWO'
}

export type Exceptions = {
  __typename?: 'Exceptions';
  /** @deprecated No longer supported */
  ROI?: Maybe<Scalars['String']['output']>;
  /** @deprecated use exceptionCode */
  codiceEccezione?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  codiceEccezioneCamp?: Maybe<Scalars['String']['output']>;
  /** @deprecated use exceptionDescription */
  descEccezione?: Maybe<Scalars['String']['output']>;
  /** @deprecated use fieldExceptionDescription */
  descEccezioneCampo?: Maybe<Scalars['String']['output']>;
  exceptionCode: Scalars['String']['output'];
  exceptionDescription: Scalars['String']['output'];
  fieldExceptionDescription?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  fieldValue?: Maybe<Scalars['String']['output']>;
  internalExceptionCode?: Maybe<PrescriptionExceptionCode>;
  /** @deprecated use fieldName */
  nomeCampo?: Maybe<Scalars['String']['output']>;
  /** @deprecated use fieldValue */
  valoreCampo?: Maybe<Scalars['String']['output']>;
};

export type Exemption = {
  __typename?: 'Exemption';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  flAmbitoFarmaceutico?: Maybe<Scalars['Boolean']['output']>;
  flAmbitoSpecialistico?: Maybe<Scalars['Boolean']['output']>;
  isAddedAutomatically?: Maybe<Scalars['Boolean']['output']>;
  protocolCode?: Maybe<Scalars['String']['output']>;
  regions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: ExemptionType;
};

export type ExemptionPaginateResult = {
  __typename?: 'ExemptionPaginateResult';
  nodes: Array<Maybe<FarmadatiExemption>>;
  pageInfo: PageInfo;
};

export enum ExemptionType {
  Doppia = 'DOPPIA',
  Invalidita = 'INVALIDITA',
  InvaliditaSeCorrelata = 'INVALIDITA_SE_CORRELATA',
  InvaliditaTotale = 'INVALIDITA_TOTALE',
  MalattiaRara = 'MALATTIA_RARA',
  Patologia = 'PATOLOGIA',
  Reddito = 'REDDITO',
  Sconosciuto = 'SCONOSCIUTO',
  Screening = 'SCREENING',
  Tdl = 'TDL',
  Temporanea = 'TEMPORANEA'
}

export type ExemptionsForPatientReturn = {
  __typename?: 'ExemptionsForPatientReturn';
  exemptions: Array<Exemption>;
};

export type ExemptionsInput = {
  code: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  importedFromFreenet?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Region>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ExemptionsInputArray = {
  values?: InputMaybe<Array<ExemptionsInput>>;
};

export type ExemptionsParam = Node & UserParamInterface & {
  __typename?: 'ExemptionsParam';
  _id: Scalars['ID']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: ExemptionsPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type ExemptionsPayload = {
  __typename?: 'ExemptionsPayload';
  code: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Timestamp']['output']>;
  exemption: Exemption;
  region?: Maybe<Region>;
  startDate?: Maybe<Scalars['Timestamp']['output']>;
};

export type ExemptionsPayloadArray = {
  __typename?: 'ExemptionsPayloadArray';
  values?: Maybe<Array<ExemptionsPayload>>;
};

export type ExemptionsReturn = {
  __typename?: 'ExemptionsReturn';
  nodes?: Maybe<Array<Exemption>>;
  pageInfo: PageInfo;
};

export enum ExpenseType {
  Aa = 'AA',
  Ad = 'AD',
  As = 'AS',
  Ct = 'CT',
  Fc = 'FC',
  Fv = 'FV',
  Ic = 'IC',
  Pi = 'PI',
  Sp = 'SP',
  Sr = 'SR',
  Sv = 'SV',
  Tk = 'TK'
}

export type ExportPatientsResponse = {
  __typename?: 'ExportPatientsResponse';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum ExternalService {
  TantoSvago = 'TANTO_SVAGO',
  Unisalute = 'UNISALUTE',
  VirtualCare = 'VIRTUAL_CARE'
}

export type FarmadatiAPsInteractionsInput = {
  codes: Array<Scalars['String']['input']>;
  pagination?: InputMaybe<QueryPagination>;
  sorting?: InputMaybe<QuerySorting>;
};

export type FarmadatiActivePrinciple = {
  __typename?: 'FarmadatiActivePrinciple';
  abbrevation?: Maybe<Scalars['String']['output']>;
  atcCode1?: Maybe<Scalars['String']['output']>;
  atcCode2?: Maybe<Scalars['String']['output']>;
  atcCode3?: Maybe<Scalars['String']['output']>;
  atcCode4?: Maybe<Scalars['String']['output']>;
  atcCode5?: Maybe<Scalars['String']['output']>;
  atcCode6?: Maybe<Scalars['String']['output']>;
  atcCode7?: Maybe<Scalars['String']['output']>;
  atcCode8?: Maybe<Scalars['String']['output']>;
  atcCode9?: Maybe<Scalars['String']['output']>;
  atcCode10?: Maybe<Scalars['String']['output']>;
  base?: Maybe<FarmadatiActivePrinciple>;
  baseCode?: Maybe<Scalars['String']['output']>;
  categoryAbbrevation?: Maybe<Scalars['String']['output']>;
  categoryDescription?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  interactions1: Array<Maybe<FarmadatiActivePrincipleInteraction>>;
  interactions2: Array<Maybe<FarmadatiActivePrincipleInteraction>>;
  isForAnimal?: Maybe<Scalars['Boolean']['output']>;
  patentExpirationDate?: Maybe<Scalars['String']['output']>;
};

export type FarmadatiActivePrincipleInteraction = {
  __typename?: 'FarmadatiActivePrincipleInteraction';
  activePrinciple1?: Maybe<FarmadatiActivePrinciple>;
  activePrinciple2?: Maybe<FarmadatiActivePrinciple>;
  code1: Scalars['String']['output'];
  code2: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type FarmadatiActivePrincipleInteractionPartial = {
  __typename?: 'FarmadatiActivePrincipleInteractionPartial';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type FarmadatiDrug = {
  __typename?: 'FarmadatiDrug';
  _id: Scalars['ID']['output'];
  activePrinciple?: Maybe<FarmadatiActivePrinciple>;
  activePrincipleCode?: Maybe<Scalars['String']['output']>;
  activePrincipleDescription?: Maybe<Scalars['String']['output']>;
  allActivePrincipleInteractions?: Maybe<Array<Maybe<FarmadatiActivePrincipleInteractionPartial>>>;
  atcCode?: Maybe<Scalars['String']['output']>;
  atcDescription?: Maybe<Scalars['String']['output']>;
  classCode?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  cufNote?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  discretionaryExemptionsCodes?: Maybe<Array<Scalars['String']['output']>>;
  distribuzioneDirettaSpecialCodes?: Maybe<Array<DrugDeliverySpecialCode>>;
  distribuzionePerContoSpecialCodes?: Maybe<Array<DrugDeliverySpecialCode>>;
  equivalenceGroup?: Maybe<FarmadatiEquivalenceGroup>;
  equivalenceGroupCode?: Maybe<Scalars['String']['output']>;
  exceptionalEquivalenceGroup?: Maybe<FarmadatiEquivalenceGroup>;
  exceptionalEquivalenceGroupCode?: Maybe<Scalars['String']['output']>;
  exemptions?: Maybe<Array<Maybe<FarmadatiExemption>>>;
  gluten?: Maybe<Scalars['Boolean']['output']>;
  informationSheets?: Maybe<Array<FarmadatiInformationSheet>>;
  isBiologic?: Maybe<Scalars['Boolean']['output']>;
  isBiosimilar?: Maybe<Scalars['Boolean']['output']>;
  isDistribuzioneDiretta?: Maybe<Scalars['Boolean']['output']>;
  isDistribuzionePerConto?: Maybe<Scalars['Boolean']['output']>;
  isPatented?: Maybe<Scalars['Boolean']['output']>;
  lactose?: Maybe<Scalars['Boolean']['output']>;
  latestMarketabilityStatus?: Maybe<FarmadatiMarketabilityStatus>;
  marketabilityStatuses?: Maybe<Array<Maybe<FarmadatiMarketabilityStatus>>>;
  multiPrescribable: Scalars['Boolean']['output'];
  narcotic: Scalars['Boolean']['output'];
  narcoticCategory?: Maybe<Scalars['String']['output']>;
  onTheMarket?: Maybe<FarmadatiDrugOnTheMarket>;
  particularities?: Maybe<Array<FarmadatiParticularityWithLevel>>;
  phleboclysis?: Maybe<Scalars['Boolean']['output']>;
  posologyUMR?: Maybe<FarmadatiPosologyUmr>;
  prescribability?: Maybe<FarmadatiPrescribability>;
  prescribabilityCode?: Maybe<Scalars['String']['output']>;
  price?: Maybe<DrugPrice>;
  recipeCode?: Maybe<Scalars['String']['output']>;
  recipeDescription?: Maybe<Scalars['String']['output']>;
  regime?: Maybe<Scalars['String']['output']>;
  repeatable: Scalars['Boolean']['output'];
  replacedBy?: Maybe<Scalars['String']['output']>;
  replaces?: Maybe<Scalars['String']['output']>;
  requiresTherapeuticPlan: Scalars['Boolean']['output'];
  tdd: Scalars['Boolean']['output'];
  technicalSheet?: Maybe<FarmadatiTechnicalSheet>;
  validExemptionsCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export enum FarmadatiDrugOnTheMarket {
  Everywhere = 'EVERYWHERE',
  Hospital = 'HOSPITAL',
  Nowhere = 'NOWHERE'
}

export type FarmadatiDrugsByEquivalenceGroupInput = {
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination?: InputMaybe<QueryPagination>;
  sorting?: InputMaybe<QuerySorting>;
};

export type FarmadatiEquivalenceGroup = {
  __typename?: 'FarmadatiEquivalenceGroup';
  active?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isInListAIFA?: Maybe<Scalars['Boolean']['output']>;
  longDescription?: Maybe<Scalars['String']['output']>;
};

export type FarmadatiExemption = {
  __typename?: 'FarmadatiExemption';
  aslCode?: Maybe<Scalars['String']['output']>;
  exemptionCode: Scalars['String']['output'];
  icdCode?: Maybe<Scalars['String']['output']>;
  icdPathologyCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  product?: Maybe<FarmadatiDrug>;
  productCode: Scalars['String']['output'];
  regionCode?: Maybe<Scalars['String']['output']>;
};

export type FarmadatiExemptionInput = {
  filters?: InputMaybe<Array<QueryFilters>>;
  pagination?: InputMaybe<QueryPagination>;
  query?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<QuerySorting>;
};

export type FarmadatiInformationSheet = {
  __typename?: 'FarmadatiInformationSheet';
  docCode?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  progressiveNumber?: Maybe<Scalars['UnsignedInt']['output']>;
};

export type FarmadatiMarketabilityStatus = {
  __typename?: 'FarmadatiMarketabilityStatus';
  communicationSource?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['String']['output'];
  marketabilityStatus: MarketabilityStatusEnum;
  measureNumber?: Maybe<Scalars['Int']['output']>;
  measureYear?: Maybe<Scalars['Int']['output']>;
  productCode: Scalars['String']['output'];
  reasonCode?: Maybe<Scalars['String']['output']>;
  sellableUntilStockDepletionDate?: Maybe<Scalars['Timestamp']['output']>;
};

export type FarmadatiParticularityWithLevel = {
  __typename?: 'FarmadatiParticularityWithLevel';
  active?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  date?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extendedDescription?: Maybe<Scalars['String']['output']>;
  level: ParticularityLevel;
  publicNotes?: Maybe<Scalars['String']['output']>;
};

export type FarmadatiPosologyUmr = {
  __typename?: 'FarmadatiPosologyUMR';
  umrCode?: Maybe<Scalars['String']['output']>;
  umrNumber?: Maybe<Scalars['Float']['output']>;
};

export type FarmadatiPrescribability = {
  __typename?: 'FarmadatiPrescribability';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  longDescription: Scalars['String']['output'];
  maxQuantity?: Maybe<Scalars['UnsignedInt']['output']>;
  multiPrescribable: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phleboclysis: Scalars['Boolean']['output'];
  photocopiesDescription?: Maybe<Scalars['String']['output']>;
};

export type FarmadatiTechnicalSheet = {
  __typename?: 'FarmadatiTechnicalSheet';
  docCode?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  progressiveNumber?: Maybe<Scalars['UnsignedInt']['output']>;
};

export enum FeedbackOperation {
  Assigned = 'ASSIGNED',
  Comment = 'COMMENT',
  CommentEdited = 'COMMENT_EDITED',
  CommentRemoved = 'COMMENT_REMOVED',
  StatusChange = 'STATUS_CHANGE'
}

export type FeedbackUpdatedResponse = {
  __typename?: 'FeedbackUpdatedResponse';
  feedback: UserbackFeedback;
  hasUnreadFeedbacks: Scalars['Boolean']['output'];
  operation: FeedbackOperation;
};

export enum FeedbacksQueryTab {
  Ideas = 'IDEAS',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type FertilityInput = {
  fertilityNotes?: InputMaybe<Scalars['String']['input']>;
  firstPeriodDate?: InputMaybe<Scalars['Timestamp']['input']>;
  infertilityNotes?: InputMaybe<Scalars['String']['input']>;
  infertilityStartingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<FertilityStatus>;
  tryingToConceive: Scalars['Boolean']['input'];
};

export type FertilityParam = Node & UserParamInterface & {
  __typename?: 'FertilityParam';
  _id: Scalars['ID']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: FertilityPayload;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type FertilityPayload = {
  __typename?: 'FertilityPayload';
  fertilityNotes?: Maybe<Scalars['String']['output']>;
  firstPeriodDate?: Maybe<Scalars['Timestamp']['output']>;
  infertilityNotes?: Maybe<Scalars['String']['output']>;
  infertilityStartingDate?: Maybe<Scalars['Timestamp']['output']>;
  status?: Maybe<FertilityStatus>;
  tryingToConceive?: Maybe<Scalars['Boolean']['output']>;
};

export enum FertilityStatus {
  Fertile = 'FERTILE',
  Infertile = 'INFERTILE'
}

export type File = {
  __typename?: 'File';
  encoding: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
};

export enum FilteringMethod {
  All = 'ALL',
  Any = 'ANY'
}

export type ForeignAndSeafarin = {
  __typename?: 'ForeignAndSeafarin';
  dataNascitaAssIstEstera?: Maybe<Scalars['Timestamp']['output']>;
  dataScadenzaTesseraEuropea?: Maybe<Scalars['Timestamp']['output']>;
  istituzCompetente?: Maybe<Scalars['String']['output']>;
  numTessSasn?: Maybe<Scalars['String']['output']>;
  numeroTesseraEuropea?: Maybe<Scalars['String']['output']>;
  siglaStatoEstero?: Maybe<Scalars['String']['output']>;
  socNavigaz?: Maybe<Scalars['String']['output']>;
};

export type ForeignAndSeafarinInput = {
  dataNascitaAssIstEstera?: InputMaybe<Scalars['Timestamp']['input']>;
  dataScadenzaTesseraEuropea?: InputMaybe<Scalars['Timestamp']['input']>;
  istituzCompetente?: InputMaybe<Scalars['String']['input']>;
  numTessSasn?: InputMaybe<Scalars['String']['input']>;
  numeroTesseraEuropea?: InputMaybe<Scalars['String']['input']>;
  siglaStatoEstero?: InputMaybe<Scalars['String']['input']>;
  socNavigaz?: InputMaybe<Scalars['String']['input']>;
};

export type FreeDrugsRequest = Node & PatientRequestInterface & {
  __typename?: 'FreeDrugsRequest';
  _id: Scalars['ID']['output'];
  action: PatientRequestAction;
  createdAt: Scalars['Timestamp']['output'];
  deleteReason?: Maybe<DeleteReason>;
  deleteReasonNote?: Maybe<Scalars['String']['output']>;
  doctor: User;
  internalNote?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteToPatient?: Maybe<Scalars['String']['output']>;
  noteToPatientAttachment?: Maybe<Document>;
  patient: User;
  payload: FreeRequestArrayPayload;
  processingDate?: Maybe<Scalars['Timestamp']['output']>;
  /** @deprecated Use relatedPrescriptions instead */
  relatedPrescription?: Maybe<Prescription>;
  relatedPrescriptions?: Maybe<Array<Prescription>>;
  requestedBy?: Maybe<User>;
  requestedByAI?: Maybe<Scalars['Boolean']['output']>;
  status: PatientRequestStatus;
  type: PatientRequestType;
};

export type FreePrescription = BasicPrescription & Node & {
  __typename?: 'FreePrescription';
  _id: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy?: Maybe<User>;
  creationMode: CreationMode;
  darkeningReason?: Maybe<DarkeningReason>;
  date: Scalars['Timestamp']['output'];
  doctorData?: Maybe<DoctorData>;
  downgradeReasons?: Maybe<Array<DowngradeReasons>>;
  enlistingIdPai?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  exceptions?: Maybe<Array<Exceptions>>;
  exemption?: Maybe<Exemption>;
  exemptionForPrint?: Maybe<Scalars['String']['output']>;
  flagOther?: Maybe<Scalars['Boolean']['output']>;
  freeDescription: Scalars['String']['output'];
  incomeSelfCertificationNumber?: Maybe<Scalars['String']['output']>;
  iupCode?: Maybe<Scalars['String']['output']>;
  mefCode?: Maybe<Scalars['String']['output']>;
  notaCuf?: Maybe<Scalars['String']['output']>;
  owner: User;
  paiLotNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  patient: User;
  personalDataSiss?: Maybe<PersonalDataSiss>;
  pinNrbe?: Maybe<Scalars['String']['output']>;
  prescriptionCode?: Maybe<Scalars['String']['output']>;
  printPdf?: Maybe<Document>;
  priorityClass?: Maybe<PriorityClass>;
  processingDate?: Maybe<Scalars['Timestamp']['output']>;
  progressiveNumber: Scalars['UnsignedInt']['output'];
  quantity?: Maybe<Scalars['UnsignedInt']['output']>;
  regionalCodedMotivation?: Maybe<OptionType>;
  regionalCommunication?: Maybe<Array<Maybe<PrescriptionRegionalCommunication>>>;
  regionalOptions?: Maybe<PrescriptionRegionalOptions>;
  regionalStatus?: Maybe<RegionalPrescriptionStatus>;
  relatedRequests?: Maybe<Array<PatientRequestInstance>>;
  showPatientInformation?: Maybe<ShowPatientInformation>;
  sissCounterPai?: Maybe<Scalars['String']['output']>;
  /** @deprecated use regionalStatus */
  sissPrescriptionStatus?: Maybe<SissPrescriptionStatus>;
  status: PrescriptionStatus;
  suggested?: Maybe<Scalars['Boolean']['output']>;
  suggestedCode?: Maybe<Scalars['String']['output']>;
  textualDiagnosis?: Maybe<Scalars['String']['output']>;
  therapeuticPlanCode?: Maybe<Scalars['String']['output']>;
  type: PrescriptionType;
  urgency?: Maybe<Scalars['Boolean']['output']>;
  withdrawalData?: Maybe<Array<WithdrawalData>>;
};

export type FreePrescriptionInput = {
  date?: InputMaybe<Scalars['UnsignedInt']['input']>;
  exemption?: InputMaybe<Scalars['String']['input']>;
  freeDescription: Scalars['String']['input'];
  notaCuf?: InputMaybe<Scalars['String']['input']>;
  prescriptionId?: InputMaybe<Scalars['String']['input']>;
  priorityClass?: InputMaybe<PriorityClass>;
  quantity: Scalars['UnsignedInt']['input'];
  suggested?: InputMaybe<Scalars['Boolean']['input']>;
  type: PrescriptionType;
};

export type FreeRequestArrayPayload = {
  __typename?: 'FreeRequestArrayPayload';
  values: Array<FreeRequestPayload>;
};

export type FreeRequestPayload = {
  __typename?: 'FreeRequestPayload';
  patientNote?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type FreeServicesRequest = Node & PatientRequestInterface & {
  __typename?: 'FreeServicesRequest';
  _id: Scalars['ID']['output'];
  action: PatientRequestAction;
  createdAt: Scalars['Timestamp']['output'];
  deleteReason?: Maybe<DeleteReason>;
  deleteReasonNote?: Maybe<Scalars['String']['output']>;
  doctor: User;
  internalNote?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteToPatient?: Maybe<Scalars['String']['output']>;
  noteToPatientAttachment?: Maybe<Document>;
  patient: User;
  payload: FreeRequestArrayPayload;
  processingDate?: Maybe<Scalars['Timestamp']['output']>;
  /** @deprecated Use relatedPrescriptions instead */
  relatedPrescription?: Maybe<Prescription>;
  relatedPrescriptions?: Maybe<Array<Prescription>>;
  requestedBy?: Maybe<User>;
  requestedByAI?: Maybe<Scalars['Boolean']['output']>;
  status: PatientRequestStatus;
  type: PatientRequestType;
};

export type FreenetAuthProvider = Node & {
  __typename?: 'FreenetAuthProvider';
  _id: Scalars['ID']['output'];
  authUrl: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  endpointOverrides?: Maybe<FreenetEndpointOverrides>;
  isCompliant: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
  providerClientId: Scalars['String']['output'];
  providerClientSecret: Scalars['String']['output'];
};

export type FreenetAuthProviderInput = {
  authUrl: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  endpointOverrides: FreenetEndpointOverridesInput;
  isCompliant: Scalars['Boolean']['input'];
  provider: Scalars['String']['input'];
  providerClientId: Scalars['String']['input'];
  providerClientSecret: Scalars['String']['input'];
};

export type FreenetAuthUser = Node & {
  __typename?: 'FreenetAuthUser';
  _id: Scalars['ID']['output'];
  authorizedDoctorName: Scalars['String']['output'];
  authorizedDoctorSurname: Scalars['String']['output'];
  doctors: Array<Scalars['String']['output']>;
  excludedPatients?: Maybe<Array<Scalars['String']['output']>>;
  provider: Scalars['String']['output'];
  user: User;
};

export type FreenetAuthUserInput = {
  authorizedDoctorName: Scalars['String']['input'];
  authorizedDoctorSurname: Scalars['String']['input'];
  doctors: Array<Scalars['String']['input']>;
  excludedPatients: Array<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  user: Scalars['ObjectId']['input'];
};

export type FreenetEndpointOverrides = {
  __typename?: 'FreenetEndpointOverrides';
  caricapaziente?: Maybe<Scalars['String']['output']>;
  cercapaziente?: Maybe<Scalars['String']['output']>;
  salvapaziente?: Maybe<Scalars['String']['output']>;
};

export type FreenetEndpointOverridesInput = {
  caricapaziente: Scalars['String']['input'];
  cercapaziente: Scalars['String']['input'];
  salvapaziente: Scalars['String']['input'];
};

export type FreenetExportPatientsInput = {
  doctorTaxCode: Scalars['String']['input'];
  /** Freenet patient identifier obtained from the `pendingPatients` query */
  patientId: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};

export type FreenetId = {
  __typename?: 'FreenetId';
  doctorTaxCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

export type FreenetImportPatientsInput = {
  doctorTaxCode: Scalars['String']['input'];
  /** Freenet patient identifier obtained from the `searchPatient` query */
  id: Scalars['String']['input'];
  patientTaxCode: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};

export enum FrequencyMonitoring {
  BiWeekOne = 'BI_WEEK_ONE',
  DayOne = 'DAY_ONE',
  DayTwo = 'DAY_TWO',
  MonthOne = 'MONTH_ONE',
  ThreeTimeWeekOne = 'THREE_TIME_WEEK_ONE',
  TwoTimeWeekOne = 'TWO_TIME_WEEK_ONE',
  WeekOne = 'WEEK_ONE'
}

export type GeneratePssCda2DocumentInput = {
  patientSummaryId: Scalars['ID']['input'];
};

export type GeneratePssCda2DocumentResult = {
  __typename?: 'GeneratePssCda2DocumentResult';
  cda2Document: Scalars['String']['output'];
  cda2Version: Scalars['String']['output'];
};

export type GeneratePssDocumentsForFseInput = {
  patientSummaryId: Scalars['ID']['input'];
};

export type GeneratePssDocumentsForFseResult = {
  __typename?: 'GeneratePssDocumentsForFseResult';
  cda2Xml: Scalars['String']['output'];
  pdfBase64: Scalars['String']['output'];
};

export type GeolocInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type Geolocalization = {
  __typename?: 'Geolocalization';
  coordinates?: Maybe<Array<Scalars['Float']['output']>>;
  type: Scalars['String']['output'];
};

export type GetAnnualRecurringRevenueReturn = {
  __typename?: 'GetAnnualRecurringRevenueReturn';
  actualRevenue: Scalars['Float']['output'];
  actualRevenueWithVat: Scalars['Float']['output'];
  projectedRevenue: Scalars['Float']['output'];
  projectedRevenueWithVat: Scalars['Float']['output'];
};

export type GetCatalogueCodeInput = {
  loincs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetCatalogueCodeResponse = {
  __typename?: 'GetCatalogueCodeResponse';
  loincCatalogueMap?: Maybe<Array<Maybe<LoincCatalogueType>>>;
};

export type GetInvoicesReturn = ComplexQueryReturn & {
  __typename?: 'GetInvoicesReturn';
  nodes?: Maybe<Array<SubscriptionPlanUser>>;
  pageInfo: PageInfo;
};

export type GetMedicalDocumentInput = {
  assistedTaxCode?: InputMaybe<Array<MultiregionAssistedTaxCode>>;
  documentId: Scalars['String']['input'];
  documentType?: InputMaybe<MultiregionDocumentType>;
  operationalContext?: InputMaybe<MultiregionOperationalContext>;
  organizationDescription?: InputMaybe<MultiregionOrganizationId>;
  organizationIdDoc?: InputMaybe<Scalars['String']['input']>;
  patientTaxCode: Scalars['String']['input'];
  repositoryId?: InputMaybe<Scalars['String']['input']>;
  takenInCharge?: InputMaybe<Scalars['Boolean']['input']>;
  userRole?: InputMaybe<MultiregionUserRole>;
  userStructure?: InputMaybe<Scalars['String']['input']>;
};

export type GetMedicalDocumentResponse = {
  __typename?: 'GetMedicalDocumentResponse';
  sissReport?: Maybe<SissReport>;
};

export type GetMedicalDocumentsInput = {
  assistedIdDoc?: InputMaybe<Scalars['String']['input']>;
  assistedTaxCode?: InputMaybe<Array<MultiregionAssistedTaxCode>>;
  documentId?: InputMaybe<Array<Scalars['String']['input']>>;
  documentKind?: InputMaybe<Array<MultiregionDocumentType>>;
  documentState?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<MultiregionDocumentType>;
  from?: InputMaybe<Scalars['Timestamp']['input']>;
  operationalContext: MultiregionOperationalContext;
  organizationDescription?: InputMaybe<MultiregionOrganizationId>;
  patientTaxCode: Scalars['String']['input'];
  requestOptions?: InputMaybe<Array<RequestOptions>>;
  responseOptions?: InputMaybe<Scalars['String']['input']>;
  takenInCharge: Scalars['Boolean']['input'];
  to?: InputMaybe<Scalars['Timestamp']['input']>;
  userRole?: InputMaybe<MultiregionUserRole>;
  userStructure?: InputMaybe<Scalars['String']['input']>;
};

export type GetPlanInfoFromTaxCodeResponse = {
  __typename?: 'GetPlanInfoFromTaxCodeResponse';
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  trialEndDate: Scalars['String']['output'];
  trialMonths: Scalars['Int']['output'];
  usedMonths: Scalars['Int']['output'];
};

export type GetPresignedUrlForUploadResponse = {
  __typename?: 'GetPresignedUrlForUploadResponse';
  documentId: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type GetRegionalAddressesOpts = {
  region?: InputMaybe<Region>;
  type?: InputMaybe<RegionalStructureTypes>;
};

export type GetSantagostinoSettingsResponse = {
  __typename?: 'GetSantagostinoSettingsResponse';
  settings?: Maybe<SantagostinoSettings>;
};

export type GetStripeSubscriptionReturn = {
  __typename?: 'GetStripeSubscriptionReturn';
  billingAddress?: Maybe<StructuredAddress>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  subscriptionData: SubscriptionPlanUserStripeData;
};

export type GetStructuredReportInput = {
  medicalDocumentId: Scalars['ID']['input'];
};

export type GetStructuredReportMeasurement = {
  __typename?: 'GetStructuredReportMeasurement';
  catalogueCode?: Maybe<Scalars['String']['output']>;
  components?: Maybe<Array<Maybe<GetStructuredReportMeasurementEntry>>>;
  loinc?: Maybe<Scalars['String']['output']>;
};

export type GetStructuredReportMeasurementEntry = {
  __typename?: 'GetStructuredReportMeasurementEntry';
  catalogueCode?: Maybe<Scalars['String']['output']>;
  loincCode?: Maybe<Scalars['String']['output']>;
  maxValue?: Maybe<Scalars['String']['output']>;
  minValue?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type GetStructuredReportOutput = {
  __typename?: 'GetStructuredReportOutput';
  identifier?: Maybe<Scalars['String']['output']>;
  measurements: Array<Maybe<GetStructuredReportMeasurement>>;
};

export type GetUsedNresOutput = {
  __typename?: 'GetUsedNresOutput';
  lot?: Maybe<Scalars['String']['output']>;
  nre: Scalars['String']['output'];
  prescriptionDate?: Maybe<Scalars['UnsignedInt']['output']>;
  prescriptionType?: Maybe<NrePrescriptionType>;
  taxCodeUser?: Maybe<Scalars['String']['output']>;
};

export type GroupOutpatientService = {
  __typename?: 'GroupOutpatientService';
  outpatientService: OutpatientService;
  periodicity: Scalars['UnsignedInt']['output'];
  quantity?: Maybe<Scalars['UnsignedInt']['output']>;
};

export type GroupOutpatientServiceInput = {
  categoryCode: Scalars['String']['input'];
  outpatientServiceCode: Scalars['String']['input'];
  periodicity: Scalars['UnsignedInt']['input'];
  quantity?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export enum GroupedDiaryType {
  AutomaticallyGenerated = 'AutomaticallyGenerated',
  HomeVisit = 'HomeVisit',
  MedicalDocument = 'MedicalDocument',
  Other = 'Other',
  StudioVisit = 'StudioVisit',
  TelephoneContact = 'TelephoneContact'
}

export type HasPrescriptionsResult = {
  __typename?: 'HasPrescriptionsResult';
  result: Scalars['Boolean']['output'];
};

export type HasValidNresOutput = {
  __typename?: 'HasValidNresOutput';
  forDemPrescriptions: Scalars['Boolean']['output'];
  forRedPrescriptions: Scalars['Boolean']['output'];
};

export enum HealthlineState {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  EndedByDoctor = 'ENDED_BY_DOCTOR'
}

export type HealthlineUpdateStateMessage = {
  __typename?: 'HealthlineUpdateStateMessage';
  newState?: Maybe<HealthlineState>;
};

export enum HemorragicRiskFactors {
  Alcoholism = 'ALCOHOLISM',
  Anemia = 'ANEMIA',
  Dialysis = 'DIALYSIS',
  Fans = 'FANS',
  GeneticFactors = 'GENETIC_FACTORS',
  GrowthDifferentiationFactor15 = 'GROWTH_DIFFERENTIATION_FACTOR15',
  HighTroponinLevels = 'HIGH_TROPONIN_LEVELS',
  KidneyFailure = 'KIDNEY_FAILURE',
  LiverCirrhosis = 'LIVER_CIRRHOSIS',
  LiverFailure = 'LIVER_FAILURE',
  MajorBleeding = 'MAJOR_BLEEDING',
  MoreThan65Years = 'MORE_THAN65_YEARS',
  Noone = 'NOONE',
  Other = 'OTHER',
  Stroke = 'STROKE',
  Thrombocytopathy = 'THROMBOCYTOPATHY',
  TtrLess60OrInrUnstable = 'TTR_LESS60_OR_INR_UNSTABLE',
  Tumors = 'TUMORS',
  UncontrolledHighBloodPressure = 'UNCONTROLLED_HIGH_BLOOD_PRESSURE'
}

export type HistoricalUserParamsResult = {
  __typename?: 'HistoricalUserParamsResult';
  nodes?: Maybe<Array<UserParam>>;
  pageInfo: PageInfo;
};

export type HomeVisit = {
  __typename?: 'HomeVisit';
  address?: Maybe<Scalars['String']['output']>;
  cap?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
};

export type HomeVisitInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cap?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  isHomeVisit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HospitalAdmissionForm = Node & {
  __typename?: 'HospitalAdmissionForm';
  _id: Scalars['ID']['output'];
  advanceNoticeBeforeDischarge?: Maybe<Scalars['Boolean']['output']>;
  alcohol?: Maybe<HospitalizationLifestyleParam>;
  alcoholNotes?: Maybe<HospitalizationStringParam>;
  allergies?: Maybe<Array<HospitalizationStringParam>>;
  availabilityWithPhoneAgreement?: Maybe<Scalars['Boolean']['output']>;
  bloodType?: Maybe<HospitalizationLifestyleParam>;
  bodyHeight?: Maybe<HospitalizationStringParam>;
  bodyWeight?: Maybe<HospitalizationStringParam>;
  celiacDiseaseIssues?: Maybe<Array<HospitalizationStringParam>>;
  chronicDrugs?: Maybe<Array<LastDrugPrescription>>;
  chronicServices?: Maybe<Array<LastServicePrescription>>;
  date: Scalars['Timestamp']['output'];
  detailedClinicalReportRequest?: Maybe<Scalars['Boolean']['output']>;
  drugAddiction?: Maybe<HospitalizationStringParam>;
  hospitalWard?: Maybe<Scalars['String']['output']>;
  intolerances?: Maybe<Array<HospitalizationStringParam>>;
  lifestyleNotes?: Maybe<HospitalizationStringParam>;
  medicalDevices?: Maybe<Array<HospitalizationStringParam>>;
  medicalRecordsNotes?: Maybe<Scalars['String']['output']>;
  missingOrgans?: Maybe<Array<HospitalizationStringParam>>;
  notSelfSufficiencies?: Maybe<HospitalizationStringParam>;
  ordinaryDrugs?: Maybe<Array<LastDrugPrescription>>;
  ordinaryServices?: Maybe<Array<LastServicePrescription>>;
  owner: User;
  patient: User;
  pregnancy?: Maybe<HospitalizationStringParam>;
  prescriptionNotes?: Maybe<Scalars['String']['output']>;
  problemNotes?: Maybe<Scalars['String']['output']>;
  problems?: Maybe<Array<HospitalizationProblem>>;
  professions?: Maybe<Array<HospitalizationStringParam>>;
  prosthesis?: Maybe<Array<HospitalizationStringParam>>;
  reasonForHospitalization: Scalars['String']['output'];
  smoke?: Maybe<HospitalizationLifestyleParam>;
  smokeNotes?: Maybe<HospitalizationStringParam>;
  sportActivity?: Maybe<HospitalizationLifestyleParam>;
  sportActivityNotes?: Maybe<HospitalizationStringParam>;
  surgicalProcedures?: Maybe<Array<HospitalizationStringParam>>;
  textualDiagnosis?: Maybe<Scalars['String']['output']>;
  transplants?: Maybe<Array<HospitalizationStringParam>>;
};

export type HospitalAdmissionFormInput = {
  advanceNoticeBeforeDischarge?: InputMaybe<Scalars['Boolean']['input']>;
  alcohol?: InputMaybe<HospitalizationLifestyleParamInput>;
  alcoholNotes?: InputMaybe<HospitalizationStringParamInput>;
  allergies?: InputMaybe<Array<HospitalizationStringParamInput>>;
  availabilityWithPhoneAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  bloodType?: InputMaybe<HospitalizationLifestyleParamInput>;
  bodyHeight?: InputMaybe<HospitalizationStringParamInput>;
  bodyWeight?: InputMaybe<HospitalizationStringParamInput>;
  celiacDiseaseIssues?: InputMaybe<Array<HospitalizationStringParamInput>>;
  chronicDrugs?: InputMaybe<Array<LastDrugPrescriptionInput>>;
  chronicServices?: InputMaybe<Array<LastServicePrescriptionInput>>;
  detailedClinicalReportRequest?: InputMaybe<Scalars['Boolean']['input']>;
  drugAddiction?: InputMaybe<HospitalizationStringParamInput>;
  hospitalWard?: InputMaybe<Scalars['String']['input']>;
  intolerances?: InputMaybe<Array<HospitalizationStringParamInput>>;
  lifestyleNotes?: InputMaybe<HospitalizationStringParamInput>;
  medicalDevices?: InputMaybe<Array<HospitalizationStringParamInput>>;
  medicalRecordsNotes?: InputMaybe<Scalars['String']['input']>;
  missingOrgans?: InputMaybe<Array<HospitalizationStringParamInput>>;
  notSelfSufficiencies?: InputMaybe<HospitalizationStringParamInput>;
  ordinaryDrugs?: InputMaybe<Array<LastDrugPrescriptionInput>>;
  ordinaryServices?: InputMaybe<Array<LastServicePrescriptionInput>>;
  pregnancy?: InputMaybe<HospitalizationStringParamInput>;
  prescriptionId?: InputMaybe<Scalars['String']['input']>;
  prescriptionNotes?: InputMaybe<Scalars['String']['input']>;
  problemNotes?: InputMaybe<Scalars['String']['input']>;
  problems?: InputMaybe<Array<HospitalizationProblemInput>>;
  professions?: InputMaybe<Array<HospitalizationStringParamInput>>;
  prosthesis?: InputMaybe<Array<HospitalizationStringParamInput>>;
  reasonForHospitalization: Scalars['String']['input'];
  smoke?: InputMaybe<HospitalizationLifestyleParamInput>;
  smokeNotes?: InputMaybe<HospitalizationStringParamInput>;
  sportActivity?: InputMaybe<HospitalizationLifestyleParamInput>;
  sportActivityNotes?: InputMaybe<HospitalizationStringParamInput>;
  surgicalProcedures?: InputMaybe<Array<HospitalizationStringParamInput>>;
  textualDiagnosis?: InputMaybe<Scalars['String']['input']>;
  transplants?: InputMaybe<Array<HospitalizationStringParamInput>>;
};

export type HospitalAdmissionFormsResult = ComplexQueryReturn & {
  __typename?: 'HospitalAdmissionFormsResult';
  nodes: Array<HospitalAdmissionForm>;
  pageInfo: PageInfo;
};

export type HospitalizationLifestyleParam = {
  __typename?: 'HospitalizationLifestyleParam';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  text: LifestyleInformationValue;
  userParamName: Scalars['String']['output'];
};

export type HospitalizationLifestyleParamInput = {
  _id: Scalars['ID']['input'];
  checked: Scalars['Boolean']['input'];
  text: LifestyleInformationValue;
  userParamName: Scalars['String']['input'];
};

export type HospitalizationPrescription = BasicPrescription & Node & {
  __typename?: 'HospitalizationPrescription';
  _id: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy?: Maybe<User>;
  creationMode: CreationMode;
  darkeningReason?: Maybe<DarkeningReason>;
  date: Scalars['Timestamp']['output'];
  doctorData?: Maybe<DoctorData>;
  downgradeReasons?: Maybe<Array<DowngradeReasons>>;
  enlistingIdPai?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  exceptions?: Maybe<Array<Exceptions>>;
  exemption?: Maybe<Exemption>;
  exemptionForPrint?: Maybe<Scalars['String']['output']>;
  flagOther?: Maybe<Scalars['Boolean']['output']>;
  hospitalAdmissionForm?: Maybe<HospitalAdmissionForm>;
  hospitalizationWard?: Maybe<Scalars['String']['output']>;
  incomeSelfCertificationNumber?: Maybe<Scalars['String']['output']>;
  iupCode?: Maybe<Scalars['String']['output']>;
  mefCode?: Maybe<Scalars['String']['output']>;
  owner: User;
  paiLotNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  patient: User;
  personalDataSiss?: Maybe<PersonalDataSiss>;
  pinNrbe?: Maybe<Scalars['String']['output']>;
  prescriptionCode?: Maybe<Scalars['String']['output']>;
  printPdf?: Maybe<Document>;
  processingDate?: Maybe<Scalars['Timestamp']['output']>;
  progressiveNumber: Scalars['UnsignedInt']['output'];
  reasonForHospitalization: Scalars['String']['output'];
  regionalCodedMotivation?: Maybe<OptionType>;
  regionalCommunication?: Maybe<Array<Maybe<PrescriptionRegionalCommunication>>>;
  regionalOptions?: Maybe<PrescriptionRegionalOptions>;
  regionalStatus?: Maybe<RegionalPrescriptionStatus>;
  relatedRequests?: Maybe<Array<PatientRequestInstance>>;
  showPatientInformation?: Maybe<ShowPatientInformation>;
  sissCounterPai?: Maybe<Scalars['String']['output']>;
  /** @deprecated use regionalStatus */
  sissPrescriptionStatus?: Maybe<SissPrescriptionStatus>;
  status: PrescriptionStatus;
  suggested?: Maybe<Scalars['Boolean']['output']>;
  suggestedCode?: Maybe<Scalars['String']['output']>;
  textualDiagnosis?: Maybe<Scalars['String']['output']>;
  textualHospitalAdmissionForm?: Maybe<Scalars['String']['output']>;
  therapeuticPlanCode?: Maybe<Scalars['String']['output']>;
  type: PrescriptionType;
  urgency?: Maybe<Scalars['Boolean']['output']>;
  withdrawalData?: Maybe<Array<WithdrawalData>>;
};

export type HospitalizationProblem = {
  __typename?: 'HospitalizationProblem';
  checked: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  problemCode?: Maybe<Scalars['String']['output']>;
  problemText?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Timestamp']['output']>;
  status?: Maybe<PatientProblemStatus>;
};

export type HospitalizationProblemInput = {
  checked: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  problemCode?: InputMaybe<Scalars['String']['input']>;
  problemText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<PatientProblemStatus>;
};

export type HospitalizationStringParam = {
  __typename?: 'HospitalizationStringParam';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  userParamName: Scalars['String']['output'];
};

export type HospitalizationStringParamInput = {
  _id: Scalars['ID']['input'];
  checked: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
  userParamName: Scalars['String']['input'];
};

/** Generic type for id+text pairs used across vaccination data. */
export type IdText = {
  __typename?: 'IdText';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/** Generic input for id+text pairs used across vaccination data. */
export type IdTextInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type IdentificaCittadinoV2Result = {
  __typename?: 'IdentificaCittadinoV2Result';
  alExemptions?: Maybe<Array<ExemptionsPayload>>;
  alPersonalDataSiss?: Maybe<PersonalDataSiss>;
  sissExemptions?: Maybe<Array<ExemptionsPayload>>;
  sissPersonalDataSiss?: Maybe<PersonalDataSiss>;
};

export enum IdentityType {
  Passport = 'PASSPORT',
  ProfileCiBack = 'PROFILE_CI_BACK',
  ProfileCiFront = 'PROFILE_CI_FRONT'
}

export type IdentityValidationDocument = {
  __typename?: 'IdentityValidationDocument';
  gcStoragePath: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: IdentityType;
};

export type IdentityValidationPageResponse = {
  __typename?: 'IdentityValidationPageResponse';
  count: Scalars['Int']['output'];
  results: Array<IdentityValidationResponse>;
};

export type IdentityValidationPatient = {
  __typename?: 'IdentityValidationPatient';
  birthdate?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Sex>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  surname: Scalars['String']['output'];
  taxCode?: Maybe<Scalars['String']['output']>;
};

export type IdentityValidationResponse = {
  __typename?: 'IdentityValidationResponse';
  blockedMessage?: Maybe<Scalars['String']['output']>;
  documents: Array<IdentityValidationDocument>;
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  patient: IdentityValidationPatient;
  status: IdentityValidationStatus;
  updatedAt: Scalars['Date']['output'];
  usernames: Array<Scalars['String']['output']>;
};

export type IdentityValidationSignedDocument = {
  __typename?: 'IdentityValidationSignedDocument';
  id: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  type: IdentityType;
};

export enum IdentityValidationStatus {
  AutomaticVerified = 'AUTOMATIC_VERIFIED',
  Blocked = 'BLOCKED',
  NotVerified = 'NOT_VERIFIED',
  Verified = 'VERIFIED'
}

export type IdentityValidationWithSignedUrl = {
  __typename?: 'IdentityValidationWithSignedUrl';
  blockedMessage?: Maybe<Scalars['String']['output']>;
  documents: Array<IdentityValidationSignedDocument>;
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  patient: IdentityValidationPatient;
  status: IdentityValidationStatus;
  usernames: Array<Scalars['String']['output']>;
};

export type ImportContactAnagraphicsCsvInputSettings = {
  archiveUserNotInTheCsv?: InputMaybe<Scalars['Boolean']['input']>;
  smsSettings: WelcomeSmsSettingsInput;
  treatmentDataApproval?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportFromSissCsvInputSettings = {
  archiveUserNotInTheCsv?: InputMaybe<Scalars['Boolean']['input']>;
  treatmentDataApproval?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportInfo = {
  __typename?: 'ImportInfo';
  importId?: Maybe<Scalars['ObjectId']['output']>;
  importedFromFreenet?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportPaiDataInput = {
  alcohol?: InputMaybe<Scalars['String']['input']>;
  allergies?: InputMaybe<Array<AllergiesInput>>;
  chronicDrugs?: InputMaybe<Array<DrugParamInput>>;
  chronicOutpatients?: InputMaybe<Array<OutpatientServiceParamInput>>;
  exemptions?: InputMaybe<Array<ExemptionsInput>>;
  problems?: InputMaybe<Array<PaiProblemInput>>;
  smoke?: InputMaybe<Scalars['String']['input']>;
  sportActivity?: InputMaybe<Scalars['String']['input']>;
  vaccinationServices?: InputMaybe<Array<SimpleServicesInput>>;
};

export type ImportPatientFromSissCsvResponse = {
  __typename?: 'ImportPatientFromSissCsvResponse';
  status: Scalars['Boolean']['output'];
};

export type ImportPatientsForAmtInputSettings = {
  archivePrevious: Scalars['Boolean']['input'];
  doctorId: Scalars['ObjectId']['input'];
  separator: Scalars['String']['input'];
};

export type ImportedUserNote = {
  __typename?: 'ImportedUserNote';
  _id: Scalars['ID']['output'];
  createdBy?: Maybe<User>;
  date: Scalars['Timestamp']['output'];
  importInfo?: Maybe<ImportInfo>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  notes: Scalars['String']['output'];
  parameter: ImportedUserNoteParameter;
  patient: User;
};

export enum ImportedUserNoteParameter {
  AlcoholNotes = 'ALCOHOL_NOTES',
  BloodTypeNotes = 'BLOOD_TYPE_NOTES',
  DrugAddictionNotes = 'DRUG_ADDICTION_NOTES',
  FertilityNotes = 'FERTILITY_NOTES',
  ManualExemptionsNotes = 'MANUAL_EXEMPTIONS_NOTES',
  MedicalDevicesNotes = 'MEDICAL_DEVICES_NOTES',
  MethodologiesNotes = 'METHODOLOGIES_NOTES',
  MotorCapacityNotes = 'MOTOR_CAPACITY_NOTES',
  OrdinaryPrescribedOutpatientServicesNotes = 'ORDINARY_PRESCRIBED_OUTPATIENT_SERVICES_NOTES',
  PastVaccinationsNotes = 'PAST_VACCINATIONS_NOTES',
  PregnanciesNotes = 'PREGNANCIES_NOTES',
  PrescribedOutpatientServicesNotes = 'PRESCRIBED_OUTPATIENT_SERVICES_NOTES',
  ProblemNotes = 'PROBLEM_NOTES',
  ProsthesisNotes = 'PROSTHESIS_NOTES',
  SmokeNotes = 'SMOKE_NOTES',
  SportActivityNotes = 'SPORT_ACTIVITY_NOTES',
  SurgicalProceduresNotes = 'SURGICAL_PROCEDURES_NOTES',
  VaccinationsNotes = 'VACCINATIONS_NOTES'
}

export type InappWidgetSettings = {
  __typename?: 'InappWidgetSettings';
  caducyEnabled?: Maybe<Scalars['Boolean']['output']>;
  skiniveEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type InappWidgetSettingsInput = {
  caducyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  skiniveEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InclinicCreateReservationInput = {
  availabilitySlotId: Scalars['String']['input'];
  bookingInformations: BookingInformations;
  couponInformations?: InputMaybe<CouponInput>;
  homeVisitInformations: HomeVisitInput;
  isVideoConsultation: Scalars['Boolean']['input'];
  onBehalfOfInformations: OnBehalfOfInput;
  originalPrice: Scalars['Int']['input'];
  payedPrice: Scalars['Int']['input'];
  payment: UserInclinicPayment;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  reservationOrigin?: InputMaybe<ReservationOrigin>;
  specialityTemplateId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  userNewsletterEnabled: Scalars['Boolean']['input'];
  userPhone: Scalars['String']['input'];
  userSurname: Scalars['String']['input'];
  userTaxCode: Scalars['String']['input'];
  workgroupId?: InputMaybe<Scalars['String']['input']>;
};

export type InclinicCreateReservationResult = {
  __typename?: 'InclinicCreateReservationResult';
  error?: Maybe<InclinicError>;
  reservationCode?: Maybe<Scalars['String']['output']>;
  reservationSecret?: Maybe<Scalars['String']['output']>;
  reservationStatus?: Maybe<ReservationStatus>;
  result: Scalars['Boolean']['output'];
};

export type InclinicError = {
  __typename?: 'InclinicError';
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
};

export enum InclinicPayment {
  Deferred = 'DEFERRED',
  Online = 'ONLINE',
  Onsite = 'ONSITE'
}

export type InputNotification = {
  body: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type InputVerifyPrescription = {
  auth?: InputMaybe<RegionalSystemLogin>;
  idSession?: InputMaybe<Scalars['String']['input']>;
  prescriptionId: Scalars['ID']['input'];
};

export type InsertBillingInput = {
  auth?: InputMaybe<RegionalSystemLogin>;
  billing: BillingInput;
  doctor: Scalars['ID']['input'];
  isDraft: Scalars['Boolean']['input'];
  patient: Scalars['ID']['input'];
};

export type InsertBillingItemTemplateInput = {
  billing: BillingItemTemplateInput;
};

export type InsertTherapeuticPlanInput = {
  patientId: Scalars['ID']['input'];
  therapeuticPlans: Array<NewTherapeuticPlanInput>;
};

export enum InstructionPrescriptionType {
  Chronic = 'CHRONIC',
  Ordinary = 'ORDINARY'
}

export enum InstructionRequestType {
  MedicalDocument = 'MEDICAL_DOCUMENT',
  PrescriptionRequest = 'PRESCRIPTION_REQUEST',
  Reservation = 'RESERVATION'
}

export type IntolerancesArrayInput = {
  values?: InputMaybe<Array<IntolerancesInput>>;
};

export type IntolerancesArrayParam = Node & UserParamInterface & {
  __typename?: 'IntolerancesArrayParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: IntolerancesPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type IntolerancesInput = {
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  isLactoseIntolerance?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type IntolerancesPayload = {
  __typename?: 'IntolerancesPayload';
  date?: Maybe<Scalars['Timestamp']['output']>;
  isLactoseIntolerance?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type IntolerancesPayloadArray = {
  __typename?: 'IntolerancesPayloadArray';
  values?: Maybe<Array<IntolerancesPayload>>;
};

export type InviteInput = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  msg: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Float']['output'];
  conflictingInvoice?: Maybe<ConflictingInvoice>;
  dueDate: Scalars['Timestamp']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  issuedAt: Scalars['Timestamp']['output'];
  status: InvoiceStatus;
  type: InvoiceType;
  vat: Scalars['Float']['output'];
};

export type InvoiceInput = {
  amount: Scalars['Float']['input'];
  dueDate: Scalars['Timestamp']['input'];
  issuedAt: Scalars['Timestamp']['input'];
  status: InvoiceStatus;
  vat: Scalars['Float']['input'];
};

export type InvoiceOnlyId = {
  __typename?: 'InvoiceOnlyId';
  id: Scalars['String']['output'];
};

export enum InvoiceStatus {
  Outstanding = 'Outstanding',
  Overdue = 'Overdue',
  Paid = 'Paid',
  Processing = 'Processing',
  Projected = 'Projected'
}

export enum InvoiceType {
  Manual = 'Manual',
  Stripe = 'Stripe'
}

export type IsRegisteredResult = {
  __typename?: 'IsRegisteredResult';
  is: Scalars['Boolean']['output'];
};

export enum Language {
  Arabic = 'ARABIC',
  English = 'ENGLISH',
  French = 'FRENCH',
  German = 'GERMAN',
  Italian = 'ITALIAN',
  Spanish = 'SPANISH'
}

export enum LanguageApp {
  En = 'EN',
  It = 'IT'
}

export type LastDrugPrescription = {
  __typename?: 'LastDrugPrescription';
  checked: Scalars['Boolean']['output'];
  drugProductCode: Scalars['String']['output'];
  drugProductName?: Maybe<Scalars['String']['output']>;
  lastPrescriptionDate?: Maybe<Scalars['Timestamp']['output']>;
  posology?: Maybe<Scalars['String']['output']>;
};

export type LastDrugPrescriptionInput = {
  checked: Scalars['Boolean']['input'];
  drugProductCode: Scalars['String']['input'];
  drugProductName?: InputMaybe<Scalars['String']['input']>;
  lastPrescriptionDate?: InputMaybe<Scalars['Timestamp']['input']>;
  posology?: InputMaybe<Scalars['String']['input']>;
};

export type LastPaiResult = {
  __typename?: 'LastPaiResult';
  current?: Maybe<Pai>;
  differences?: Maybe<PaiDifferences>;
  requirementsCompletion: PaiRequirementsCompletion;
};

export type LastServicePrescription = {
  __typename?: 'LastServicePrescription';
  checked: Scalars['Boolean']['output'];
  lastPrescriptionDate?: Maybe<Scalars['Timestamp']['output']>;
  periodicity?: Maybe<Scalars['String']['output']>;
  serviceCode: Scalars['String']['output'];
  serviceName?: Maybe<Scalars['String']['output']>;
};

export type LastServicePrescriptionInput = {
  checked: Scalars['Boolean']['input'];
  lastPrescriptionDate?: InputMaybe<Scalars['Timestamp']['input']>;
  periodicity?: InputMaybe<Scalars['String']['input']>;
  serviceCode: Scalars['String']['input'];
  serviceName?: InputMaybe<Scalars['String']['input']>;
};

export type LastUserAccessInfo = Node & {
  __typename?: 'LastUserAccessInfo';
  _id: Scalars['ID']['output'];
  clientType: ClientType;
  clientVersion: Scalars['String']['output'];
  deviceType: Scalars['String']['output'];
  ipAddress: Scalars['String']['output'];
  lastAccess: Scalars['Timestamp']['output'];
  user?: Maybe<User>;
};

export type LastUserAccessInfoInput = {
  clientType: ClientType;
  clientVersion: Scalars['String']['input'];
  deviceType: Scalars['String']['input'];
};

export type LatestUserParams = {
  __typename?: 'LatestUserParams';
  _id: Scalars['ID']['output'];
  adiAccessi?: Maybe<NumberParam>;
  allergies?: Maybe<AllergiesParam>;
  altroServizio?: Maybe<StringParam>;
  appleEcg?: Maybe<AppleEcgParam>;
  bisogniSocialiSanitari?: Maybe<StringParam>;
  bloodDonor?: Maybe<BooleanParam>;
  calorie?: Maybe<NumberParam>;
  capacitaDiUsareTelefono?: Maybe<StringParam>;
  celiacDiseaseIssues?: Maybe<CeliacDiseaseIssuesArrayParam>;
  chronicDrugs?: Maybe<DrugsParam>;
  condizioniCliniche?: Maybe<StringArrayParam>;
  covidRapidTestResult?: Maybe<StringParam>;
  covidRapidTestResultTypeTwo?: Maybe<StringParam>;
  custodiaAccessi?: Maybe<NumberParam>;
  diabetesEverDiagnosed?: Maybe<BooleanParam>;
  drugAllergies?: Maybe<StringArrayParam>;
  esitoTampone?: Maybe<StringParam>;
  exemptions?: Maybe<ExemptionsParam>;
  facilitiesPreferences?: Maybe<StringArrayParam>;
  fertility?: Maybe<FertilityParam>;
  glutenAllergy?: Maybe<BooleanParam>;
  highGlycemicLevel?: Maybe<BooleanParam>;
  intolerances?: Maybe<IntolerancesArrayParam>;
  lactoseAllergy?: Maybe<BooleanParam>;
  lifestyleNotes?: Maybe<StringParam>;
  manualExemptions?: Maybe<ExemptionsParam>;
  methodologies?: Maybe<MethodologiesParam>;
  missingOrgans?: Maybe<StringPlusDateArrayParam>;
  monitoringNote?: Maybe<StringParam>;
  noDeclaredAllergies?: Maybe<BooleanParam>;
  /** @deprecated Use motorCapacity instead. This field is kept for backward compatibility only. */
  notSelfSufficiencies?: Maybe<StringParam>;
  ordinaryDrugs?: Maybe<DrugsParam>;
  ordinaryPrescribedOutpatientServices?: Maybe<OutpatientServicesParam>;
  passiGiornalieri?: Maybe<NumberParam>;
  pastVaccinations?: Maybe<VaccinationsParam>;
  pastiAccessi?: Maybe<NumberParam>;
  patientCardNote?: Maybe<StringParam>;
  patologie?: Maybe<StringArrayParam>;
  postIt?: Maybe<StringParam>;
  pregnancies?: Maybe<PregnanciesParam>;
  pregressoRicoveroOspedaliero?: Maybe<StringParam>;
  preparazioneTerapiaFarmacologica?: Maybe<StringParam>;
  prescribedOutpatientServices?: Maybe<OutpatientServicesParam>;
  presenzaCaregiver?: Maybe<StringParam>;
  pressureDrugsEverUsed?: Maybe<BooleanParam>;
  prestazioniAmbulatoriali?: Maybe<StringArrayParam>;
  prestazioniDomiciliari?: Maybe<StringArrayParam>;
  primaryDiseases?: Maybe<StringParam>;
  professions?: Maybe<ProfessionsParam>;
  prosthesis?: Maybe<ProsthesisParam>;
  reteInformaleAccessi?: Maybe<NumberParam>;
  riskLevel?: Maybe<StringParam>;
  sadAccessi?: Maybe<NumberParam>;
  scalaBrass?: Maybe<StringArrayParam>;
  scalaMorisky?: Maybe<MoriskyScaleParam>;
  secondaryDiseases?: Maybe<StringArrayParam>;
  signs?: Maybe<StringArrayParam>;
  signsNote?: Maybe<StringParam>;
  surgicalProcedures?: Maybe<SurgicalProceduresParam>;
  tampone1?: Maybe<StringParam>;
  tipoPaziente?: Maybe<StringParam>;
  transplants?: Maybe<StringPlusDateArrayParam>;
  user: User;
  vaccinations?: Maybe<VaccinationsParam>;
};

export type Lead = Node & {
  __typename?: 'Lead';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  region: Region;
  surname: Scalars['String']['output'];
};

export type LeadInput = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  region: Region;
  surname: Scalars['String']['input'];
};

export enum License {
  None = 'NONE',
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

export type LifestyleInformation = Node & {
  __typename?: 'LifestyleInformation';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  importInfo?: Maybe<ImportInfo>;
  note?: Maybe<Scalars['String']['output']>;
  patient: User;
  type: LifestyleInformationType;
  updatedAt: Scalars['Timestamp']['output'];
  value: LifestyleInformationValue;
};

export type LifestyleInformationInput = {
  date: Scalars['Timestamp']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  type: LifestyleInformationType;
  value: LifestyleInformationValue;
};

export type LifestyleInformationPssInput = {
  value?: InputMaybe<LifestyleInformationValue>;
};

export enum LifestyleInformationType {
  Alcohol = 'ALCOHOL',
  BloodType = 'BLOOD_TYPE',
  DrugAddiction = 'DRUG_ADDICTION',
  FruitAndVegetablesFrequency = 'FRUIT_AND_VEGETABLES_FREQUENCY',
  MotorCapacity = 'MOTOR_CAPACITY',
  Smoke = 'SMOKE',
  SportActivity = 'SPORT_ACTIVITY'
}

export enum LifestyleInformationValue {
  AlcoholAstemio = 'ALCOHOL_ASTEMIO',
  AlcoholHeavy = 'ALCOHOL_HEAVY',
  AlcoholLight = 'ALCOHOL_LIGHT',
  AlcoholModerate = 'ALCOHOL_MODERATE',
  BloodTypeAbNegative = 'BLOOD_TYPE_AB_NEGATIVE',
  BloodTypeAbPositive = 'BLOOD_TYPE_AB_POSITIVE',
  BloodTypeANegative = 'BLOOD_TYPE_A_NEGATIVE',
  BloodTypeAPositive = 'BLOOD_TYPE_A_POSITIVE',
  BloodTypeBNegative = 'BLOOD_TYPE_B_NEGATIVE',
  BloodTypeBPositive = 'BLOOD_TYPE_B_POSITIVE',
  BloodTypeONegative = 'BLOOD_TYPE_O_NEGATIVE',
  BloodTypeOPositive = 'BLOOD_TYPE_O_POSITIVE',
  DrugAddictionDepressing = 'DRUG_ADDICTION_DEPRESSING',
  DrugAddictionHallucinogenic = 'DRUG_ADDICTION_HALLUCINOGENIC',
  DrugAddictionNone = 'DRUG_ADDICTION_NONE',
  DrugAddictionOther = 'DRUG_ADDICTION_OTHER',
  DrugAddictionStimulant = 'DRUG_ADDICTION_STIMULANT',
  FruitAndVegetablesFrequencyHigh = 'FRUIT_AND_VEGETABLES_FREQUENCY_HIGH',
  FruitAndVegetablesFrequencyLow = 'FRUIT_AND_VEGETABLES_FREQUENCY_LOW',
  FruitAndVegetablesFrequencyMedium = 'FRUIT_AND_VEGETABLES_FREQUENCY_MEDIUM',
  MotorCapacityAllettato = 'MOTOR_CAPACITY_ALLETTATO',
  MotorCapacityAssisted = 'MOTOR_CAPACITY_ASSISTED',
  MotorCapacityAutonomo = 'MOTOR_CAPACITY_AUTONOMO',
  SmokeExOver_1 = 'SMOKE_EX_OVER_1',
  SmokeExOver_10 = 'SMOKE_EX_OVER_10',
  SmokeExUnder_1 = 'SMOKE_EX_UNDER_1',
  SmokeHeavy = 'SMOKE_HEAVY',
  SmokeModerate = 'SMOKE_MODERATE',
  SmokeNonSmoker = 'SMOKE_NON_SMOKER',
  SportActivityLight = 'SPORT_ACTIVITY_LIGHT',
  SportActivityRegular = 'SPORT_ACTIVITY_REGULAR',
  SportActivitySedentary = 'SPORT_ACTIVITY_SEDENTARY'
}

export type LifestyleInformationsResult = ComplexQueryReturn & {
  __typename?: 'LifestyleInformationsResult';
  nodes?: Maybe<Array<LifestyleInformation>>;
  pageInfo: PageInfo;
};

export type ListMultipartUploadResult = {
  __typename?: 'ListMultipartUploadResult';
  key?: Maybe<Scalars['String']['output']>;
  timeInSeconds?: Maybe<Scalars['UnsignedInt']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
};

export type LocationInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum LocationType {
  Clinic = 'CLINIC',
  Studio = 'STUDIO'
}

export type LogInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  log: Scalars['String']['input'];
  reservationId?: InputMaybe<Scalars['ID']['input']>;
  type: VideocallLogType;
  videoSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type LoincCatalogueType = {
  __typename?: 'LoincCatalogueType';
  catalogue?: Maybe<Scalars['String']['output']>;
  loinc?: Maybe<Scalars['String']['output']>;
};

export enum MacroSpeciality {
  Acupuncture = 'ACUPUNCTURE',
  AestheticMedicine = 'AESTHETIC_MEDICINE',
  Allergology = 'ALLERGOLOGY',
  Andrology = 'ANDROLOGY',
  Anesthesia = 'ANESTHESIA',
  Angiology = 'ANGIOLOGY',
  CardiacSurgery = 'CARDIAC_SURGERY',
  Cardiology = 'CARDIOLOGY',
  Chiropratic = 'CHIROPRATIC',
  ClinicalAnalysis = 'CLINICAL_ANALYSIS',
  Counselor = 'COUNSELOR',
  Default = 'DEFAULT',
  DefaultNurse = 'DEFAULT_NURSE',
  Dentistry = 'DENTISTRY',
  DermatologyAndVenereology = 'DERMATOLOGY_AND_VENEREOLOGY',
  Diagnostics = 'DIAGNOSTICS',
  Dietics = 'DIETICS',
  DiseasesOfTheCardiovascularSystem = 'DISEASES_OF_THE_CARDIOVASCULAR_SYSTEM',
  DiseasesOfTheDigestiveSystem = 'DISEASES_OF_THE_DIGESTIVE_SYSTEM',
  DiseasesOfTheRespiratorySystem = 'DISEASES_OF_THE_RESPIRATORY_SYSTEM',
  Ecography = 'ECOGRAPHY',
  EmergencyUrgencyMedicine = 'EMERGENCY_URGENCY_MEDICINE',
  EndocrinologyAndMetabolicDiseases = 'ENDOCRINOLOGY_AND_METABOLIC_DISEASES',
  ForensicMedicine = 'FORENSIC_MEDICINE',
  Gastroenterology = 'GASTROENTEROLOGY',
  GeneralMedicine = 'GENERAL_MEDICINE',
  GeneralSurgery = 'GENERAL_SURGERY',
  Genetics = 'GENETICS',
  Geriatrics = 'GERIATRICS',
  GynecologyAndObstetrics = 'GYNECOLOGY_AND_OBSTETRICS',
  Hematology = 'HEMATOLOGY',
  Homeopathy = 'HOMEOPATHY',
  HygieneAndPreventiveMedicine = 'HYGIENE_AND_PREVENTIVE_MEDICINE',
  Immunology = 'IMMUNOLOGY',
  InfectiousDiseaseAndTropicalDiseases = 'INFECTIOUS_DISEASE_AND_TROPICAL_DISEASES',
  InternalMedicine = 'INTERNAL_MEDICINE',
  Massotherapy = 'MASSOTHERAPY',
  MaxillofacialSurgery = 'MAXILLOFACIAL_SURGERY',
  Nephrology = 'NEPHROLOGY',
  NeurologicalRehabilitation = 'NEUROLOGICAL_REHABILITATION',
  Neurology = 'NEUROLOGY',
  Neuropsychiatry = 'NEUROPSYCHIATRY',
  NuclearMedicine = 'NUCLEAR_MEDICINE',
  Nursing = 'NURSING',
  Nutrition = 'NUTRITION',
  Obstetrics = 'OBSTETRICS',
  OccupationalMedicine = 'OCCUPATIONAL_MEDICINE',
  Oncology = 'ONCOLOGY',
  Ophthalmology = 'OPHTHALMOLOGY',
  OrthopedicsAndTraumatology = 'ORTHOPEDICS_AND_TRAUMATOLOGY',
  OrthopedicRehabilitation = 'ORTHOPEDIC_REHABILITATION',
  Orthoptistic = 'ORTHOPTISTIC',
  Osteopathy = 'OSTEOPATHY',
  Otolaryngology = 'OTOLARYNGOLOGY',
  PainTherapy = 'PAIN_THERAPY',
  Pediatrics = 'PEDIATRICS',
  PediatricOrthopedics = 'PEDIATRIC_ORTHOPEDICS',
  PediatricSurgery = 'PEDIATRIC_SURGERY',
  PharmaceuticalSciences = 'PHARMACEUTICAL_SCIENCES',
  Physiatry = 'PHYSIATRY',
  Physiotherapy = 'PHYSIOTHERAPY',
  PlasticSurgery = 'PLASTIC_SURGERY',
  Pmg = 'PMG',
  Pneumology = 'PNEUMOLOGY',
  Podiatry = 'PODIATRY',
  Prevention = 'PREVENTION',
  Proctology = 'PROCTOLOGY',
  Psychiatry = 'PSYCHIATRY',
  Psychology = 'PSYCHOLOGY',
  Radiology = 'RADIOLOGY',
  Rheumatology = 'RHEUMATOLOGY',
  Senology = 'SENOLOGY',
  Sexology = 'SEXOLOGY',
  SpeechTherapy = 'SPEECH_THERAPY',
  SportsMedicine = 'SPORTS_MEDICINE',
  SportPerformanceRehabilitation = 'SPORT_PERFORMANCE_REHABILITATION',
  ThermalMedicine = 'THERMAL_MEDICINE',
  ThoracicSurgery = 'THORACIC_SURGERY',
  TumorsOfTheHeadAndNeck = 'TUMORS_OF_THE_HEAD_AND_NECK',
  Urology = 'UROLOGY'
}

export enum ManualDiaryType {
  HomeVisit = 'HomeVisit',
  Other = 'Other',
  StudioVisit = 'StudioVisit',
  TelephoneContact = 'TelephoneContact'
}

export type ManualMedicalReportAuthorInput = {
  codiceFiscale: Scalars['String']['input'];
  cognome?: InputMaybe<Scalars['String']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  ruolo?: InputMaybe<Scalars['String']['input']>;
};

export enum MarketabilityStatusEnum {
  Ricommercializzato = 'RICOMMERCIALIZZATO',
  RitiroDefinitivo = 'RITIRO_DEFINITIVO',
  VendibileFino = 'VENDIBILE_FINO'
}

export type MaybeAuthData = {
  __typename?: 'MaybeAuthData';
  auth: AutomaticAuthentication;
  refreshToken?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  tokenExpiration: Scalars['Int']['output'];
  user: User;
};

export type Measurement = Node & {
  __typename?: 'Measurement';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  importInfo?: Maybe<ImportInfo>;
  patient: User;
  type: MeasurementType;
  updatedAt: Scalars['Timestamp']['output'];
  value: Scalars['Float']['output'];
};

export type MeasurementInput = {
  date: Scalars['Timestamp']['input'];
  type: MeasurementType;
  value: Scalars['Float']['input'];
};

export enum MeasurementType {
  BodyHeight = 'BODY_HEIGHT',
  BodyWeight = 'BODY_WEIGHT',
  BreathRate = 'BREATH_RATE',
  Glycemia = 'GLYCEMIA',
  HeartRate = 'HEART_RATE',
  MaxPressure = 'MAX_PRESSURE',
  MinPressure = 'MIN_PRESSURE',
  OxygenSaturation = 'OXYGEN_SATURATION',
  Temperature = 'TEMPERATURE',
  WaistCircumference = 'WAIST_CIRCUMFERENCE'
}

export type MeasurementsResult = ComplexQueryReturn & {
  __typename?: 'MeasurementsResult';
  nodes?: Maybe<Array<Measurement>>;
  pageInfo: PageInfo;
};

export type MedeaReport = {
  __typename?: 'MedeaReport';
  annotazioni: Scalars['String']['output'];
  categoria_esame: Scalars['String']['output'];
  data_esame: Scalars['String']['output'];
  data_montaggio?: Maybe<Scalars['String']['output']>;
  data_refertazione: Scalars['String']['output'];
  data_richiesta: Scalars['String']['output'];
  data_smontaggio?: Maybe<Scalars['String']['output']>;
  diario_clinico?: Maybe<Scalars['String']['output']>;
  farmaci?: Maybe<Scalars['String']['output']>;
  file_referto: Scalars['String']['output'];
  healt_point?: Maybe<Scalars['String']['output']>;
  m_cognome?: Maybe<Scalars['String']['output']>;
  m_iscrizione_albo?: Maybe<Scalars['String']['output']>;
  m_nome?: Maybe<Scalars['String']['output']>;
  m_titolo?: Maybe<Scalars['String']['output']>;
  mailhp?: Maybe<Scalars['String']['output']>;
  motivo_esame?: Maybe<Scalars['String']['output']>;
  partita_iva?: Maybe<Scalars['String']['output']>;
  patologie?: Maybe<Scalars['String']['output']>;
  paziente_codice_fiscale: Scalars['String']['output'];
  paziente_cognome?: Maybe<Scalars['String']['output']>;
  paziente_data_nascita: Scalars['String']['output'];
  paziente_nome: Scalars['String']['output'];
  paziente_pmk?: Maybe<Scalars['String']['output']>;
  paziente_sesso: Scalars['String']['output'];
  ragione_sociale: Scalars['String']['output'];
  referto: Scalars['String']['output'];
  stato_esame: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type MedicalDevicesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  deviceDescription?: InputMaybe<Scalars['String']['input']>;
  plantDate?: InputMaybe<Scalars['Timestamp']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MedicalDevicesInputArray = {
  values?: InputMaybe<Array<MedicalDevicesInput>>;
};

export type MedicalDevicesPayload = {
  __typename?: 'MedicalDevicesPayload';
  category?: Maybe<Scalars['String']['output']>;
  deviceDescription?: Maybe<Scalars['String']['output']>;
  plantDate?: Maybe<Scalars['Timestamp']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MedicalDocumentSettings = {
  __typename?: 'MedicalDocumentSettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type MedicalDocumentSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MedicalInstruction = Node & {
  __typename?: 'MedicalInstruction';
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  afterAttachment?: Maybe<Document>;
  afterText?: Maybe<Scalars['String']['output']>;
  beforeAttachment?: Maybe<Document>;
  beforeText?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy: Scalars['ID']['output'];
  instructionRequestType: InstructionRequestType;
  prescriptionType?: Maybe<InstructionPrescriptionType>;
  specialityTemplates?: Maybe<Array<SpecialityTemplate>>;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
};

export type MedicalInstructionInput = {
  active: Scalars['Boolean']['input'];
  afterAttachment?: InputMaybe<Scalars['Upload']['input']>;
  afterText?: InputMaybe<Scalars['String']['input']>;
  beforeAttachment?: InputMaybe<Scalars['Upload']['input']>;
  beforeText?: InputMaybe<Scalars['String']['input']>;
  instructionRequestType: InstructionRequestType;
  prescriptionType?: InputMaybe<InstructionPrescriptionType>;
  specialityTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};

/**
 * Old Medical Report
 *
 *   Restored to make mobile APP calls compatible
 */
export type MedicalReport = Node & {
  __typename?: 'MedicalReport';
  _id: Scalars['ID']['output'];
  aggregationDocumentId: Scalars['String']['output'];
  /** davinci Fields */
  attributes?: Maybe<Array<Maybe<OptionType>>>;
  /**
   * other fields not used in this moment
   * storageStructure: StrutturaArchiviazione;
   * authorizingOperator?: OperatoreAutorizzante;
   * specificAttributes?: any;
   */
  author?: Maybe<AutoreDocumento>;
  availabilityNote?: Maybe<Scalars['String']['output']>;
  clinicCharacterizations?: Maybe<Array<ClinicCharacterization>>;
  creationStructure?: Maybe<StrutturaCreazione>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  discipline?: Maybe<Scalars['String']['output']>;
  disciplineName?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  documentTypeDesc: Scalars['String']['output'];
  documents?: Maybe<Array<Document>>;
  documentsSetId: Scalars['String']['output'];
  downloadBy: Scalars['ID']['output'];
  endDate?: Maybe<Scalars['Timestamp']['output']>;
  followUp?: Maybe<MedicalReportsFollowUp>;
  idLOINC?: Maybe<Scalars['String']['output']>;
  /** davinci Fields */
  internalNotes?: Maybe<Scalars['String']['output']>;
  internalNotesAuthor?: Maybe<User>;
  operationalContext?: Maybe<MultiregionOperationalContext>;
  pathologyNetwork?: Maybe<Scalars['String']['output']>;
  pathologyNetworkId?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<User>;
  patientNote?: Maybe<Scalars['String']['output']>;
  /** davinci Fields */
  read?: Maybe<Scalars['Boolean']['output']>;
  referenceDocumentId?: Maybe<Scalars['String']['output']>;
  referenceDocumentVersion?: Maybe<Scalars['String']['output']>;
  reportName?: Maybe<Scalars['String']['output']>;
  /** davinci Fields */
  sharedNotes?: Maybe<Scalars['String']['output']>;
  sissAttachments?: Maybe<Array<SissAttachment>>;
  sissCreationDate: Scalars['Timestamp']['output'];
  sissReport?: Maybe<SissReport>;
  source?: Maybe<MedicalReportsSourceType>;
  statusAuthorization?: Maybe<Scalars['String']['output']>;
  takenInCharge?: Maybe<Scalars['Boolean']['output']>;
  textualDiagnosis?: Maybe<Scalars['String']['output']>;
  updateMotivation?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
  versionNumber: Scalars['String']['output'];
};

export type MedicalReportAuthor = {
  __typename?: 'MedicalReportAuthor';
  name?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
};

export type MedicalReportAuthorInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
};

export type MedicalReportDocument = {
  __typename?: 'MedicalReportDocument';
  category: DocumentCategory;
  datiRefertoLaboratorio?: Maybe<DatiRefertoLaboratorio>;
  label?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MedicalReportDocumentType>;
  uploadedBy?: Maybe<User>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MedicalReportDocumentInput = {
  category: DocumentCategory;
  file?: InputMaybe<Scalars['Upload']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type: MedicalReportDocumentType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum MedicalReportDocumentType {
  Attachment = 'ATTACHMENT',
  Document = 'DOCUMENT'
}

export type MedicalReportDocumentUpload = {
  data: Scalars['String']['input'];
  uri: Scalars['String']['input'];
};

export type MedicalReportDocumentXmlRequest = {
  __typename?: 'MedicalReportDocumentXMLRequest';
  uri: Scalars['String']['output'];
  xml: Scalars['String']['output'];
};

export type MedicalReportV2 = Node & {
  __typename?: 'MedicalReportV2';
  _id: Scalars['ID']['output'];
  /**
   * [User/System field] Medical report's metadata:
   * It is an array of record key/value
   */
  attributes?: Maybe<Array<Maybe<OptionType>>>;
  /** [System field] Who wrote the medical report */
  author?: Maybe<MedicalReportAuthor>;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  creationDate: Scalars['Timestamp']['output'];
  /** [System field] Structure that emitted the medical report */
  creationStructure?: Maybe<Scalars['String']['output']>;
  /** [User field] Flag to soft delete */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** [System field] Discipline of the medical report */
  discipline?: Maybe<Scalars['String']['output']>;
  disciplineName?: Maybe<Scalars['String']['output']>;
  /** [System field] Document type */
  documentType: Scalars['String']['output'];
  /** [System field] Document type description */
  documentTypeDesc: Scalars['String']['output'];
  /**
   * [User/System field] documents is an array of medical report's document.
   * Each element contains information about the location of document and other metadata
   */
  documents?: Maybe<Array<Maybe<MedicalReportDocument>>>;
  /** [System field] Indicates who downloaded the medical report */
  downloadBy?: Maybe<User>;
  followUp?: Maybe<MedicalReportsFollowUp>;
  /** [System field] Medical report unique identifier */
  identifier: Scalars['String']['output'];
  importDate?: Maybe<Scalars['Timestamp']['output']>;
  /** [System field] If imported, indicates the source and the import date of the report */
  importSource?: Maybe<DataImportTemplates>;
  /** [System field] If imported, indicates the pai imported from the report */
  importedPai?: Maybe<Pai>;
  /** [Doctor field] Doctor's notes cannot be shared */
  internalNotes?: Maybe<Scalars['String']['output']>;
  internalNotesAuthor?: Maybe<User>;
  /** [User field] Indicates if the overall status of the medical report */
  interpretation?: Maybe<OutpatientServiceOutcomeInterpretation>;
  isTranscribedByAI?: Maybe<Scalars['Boolean']['output']>;
  operationalContext?: Maybe<MultiregionOperationalContext>;
  /** [System field] Indicates who is the medical report's patient */
  patient?: Maybe<User>;
  /** [Patient field] Patient additional notes */
  patientNotes?: Maybe<Scalars['String']['output']>;
  /** [User field] Flag to indicate whether a document has been read */
  read: Scalars['Boolean']['output'];
  /** [System field] Report name */
  reportName?: Maybe<Scalars['String']['output']>;
  /** [Doctor field] Doctor's notes can be shared with other user */
  sharedNotes?: Maybe<Scalars['String']['output']>;
  /**
   * [System field]
   * One of "FSE", "MANUAL" or "APP":
   * - FSE: imported from SE system
   * - MANUAL: Created by user
   * - APP: Created by patient
   */
  source?: Maybe<MedicalReportsSourceType>;
  takenInCharge?: Maybe<Scalars['Boolean']['output']>;
  /** [Doctor field] Medical report region */
  textualDiagnosis?: Maybe<Scalars['String']['output']>;
  /** [User field] Only when a medical report changed. Indicates the reason why the medical report was changed */
  updateMotivation?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
};

export enum MedicalReportsFollowUp {
  Appointment = 'APPOINTMENT',
  Duplicated = 'DUPLICATED',
  MissingInfo = 'MISSING_INFO',
  NoFollowUp = 'NO_FOLLOW_UP',
  NoNote = 'NO_NOTE',
  Other = 'OTHER',
  Unreadable = 'UNREADABLE'
}

export type MedicalReportsInput = {
  author: ManualMedicalReportAuthorInput;
  documents?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['Timestamp']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  patientNote?: InputMaybe<Scalars['String']['input']>;
  reportName: Scalars['String']['input'];
  source: MedicalReportsSourceType;
};

export type MedicalReportsReturn = ComplexQueryReturn & {
  __typename?: 'MedicalReportsReturn';
  nodes?: Maybe<Array<MedicalReport>>;
  pageInfo: PageInfo;
};

export enum MedicalReportsSourceType {
  App = 'APP',
  Fse = 'FSE',
  Manual = 'MANUAL',
  Medea = 'MEDEA',
  Santagostino = 'SANTAGOSTINO'
}

export type MedicalReportsV2Return = ComplexQueryReturn & {
  __typename?: 'MedicalReportsV2Return';
  nodes?: Maybe<Array<MedicalReportV2>>;
  pageInfo: PageInfo;
};

export type MedicalTranscriptionOutput = {
  __typename?: 'MedicalTranscriptionOutput';
  doctorNotes?: Maybe<DoctorNotes>;
  metadata?: Maybe<TranscriptionMetadata>;
  patientNotes?: Maybe<PatientNotes>;
  rawTranscription: Scalars['String']['output'];
};

export enum MessageType {
  NewMessage = 'NEW_MESSAGE',
  UpdateState = 'UPDATE_STATE'
}

export type MethodologiesInput = {
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MethodologiesInputArray = {
  values?: InputMaybe<Array<MethodologiesInput>>;
};

export type MethodologiesParam = Node & UserParamInterface & {
  __typename?: 'MethodologiesParam';
  _id: Scalars['ID']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: MethodologiesPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type MethodologiesPayload = {
  __typename?: 'MethodologiesPayload';
  date?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SissValue>;
};

export type MethodologiesPayloadArray = {
  __typename?: 'MethodologiesPayloadArray';
  values?: Maybe<Array<MethodologiesPayload>>;
};

export enum MethodsOfAdministration {
  ADigiuno = 'A_DIGIUNO',
  AStomacoPieno = 'A_STOMACO_PIENO',
  AStomacoVuoto = 'A_STOMACO_VUOTO',
  Buccale = 'BUCCALE',
  ConAcqua = 'CON_ACQUA',
  DopoCena = 'DOPO_CENA',
  DopoPasti = 'DOPO_PASTI',
  DurantePasto = 'DURANTE_PASTO',
  LontanoPasti = 'LONTANO_PASTI',
  Masticare = 'MASTICARE',
  Mattina = 'MATTINA',
  NonMasticare = 'NON_MASTICARE',
  OrarioFisso = 'ORARIO_FISSO',
  Pomeriggio = 'POMERIGGIO',
  PostIntervento = 'POST_INTERVENTO',
  PrimaAttivita = 'PRIMA_ATTIVITA',
  PrimaColazione = 'PRIMA_COLAZIONE',
  PrimaDiDormire = 'PRIMA_DI_DORMIRE',
  PrimaPasti = 'PRIMA_PASTI',
  Risciacquare = 'RISCIACQUARE',
  Risveglio = 'RISVEGLIO',
  ScioltoAcqua = 'SCIOLTO_ACQUA',
  ScioltoBocca = 'SCIOLTO_BOCCA',
  Sera = 'SERA',
  Sublinguale = 'SUBLINGUALE'
}

export type Moderation = {
  __typename?: 'Moderation';
  level?: Maybe<ModerationLevel>;
  motivation?: Maybe<Scalars['String']['output']>;
};

export enum ModerationLevel {
  Blocked = 'blocked',
  Info = 'info',
  Ok = 'ok',
  Warning = 'warning'
}

export enum MonitoringStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type MoriskyScaleInput = {
  answers?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type MoriskyScaleParam = Node & UserParamInterface & {
  __typename?: 'MoriskyScaleParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: MoriskyScalePayload;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type MoriskyScalePayload = {
  __typename?: 'MoriskyScalePayload';
  answers?: Maybe<Array<Maybe<Scalars['Boolean']['output']>>>;
};

export enum MotorCapacityCondition {
  Allettato = 'ALLETTATO',
  Assistito = 'ASSISTITO',
  Autonomo = 'AUTONOMO'
}

export type MotorCapacityInput = {
  condition?: InputMaybe<MotorCapacityCondition>;
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type MotorCapacityParam = Node & UserParamInterface & {
  __typename?: 'MotorCapacityParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: MotorCapacityPayload;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type MotorCapacityPayload = {
  __typename?: 'MotorCapacityPayload';
  condition?: Maybe<MotorCapacityCondition>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type MultipleDownloadMedicalDocumentsInput = {
  doctorId: Scalars['ID']['input'];
  documentType?: InputMaybe<MultiregionDocumentType>;
  downloadLastResult: Scalars['Boolean']['input'];
  from: Scalars['Timestamp']['input'];
  operationalContext: MultiregionOperationalContext;
  patientTaxCode?: InputMaybe<Scalars['String']['input']>;
  takenInCharge: Scalars['Boolean']['input'];
  to: Scalars['Timestamp']['input'];
};

export enum MultiregionActivityType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Read = 'READ',
  Update = 'UPDATE'
}

export type MultiregionAssistedTaxCode = {
  active: Scalars['Boolean']['input'];
  taxCode: Scalars['String']['input'];
};

export enum MultiregionAssociationType {
  Addendum = 'ADDENDUM',
  DigitalSignature = 'DIGITAL_SIGNATURE',
  MembershipRegistryPackage = 'MEMBERSHIP_REGISTRY_PACKAGE',
  Replace = 'REPLACE',
  ReplaceWithTransformation = 'REPLACE_WITH_TRANSFORMATION',
  Snapshot = 'SNAPSHOT',
  Transformation = 'TRANSFORMATION'
}

export type MultiregionAuthor = {
  __typename?: 'MultiregionAuthor';
  contact?: Maybe<Scalars['String']['output']>;
  institution?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
};

export type MultiregionBooleanResult = {
  __typename?: 'MultiregionBooleanResult';
  data: Scalars['Boolean']['output'];
};

export enum MultiregionClinicalActivity {
  BookedServiceDelivery = 'BOOKED_SERVICE_DELIVERY',
  Consultation = 'CONSULTATION',
  Discharge = 'DISCHARGE',
  PersonalHealthRecordUpdate = 'PERSONAL_HEALTH_RECORD_UPDATE',
  TsSystem = 'TS_SYSTEM'
}

export enum MultiregionConfidentialityLevel {
  Low = 'LOW',
  Moderate = 'MODERATE',
  Normal = 'NORMAL',
  Restricted = 'RESTRICTED',
  Unrestricted = 'UNRESTRICTED',
  VeryRestricted = 'VERY_RESTRICTED'
}

export type MultiregionConsent = {
  __typename?: 'MultiregionConsent';
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  value: Scalars['Boolean']['output'];
};

export enum MultiregionDocumentType {
  AssistanceCard = 'ASSISTANCE_CARD',
  BirthSchedule = 'BIRTH_SCHEDULE',
  CitizenDocuments = 'CITIZEN_DOCUMENTS',
  ClinicalAssistancePlanningDocument = 'CLINICAL_ASSISTANCE_PLANNING_DOCUMENT',
  ClinicalPathwayEvaluation = 'CLINICAL_PATHWAY_EVALUATION',
  ConsentDocument = 'CONSENT_DOCUMENT',
  Covid19DigitalCertificate = 'COVID19_DIGITAL_CERTIFICATE',
  Covid19HealingCertificate = 'COVID19_HEALING_CERTIFICATE',
  DeviceControlPlan = 'DEVICE_CONTROL_PLAN',
  DiagnosticCard = 'DIAGNOSTIC_CARD',
  DiagnosticSpecialistPrescription = 'DIAGNOSTIC_SPECIALIST_PRESCRIPTION',
  ElectronicTherapeuticPlan = 'ELECTRONIC_THERAPEUTIC_PLAN',
  EquipmentPrescription = 'EQUIPMENT_PRESCRIPTION',
  EvaluationNote = 'EVALUATION_NOTE',
  FirstAidReport = 'FIRST_AID_REPORT',
  FirstPostnatalObstetricHealthAssessment = 'FIRST_POSTNATAL_OBSTETRIC_HEALTH_ASSESSMENT',
  FirstPrenatalObstetricHealthAssessment = 'FIRST_PRENATAL_OBSTETRIC_HEALTH_ASSESSMENT',
  HospitalDischarge = 'HOSPITAL_DISCHARGE',
  IncomeExemption = 'INCOME_EXEMPTION',
  IndividualTherapeuticPlan = 'INDIVIDUAL_THERAPEUTIC_PLAN',
  IntensiveCareClinicalSummary = 'INTENSIVE_CARE_CLINICAL_SUMMARY',
  LabReport = 'LAB_REPORT',
  MedicalGuardAccessSummary = 'MEDICAL_GUARD_ACCESS_SUMMARY',
  MedicalRecords = 'MEDICAL_RECORDS',
  NetworkReport = 'NETWORK_REPORT',
  NonHospitalDischarge = 'NON_HOSPITAL_DISCHARGE',
  ObstetricNote = 'OBSTETRIC_NOTE',
  Pai = 'PAI',
  PathologicalAnatomyReport = 'PATHOLOGICAL_ANATOMY_REPORT',
  PathologySheet = 'PATHOLOGY_SHEET',
  PatientSafetyReport = 'PATIENT_SAFETY_REPORT',
  PediatricHealthAssessment = 'PEDIATRIC_HEALTH_ASSESSMENT',
  PharmaceuticalPrescription = 'PHARMACEUTICAL_PRESCRIPTION',
  PharmaceuticalService = 'PHARMACEUTICAL_SERVICE',
  PhoneContactReport = 'PHONE_CONTACT_REPORT',
  PostnatalObstetricHealthAssessment = 'POSTNATAL_OBSTETRIC_HEALTH_ASSESSMENT',
  PrenatalObstetricHealthAssessment = 'PRENATAL_OBSTETRIC_HEALTH_ASSESSMENT',
  ProstheticReport = 'PROSTHETIC_REPORT',
  RadiologyReport = 'RADIOLOGY_REPORT',
  RecoveryCertificate = 'RECOVERY_CERTIFICATE',
  RehabilitationPlan = 'REHABILITATION_PLAN',
  SendingLetter = 'SENDING_LETTER',
  SickCertificate = 'SICK_CERTIFICATE',
  SpecialistPathologyDataCollectionReport = 'SPECIALIST_PATHOLOGY_DATA_COLLECTION_REPORT',
  SpecialistReport = 'SPECIALIST_REPORT',
  SpecialistService = 'SPECIALIST_SERVICE',
  SyntheticHealthProfile = 'SYNTHETIC_HEALTH_PROFILE',
  TeleconsultationResult = 'TELECONSULTATION_RESULT',
  VaccinationCard = 'VACCINATION_CARD',
  VaccinationCertificate = 'VACCINATION_CERTIFICATE'
}

export enum MultiregionDocumentTypeHigh {
  Exemption = 'EXEMPTION',
  HospitalDischargeLetter = 'HOSPITAL_DISCHARGE_LETTER',
  Notebook = 'NOTEBOOK',
  Prescription = 'PRESCRIPTION',
  Report = 'REPORT',
  Request = 'REQUEST',
  Service = 'SERVICE',
  Summary = 'SUMMARY',
  WorkflowDocument = 'WORKFLOW_DOCUMENT'
}

export enum MultiregionDocumentTypeLow {
  HospitalDischarge = 'HOSPITAL_DISCHARGE',
  LabReport = 'LAB_REPORT',
  Pdf = 'PDF',
  Prescription = 'PRESCRIPTION',
  RadiologyReport = 'RADIOLOGY_REPORT',
  SyntheticHealthProfile = 'SYNTHETIC_HEALTH_PROFILE',
  TsSystemExemption = 'TS_SYSTEM_EXEMPTION',
  TsSystemPrescription = 'TS_SYSTEM_PRESCRIPTION',
  TsSystemService = 'TS_SYSTEM_SERVICE',
  Txt = 'TXT'
}

export enum MultiregionOperationalContext {
  Administrative = 'ADMINISTRATIVE',
  Consent = 'CONSENT',
  Emergency = 'EMERGENCY',
  Personal = 'PERSONAL',
  Pubemergency = 'PUBEMERGENCY',
  Sysadmin = 'SYSADMIN',
  Treatment = 'TREATMENT',
  Update = 'UPDATE'
}

export enum MultiregionOrganizationId {
  Abruzzo = 'ABRUZZO',
  Basilicata = 'BASILICATA',
  Calabria = 'CALABRIA',
  Campania = 'CAMPANIA',
  EmiliaRomagna = 'EMILIA_ROMAGNA',
  FriuliVeneziaGiulia = 'FRIULI_VENEZIA_GIULIA',
  InteroperabilityNationalInfrastructure = 'INTEROPERABILITY_NATIONAL_INFRASTRUCTURE',
  Lazio = 'LAZIO',
  Liguria = 'LIGURIA',
  Lombardia = 'LOMBARDIA',
  Marche = 'MARCHE',
  Molise = 'MOLISE',
  PaBolzano = 'PA_BOLZANO',
  PaTrento = 'PA_TRENTO',
  Piemonte = 'PIEMONTE',
  Puglia = 'PUGLIA',
  Sardegna = 'SARDEGNA',
  Sicilia = 'SICILIA',
  Toscana = 'TOSCANA',
  Umbria = 'UMBRIA',
  ValleDaosta = 'VALLE_DAOSTA',
  Veneto = 'VENETO'
}

export enum MultiregionOrganizationalAsset {
  Allergy = 'ALLERGY',
  AnesthesiaAndReanimation = 'ANESTHESIA_AND_REANIMATION',
  Angiology = 'ANGIOLOGY',
  BasicMedicine = 'BASIC_MEDICINE',
  BigBurns = 'BIG_BURNS',
  Cardiology = 'CARDIOLOGY',
  ChildNeuropsychiatry = 'CHILD_NEUROPSYCHIATRY',
  ClinicalChemicalAnalysisLab = 'CLINICAL_CHEMICAL_ANALYSIS_LAB',
  ClinicalPharmacology = 'CLINICAL_PHARMACOLOGY',
  ConsentCollection = 'CONSENT_COLLECTION',
  CoronaryUnit = 'CORONARY_UNIT',
  DayHospital = 'DAY_HOSPITAL',
  DentistryAndStomatology = 'DENTISTRY_AND_STOMATOLOGY',
  Dermatology = 'DERMATOLOGY',
  Detainees = 'DETAINEES',
  EmergencyRoom = 'EMERGENCY_ROOM',
  EndocrineReplacementNutritionDiseases = 'ENDOCRINE_REPLACEMENT_NUTRITION_DISEASES',
  FreelanceHospitalization = 'FREELANCE_HOSPITALIZATION',
  FunctionalRehabilitation = 'FUNCTIONAL_REHABILITATION',
  Gastroenterology = 'GASTROENTEROLOGY',
  GeneralMedicine = 'GENERAL_MEDICINE',
  GeneralSurgery = 'GENERAL_SURGERY',
  Geriatrics = 'GERIATRICS',
  HeartSurgery = 'HEART_SURGERY',
  HematologyImmunohematology = 'HEMATOLOGY_IMMUNOHEMATOLOGY',
  Hemodialysis = 'HEMODIALYSIS',
  Hospice = 'HOSPICE',
  Immunology = 'IMMUNOLOGY',
  InfectiveTropicalDiseases = 'INFECTIVE_TROPICAL_DISEASES',
  IntensiveCare = 'INTENSIVE_CARE',
  LargePediatricBurns = 'LARGE_PEDIATRIC_BURNS',
  LegalMedicine = 'LEGAL_MEDICINE',
  LongTerm = 'LONG_TERM',
  MaxillofacialSurgery = 'MAXILLOFACIAL_SURGERY',
  MultispecialDaySurgery = 'MULTISPECIAL_DAY_SURGERY',
  NeonatalIntensiveCare = 'NEONATAL_INTENSIVE_CARE',
  Neonatology = 'NEONATOLOGY',
  Nephrology = 'NEPHROLOGY',
  NephrologyLiverTransplant = 'NEPHROLOGY_LIVER_TRANSPLANT',
  Nest = 'NEST',
  Neurology = 'NEUROLOGY',
  Neuroradiology = 'NEURORADIOLOGY',
  Neurosurgery = 'NEUROSURGERY',
  NeuroRehabilitation = 'NEURO_REHABILITATION',
  NuclearMedicine = 'NUCLEAR_MEDICINE',
  ObstetricsAndGynecology = 'OBSTETRICS_AND_GYNECOLOGY',
  OccupationalMedicine = 'OCCUPATIONAL_MEDICINE',
  Oncohematology = 'ONCOHEMATOLOGY',
  OncologicalRadiotherapy = 'ONCOLOGICAL_RADIOTHERAPY',
  Oncology = 'ONCOLOGY',
  OperationsCenter_118 = 'OPERATIONS_CENTER_118',
  OperatorSectionsDaySurgery = 'OPERATOR_SECTIONS_DAY_SURGERY',
  OperatorSectionsOrdinaryHospitalization = 'OPERATOR_SECTIONS_ORDINARY_HOSPITALIZATION',
  Ophthalmology = 'OPHTHALMOLOGY',
  OrgansTissueTransplant = 'ORGANS_TISSUE_TRANSPLANT',
  OrthopedicsAndTraumatology = 'ORTHOPEDICS_AND_TRAUMATOLOGY',
  Otolaryngology = 'OTOLARYNGOLOGY',
  PathologicalAnatomyHistology = 'PATHOLOGICAL_ANATOMY_HISTOLOGY',
  PathophysiologyRehabilitation = 'PATHOPHYSIOLOGY_REHABILITATION',
  Pediatrics = 'PEDIATRICS',
  PediatricHeartSurgery = 'PEDIATRIC_HEART_SURGERY',
  PediatricNephrology = 'PEDIATRIC_NEPHROLOGY',
  PediatricNeurosurgery = 'PEDIATRIC_NEUROSURGERY',
  PediatricOncohematology = 'PEDIATRIC_ONCOHEMATOLOGY',
  PediatricSurgery = 'PEDIATRIC_SURGERY',
  PediatricUrology = 'PEDIATRIC_UROLOGY',
  PlasticSurgery = 'PLASTIC_SURGERY',
  Pneumology = 'PNEUMOLOGY',
  Polyclinic = 'POLYCLINIC',
  Psychiatry = 'PSYCHIATRY',
  Radiodiagnostics = 'RADIODIAGNOSTICS',
  Radiology = 'RADIOLOGY',
  Radiotherapy = 'RADIOTHERAPY',
  ReceptionWard = 'RECEPTION_WARD',
  Rheumatology = 'RHEUMATOLOGY',
  SpinalUnit = 'SPINAL_UNIT',
  SportsMedicine = 'SPORTS_MEDICINE',
  TerritorialAssistance = 'TERRITORIAL_ASSISTANCE',
  ThoracicSurgery = 'THORACIC_SURGERY',
  Toxicology = 'TOXICOLOGY',
  TransfusionImmunohaematologicalCenter = 'TRANSFUSION_IMMUNOHAEMATOLOGICAL_CENTER',
  Urology = 'UROLOGY',
  VascularSurgery = 'VASCULAR_SURGERY',
  VirologyMicrobiology = 'VIROLOGY_MICROBIOLOGY'
}

export type MultiregionPatient = {
  __typename?: 'MultiregionPatient';
  id?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
};

export type MultiregionPrescriptionResult = {
  __typename?: 'MultiregionPrescriptionResult';
  prescriptions: Array<Prescription>;
};

export type MultiregionStringResult = {
  __typename?: 'MultiregionStringResult';
  result: Scalars['String']['output'];
};

export enum MultiregionStructureType {
  Hospital = 'HOSPITAL',
  Prevention = 'PREVENTION',
  Territory = 'TERRITORY',
  TsSystem = 'TS_SYSTEM'
}

export type MultiregionTherapeuticPlanResult = {
  __typename?: 'MultiregionTherapeuticPlanResult';
  downloadedTherapeuticPlansCount: Scalars['Int']['output'];
};

export enum MultiregionThreeStateEnum {
  False = 'FALSE',
  NotProvided = 'NOT_PROVIDED',
  True = 'TRUE'
}

export type MultiregionThreeStateResult = {
  __typename?: 'MultiregionThreeStateResult';
  data: MultiregionThreeStateEnum;
};

export enum MultiregionUserRole {
  AdministrativeDirector = 'ADMINISTRATIVE_DIRECTOR',
  AdministrativeOperator = 'ADMINISTRATIVE_OPERATOR',
  Assisted = 'ASSISTED',
  ConsentOperator = 'CONSENT_OPERATOR',
  GeneralPhysician = 'GENERAL_PHYSICIAN',
  HealthcareExecutive = 'HEALTHCARE_EXECUTIVE',
  HighSpecializationStaff = 'HIGH_SPECIALIZATION_STAFF',
  InformalGiver = 'INFORMAL_GIVER',
  InformationOperator = 'INFORMATION_OPERATOR',
  InteroperabilityNationalInfrastructure = 'INTEROPERABILITY_NATIONAL_INFRASTRUCTURE',
  MedicalDirector = 'MEDICAL_DIRECTOR',
  NursingStaff = 'NURSING_STAFF',
  Parent = 'PARENT',
  PathologyNetworkPhysician = 'PATHOLOGY_NETWORK_PHYSICIAN',
  Pharmacist = 'PHARMACIST',
  RegionalNode = 'REGIONAL_NODE',
  RsaMedic = 'RSA_MEDIC',
  SocialProfessional = 'SOCIAL_PROFESSIONAL',
  Tutor = 'TUTOR'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptIdentityValidation: IdentityValidationWithSignedUrl;
  acceptRelationship: Relationship;
  acceptReservation: Reservation;
  addAvailability?: Maybe<Array<Slot>>;
  addCardToPatient: AddCardToPatientResult;
  addCommentToFeedback: UserbackFeedbackComment;
  addFamilyMemberWithRelationship: Relationship;
  addLocation?: Maybe<UserLocationResult>;
  addMedicalInstruction: MedicalInstruction;
  addOrEditTag: Tag;
  addPaiPrescriptionLot: MultiregionBooleanResult;
  addPatient: User;
  addPatientEmail: Scalars['Boolean']['output'];
  addPatientParseSissV2: ParseSissAddPatientResultV2;
  addPatientPhone: Scalars['Boolean']['output'];
  addPatientSissCloud: ParseSissAddPatientResultV2;
  addPatientV2SissCloud: ParseSissAddPatientResultV2;
  addRelationship: Relationship;
  addRelationshipFromContacts?: Maybe<Relationship>;
  addRelative: AddRelativeResult;
  addUserContactsAndSendWelcomeMessage: User;
  addUsersToWorkgroup: Workgroup;
  addUsersToWorkgroupsByTaxCodeAdmin: BulkAddUsersToWorkgroupsResult;
  addVideocallLog: AddVideocallLogResult;
  addWorkgroup: Workgroup;
  adminDeleteAuthentication: Authentication;
  adminSendInclinicEmail?: Maybe<Scalars['Boolean']['output']>;
  aggiornaPaiParseSiss: SissPaiResult;
  aggiornaPaiSissCloud: SissPaiResult;
  annotateTranscription: TranscriptionJob;
  annullaPaiParseSiss: LastPaiResult;
  annullaPaiSissCloud: LastPaiResult;
  annullaPrescrizioneBiancaParseSiss: MultiregionBooleanResult;
  annullaPrescrizioneBiancaSissCloud: MultiregionBooleanResult;
  annullaPrescrizioneParseSiss: MultiregionBooleanResult;
  annullaPrescrizioneSissCloud: MultiregionBooleanResult;
  annullamentoPianoTerapeuticoAifaParseSiss: MultiregionBooleanResult;
  archivePaiExternally: Array<Maybe<PaiArchiveExternallyResult>>;
  archivePrescriptions: ArchivedPrescriptionsResult;
  authWithSpidService: MaybeAuthData;
  blockIdentityValidation: IdentityValidationWithSignedUrl;
  bookPrescriptionReservation: PrescriptionReservationResult;
  bookReservationV2: BookReservationResult;
  bulkAddOrEditOutpatientServiceOutcomeParameters: OutpatientServiceOutcomeResult;
  bulkAddOrEditOutpatientServiceOutcomeServiceExamParameters: OutpatientServiceOutcomeResult;
  bulkCompleteDrugReservationsDrugstore: Array<DrugReservation>;
  bulkSendBillings: Array<BulkSendBillingResult>;
  cancelAccount?: Maybe<User>;
  cancelBilling: Scalars['Boolean']['output'];
  cancelCalendarEvent: CancelCalendarEventResult;
  cancelClinicWorkgroupsClosures?: Maybe<Scalars['Void']['output']>;
  cancelDraftPai: LastPaiResult;
  cancelDrugReservationDrugstore: DrugReservation;
  cancelDrugReservationPatient: DrugReservation;
  /**
   * Cancel a Patient Summary.
   * Creates and transmits a cancel document to FSE, then sets cancelledAt timestamp.
   */
  cancelPatientSummary: PatientSummary;
  cancelPaymentIntent?: Maybe<Scalars['Boolean']['output']>;
  cancelPrescription: MultiregionBooleanResult;
  cancelRecurrenceCalendarEvent: Scalars['Boolean']['output'];
  cancelSetupIntent?: Maybe<Scalars['Boolean']['output']>;
  cancelSubscriptionPlanUsers: Scalars['Boolean']['output'];
  cancelTherapeuticPlan: Scalars['Boolean']['output'];
  cancelVirtualCareSubscription?: Maybe<Scalars['Boolean']['output']>;
  cancellaCertificatoMalattiaParseSiss: RegionCertificateResult;
  cancellaCertificatoMalattiaSissCloud: RegionCertificateResult;
  changeAuthenticationPasswordAdmin?: Maybe<Scalars['Boolean']['output']>;
  changePassword: AuthData;
  completeDrugReservationsDrugstore: Array<DrugReservation>;
  completeReservationDeferredPayment: CompleteReservationDeferredPaymentResult;
  confirmDrugReservationDrugstore: DrugReservation;
  confirmDrugReservationPatient: DrugReservation;
  /** @deprecated use bookReservation in clinic-aggregator module  */
  confirmReservation: InclinicCreateReservationResult;
  confirmReservationWithoutEmails: InclinicCreateReservationResult;
  consultaDocumentiFascicoloParseSiss: MultiregionBooleanResult;
  consultaEsenzioniPrescrittoreSissCloud: ConsultaEsenzioniPrescrittoreResult;
  consultaStatoParseSiss: MultiregionBooleanResult;
  consultaStatoSissCloud: MultiregionBooleanResult;
  convertPrescriptionsToNonDem: PrescriptionsResult;
  createAdminUser: User;
  createAmbulatoryTest: AmbulatoryTest;
  createAnamnesis: Anamnesis;
  createAssistedUserAuthentication: CreateAssistedUserAuthenticationResponse;
  createAuthProvider: FreenetAuthProvider;
  createAuthUsers: Array<FreenetAuthUser>;
  createAuthenticationForAdmin?: Maybe<Authentication>;
  createBlacklistEntry: BlacklistMutationResponse;
  createCalendarEvent: CreateCalendarEventResult;
  createCancellationPai: CreateCancellationPaiResult;
  createCertificate: Certificate;
  createCertificateTemplate: CertificateTemplate;
  createChat: Chat;
  createClinicGroup: ClinicGroup;
  createClinicWorkgroup: Workgroup;
  createClinicWorkgroupsClosures: Array<ClinicWorkgroupClosure>;
  createDiary: Diary;
  createDiseaseCertificate: Certificate;
  createDrugReservationPatient: DrugReservation;
  createHospitalAdmissionForm: HospitalAdmissionForm;
  createInvoice: SubscriptionPlanUser;
  createLead: CreateLeadResult;
  createManualSissReport: SissReport;
  createMeasurement: Measurement;
  createMeasurements: Array<Measurement>;
  /** @deprecated No longer supported */
  createMedicalReport: MedicalReport;
  createMedicalReportV2: MedicalReportV2;
  createNextPai: LastPaiResult;
  createOrUpdateSpeciality: Speciality;
  createOrUpdateVaccination: Vaccination;
  createOutpatientServiceCustomGroup: OutpatientServiceGroup;
  createPai: Pai;
  createPartner: Partner;
  createPatientAuth: Scalars['Boolean']['output'];
  createPatientMedicalDevices: Array<PatientMedicalDevice>;
  createPatientProblem: PatientProblem;
  createPatientRequest: CreatePatientRequest;
  createPatientRequestDoctor: CreatePatientRequest;
  /**
   * Create a PatientSummary record with selected user parameters.
   * Saves the data but does NOT generate the CDA2 XML document immediately.
   * The XML will be generated on-demand when needed for FSE transmission.
   */
  createPatientSummary: CreatePatientSummaryResult;
  createPaymentIntent?: Maybe<StripeIntentResult>;
  createPrescriptions: PrescriptionsResult;
  createPrescriptionsParseSiss: MultiregionPrescriptionResult;
  createPrescriptionsSissCloud: MultiregionPrescriptionResult;
  createQuickAnswer: CreateQuickAnswerResult;
  createSetupIntent?: Maybe<StripeIntentResult>;
  createSpecialities?: Maybe<Array<Speciality>>;
  createSpecialityTemplate: SpecialityTemplate;
  createStripeSubscription: CreateStripeSubscriptionResponse;
  createSubscriptionPlanUsers: Array<SubscriptionPlanUser>;
  /** @deprecated moved to inclinic-gateway */
  createTantoSvagoReservation: InclinicCreateReservationResult;
  createUser: User;
  createVirtualCarePlanSubscription?: Maybe<CreateVirtualCarePlanSubscriptionResponse>;
  declineRelationship: Relationship;
  declineReservation: Reservation;
  deleteAccount?: Maybe<Authentication>;
  deleteAnamnesis: Scalars['Boolean']['output'];
  deleteAssistedUsers: Scalars['Boolean']['output'];
  deleteAuthProvider: Scalars['Boolean']['output'];
  deleteAuthUser: Scalars['Boolean']['output'];
  deleteAuthentication?: Maybe<Authentication>;
  deleteAvailability?: Maybe<Array<Slot>>;
  deleteBilling: Scalars['Boolean']['output'];
  deleteBillingItemTemplate: Scalars['Boolean']['output'];
  deleteCeliacDisease: Scalars['Boolean']['output'];
  deleteCertificateTemplate: Scalars['Boolean']['output'];
  deleteClinicGroup: ClinicGroup;
  deleteCommunication: DeleteCommunicationResult;
  deleteCovidTest: DeleteCovidTestResponse;
  deleteDiary: Scalars['Boolean']['output'];
  deleteDiaryMonitoring: DiaryMonitoring;
  deleteDiseaseCertificate: RegionCertificateResult;
  deleteDocument?: Maybe<DeleteDocumentResponse>;
  deleteDocuments: Scalars['Boolean']['output'];
  deleteDraftDiseaseCertificate: Scalars['Boolean']['output'];
  deleteFamilyMemberRelationship: Relationship;
  deleteManualSissReport: Scalars['Boolean']['output'];
  deleteMeasurement: Scalars['Boolean']['output'];
  deleteMedicalInstruction?: Maybe<MedicalInstruction>;
  deleteMedicalReportV2: MedicalReportV2;
  deleteMessage: Scalars['Boolean']['output'];
  deleteMyAuthentication?: Maybe<Authentication>;
  deleteMyNotifications?: Maybe<Scalars['Int']['output']>;
  deleteNotification?: Maybe<Scalars['Int']['output']>;
  deleteOutpatientServiceGroups: Scalars['Boolean']['output'];
  deleteOutpatientServiceOutcome: Scalars['Boolean']['output'];
  deleteOutpatientServiceOutcomeParameter: Scalars['Boolean']['output'];
  deleteOutpatientServiceOutcomeServiceExamParameter: Scalars['Boolean']['output'];
  deletePatientMedicalDevices: Scalars['Boolean']['output'];
  deletePatientProblem: PatientProblem;
  deletePatientRequests: PatientRequestsResult;
  /**
   * Delete a Patient Summary.
   * Only allows deletion of drafts (never transmitted) or cancelled documents.
   */
  deletePatientSummary: Scalars['Boolean']['output'];
  deletePrescriptions: DeletedPrescriptionsResult;
  deleteQuickAnswer: DeleteQuickAnswerResult;
  deleteRegionalSystemCredentials: UpdateRegionalSystemCredentialsResponse;
  deleteRelative: Scalars['Boolean']['output'];
  deleteReservationByUser?: Maybe<Scalars['Boolean']['output']>;
  deleteReservationByUserWithoutEmails?: Maybe<Scalars['Boolean']['output']>;
  deleteSpecialityTemplate: SpecialityTemplate;
  deleteStripeSubscription: SubscriptionPlanUser;
  deleteSubscriptionPlanUser: Scalars['Boolean']['output'];
  deleteTag?: Maybe<Array<Tag>>;
  deleteTherapeuticPlan: Scalars['Boolean']['output'];
  deleteUserAdmin: User;
  deleteUserDoctorRelationship?: Maybe<User>;
  deleteUserDoctorRelationships: User;
  deleteVaccination: DeleteVaccinationResponse;
  deleteWhitePrescription: MultiregionBooleanResult;
  deleteWorkgroup: Workgroup;
  deleteWorkgroupAvailabilitySlotsForAdmin: DeleteResult;
  deleteWorkgroupSpecialityTemplatesForAdmin: DeleteResult;
  disarruolaParseSiss: ParseSissPatientResult;
  disarruolaSissCloud: ParseSissPatientResult;
  disarruolaTuttiSissCloud: MultiregionBooleanResult;
  downloadData?: Maybe<User>;
  downloadDiseaseCertificates: DownloadDiseaseCertificatesResponse;
  downloadExemptions: DownloadExemptionsResponse;
  downloadMedicalReportDocuments: MedicalReportV2;
  downloadPatient: DownloadPatientResponse;
  downloadPatientCovidTests: DownloadPatientCovidTestsResponse;
  downloadPatientExemptions: DownloadPatientExemptionsResponse;
  downloadPatients: DownloadPatientsResponse;
  downloadSantagostinoReport?: Maybe<DownloadSantagostinoReportResult>;
  downloadTherapeuticPlan: TherapeuticPlan;
  downloadTherapeuticPlans: MultiregionTherapeuticPlanResult;
  downloadVaccinations: DownloadVaccinationsResponse;
  editAvailability?: Maybe<Array<Slot>>;
  editOutcomeInterpretation: Scalars['Boolean']['output'];
  editOutcomeParameterInterpretation: Scalars['Boolean']['output'];
  editOutpatientServiceOutcomeParameter: OutpatientServiceOutcomeParameterResult;
  editOutpatientServiceOutcomeServiceExamParameter: OutpatientServiceOutcomeServiceExamParameterResult;
  editPatientRequestInternalNote: Scalars['Boolean']['output'];
  editTaxCodeAuthentication?: Maybe<Scalars['Boolean']['output']>;
  elencoProtocolliPianiTerapeuticiAifaParseSiss: MultiregionTherapeuticPlanResult;
  elencoProtocolliPianiTerapeuticiAifaSissCloud: MultiregionTherapeuticPlanResult;
  exportExemptionsForAtc?: Maybe<Scalars['Boolean']['output']>;
  exportPatients: Array<ExportPatientsResponse>;
  extendAvailabilitiesForClinicWorkgroups: Scalars['String']['output'];
  firmaPaiParseSiss: ParseSissPaiResult;
  forceDeleteUserParam: Scalars['Boolean']['output'];
  /** if it's set coupons the system ignore number. Creation depends on the number of coupons in the coupons variable, numberCoupons default is 1 */
  generatePartnerCodes: Array<PartnerCode>;
  /**
   * Generate CDA2 XML document from an existing PatientSummary.
   * This is called on-demand when the document needs to be transmitted to FSE.
   */
  generatePssCda2Document: GeneratePssCda2DocumentResult;
  /**
   * Generate both CDA2 XML and PDF documents together from an existing PatientSummary.
   * Both documents are generated directly from selectedParams (same source of truth).
   * This is called on-demand when the documents need to be transmitted to FSE.
   */
  generatePssDocumentsForFse: GeneratePssDocumentsForFseResult;
  generatesCouponForPatient: Array<Coupon>;
  /** if it's set coupons the system ignore number. Creation depends on the number of coupons in the coupons variable, numberCoupons default is 1 */
  generatesCoupons: Array<Coupon>;
  getPaperPrescriptionNre: BookNreOutput;
  getSantagostinoPatientReports?: Maybe<Scalars['Boolean']['output']>;
  grantFseAccess: Relationship;
  hideDiaryLog?: Maybe<DiaryLog>;
  hideImportedUserNotes: Scalars['Boolean']['output'];
  hideInvoice: SubscriptionPlanUser;
  hideUserParams: Scalars['Boolean']['output'];
  identificaCittadinoParseSiss: ParseSissUserResult;
  identificaCittadinoSissCloud: ParseSissUserResult;
  identificaCittadinoV2ParseSiss: IdentificaCittadinoV2Result;
  identificaCittadinoV2SissCloud: IdentificaCittadinoV2Result;
  identificaPrescrizioneParseSiss: MultiregionBooleanResult;
  identificaPrescrizioneSissCloud: MultiregionBooleanResult;
  importPatientContacts: DataImportRequest;
  importPatientContactsWithAnagraphics: DataImportRequest;
  importPatientPaiData: Scalars['Boolean']['output'];
  importPatients: Array<User>;
  importPatientsForAmt: Scalars['Boolean']['output'];
  importPersonalDataSiss: DataImportRequest;
  incrementVideoconsultoUsage?: Maybe<Scalars['Boolean']['output']>;
  insertBilling: Billing;
  insertBillingItemTemplate: BillingItemTemplate;
  insertOutpatientServiceOutcomes: OutpatientServiceOutcomeResult;
  insertTherapeuticPlans: Array<TherapeuticPlan>;
  invioCertificatoMalattiaParseSiss: RegionCertificateResult;
  invitePatientForMonitoring: User;
  invitePatientToJoinCall: User;
  inviteToDownloadApp: Scalars['Boolean']['output'];
  makeAvailableNre?: Maybe<MultiregionBooleanResult>;
  marcaPaiParseSiss: ParseSissPaiResult;
  markFeedbackAsRead: UserbackFeedback;
  markFeedbackAsResolved: UserbackFeedback;
  markNotificationAsRead: Notification;
  mergeUsersAdmin: User;
  notifyPatientOfPrescriptions: NotifyPatientOfPrescriptionsResult;
  ottieniPatologieParseSiss?: Maybe<Array<PatientProblem>>;
  ottieniPatologieSissCloud?: Maybe<Array<PatientProblem>>;
  ottieniTabellaParseSiss: MultiregionStringResult;
  payReservation?: Maybe<PayReservationResult>;
  prenotaArruolamentoParseSiss: ParsePrenotaArruolamentoResult;
  prenotaArruolamentoSissCloud: ParsePrenotaArruolamentoResult;
  previewAmtPatientsFile: PreviewAmtPatientsFileReturn;
  pubblicaPaiParseSiss: SissPaiResult;
  pubblicaPaiSissCloud: SissPaiResult;
  publishCovidTest?: Maybe<PublishCovidTestResponse>;
  publishDiseaseCertificate: RegionCertificateResult;
  publishPatientSummary: Scalars['String']['output'];
  publishPrescriptions: MultiregionPrescriptionResult;
  publishVaccination: PublishVaccinationResponse;
  publishWhitePrescriptions: MultiregionPrescriptionResult;
  readAllNotifications?: Maybe<Scalars['Boolean']['output']>;
  readAllNotificationsForCategory?: Maybe<Scalars['Boolean']['output']>;
  recordNpsClosedWithoutVote: Scalars['Boolean']['output'];
  recordNpsModalShown: Scalars['Boolean']['output'];
  recordNpsVote: NpsFeedback;
  refundBilling: Billing;
  registraPrescrizioniBiancheParseSiss: MultiregionPrescriptionResult;
  registraPrescrizioniBiancheSissCloud: MultiregionPrescriptionResult;
  removeBlacklistEntry: BlacklistMutationResponse;
  removePatientAuth: Scalars['Boolean']['output'];
  removePatientEmail: Scalars['Boolean']['output'];
  removePatientPhone: Scalars['Boolean']['output'];
  removeUsersFromWorkgroup: Workgroup;
  reportAfterImportCsv?: Maybe<User>;
  requestAuthenticationDeletion?: Maybe<Scalars['Boolean']['output']>;
  requestDataExport: DataExportRequest;
  requestDataImport: DataImportRequest;
  requestOtpGeneration: RequestOtpGenerationResult;
  requestPaymentSheet?: Maybe<PaymentSheetResult>;
  resendPrescriptionNotifications: NotifyPatientOfPrescriptionsResult;
  resendVerified: User;
  resetPassword: Authentication;
  resetPasswordV2: AuthData;
  resetPasswordV3: AuthData;
  resetPatientPassword: Scalars['Boolean']['output'];
  retryDataImport: DataImportRequest;
  rettificaCertificatoMalattiaParseSiss: RegionCertificateResult;
  rettificaCertificatoMalattiaSissCloud: RegionCertificateResult;
  revokeFseAccess: Relationship;
  ricercaCertificatiMalattiaParseSiss: RegionCertificateResult;
  ricercaCertificatiMalattiaSissCloud: RegionCertificateResult;
  richiestaPromemoriaParseSiss: MultiregionBooleanResult;
  richiestaPromemoriaSissCloud: MultiregionBooleanResult;
  rilevaCartaCittadinoParseSiss: MultiregionBooleanResult;
  rilevaCartaCittadinoSissCloud: MultiregionBooleanResult;
  rilevaCartaOperatoreParseSiss: ParseSissCredentialResult;
  rinnovaPaiParseSiss: SissPaiResult;
  rinnovaPaiSissCloud: SissPaiResult;
  riscontraFirmaMarcaParseSiss: ParseSissPaiResult;
  runDataMigration: Array<Maybe<DataMigration>>;
  /** @deprecated No longer supported */
  saveDoctorSpecialities?: Maybe<Array<Speciality>>;
  saveIdentityDocument?: Maybe<SaveIdentityDocumentResponse>;
  /**
   * Save PSS edits back to user params using a merge-not-replace strategy.
   * Only PSS-editable fields are overwritten; all other fields are preserved from
   * the current database state to prevent unintended data loss.
   */
  savePatientSummaryBackToUserParams: SaveBackToUserParamsResult;
  saveUserParams: LatestUserParams;
  seeAllNotifications?: Maybe<Scalars['Boolean']['output']>;
  sendBilling: Billing;
  sendCommunication: SendCommunicationResult;
  sendDiseaseCertificateNotification?: Maybe<Scalars['Boolean']['output']>;
  sendInvitations: Scalars['Boolean']['output'];
  sendMessage?: Maybe<ChatMessage>;
  sendNotificationsForUsers?: Maybe<UserToken>;
  sendNreViaSms: MultiregionBooleanResult;
  sendPatientRequestNoteToPatient: Scalars['Boolean']['output'];
  sendRedPrescriptions: MultiregionBooleanResult;
  sendTopicNotification?: Maybe<Scalars['Boolean']['output']>;
  setAsUnread: ChatMessage;
  setAts: User;
  setHighlight: Scalars['Boolean']['output'];
  setLastUserAccessInfo?: Maybe<Scalars['Void']['output']>;
  setRequiredAppVersion: Scalars['Boolean']['output'];
  setReservationAndUserConsents: Scalars['Boolean']['output'];
  setSantagostinoConsent?: Maybe<SetSantagostinoConsentResponse>;
  setSignupRequest?: Maybe<SignupRequestReturn>;
  setUserSettings?: Maybe<UserSettings>;
  showDiaryLog?: Maybe<DiaryLog>;
  /**
   * Complete flow: generate CDA2 + PDF, inject CDA2 into PDF, sign PDFA3 with PAdES, and transmit to FSE.
   * This is an optional convenience mutation that handles the entire flow.
   */
  signAndTransmitPssToFse: SignAndTransmitPssToFseResult;
  signMarkPai: Array<SignedPaiId>;
  signup: AuthData;
  signupAssistedUser: SignupAssistedUserResponse;
  signupDoctor: AuthData;
  signupPatient: AuthData;
  signupV2: AuthData;
  sostituisciPaiParseSiss: SissPaiResult;
  sostituisciPaiSissCloud: SissPaiResult;
  startBulkImport: Scalars['Boolean']['output'];
  startCall: StartCallResult;
  startTranscription: TranscriptionJobCreateResponse;
  submitTherapeuticPlanEvaluation97?: Maybe<ResponseSubmitTherapeuticPlan>;
  submitTherapeuticPlanEvaluation100?: Maybe<ResponseSubmitTherapeuticPlan>;
  submitTherapeuticPlanFollowup97?: Maybe<ResponseSubmitTherapeuticPlan>;
  submitTherapeuticPlanFollowup100?: Maybe<ResponseSubmitTherapeuticPlan>;
  submitTherapeuticPlanPaxlovid?: Maybe<ResponseSubmitTherapeuticPlan>;
  syncAllStripeSubscriptions: Scalars['Boolean']['output'];
  syncStripeSubscription: SubscriptionPlanUser;
  transcribeAndAnnotate: TranscriptionJob;
  trasmissionePianiTerapeuticiAifaParseSiss: ResponseSubmitTherapeuticPlan;
  unreadNotification: Notification;
  updateAnamnesis: Anamnesis;
  updateAssistedUserFields: AssistedUser;
  updateAuthAdmin?: Maybe<Scalars['Boolean']['output']>;
  updateAuthProvider: FreenetAuthProvider;
  updateAuthUser: FreenetAuthUser;
  updateAuthentication: Authentication;
  updateBilling: Billing;
  updateBillingItemTemplate: BillingItemTemplate;
  updateBlacklistEntry: BlacklistMutationResponse;
  updateCalendarEvent: UpdateCalendarEventResult;
  updateCertificate: Certificate;
  updateCertificateTemplate: CertificateTemplate;
  updateChat: UpdateChatResult;
  updateClinicGroup: ClinicGroup;
  updateClinicWorkgroup: Workgroup;
  updateClinicWorkgroupsClosures: Array<ClinicWorkgroupClosure>;
  updateDiary: Diary;
  updateDiaryMonitoring: DiaryMonitoring;
  updateDiseaseCertificate: RegionCertificateResult;
  updateDoctorPatientSetting?: Maybe<Scalars['Void']['output']>;
  updateDoctorSpecialities?: Maybe<Scalars['Boolean']['output']>;
  updateDraftDiseaseCertificate: Certificate;
  updateIdentityValidationNotes: IdentityValidationWithSignedUrl;
  updateIdentityValidationPatientFields: IdentityValidationPatient;
  updateInvoice: SubscriptionPlanUser;
  updateLabels: SubscriptionPlanUser;
  updateLinkedUsersRelationships: Scalars['Boolean']['output'];
  updateMedicalInstruction: MedicalInstruction;
  updateMedicalReportV2: MedicalReportV2;
  /**
   * Usage:
   * change the list of users who have seen that message.
   * Note that the array will be merged to the existing one as no "seenBy" can be removed once added.
   * If an ID is already present, it won't affect the array.
   *
   * @seenBy: array of IDs of the users who have seen the message
   */
  updateMessage: ChatMessage;
  updateOutpatientServiceGroup: OutpatientServiceGroup;
  updateOutpatientServiceGroupsStatus: Scalars['Boolean']['output'];
  updatePaiExternalLogicLink: Array<Maybe<PaiArchiveExternallyResult>>;
  updatePatientFields: Scalars['Boolean']['output'];
  updatePatientMedicalDevices: Array<PatientMedicalDevice>;
  updatePatientProblem: PatientProblem;
  updatePatientRequestPayload: PatientRequestResult;
  updatePatientRequestStatus: PatientRequestResult;
  /**
   * Update an existing PatientSummary record.
   * If the PSS has already been transmitted, the old model state is saved to history
   * and the root model is replaced with the new draft version.
   */
  updatePatientSummary: UpdatePatientSummaryResult;
  updatePrescription: PrescriptionResult;
  updatePrescriptionReservation: PrescriptionReservationResult;
  updateRecurrenceCalendarEvent: UpdateCalendarEventResults;
  updateRegionalSystemCredentials: UpdateRegionalSystemCredentialsResponse;
  updateRelationship: Relationship;
  /** sample usages include: start the reservation, end the reservation, open it back. */
  updateReservation: Reservation;
  updateReservationByUserWithoutEmails: Scalars['Boolean']['output'];
  updateReservationsInBulk?: Maybe<Scalars['Void']['output']>;
  updateStringParam: StringParam;
  updateSubscriptionPlanUserByUserId: Scalars['Boolean']['output'];
  updateSubscriptionPlanUsers: Array<SubscriptionPlanUser>;
  updateTherapeuticPlan?: Maybe<TherapeuticPlan>;
  updateTriageAiConfig: TriageAiConfig;
  updateUser: User;
  updateUserAdmin: User;
  updateUserDoctorRelationship: User;
  updateUserDoctorRelationships: User;
  updateUsernameAuthAdmin?: Maybe<Scalars['Boolean']['output']>;
  updateVaccination: UpdateVaccinationResponse;
  updateVirtualCareSubscriptionPaymentMethod?: Maybe<Scalars['Boolean']['output']>;
  updateVirtualCareSubscriptionStatus?: Maybe<Scalars['Boolean']['output']>;
  updateWorkgroup: Workgroup;
  updateWorkgroupRolesPermissions: Workgroup;
  uploadDocument?: Maybe<UploadDocumentResponse>;
  uploadDocuments?: Maybe<UploadDocumentsResponse>;
  uploadIdentityDocument?: Maybe<UploadIdentityDocumentResponse>;
  uploadMedicalReportDocumentsPDL: Scalars['Boolean']['output'];
  uploadPai: SissSessionResult;
  upsertLifestyleInformation: LifestyleInformation;
  usePartnerCode: PartnerCode;
  validaFlussoCda2ParseSiss: MultiregionBooleanResult;
  validaFlussoCda2SissCloud: MultiregionBooleanResult;
  verificaArruolabilitaParseSiss: VerificaArruolabilitaParseSissResult;
  verificaArruolabilitaSissCloud: VerificaArruolabilitaParseSissResult;
  verificaPresaInCaricoAttivaParseSiss: ParseSissStatusResult;
  verificaPresaInCaricoAttivaSissCloud: ParseSissStatusResult;
  verify: MaybeAuthData;
  verifyAssistedUser: Scalars['Boolean']['output'];
  verifyOtp: VerifyOtpResult;
  verifyPaymentIntent?: Maybe<PayReservationResult>;
  visualizzaPrescrittoRBParseSiss: MultiregionBooleanResult;
  visualizzaPrescrittoRBSissCloud: MultiregionBooleanResult;
  visualizzaTestoRefertoParseSiss: VisualizzaTestoRefertoResult;
  visualizzazionePianoTerapeuticoAifaParseSiss: TherapeuticPlan;
  welcomeSmsSettingsByDoctorOrPatient: WelcomeSmsSettingsByDoctorOrPatientPayload;
};


export type MutationAcceptIdentityValidationArgs = {
  identityValidationId: Scalars['String']['input'];
};


export type MutationAcceptRelationshipArgs = {
  fseAccessGranted?: InputMaybe<Scalars['Boolean']['input']>;
  relationshipId: Scalars['ID']['input'];
};


export type MutationAcceptReservationArgs = {
  reservationId: Scalars['ID']['input'];
};


export type MutationAddAvailabilityArgs = {
  addHoliday?: InputMaybe<Scalars['Boolean']['input']>;
  allSpecialityTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  alternateWeeks: Scalars['Boolean']['input'];
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  isAvailableToMyPatient: Scalars['Boolean']['input'];
  isAvailableToWorkgroupPatient?: InputMaybe<Scalars['Boolean']['input']>;
  newSlot: SlotInput;
  recurringWeeks?: InputMaybe<Scalars['Int']['input']>;
  recurringWeeksOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  slotSpecialities?: InputMaybe<Array<SlotSpecialityInput>>;
  specialityTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
  workgroup?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddCardToPatientArgs = {
  cardHolder: Scalars['String']['input'];
  cardToken: Scalars['String']['input'];
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddCommentToFeedbackArgs = {
  content: Scalars['String']['input'];
  feedbackId: Scalars['String']['input'];
};


export type MutationAddFamilyMemberWithRelationshipArgs = {
  birth: BirthInput;
  caregiverTutor?: InputMaybe<Scalars['Boolean']['input']>;
  childId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  relationshipType: RelationshipType;
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
};


export type MutationAddLocationArgs = {
  location: UserLocationInput;
};


export type MutationAddMedicalInstructionArgs = {
  medicalInstructionInput: MedicalInstructionInput;
};


export type MutationAddOrEditTagArgs = {
  tagInput?: InputMaybe<TagInput>;
};


export type MutationAddPaiPrescriptionLotArgs = {
  paiData: Array<PaiPrescriptionLotData>;
};


export type MutationAddPatientArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  emails?: InputMaybe<Array<Scalars['EmailAddress']['input']>>;
  foreignAndSeafarinOptions?: InputMaybe<ForeignAndSeafarinInput>;
  homeAddress?: InputMaybe<StructuredAddressInput>;
  isFamilyDoctor?: InputMaybe<Scalars['Boolean']['input']>;
  listName?: InputMaybe<RelationshipPatientList>;
  name: Scalars['String']['input'];
  numIdentPers?: InputMaybe<Scalars['String']['input']>;
  patientRequestSettings?: InputMaybe<PatientRequestSettingsInput>;
  phones?: InputMaybe<Array<PhonesInput>>;
  regime: PatientRegime;
  sex?: InputMaybe<Sex>;
  surname: Scalars['String']['input'];
  taxCode?: InputMaybe<Scalars['TaxCode']['input']>;
  temporaryEndAt?: InputMaybe<Scalars['Timestamp']['input']>;
  temporaryStartAt?: InputMaybe<Scalars['Timestamp']['input']>;
  welcomeSmsSettings?: InputMaybe<WelcomeSmsSettingsInput>;
};


export type MutationAddPatientEmailArgs = {
  email: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  primary: Scalars['Boolean']['input'];
};


export type MutationAddPatientParseSissV2Args = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  xml: Scalars['String']['input'];
};


export type MutationAddPatientPhoneArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  primary: Scalars['Boolean']['input'];
};


export type MutationAddPatientSissCloudArgs = {
  patientTaxCode: Scalars['String']['input'];
};


export type MutationAddRelationshipArgs = {
  childId: Scalars['ID']['input'];
  familyDoctor?: InputMaybe<Scalars['Boolean']['input']>;
  fseAccessGranted?: InputMaybe<Scalars['Boolean']['input']>;
  listName?: InputMaybe<RelationshipPatientList>;
  parentId: Scalars['ID']['input'];
  relationshipType: RelationshipType;
};


export type MutationAddRelationshipFromContactsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};


export type MutationAddRelativeArgs = {
  relativeInput: AddRelativeInput;
};


export type MutationAddUserContactsAndSendWelcomeMessageArgs = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  patientId: Scalars['ID']['input'];
  phone: PhonesInput;
  welcomeSmsSettings?: InputMaybe<WelcomeSmsSettingsInput>;
};


export type MutationAddUsersToWorkgroupArgs = {
  userIds: Array<Scalars['ID']['input']>;
  workgroupID: Scalars['String']['input'];
};


export type MutationAddUsersToWorkgroupsByTaxCodeAdminArgs = {
  taxCodes: Array<Scalars['String']['input']>;
  workgroupIds: Array<Scalars['ID']['input']>;
};


export type MutationAddVideocallLogArgs = {
  logInput: LogInput;
};


export type MutationAddWorkgroupArgs = {
  address?: InputMaybe<StructuredAddressInput>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  color: WorkgroupColor;
  coordinators?: InputMaybe<Array<Scalars['ID']['input']>>;
  displayName: Scalars['String']['input'];
  isWorkgroupHiddenInAgenda?: InputMaybe<Scalars['Boolean']['input']>;
  isWorkgroupHiddenInApp?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  operators?: InputMaybe<Array<Scalars['ID']['input']>>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  type: WorkgroupType;
};


export type MutationAdminDeleteAuthenticationArgs = {
  authId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  sendBlockNotification?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAdminSendInclinicEmailArgs = {
  mailType: ReservationMailType;
  reservationId: Scalars['String']['input'];
};


export type MutationAggiornaPaiParseSissArgs = {
  paiId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationAggiornaPaiSissCloudArgs = {
  paiId: Scalars['ID']['input'];
};


export type MutationAnnotateTranscriptionArgs = {
  input: AnnotateTranscriptionInput;
};


export type MutationAnnullaPaiParseSissArgs = {
  paiId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationAnnullaPaiSissCloudArgs = {
  paiId: Scalars['ID']['input'];
};


export type MutationAnnullaPrescrizioneBiancaParseSissArgs = {
  prescriptionId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationAnnullaPrescrizioneBiancaSissCloudArgs = {
  prescriptionId: Scalars['ID']['input'];
};


export type MutationAnnullaPrescrizioneParseSissArgs = {
  prescriptionId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationAnnullaPrescrizioneSissCloudArgs = {
  prescriptionId: Scalars['ID']['input'];
};


export type MutationAnnullamentoPianoTerapeuticoAifaParseSissArgs = {
  planId: Scalars['ID']['input'];
  xml?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchivePaiExternallyArgs = {
  input: Array<PaiDataArchiveExternally>;
};


export type MutationArchivePrescriptionsArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  prescriptionIds: Array<Scalars['ID']['input']>;
};


export type MutationAuthWithSpidServiceArgs = {
  payload: Scalars['String']['input'];
};


export type MutationBlockIdentityValidationArgs = {
  blockedMessage: Scalars['String']['input'];
  identityValidationId: Scalars['String']['input'];
};


export type MutationBookPrescriptionReservationArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  prescriptionId: Scalars['ID']['input'];
  provisionPeriod?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['UnsignedInt']['input']>;
};


export type MutationBookReservationV2Args = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingCap?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingDistrict?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingSurname?: InputMaybe<Scalars['String']['input']>;
  billingTaxCode?: InputMaybe<Scalars['String']['input']>;
  cardToken?: InputMaybe<Scalars['String']['input']>;
  channel: ReservationChannel;
  chronicPatient?: InputMaybe<Scalars['Boolean']['input']>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  createRelationshipWithDoctor?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  duration?: InputMaybe<Scalars['UnsignedInt']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<ReservationOrigin>;
  patientBirth?: InputMaybe<Scalars['Timestamp']['input']>;
  patientBirthCity?: InputMaybe<Scalars['String']['input']>;
  patientBirthDistrict?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  patientName?: InputMaybe<Scalars['String']['input']>;
  patientSex?: InputMaybe<Sex>;
  patientSurname?: InputMaybe<Scalars['String']['input']>;
  patientTaxCode?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['UnsignedInt']['input'];
  specialityShowcase?: InputMaybe<SpecialityShowcase>;
  specialityTemplateId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['Timestamp']['input']>;
  viewers?: InputMaybe<Array<Scalars['ID']['input']>>;
  workgroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBulkAddOrEditOutpatientServiceOutcomeParametersArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: Array<OutpatientServiceOutcomeParameterInput>;
  outpatientServiceOutcomeId: Scalars['ID']['input'];
};


export type MutationBulkAddOrEditOutpatientServiceOutcomeServiceExamParametersArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: Array<OutpatientServiceOutcomeServiceExamParameterInput>;
  outpatientServiceOutcomeId: Scalars['ID']['input'];
};


export type MutationBulkSendBillingsArgs = {
  input: BulkSendBillingsInput;
};


export type MutationCancelAccountArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCancelBillingArgs = {
  input: CancelBillingInput;
};


export type MutationCancelCalendarEventArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationCancelClinicWorkgroupsClosuresArgs = {
  clinicClosureId: Scalars['String']['input'];
};


export type MutationCancelDraftPaiArgs = {
  paiId: Scalars['ID']['input'];
};


export type MutationCancelDrugReservationDrugstoreArgs = {
  id: Scalars['ObjectId']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelDrugReservationPatientArgs = {
  id: Scalars['ObjectId']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelPatientSummaryArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  input: CancelPatientSummaryInput;
};


export type MutationCancelPaymentIntentArgs = {
  paymentIntent: Scalars['String']['input'];
};


export type MutationCancelPrescriptionArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  idSession?: InputMaybe<Scalars['String']['input']>;
  prescriptionId: Scalars['ID']['input'];
};


export type MutationCancelRecurrenceCalendarEventArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  recurringId: Scalars['String']['input'];
};


export type MutationCancelSetupIntentArgs = {
  setupIntent: Scalars['String']['input'];
};


export type MutationCancelSubscriptionPlanUsersArgs = {
  userId: Scalars['ObjectId']['input'];
};


export type MutationCancelTherapeuticPlanArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  id: Scalars['ID']['input'];
};


export type MutationCancelVirtualCareSubscriptionArgs = {
  cancelCustomReason?: InputMaybe<Scalars['String']['input']>;
  cancelCustomerSuggestion?: InputMaybe<Scalars['String']['input']>;
  cancelReason?: InputMaybe<VirtualCareSubscriptionCancelReason>;
  subscriptionId: Scalars['String']['input'];
};


export type MutationCancellaCertificatoMalattiaParseSissArgs = {
  certificateId?: InputMaybe<Scalars['ID']['input']>;
  xml: Scalars['String']['input'];
};


export type MutationCancellaCertificatoMalattiaSissCloudArgs = {
  certificateId: Scalars['ID']['input'];
};


export type MutationChangeAuthenticationPasswordAdminArgs = {
  authenticationId: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationCompleteDrugReservationsDrugstoreArgs = {
  ids: Array<Scalars['ObjectId']['input']>;
};


export type MutationCompleteReservationDeferredPaymentArgs = {
  input: CompleteReservationDeferredPaymentInput;
};


export type MutationConfirmDrugReservationDrugstoreArgs = {
  id: Scalars['ObjectId']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConfirmDrugReservationPatientArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationConfirmReservationArgs = {
  inclinicCreateReservationInput: InclinicCreateReservationInput;
};


export type MutationConfirmReservationWithoutEmailsArgs = {
  virtualcareCreateReservationInput: VirtualcareCreateReservationInput;
};


export type MutationConsultaDocumentiFascicoloParseSissArgs = {
  xml: Scalars['String']['input'];
};


export type MutationConsultaEsenzioniPrescrittoreSissCloudArgs = {
  lastFiveDigitsTS: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
  registryType?: InputMaybe<EsenzioniTipoAnagraficaSiss>;
};


export type MutationConsultaStatoParseSissArgs = {
  xml: Scalars['String']['input'];
};


export type MutationConsultaStatoSissCloudArgs = {
  patientId: Scalars['ID']['input'];
};


export type MutationConvertPrescriptionsToNonDemArgs = {
  prescriptionIds: Array<Scalars['ID']['input']>;
};


export type MutationCreateAdminUserArgs = {
  firstName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  surname: Scalars['String']['input'];
};


export type MutationCreateAmbulatoryTestArgs = {
  ambulatoryTest: AmbulatoryTestInput;
};


export type MutationCreateAnamnesisArgs = {
  input: CreateAnamnesisInput;
  patientId: Scalars['ID']['input'];
};


export type MutationCreateAssistedUserAuthenticationArgs = {
  assistedUserId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  username: Scalars['Username']['input'];
};


export type MutationCreateAuthProviderArgs = {
  input: FreenetAuthProviderInput;
};


export type MutationCreateAuthUsersArgs = {
  inputs: Array<FreenetAuthUserInput>;
};


export type MutationCreateAuthenticationForAdminArgs = {
  password: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
  username: Scalars['Username']['input'];
};


export type MutationCreateBlacklistEntryArgs = {
  input: CreateBlacklistEntryInput;
};


export type MutationCreateCalendarEventArgs = {
  category: EventCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  endTime: Scalars['Timestamp']['input'];
  recurrence?: InputMaybe<EventRecurrence>;
  startTime: Scalars['Timestamp']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  workgroup?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateCancellationPaiArgs = {
  cancelEnlisting: Scalars['Boolean']['input'];
  paiId: Scalars['ID']['input'];
};


export type MutationCreateCertificateArgs = {
  certificateType: CertificateType;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
  templateCertificateOptions: TemplateCertificateOptionsInput;
};


export type MutationCreateCertificateTemplateArgs = {
  input: CreateCertificateTemplateInput;
};


export type MutationCreateChatArgs = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  origin: ChatOrigin;
  users: Array<Scalars['ID']['input']>;
};


export type MutationCreateClinicGroupArgs = {
  clinicGroup: AddClinicGroupInput;
};


export type MutationCreateClinicWorkgroupArgs = {
  workgroup: CreateClinicWorkgroupInput;
};


export type MutationCreateClinicWorkgroupsClosuresArgs = {
  endTime: Scalars['Timestamp']['input'];
  startTime: Scalars['Timestamp']['input'];
  title: Scalars['String']['input'];
  workgroups: Array<Scalars['ID']['input']>;
};


export type MutationCreateDiaryArgs = {
  document?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  transcriptionResult?: InputMaybe<TranscriptionDiaryInput>;
  type: DiaryType;
};


export type MutationCreateDiseaseCertificateArgs = {
  diseaseCertificateAddress?: InputMaybe<StructuredAddressInput>;
  diseaseCertificateAvailabilityAddress?: InputMaybe<StructuredAddressInputWithSurname>;
  diseaseCertificateOptions: DiseaseCertificateOptionsInput;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
};


export type MutationCreateDrugReservationPatientArgs = {
  drugstoreId: Scalars['ObjectId']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  prescriptionId: Scalars['ObjectId']['input'];
};


export type MutationCreateHospitalAdmissionFormArgs = {
  advanceNoticeBeforeDischarge?: InputMaybe<Scalars['Boolean']['input']>;
  allergies?: InputMaybe<Array<HospitalizationStringParamInput>>;
  availabilityWithPhoneAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  bloodType?: InputMaybe<HospitalizationStringParamInput>;
  celiacDiseaseIssues?: InputMaybe<Array<HospitalizationStringParamInput>>;
  chronicDrugs?: InputMaybe<Array<LastDrugPrescriptionInput>>;
  chronicServices?: InputMaybe<Array<LastServicePrescriptionInput>>;
  detailedClinicalReportRequest?: InputMaybe<Scalars['Boolean']['input']>;
  drugAddiction?: InputMaybe<HospitalizationStringParamInput>;
  hospitalWard?: InputMaybe<Scalars['String']['input']>;
  intolerances?: InputMaybe<Array<HospitalizationStringParamInput>>;
  lifestyle?: InputMaybe<HospitalizationStringParamInput>;
  medicalDevices?: InputMaybe<Array<HospitalizationStringParamInput>>;
  medicalRecordsNotes?: InputMaybe<Scalars['String']['input']>;
  missingOrgans?: InputMaybe<Array<HospitalizationStringParamInput>>;
  notSelfSufficiencies?: InputMaybe<HospitalizationStringParamInput>;
  ordinaryDrugs?: InputMaybe<Array<LastDrugPrescriptionInput>>;
  ordinaryServices?: InputMaybe<Array<LastServicePrescriptionInput>>;
  patientId: Scalars['ID']['input'];
  pregnancy?: InputMaybe<HospitalizationStringParamInput>;
  prescriptionId: Scalars['ID']['input'];
  prescriptionNotes?: InputMaybe<Scalars['String']['input']>;
  problemNotes?: InputMaybe<Scalars['String']['input']>;
  problems?: InputMaybe<Array<HospitalizationProblemInput>>;
  professions?: InputMaybe<Array<HospitalizationStringParamInput>>;
  prosthesis?: InputMaybe<Array<HospitalizationStringParamInput>>;
  reasonForHospitalization: Scalars['String']['input'];
  surgicalProcedures?: InputMaybe<Array<HospitalizationStringParamInput>>;
  textualDiagnosis?: InputMaybe<Scalars['String']['input']>;
  transplants?: InputMaybe<Array<HospitalizationStringParamInput>>;
};


export type MutationCreateInvoiceArgs = {
  input: InvoiceInput;
  subscriptionPlanUserId: Scalars['ObjectId']['input'];
};


export type MutationCreateLeadArgs = {
  leadInput: LeadInput;
};


export type MutationCreateManualSissReportArgs = {
  patientId: Scalars['ID']['input'];
};


export type MutationCreateMeasurementArgs = {
  input: MeasurementInput;
  patientId: Scalars['ID']['input'];
};


export type MutationCreateMeasurementsArgs = {
  inputs: Array<MeasurementInput>;
  patientId: Scalars['ID']['input'];
};


export type MutationCreateMedicalReportArgs = {
  input: MedicalReportsInput;
};


export type MutationCreateMedicalReportV2Args = {
  input: CreateMedicalReportV2Input;
};


export type MutationCreateNextPaiArgs = {
  patientId: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateSpecialityArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: CreateSpecialityInput;
};


export type MutationCreateOrUpdateVaccinationArgs = {
  vaccination: VaccinationInput;
  vaccinationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateOutpatientServiceCustomGroupArgs = {
  input: OutpatientServiceGroupInput;
};


export type MutationCreatePaiArgs = {
  alcohol?: InputMaybe<LifestyleInformationValue>;
  allergiesArray?: InputMaybe<Array<AllergiesInput>>;
  availabilityNote?: InputMaybe<Scalars['String']['input']>;
  chronicDrugs?: InputMaybe<Array<DrugParamInput>>;
  chronicOutpatients?: InputMaybe<Array<OutpatientServiceParamInputRequired>>;
  clinicalRecommendations?: InputMaybe<Scalars['String']['input']>;
  counselingServices?: InputMaybe<Array<SimpleServicesInput>>;
  deletedDrugs?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedOutpatientServices?: InputMaybe<Array<DeletedOutpatientServiceInput>>;
  deletedProblems?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedVaccinations?: InputMaybe<Array<Scalars['String']['input']>>;
  exemptionsArray?: InputMaybe<Array<ExemptionsInput>>;
  from: Scalars['Timestamp']['input'];
  goal: Scalars['String']['input'];
  height?: InputMaybe<Scalars['UnsignedInt']['input']>;
  hospitalizationServices?: InputMaybe<Array<SimpleServicesInput>>;
  lifestyleNotes?: InputMaybe<Scalars['String']['input']>;
  otherGoal?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  patientPhoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  phoneContacts?: InputMaybe<Array<PhoneContactInput>>;
  primaryProblem?: InputMaybe<Scalars['String']['input']>;
  problems: Array<PaiProblemInput>;
  prostheticServices?: InputMaybe<Array<SimpleServicesInput>>;
  smoke?: InputMaybe<LifestyleInformationValue>;
  sportActivity?: InputMaybe<LifestyleInformationValue>;
  vaccinationServices?: InputMaybe<Array<SimpleServicesInput>>;
  vaccinationsArray?: InputMaybe<Array<VaccinationsInput>>;
  weight?: InputMaybe<Scalars['UnsignedInt']['input']>;
};


export type MutationCreatePartnerArgs = {
  courses?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  paymentGateway?: InputMaybe<Array<InputMaybe<PaymentGateway>>>;
};


export type MutationCreatePatientAuthArgs = {
  password: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationCreatePatientMedicalDevicesArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: Array<CreatePatientMedicalDeviceInput>;
  patientId: Scalars['ID']['input'];
};


export type MutationCreatePatientProblemArgs = {
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  patientId: Scalars['ID']['input'];
  problemPayload: ProblemInput;
};


export type MutationCreatePatientRequestArgs = {
  doctorId: Scalars['ID']['input'];
  input: CreateRequestInput;
};


export type MutationCreatePatientRequestDoctorArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: CreateRequestInput;
  patientId: Scalars['ID']['input'];
};


export type MutationCreatePatientSummaryArgs = {
  input: CreatePatientSummaryInput;
};


export type MutationCreatePaymentIntentArgs = {
  price: Scalars['Int']['input'];
  promoCode: Scalars['String']['input'];
};


export type MutationCreatePrescriptionsArgs = {
  creationMode: CreationMode;
  doctorId?: InputMaybe<Scalars['ObjectId']['input']>;
  prescriptionInputs: Array<PrescriptionInput>;
};


export type MutationCreatePrescriptionsParseSissArgs = {
  xml: Scalars['String']['input'];
};


export type MutationCreatePrescriptionsSissCloudArgs = {
  aslCodeOverride?: InputMaybe<Scalars['String']['input']>;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  prescriptionIds: Array<Scalars['ID']['input']>;
};


export type MutationCreateQuickAnswerArgs = {
  input: CreateQuickAnswerInput;
};


export type MutationCreateSetupIntentArgs = {
  input: SetupIntentInput;
};


export type MutationCreateSpecialitiesArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  showcase?: InputMaybe<SpecialityShowcase>;
  templateIds: Array<Scalars['ID']['input']>;
};


export type MutationCreateSpecialityTemplateArgs = {
  duration: Scalars['UnsignedInt']['input'];
  name: Scalars['String']['input'];
  standardPrice: Scalars['UnsignedInt']['input'];
};


export type MutationCreateStripeSubscriptionArgs = {
  couponId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  recurringType: Scalars['String']['input'];
};


export type MutationCreateSubscriptionPlanUsersArgs = {
  subscriptionPlans: Array<CreateSubscriptionPlanUserInput>;
  userId: Scalars['ObjectId']['input'];
};


export type MutationCreateTantoSvagoReservationArgs = {
  input: TantoSvagoOrderRequest;
};


export type MutationCreateUserArgs = {
  birthDate?: InputMaybe<Scalars['Timestamp']['input']>;
  macroSpeciality?: InputMaybe<MacroSpeciality>;
  name: Scalars['String']['input'];
  region: Region;
  role: Role;
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
};


export type MutationCreateVirtualCarePlanSubscriptionArgs = {
  input: CreateVirtualCarePlanSubscriptionInput;
};


export type MutationDeclineRelationshipArgs = {
  relationshipId: Scalars['ID']['input'];
};


export type MutationDeclineReservationArgs = {
  deleteAppointmentReasonType?: InputMaybe<DeleteAppointmentReason>;
  deleteMotivation?: InputMaybe<Scalars['String']['input']>;
  reservationId: Scalars['ID']['input'];
};


export type MutationDeleteAnamnesisArgs = {
  anamnesisId: Scalars['ID']['input'];
};


export type MutationDeleteAssistedUsersArgs = {
  assistedUserIds: Array<Scalars['ID']['input']>;
};


export type MutationDeleteAuthProviderArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDeleteAuthUserArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDeleteAvailabilityArgs = {
  deleteRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  slot: SlotInput;
};


export type MutationDeleteBillingArgs = {
  input: DeleteBillingInput;
};


export type MutationDeleteBillingItemTemplateArgs = {
  input: DeleteBillingItemTemplateInput;
};


export type MutationDeleteCeliacDiseaseArgs = {
  patientId: Scalars['ID']['input'];
};


export type MutationDeleteCertificateTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationDeleteClinicGroupArgs = {
  clinicGroupId: Scalars['ID']['input'];
};


export type MutationDeleteCommunicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCovidTestArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  covidTestId: Scalars['ID']['input'];
};


export type MutationDeleteDiaryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDiaryMonitoringArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDiseaseCertificateArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  certificateId: Scalars['ID']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentsArgs = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationDeleteDraftDiseaseCertificateArgs = {
  certificateId: Scalars['ID']['input'];
};


export type MutationDeleteFamilyMemberRelationshipArgs = {
  relationshipId: Scalars['ID']['input'];
};


export type MutationDeleteManualSissReportArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationDeleteMeasurementArgs = {
  measurementId: Scalars['ID']['input'];
};


export type MutationDeleteMedicalInstructionArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  medicalInstructionId: Scalars['ID']['input'];
};


export type MutationDeleteMedicalReportV2Args = {
  input: DeleteMedicalReportV2Input;
};


export type MutationDeleteMessageArgs = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  messageId: Scalars['ID']['input'];
};


export type MutationDeleteNotificationArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationDeleteOutpatientServiceGroupsArgs = {
  groupsIds: Array<Scalars['ID']['input']>;
};


export type MutationDeleteOutpatientServiceOutcomeArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  outpatientServiceOutcomeId: Scalars['ID']['input'];
};


export type MutationDeleteOutpatientServiceOutcomeParameterArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  loincCode: Scalars['String']['input'];
  outpatientServiceOutcomeId: Scalars['ID']['input'];
};


export type MutationDeleteOutpatientServiceOutcomeServiceExamParameterArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  outpatientServiceOutcomeId: Scalars['ID']['input'];
  serviceExamCode: Scalars['String']['input'];
};


export type MutationDeletePatientMedicalDevicesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePatientProblemArgs = {
  problemId: Scalars['ID']['input'];
};


export type MutationDeletePatientRequestsArgs = {
  input: DeletePatientRequestInput;
};


export type MutationDeletePatientSummaryArgs = {
  patientSummaryId: Scalars['ID']['input'];
};


export type MutationDeletePrescriptionsArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  prescriptionIds: Array<Scalars['ID']['input']>;
};


export type MutationDeleteQuickAnswerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRegionalSystemCredentialsArgs = {
  type: RegionalSystemCredentialsTypes;
  userId: Scalars['ID']['input'];
};


export type MutationDeleteRelativeArgs = {
  relativeId: Scalars['ID']['input'];
};


export type MutationDeleteReservationByUserArgs = {
  motivation?: InputMaybe<Scalars['String']['input']>;
  secret: Scalars['String']['input'];
};


export type MutationDeleteReservationByUserWithoutEmailsArgs = {
  motivation?: InputMaybe<Scalars['String']['input']>;
  secret: Scalars['String']['input'];
};


export type MutationDeleteSpecialityTemplateArgs = {
  input: DeleteSpecialityTemplateInput;
};


export type MutationDeleteStripeSubscriptionArgs = {
  subscriptionPlanUserId: Scalars['ObjectId']['input'];
};


export type MutationDeleteSubscriptionPlanUserArgs = {
  subscriptionPlanUserId: Scalars['ObjectId']['input'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTherapeuticPlanArgs = {
  therapeuticPlanId: Scalars['ID']['input'];
};


export type MutationDeleteUserAdminArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserDoctorRelationshipArgs = {
  doctorId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};


export type MutationDeleteUserDoctorRelationshipsArgs = {
  doctorIds: Array<Scalars['ObjectId']['input']>;
  userId: Scalars['ObjectId']['input'];
};


export type MutationDeleteVaccinationArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  vaccinationId: Scalars['ID']['input'];
};


export type MutationDeleteWhitePrescriptionArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  idSession?: InputMaybe<Scalars['String']['input']>;
  prescriptionId: Scalars['ID']['input'];
};


export type MutationDeleteWorkgroupArgs = {
  workgroupID: Scalars['String']['input'];
};


export type MutationDeleteWorkgroupAvailabilitySlotsForAdminArgs = {
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  workgroupId: Scalars['ID']['input'];
};


export type MutationDeleteWorkgroupSpecialityTemplatesForAdminArgs = {
  workgroupId: Scalars['ID']['input'];
};


export type MutationDisarruolaParseSissArgs = {
  patientId: Scalars['ID']['input'];
  status?: InputMaybe<VerificationStatusEnlistingEnum>;
  xml: Scalars['String']['input'];
};


export type MutationDisarruolaSissCloudArgs = {
  motivation: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
  status?: InputMaybe<VerificationStatusEnlistingEnum>;
};


export type MutationDownloadDataArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDownloadDiseaseCertificatesArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDownloadExemptionsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type MutationDownloadMedicalReportDocumentsArgs = {
  input: DownloadMedicalReportDocumentsInput;
};


export type MutationDownloadPatientArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  doctorIdOnBehalfOf?: InputMaybe<Scalars['ID']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  sanitaryCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDownloadPatientCovidTestsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  patientId: Scalars['ID']['input'];
};


export type MutationDownloadPatientExemptionsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  patientId: Scalars['ID']['input'];
};


export type MutationDownloadPatientsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  autoMessage?: InputMaybe<Scalars['String']['input']>;
  deleteUsersNotInRegionalSystem: Scalars['Boolean']['input'];
  treatmentDataApproval: Scalars['Boolean']['input'];
};


export type MutationDownloadSantagostinoReportArgs = {
  input: DownloadSantagostinoReportInput;
};


export type MutationDownloadTherapeuticPlanArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  id: Scalars['ID']['input'];
};


export type MutationDownloadTherapeuticPlansArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  patientId: Scalars['ID']['input'];
  planType: PlanRequestType;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type MutationDownloadVaccinationsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  patientId: Scalars['ID']['input'];
};


export type MutationEditAvailabilityArgs = {
  allSpecialityTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  isAvailableToMyPatient: Scalars['Boolean']['input'];
  isAvailableToWorkgroupPatient?: InputMaybe<Scalars['Boolean']['input']>;
  newSlot: SlotInput;
  recurringWeeks?: InputMaybe<Scalars['Int']['input']>;
  slot: SlotInput;
  slotSpecialities?: InputMaybe<Array<SlotSpecialityInput>>;
  specialityTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
  workgroup?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationEditOutcomeInterpretationArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  interpretation: OutpatientServiceOutcomeInterpretation;
  outpatientServiceOutcomeId: Scalars['ID']['input'];
};


export type MutationEditOutcomeParameterInterpretationArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  interpretation: OutpatientServiceOutcomeInterpretation;
  loincCode: Scalars['String']['input'];
  outpatientServiceOutcomeId: Scalars['ID']['input'];
};


export type MutationEditOutpatientServiceOutcomeParameterArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: OutpatientServiceOutcomeParameterInput;
  outpatientServiceOutcomeId: Scalars['ID']['input'];
};


export type MutationEditOutpatientServiceOutcomeServiceExamParameterArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: OutpatientServiceOutcomeServiceExamParameterInput;
  outpatientServiceOutcomeId: Scalars['ID']['input'];
};


export type MutationEditPatientRequestInternalNoteArgs = {
  internalNote?: InputMaybe<Scalars['String']['input']>;
  patientRequestId: Scalars['ID']['input'];
};


export type MutationEditTaxCodeAuthenticationArgs = {
  oldTaxCode: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
};


export type MutationElencoProtocolliPianiTerapeuticiAifaParseSissArgs = {
  patientId: Scalars['ID']['input'];
  xml?: InputMaybe<Scalars['String']['input']>;
};


export type MutationElencoProtocolliPianiTerapeuticiAifaSissCloudArgs = {
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  patientId: Scalars['ID']['input'];
  planType: PlanRequestType;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type MutationExportPatientsArgs = {
  inputs: Array<FreenetExportPatientsInput>;
};


export type MutationExtendAvailabilitiesForClinicWorkgroupsArgs = {
  startDateAsSeconds?: InputMaybe<Scalars['Timestamp']['input']>;
  workgroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationFirmaPaiParseSissArgs = {
  paiId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationForceDeleteUserParamArgs = {
  paramId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type MutationGeneratePartnerCodesArgs = {
  coupons?: InputMaybe<Array<Scalars['ID']['input']>>;
  daysOfExpiration?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  numberCoupons?: InputMaybe<Scalars['Int']['input']>;
  partners: Array<Scalars['ID']['input']>;
  prefixCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGeneratePssCda2DocumentArgs = {
  input: GeneratePssCda2DocumentInput;
};


export type MutationGeneratePssDocumentsForFseArgs = {
  input: GeneratePssDocumentsForFseInput;
};


export type MutationGeneratesCouponForPatientArgs = {
  expiration: Scalars['Timestamp']['input'];
  numberCoupons: Scalars['Int']['input'];
  percentage: Scalars['Int']['input'];
  specialityTemplates: Array<Scalars['ID']['input']>;
  user: Scalars['ID']['input'];
};


export type MutationGeneratesCouponsArgs = {
  available?: InputMaybe<Scalars['Int']['input']>;
  expiration?: InputMaybe<Scalars['Timestamp']['input']>;
  fixed?: InputMaybe<Scalars['Int']['input']>;
  macroSpecialities?: InputMaybe<Array<InputMaybe<MacroSpeciality>>>;
  numberCoupons: Scalars['Int']['input'];
  partner?: InputMaybe<Scalars['ID']['input']>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  specialityTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: CouponType;
  unlimited: Scalars['Boolean']['input'];
  user?: InputMaybe<Scalars['ID']['input']>;
  userTaxCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetPaperPrescriptionNreArgs = {
  ownerId: Scalars['String']['input'];
  prescriptionId: Scalars['String']['input'];
};


export type MutationGetSantagostinoPatientReportsArgs = {
  doctorId: Scalars['ObjectId']['input'];
  patientTaxcode: Scalars['String']['input'];
};


export type MutationGrantFseAccessArgs = {
  relationshipId: Scalars['ID']['input'];
};


export type MutationHideDiaryLogArgs = {
  diaryLogId: Scalars['ID']['input'];
};


export type MutationHideImportedUserNotesArgs = {
  noteIds: Array<Scalars['ID']['input']>;
};


export type MutationHideInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
  subscriptionPlanUserId: Scalars['ObjectId']['input'];
};


export type MutationHideUserParamsArgs = {
  paramIds: Array<Scalars['ID']['input']>;
};


export type MutationIdentificaCittadinoParseSissArgs = {
  isPatientCardInserted: Scalars['Boolean']['input'];
  patientId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationIdentificaCittadinoSissCloudArgs = {
  isPatientCardInserted: Scalars['Boolean']['input'];
  patientId: Scalars['ID']['input'];
};


export type MutationIdentificaCittadinoV2ParseSissArgs = {
  isPatientCardInserted: Scalars['Boolean']['input'];
  patientId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationIdentificaCittadinoV2SissCloudArgs = {
  isPatientCardInserted: Scalars['Boolean']['input'];
  patientId: Scalars['ID']['input'];
};


export type MutationIdentificaPrescrizioneParseSissArgs = {
  iup?: InputMaybe<Scalars['String']['input']>;
  nrbe?: InputMaybe<Scalars['String']['input']>;
  nre?: InputMaybe<Scalars['String']['input']>;
  pinNrbe?: InputMaybe<Scalars['String']['input']>;
  xml: Scalars['String']['input'];
};


export type MutationIdentificaPrescrizioneSissCloudArgs = {
  iup?: InputMaybe<Scalars['String']['input']>;
  nrbe?: InputMaybe<Scalars['String']['input']>;
  nre?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  pinNrbe?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImportPatientContactsArgs = {
  file: Scalars['Upload']['input'];
  settings?: InputMaybe<WelcomeSmsSettingsInput>;
};


export type MutationImportPatientContactsWithAnagraphicsArgs = {
  file: Scalars['Upload']['input'];
  settings?: InputMaybe<ImportContactAnagraphicsCsvInputSettings>;
};


export type MutationImportPatientPaiDataArgs = {
  paiData: ImportPaiDataInput;
  paiId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type MutationImportPatientsArgs = {
  inputs: Array<FreenetImportPatientsInput>;
};


export type MutationImportPatientsForAmtArgs = {
  file: Scalars['Upload']['input'];
  settings: ImportPatientsForAmtInputSettings;
};


export type MutationImportPersonalDataSissArgs = {
  file: Scalars['Upload']['input'];
  settings?: InputMaybe<ImportFromSissCsvInputSettings>;
};


export type MutationIncrementVideoconsultoUsageArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationInsertBillingArgs = {
  input: InsertBillingInput;
};


export type MutationInsertBillingItemTemplateArgs = {
  input: InsertBillingItemTemplateInput;
};


export type MutationInsertOutpatientServiceOutcomesArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: Array<OutpatientServiceOutcomesInput>;
};


export type MutationInsertTherapeuticPlansArgs = {
  input: InsertTherapeuticPlanInput;
};


export type MutationInvioCertificatoMalattiaParseSissArgs = {
  certificateId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationInvitePatientForMonitoringArgs = {
  patientId: Scalars['ID']['input'];
};


export type MutationInvitePatientToJoinCallArgs = {
  patientId: Scalars['ID']['input'];
  reservationId: Scalars['ID']['input'];
};


export type MutationInviteToDownloadAppArgs = {
  input: InviteInput;
};


export type MutationMakeAvailableNreArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarcaPaiParseSissArgs = {
  paiId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationMarkFeedbackAsReadArgs = {
  feedbackId: Scalars['String']['input'];
};


export type MutationMarkFeedbackAsResolvedArgs = {
  feedbackId: Scalars['String']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationMergeUsersAdminArgs = {
  fieldsToTransfer: Array<Scalars['String']['input']>;
  fromUserId: Scalars['ID']['input'];
  toUserId: Scalars['ID']['input'];
};


export type MutationNotifyPatientOfPrescriptionsArgs = {
  prescriptionIds: Array<Scalars['ID']['input']>;
};


export type MutationOttieniPatologieParseSissArgs = {
  patientId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationOttieniPatologieSissCloudArgs = {
  patientId: Scalars['ID']['input'];
};


export type MutationOttieniTabellaParseSissArgs = {
  xmls: Array<Scalars['String']['input']>;
};


export type MutationPayReservationArgs = {
  cardToken: Scalars['String']['input'];
  paymentGateway: PaymentGateway;
  reservationId: Scalars['ID']['input'];
};


export type MutationPrenotaArruolamentoParseSissArgs = {
  patientId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationPrenotaArruolamentoSissCloudArgs = {
  patientId: Scalars['ID']['input'];
  primaryDisease?: InputMaybe<Scalars['String']['input']>;
  secondaryDiseases?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationPreviewAmtPatientsFileArgs = {
  file: Scalars['Upload']['input'];
  separator: Scalars['String']['input'];
};


export type MutationPubblicaPaiParseSissArgs = {
  paiId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationPubblicaPaiSissCloudArgs = {
  paiId: Scalars['ID']['input'];
};


export type MutationPublishCovidTestArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  covidTestId: Scalars['ID']['input'];
};


export type MutationPublishDiseaseCertificateArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  certificateId: Scalars['ID']['input'];
};


export type MutationPublishPatientSummaryArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  authorInstitution: Scalars['String']['input'];
  base64: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
  userStructure: Scalars['String']['input'];
};


export type MutationPublishPrescriptionsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  idSession?: InputMaybe<Scalars['String']['input']>;
  prescriptionIds: Array<Scalars['ID']['input']>;
  userOnBehalfOfId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationPublishVaccinationArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  vaccinationId: Scalars['ID']['input'];
};


export type MutationPublishWhitePrescriptionsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  idSession?: InputMaybe<Scalars['String']['input']>;
  prescriptionIds: Array<Scalars['ID']['input']>;
};


export type MutationReadAllNotificationsForCategoryArgs = {
  category: NotificationCategory;
};


export type MutationRecordNpsVoteArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Int']['input'];
};


export type MutationRefundBillingArgs = {
  input: RefundBillingInput;
};


export type MutationRegistraPrescrizioniBiancheParseSissArgs = {
  xml: Scalars['String']['input'];
};


export type MutationRegistraPrescrizioniBiancheSissCloudArgs = {
  prescriptionIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveBlacklistEntryArgs = {
  doctorId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type MutationRemovePatientAuthArgs = {
  credentialId: Scalars['String']['input'];
  emailIdToRemove?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  phoneIdToRemove?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemovePatientEmailArgs = {
  emailId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
};


export type MutationRemovePatientPhoneArgs = {
  patientId: Scalars['String']['input'];
  phoneId: Scalars['String']['input'];
};


export type MutationRemoveUsersFromWorkgroupArgs = {
  userIds: Array<Scalars['ID']['input']>;
  workgroupID: Scalars['String']['input'];
};


export type MutationReportAfterImportCsvArgs = {
  message: Scalars['String']['input'];
};


export type MutationRequestDataExportArgs = {
  filter: DataExportRequestInput;
};


export type MutationRequestDataImportArgs = {
  attachmentsId?: InputMaybe<Scalars['ID']['input']>;
  dataTemplate: DataImportTemplates;
  documentId: Scalars['ID']['input'];
};


export type MutationRequestOtpGenerationArgs = {
  company?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  type: AuthType;
  usage: OtpUsage;
  username: Scalars['Username']['input'];
};


export type MutationRequestPaymentSheetArgs = {
  amount: Scalars['Int']['input'];
};


export type MutationResendPrescriptionNotificationsArgs = {
  prescriptionId: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  username: Scalars['Username']['input'];
};


export type MutationResetPasswordV2Args = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['Username']['input'];
};


export type MutationResetPasswordV3Args = {
  confirmPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPatientPasswordArgs = {
  newPassword: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
};


export type MutationRetryDataImportArgs = {
  importId: Scalars['ID']['input'];
};


export type MutationRettificaCertificatoMalattiaParseSissArgs = {
  certificateId?: InputMaybe<Scalars['ID']['input']>;
  xml: Scalars['String']['input'];
};


export type MutationRettificaCertificatoMalattiaSissCloudArgs = {
  certificateId: Scalars['ID']['input'];
  validityEndDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type MutationRevokeFseAccessArgs = {
  relationshipId: Scalars['ID']['input'];
};


export type MutationRicercaCertificatiMalattiaParseSissArgs = {
  xml: Scalars['String']['input'];
};


export type MutationRicercaCertificatiMalattiaSissCloudArgs = {
  certificateId: Scalars['ID']['input'];
};


export type MutationRichiestaPromemoriaParseSissArgs = {
  xml: Scalars['String']['input'];
};


export type MutationRichiestaPromemoriaSissCloudArgs = {
  prescriptionId: Scalars['ID']['input'];
};


export type MutationRilevaCartaCittadinoParseSissArgs = {
  xml: Scalars['String']['input'];
};


export type MutationRilevaCartaOperatoreParseSissArgs = {
  xml: Scalars['String']['input'];
};


export type MutationRinnovaPaiParseSissArgs = {
  paiId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationRinnovaPaiSissCloudArgs = {
  paiId: Scalars['ID']['input'];
};


export type MutationRiscontraFirmaMarcaParseSissArgs = {
  paiId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationRunDataMigrationArgs = {
  migrationNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSaveDoctorSpecialitiesArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: Array<SaveSpecialityInput>;
};


export type MutationSaveIdentityDocumentArgs = {
  file: Scalars['Upload']['input'];
  identityType: IdentityType;
};


export type MutationSavePatientSummaryBackToUserParamsArgs = {
  editedSelectedParams: SelectedUserParamsInput;
  patientId: Scalars['ID']['input'];
};


export type MutationSaveUserParamsArgs = {
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  userParams: UserParamsInput;
};


export type MutationSendBillingArgs = {
  input: SendBillingInput;
};


export type MutationSendCommunicationArgs = {
  communicationInput: CommunicationInput;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSendDiseaseCertificateNotificationArgs = {
  input: DiseaseCertificateNotificationInput;
};


export type MutationSendInvitationsArgs = {
  input?: InputMaybe<SendInvitationsInput>;
};


export type MutationSendMessageArgs = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  chatId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationSendNotificationsForUsersArgs = {
  notification: InputNotification;
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationSendNreViaSmsArgs = {
  phone: Scalars['String']['input'];
  prescriptionId: Scalars['ID']['input'];
};


export type MutationSendPatientRequestNoteToPatientArgs = {
  noteToPatient: Scalars['String']['input'];
  noteToPatientAttachment?: InputMaybe<Scalars['Upload']['input']>;
  patientRequestId: Scalars['ID']['input'];
};


export type MutationSendRedPrescriptionsArgs = {
  prescriptionIds: Array<Scalars['ID']['input']>;
  userOnBehalfOfId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationSendTopicNotificationArgs = {
  notification: InputNotification;
  topic: Scalars['String']['input'];
};


export type MutationSetAsUnreadArgs = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  chatId: Scalars['ID']['input'];
};


export type MutationSetAtsArgs = {
  ats: Ats;
  userId: Scalars['ID']['input'];
};


export type MutationSetHighlightArgs = {
  highlight?: InputMaybe<Scalars['Boolean']['input']>;
  userParamId: Scalars['ID']['input'];
};


export type MutationSetLastUserAccessInfoArgs = {
  lastUserAccessInfo: LastUserAccessInfoInput;
};


export type MutationSetRequiredAppVersionArgs = {
  client: AppClient;
  version: Scalars['String']['input'];
};


export type MutationSetReservationAndUserConsentsArgs = {
  newsletter: Scalars['Boolean']['input'];
  privacyDavinci: Scalars['Boolean']['input'];
  taxCode: Scalars['String']['input'];
  videoSessionId: Scalars['String']['input'];
};


export type MutationSetSantagostinoConsentArgs = {
  input: SetSantagostinoConsentInput;
};


export type MutationSetSignupRequestArgs = {
  input: SignupRequestInput;
  username: Scalars['Username']['input'];
};


export type MutationSetUserSettingsArgs = {
  settings: UserSettingsInput;
};


export type MutationShowDiaryLogArgs = {
  diaryLogId: Scalars['ID']['input'];
};


export type MutationSignAndTransmitPssToFseArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  input: SignAndTransmitPssToFseInput;
};


export type MutationSignMarkPaiArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  otp: Scalars['String']['input'];
  pais: Array<PaiInputData>;
  sessionId: Scalars['String']['input'];
};


export type MutationSignupArgs = {
  ats?: InputMaybe<Scalars['ID']['input']>;
  birthCity?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Company>;
  confirmPassword?: InputMaybe<Scalars['String']['input']>;
  healthProtectionAgency?: InputMaybe<Scalars['String']['input']>;
  homeAddress?: InputMaybe<StructuredAddressInput>;
  macroSpeciality?: InputMaybe<MacroSpeciality>;
  name: Scalars['String']['input'];
  nationalMedicineBoardNumber?: InputMaybe<Scalars['String']['input']>;
  nationalMedicineBoardPlace?: InputMaybe<Scalars['String']['input']>;
  newsletterEnable?: InputMaybe<Scalars['Boolean']['input']>;
  officeAddress?: InputMaybe<StructuredAddressInput>;
  partner?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  privacyDavinci?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPartner?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Region>;
  role: Role;
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
  username: Scalars['Username']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  verifiedMode?: InputMaybe<VerifiedMode>;
};


export type MutationSignupAssistedUserArgs = {
  signupAssistedUserPayload: SignupAssistedUserPayload;
};


export type MutationSignupDoctorArgs = {
  signupDoctorPayload: SignupDoctorPayload;
};


export type MutationSignupPatientArgs = {
  signupPatientPayload: SingupPatientPayload;
};


export type MutationSignupV2Args = {
  ats?: InputMaybe<Scalars['ID']['input']>;
  birthCity?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Company>;
  confirmPassword?: InputMaybe<Scalars['String']['input']>;
  healthProtectionAgency?: InputMaybe<Scalars['String']['input']>;
  homeAddress?: InputMaybe<StructuredAddressInput>;
  macroSpeciality?: InputMaybe<MacroSpeciality>;
  name: Scalars['String']['input'];
  nationalMedicineBoardNumber?: InputMaybe<Scalars['String']['input']>;
  nationalMedicineBoardPlace?: InputMaybe<Scalars['String']['input']>;
  newsletterEnable?: InputMaybe<Scalars['Boolean']['input']>;
  officeAddress?: InputMaybe<StructuredAddressInput>;
  partner?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  privacyDavinci?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPartner?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Region>;
  role: Role;
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
  username: Scalars['Username']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  verifiedMode?: InputMaybe<VerifiedMode>;
};


export type MutationSostituisciPaiParseSissArgs = {
  paiId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationSostituisciPaiSissCloudArgs = {
  paiId: Scalars['ID']['input'];
};


export type MutationStartBulkImportArgs = {
  documentId: Scalars['ID']['input'];
  workgroupId: Scalars['ID']['input'];
};


export type MutationStartCallArgs = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  chatId: Scalars['ID']['input'];
};


export type MutationStartTranscriptionArgs = {
  input: StartTranscriptionInput;
};


export type MutationSubmitTherapeuticPlanEvaluation97Args = {
  doctorPhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  patient: Scalars['ID']['input'];
  request: TherapeuticPlanAifa97EvaluationInput;
  startDate: Scalars['Int']['input'];
};


export type MutationSubmitTherapeuticPlanEvaluation100Args = {
  doctorPhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  patient: Scalars['ID']['input'];
  request: TherapeuticPlanAifa100EvaluationInput;
  startDate: Scalars['Int']['input'];
};


export type MutationSubmitTherapeuticPlanFollowup97Args = {
  doctorPhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  patient: Scalars['ID']['input'];
  request: TherapeuticPlanAifa97FollowUpInput;
  startDate: Scalars['Int']['input'];
};


export type MutationSubmitTherapeuticPlanFollowup100Args = {
  doctorPhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  patient: Scalars['ID']['input'];
  request: TherapeuticPlanAifa100FollowUpInput;
  startDate: Scalars['Int']['input'];
};


export type MutationSubmitTherapeuticPlanPaxlovidArgs = {
  doctorEmail?: InputMaybe<Scalars['String']['input']>;
  doctorPhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  patient: Scalars['ID']['input'];
  request: TherapeuticPlanPaxlovidInput;
  startDate: Scalars['Int']['input'];
};


export type MutationSyncStripeSubscriptionArgs = {
  stripeSubscriptionId: Scalars['String']['input'];
  subscriptionPlanUserId: Scalars['ObjectId']['input'];
};


export type MutationTranscribeAndAnnotateArgs = {
  input: StartTranscriptionInput;
};


export type MutationTrasmissionePianiTerapeuticiAifaParseSissArgs = {
  doctorEmail?: InputMaybe<Scalars['String']['input']>;
  doctorPhone?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Int']['input'];
  evaluation97?: InputMaybe<TherapeuticPlanAifa97EvaluationInput>;
  evaluation100?: InputMaybe<TherapeuticPlanAifa100EvaluationInput>;
  followUp97?: InputMaybe<TherapeuticPlanAifa97FollowUpInput>;
  followUp100?: InputMaybe<TherapeuticPlanAifa100FollowUpInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isContinuous: Scalars['Boolean']['input'];
  patientId: Scalars['ID']['input'];
  paxlovid?: InputMaybe<TherapeuticPlanPaxlovidInput>;
  startDate: Scalars['Int']['input'];
  type: TherapeuticPlanType;
  xml: Scalars['String']['input'];
};


export type MutationUnreadNotificationArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationUpdateAnamnesisArgs = {
  anamnesisId: Scalars['ID']['input'];
  input: UpdateAnamnesisInput;
};


export type MutationUpdateAssistedUserFieldsArgs = {
  assistedUserId: Scalars['ID']['input'];
  birthCity?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Timestamp']['input']>;
  birthDistrict?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sex: Sex;
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
};


export type MutationUpdateAuthAdminArgs = {
  authId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
};


export type MutationUpdateAuthProviderArgs = {
  id: Scalars['ObjectId']['input'];
  input: FreenetAuthProviderInput;
};


export type MutationUpdateAuthUserArgs = {
  id: Scalars['ObjectId']['input'];
  input: FreenetAuthUserInput;
};


export type MutationUpdateAuthenticationArgs = {
  authId: Scalars['ID']['input'];
  verified: VerifiedAuth;
};


export type MutationUpdateBillingArgs = {
  input: UpdateBillingInput;
};


export type MutationUpdateBillingItemTemplateArgs = {
  input: UpdateBillingItemTemplateInput;
};


export type MutationUpdateBlacklistEntryArgs = {
  input: UpdateBlacklistEntryInput;
};


export type MutationUpdateCalendarEventArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['Timestamp']['input'];
  eventId: Scalars['ID']['input'];
  startTime: Scalars['Timestamp']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  workgroup?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateCertificateArgs = {
  certificateId: Scalars['ID']['input'];
  templateCertificateOptions: TemplateCertificateOptionsInput;
};


export type MutationUpdateCertificateTemplateArgs = {
  input: UpdateCertificateTemplateInput;
  templateId: Scalars['ID']['input'];
};


export type MutationUpdateChatArgs = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  chatId: Scalars['ID']['input'];
  fields: UpdateChatInput;
};


export type MutationUpdateClinicGroupArgs = {
  clinicGroup: UpdateClinicGroupInput;
};


export type MutationUpdateClinicWorkgroupArgs = {
  workgroup: UpdateClinicWorkgroupInput;
};


export type MutationUpdateClinicWorkgroupsClosuresArgs = {
  clinicClosureId: Scalars['String']['input'];
  endTime: Scalars['Timestamp']['input'];
  startTime: Scalars['Timestamp']['input'];
  title: Scalars['String']['input'];
  workgroups: Array<Scalars['ID']['input']>;
};


export type MutationUpdateDiaryArgs = {
  document?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  transcriptionResult?: InputMaybe<TranscriptionDiaryInput>;
  type: DiaryType;
};


export type MutationUpdateDiaryMonitoringArgs = {
  alerts?: InputMaybe<Array<AlertInput>>;
  anamnesis?: InputMaybe<Scalars['String']['input']>;
  diaryMonitoringId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  frequency?: InputMaybe<FrequencyMonitoring>;
  monitorUserParams?: InputMaybe<Array<Scalars['String']['input']>>;
  motivation?: InputMaybe<DiaryMonitoringMotivation>;
  notified?: InputMaybe<Array<Scalars['ID']['input']>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type MutationUpdateDiseaseCertificateArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  certificateId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
};


export type MutationUpdateDoctorPatientSettingArgs = {
  input: DoctorPatientSettingInput;
  patientId: Scalars['ID']['input'];
};


export type MutationUpdateDoctorSpecialitiesArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: Array<UpdateSpecialityInput>;
};


export type MutationUpdateDraftDiseaseCertificateArgs = {
  certificateId: Scalars['ID']['input'];
  diseaseCertificateAddress?: InputMaybe<StructuredAddressInput>;
  diseaseCertificateOptions: DiseaseCertificateOptionsInput;
};


export type MutationUpdateIdentityValidationNotesArgs = {
  identityValidationId: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};


export type MutationUpdateIdentityValidationPatientFieldsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  surname?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateInvoiceArgs = {
  input: InvoiceInput;
  invoiceId: Scalars['String']['input'];
  subscriptionPlanUserId: Scalars['ObjectId']['input'];
};


export type MutationUpdateLabelsArgs = {
  labels: Array<Scalars['String']['input']>;
  subscriptionPlanUserId: Scalars['ObjectId']['input'];
};


export type MutationUpdateLinkedUsersRelationshipsArgs = {
  payload: Array<UpdateLinkedUsersRelationshipsPayload>;
};


export type MutationUpdateMedicalInstructionArgs = {
  updateMedicalInstructionInput: UpdateMedicalInstructionInput;
};


export type MutationUpdateMedicalReportV2Args = {
  input: UpdateMedicalReportV2Input;
};


export type MutationUpdateMessageArgs = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  messageId: Scalars['ID']['input'];
  seenBy?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateOutpatientServiceGroupArgs = {
  groupId: Scalars['ID']['input'];
  input: OutpatientServiceGroupInput;
};


export type MutationUpdateOutpatientServiceGroupsStatusArgs = {
  groupsIds: Array<Scalars['ID']['input']>;
  status: OutpatientServiceGroupStatus;
};


export type MutationUpdatePaiExternalLogicLinkArgs = {
  input: Array<PaiExternalLogicLinkInput>;
};


export type MutationUpdatePatientFieldsArgs = {
  mmgUserId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  surname?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePatientMedicalDevicesArgs = {
  input: Array<UpdatePatientMedicalDeviceInput>;
  patientId: Scalars['ID']['input'];
};


export type MutationUpdatePatientProblemArgs = {
  problemId: Scalars['ID']['input'];
  problemPayload: ProblemInput;
};


export type MutationUpdatePatientRequestPayloadArgs = {
  id: Scalars['ID']['input'];
  payload: PatientRequestPayloadInput;
};


export type MutationUpdatePatientRequestStatusArgs = {
  id: Scalars['ID']['input'];
  noteToPatient?: InputMaybe<Scalars['String']['input']>;
  noteToPatientAttachment?: InputMaybe<Scalars['Upload']['input']>;
  status: PatientRequestStatus;
};


export type MutationUpdatePatientSummaryArgs = {
  input: UpdatePatientSummaryInput;
};


export type MutationUpdatePrescriptionArgs = {
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  exemption?: InputMaybe<Scalars['String']['input']>;
  freeDescription?: InputMaybe<Scalars['String']['input']>;
  hospitalizationWard?: InputMaybe<Scalars['String']['input']>;
  iupCode?: InputMaybe<Scalars['String']['input']>;
  prescriptionCode?: InputMaybe<Scalars['String']['input']>;
  prescriptionDrugs?: InputMaybe<Array<PrescriptionDrugInput>>;
  prescriptionId: Scalars['ID']['input'];
  prescriptionOutpatientServices?: InputMaybe<Array<PrescriptionOutpatientServiceInput>>;
  prescriptionType?: InputMaybe<PrescriptionType>;
  reasonForHospitalization?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PrescriptionStatus>;
  textualDiagnosis?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePrescriptionReservationArgs = {
  facility?: InputMaybe<Scalars['String']['input']>;
  provisionPeriod?: InputMaybe<Scalars['String']['input']>;
  reservationId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['UnsignedInt']['input']>;
};


export type MutationUpdateRecurrenceCalendarEventArgs = {
  category?: InputMaybe<EventCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Timestamp']['input']>;
  recurringId: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['Timestamp']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workgroup?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateRegionalSystemCredentialsArgs = {
  password: Scalars['String']['input'];
  pincode?: InputMaybe<Scalars['String']['input']>;
  type: RegionalSystemCredentialsTypes;
  userId: Scalars['ID']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRelationshipArgs = {
  familyDoctor?: InputMaybe<Scalars['Boolean']['input']>;
  listName?: InputMaybe<RelationshipPatientList>;
  relationshipId: Scalars['ID']['input'];
};


export type MutationUpdateReservationArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['UnsignedInt']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<ReportInput>;
  reservationId: Scalars['ID']['input'];
  specialityTemplateId?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Long']['input']>;
  status?: InputMaybe<ReservationStatus>;
  viewers?: InputMaybe<Array<Scalars['ID']['input']>>;
  workgroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateReservationByUserWithoutEmailsArgs = {
  availabilitySlotId: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  slotEnd: Scalars['String']['input'];
  slotStart: Scalars['String']['input'];
};


export type MutationUpdateReservationsInBulkArgs = {
  reservationsToUpdate: Array<UpdateReservationsInBulkInput>;
  workgroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateStringParamArgs = {
  date: Scalars['Timestamp']['input'];
  userParamId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationUpdateSubscriptionPlanUserByUserIdArgs = {
  planTypeDuration: PlanTypeDuration;
  subscriptionId: Scalars['String']['input'];
  subscriptionPlan: SubscriptionPlan;
};


export type MutationUpdateSubscriptionPlanUsersArgs = {
  subscriptionPlans: Array<UpdateSubscriptionPlanUserInput>;
};


export type MutationUpdateTherapeuticPlanArgs = {
  input: UpdateTherapeuticPlanInput;
  therapeuticPlanId: Scalars['ID']['input'];
};


export type MutationUpdateTriageAiConfigArgs = {
  prompt: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  addExpoToken?: InputMaybe<Array<Scalars['String']['input']>>;
  addFcmToken?: InputMaybe<Array<Scalars['String']['input']>>;
  addWebpushFcmToken?: InputMaybe<Array<Scalars['String']['input']>>;
  aslCode?: InputMaybe<Scalars['String']['input']>;
  atsName?: InputMaybe<Ats>;
  autoAcceptSettings?: InputMaybe<AutoAcceptSettingsInput>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<StructuredAddressInput>;
  billingInvoiceHeader?: InputMaybe<Scalars['String']['input']>;
  biography?: InputMaybe<Scalars['String']['input']>;
  birthCity?: InputMaybe<Scalars['String']['input']>;
  birthCountry?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Timestamp']['input']>;
  chatSettings?: InputMaybe<ChatSettingsInput>;
  consents?: InputMaybe<Array<ConsentInput>>;
  deleteExpoToken?: InputMaybe<Array<Scalars['String']['input']>>;
  deleteFcmToken?: InputMaybe<Array<Scalars['String']['input']>>;
  deleteWebpushFcmToken?: InputMaybe<Array<Scalars['String']['input']>>;
  doctorType?: InputMaybe<DoctorType>;
  domicileAddress?: InputMaybe<StructuredAddressInput>;
  emails?: InputMaybe<Array<Scalars['EmailAddress']['input']>>;
  healthProtectionAgency?: InputMaybe<Scalars['String']['input']>;
  homeAddress?: InputMaybe<StructuredAddressInput>;
  iban?: InputMaybe<Scalars['String']['input']>;
  isPatientHidden?: InputMaybe<Scalars['Boolean']['input']>;
  languageApp?: InputMaybe<LanguageApp>;
  languages?: InputMaybe<Array<Language>>;
  macroSpeciality?: InputMaybe<Array<MacroSpeciality>>;
  medicalDocumentSettings?: InputMaybe<MedicalDocumentSettingsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  newsletterEnable?: InputMaybe<Scalars['Boolean']['input']>;
  officeAddress?: InputMaybe<StructuredAddressInput>;
  partners?: InputMaybe<Array<Scalars['ID']['input']>>;
  patientRequestSettings?: InputMaybe<PatientRequestSettingsInput>;
  personalData?: InputMaybe<PersonalDataInput>;
  personalDataSissOverride?: InputMaybe<PersonalDataSissOverrideInput>;
  phones?: InputMaybe<Array<PhonesInput>>;
  place?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  privacyDavinci?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPartner?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Region>;
  regionalCode?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  reservations?: InputMaybe<ReservationsSettingsInput>;
  residenceAddress?: InputMaybe<StructuredAddressInput>;
  sendCertificatePdfEmailSettings?: InputMaybe<SendPdfEmailSettingsInput>;
  sendPrescriptionPdfEmailSettings?: InputMaybe<SendPdfEmailSettingsInput>;
  settings?: InputMaybe<SettingsInput>;
  sex?: InputMaybe<Sex>;
  specialitySettings?: InputMaybe<SpecialitySettingsInput>;
  stampFooter?: InputMaybe<Scalars['String']['input']>;
  stampHeader?: InputMaybe<Scalars['String']['input']>;
  stripeAccountVerified?: InputMaybe<Scalars['Boolean']['input']>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  welcomeSmsSettings?: InputMaybe<WelcomeSmsSettingsInput>;
};


export type MutationUpdateUserAdminArgs = {
  chatSettings?: InputMaybe<ChatSettingsInput>;
  company?: InputMaybe<Company>;
  emails?: InputMaybe<Array<Scalars['EmailAddress']['input']>>;
  healthlineDoctor?: InputMaybe<Scalars['Boolean']['input']>;
  macroSpeciality?: InputMaybe<Array<MacroSpeciality>>;
  mfaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paiCoop?: InputMaybe<PaiCoop>;
  partners?: InputMaybe<Array<Scalars['ID']['input']>>;
  phones?: InputMaybe<Array<PhonesInput>>;
  region?: InputMaybe<Region>;
  role?: InputMaybe<Role>;
  settings?: InputMaybe<SettingsInput>;
  sex?: InputMaybe<Sex>;
  subscriptionPlan?: InputMaybe<SubscriptionPlanInput>;
  surname?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  videocallEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateUserDoctorRelationshipArgs = {
  doctor: UserDoctorInput;
  userId: Scalars['ObjectId']['input'];
};


export type MutationUpdateUserDoctorRelationshipsArgs = {
  doctors: Array<UserDoctorInput>;
  userId: Scalars['ObjectId']['input'];
};


export type MutationUpdateUsernameAuthAdminArgs = {
  authId: Scalars['ID']['input'];
  newUsername: Scalars['Username']['input'];
  oldUsername: Scalars['Username']['input'];
  type: AuthType;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateVaccinationArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  vaccinationId: Scalars['ID']['input'];
};


export type MutationUpdateVirtualCareSubscriptionPaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateVirtualCareSubscriptionStatusArgs = {
  status: VirtualCareSubscriptionStatus;
  subscriptionId: Scalars['String']['input'];
};


export type MutationUpdateWorkgroupArgs = {
  address?: InputMaybe<StructuredAddressInput>;
  color: WorkgroupColor;
  coordinators?: InputMaybe<Array<Scalars['ID']['input']>>;
  displayName: Scalars['String']['input'];
  isWorkgroupHiddenInAgenda?: InputMaybe<Scalars['Boolean']['input']>;
  isWorkgroupHiddenInApp?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  operators?: InputMaybe<Array<Scalars['ID']['input']>>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  type: WorkgroupType;
  workgroupID: Scalars['String']['input'];
};


export type MutationUpdateWorkgroupRolesPermissionsArgs = {
  rolesPermissions: RolesPermissionsInput;
  workgroupID: Scalars['String']['input'];
};


export type MutationUploadDocumentArgs = {
  category: DocumentCategory;
  file: Scalars['Upload']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  reservationId?: InputMaybe<Scalars['ID']['input']>;
  sharedWith?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUploadDocumentsArgs = {
  files?: InputMaybe<Array<UploadDocumentInput>>;
};


export type MutationUploadIdentityDocumentArgs = {
  file: Scalars['Upload']['input'];
  identityType: IdentityType;
};


export type MutationUploadMedicalReportDocumentsPdlArgs = {
  documents: Array<MedicalReportDocumentUpload>;
  forceDownloadAgain?: InputMaybe<Scalars['Boolean']['input']>;
  medicalReportId: Scalars['String']['input'];
};


export type MutationUploadPaiArgs = {
  pais: Array<PaiInputData>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertLifestyleInformationArgs = {
  input: LifestyleInformationInput;
  patientId: Scalars['ID']['input'];
};


export type MutationUsePartnerCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationValidaFlussoCda2ParseSissArgs = {
  paiId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationValidaFlussoCda2SissCloudArgs = {
  paiId: Scalars['ID']['input'];
};


export type MutationVerificaArruolabilitaParseSissArgs = {
  patientId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationVerificaArruolabilitaSissCloudArgs = {
  patientId: Scalars['ID']['input'];
};


export type MutationVerificaPresaInCaricoAttivaParseSissArgs = {
  patientId: Scalars['ID']['input'];
  xml: Scalars['String']['input'];
};


export type MutationVerificaPresaInCaricoAttivaSissCloudArgs = {
  patientId: Scalars['ID']['input'];
};


export type MutationVerifyArgs = {
  code: Scalars['String']['input'];
};


export type MutationVerifyAssistedUserArgs = {
  assistedUserId: Scalars['ID']['input'];
  verified: Scalars['Boolean']['input'];
};


export type MutationVerifyOtpArgs = {
  otp: Scalars['String']['input'];
  usage: OtpUsage;
  username: Scalars['Username']['input'];
};


export type MutationVerifyPaymentIntentArgs = {
  paymentIntent: Scalars['String']['input'];
};


export type MutationVisualizzaPrescrittoRbParseSissArgs = {
  xml: Scalars['String']['input'];
};


export type MutationVisualizzaPrescrittoRbSissCloudArgs = {
  nrbe: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
};


export type MutationVisualizzaTestoRefertoParseSissArgs = {
  uri: Scalars['String']['input'];
  xml: Scalars['String']['input'];
};


export type MutationVisualizzazionePianoTerapeuticoAifaParseSissArgs = {
  numProtocollo: Scalars['String']['input'];
  xml?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWelcomeSmsSettingsByDoctorOrPatientArgs = {
  input: WelcomeSmsSettingsByDoctorOrPatientInput;
};

export type MyCalendarEventsResult = {
  __typename?: 'MyCalendarEventsResult';
  calendarEvents: Array<Maybe<CalendarEvent>>;
};

export type MyChatsV2Result = ComplexQueryReturn & {
  __typename?: 'MyChatsV2Result';
  nodes: Array<Chat>;
  pageInfo: PageInfo;
};

export type MyFeedbacksResult = {
  __typename?: 'MyFeedbacksResult';
  nodes: Array<UserbackFeedback>;
  pageInfo: PageInfo;
};

export type MyPaisResult = {
  __typename?: 'MyPaisResult';
  pais: Array<Maybe<Pai>>;
};

export type MyPaisReturn = ComplexQueryReturn & {
  __typename?: 'MyPaisReturn';
  nodes?: Maybe<Array<Pai>>;
  pageInfo: PageInfo;
};

export type MyPatientRequestsInput = {
  isWorkgroupMode?: InputMaybe<Scalars['Boolean']['input']>;
  tab?: InputMaybe<PatientRequestTab>;
};

export type MyPatientsResult = ComplexQueryReturn & {
  __typename?: 'MyPatientsResult';
  nodes?: Maybe<Array<Relationship>>;
  pageInfo: PageInfo;
};

export type MyTagsResult = ComplexQueryReturn & {
  __typename?: 'MyTagsResult';
  nodes: Array<Tag>;
  pageInfo: PageInfo;
};

export enum NarcoticCategory {
  TabA = 'TAB_A',
  TabB = 'TAB_B',
  TabC = 'TAB_C',
  TabD = 'TAB_D',
  TabE = 'TAB_E'
}

export type NationalMedicineBoard = {
  __typename?: 'NationalMedicineBoard';
  place?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
};

/** Mapping between a client-side _tempId and the DB _id assigned on creation. */
export type NewEntryId = {
  __typename?: 'NewEntryId';
  id: Scalars['ID']['output'];
  tempId: Scalars['String']['output'];
};

export type NewTherapeuticPlanInput = {
  aicDrugs?: InputMaybe<Array<TherapeuticPlanDrugInput>>;
  atcDrugs?: InputMaybe<Array<TherapeuticPlanDrugInput>>;
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate: Scalars['Timestamp']['input'];
  isContinuous?: InputMaybe<Scalars['Boolean']['input']>;
  protocolNumber?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Timestamp']['input'];
};

export enum NoPriceFlag {
  DicretionalPrice = 'DICRETIONAL_PRICE',
  UndefinedPrice = 'UNDEFINED_PRICE'
}

export type Node = {
  _id: Scalars['ID']['output'];
};

export type NoteMef = {
  __typename?: 'NoteMef';
  diseaseOptions?: Maybe<Array<OptionType>>;
  number: Scalars['UnsignedInt']['output'];
  options?: Maybe<Array<OptionType>>;
  type: NoteMefType;
  typeDescription: Scalars['String']['output'];
};

export enum NoteMefType {
  One = 'ONE',
  Zero = 'ZERO'
}

export type Notification = Node & {
  __typename?: 'Notification';
  _id: Scalars['ID']['output'];
  category: NotificationCategory;
  createdAt: Scalars['Timestamp']['output'];
  readAt?: Maybe<Scalars['Long']['output']>;
  recipient: User;
  referId?: Maybe<Scalars['ID']['output']>;
  referType?: Maybe<NotificationReferType>;
  relatedObject?: Maybe<AcceptedRelatedObjectTypes>;
  seenAt?: Maybe<Scalars['Long']['output']>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NotificationType>;
};

export enum NotificationCategory {
  Certificate = 'CERTIFICATE',
  Chat = 'CHAT',
  DataImportRequest = 'DATA_IMPORT_REQUEST',
  DrugReservation = 'DRUG_RESERVATION',
  Feedback = 'FEEDBACK',
  Generic = 'GENERIC',
  MedicalReport = 'MEDICAL_REPORT',
  Monitoring = 'MONITORING',
  Pregnancy = 'PREGNANCY',
  Prescription = 'PRESCRIPTION',
  Relationship = 'RELATIONSHIP',
  Reservation = 'RESERVATION'
}

export enum NotificationReferType {
  Certificate = 'CERTIFICATE',
  Chat = 'CHAT',
  Communication = 'COMMUNICATION',
  DataExportRequest = 'DATA_EXPORT_REQUEST',
  DataImportRequest = 'DATA_IMPORT_REQUEST',
  Diarymonitoring = 'DIARYMONITORING',
  DrugReservation = 'DRUG_RESERVATION',
  DrugReservationPromo = 'DRUG_RESERVATION_PROMO',
  Feedback = 'FEEDBACK',
  MedicalReport = 'MEDICAL_REPORT',
  Patient = 'PATIENT',
  PatientRequest = 'PATIENT_REQUEST',
  Pregnancy = 'PREGNANCY',
  Prescription = 'PRESCRIPTION',
  Relationship = 'RELATIONSHIP',
  Reservation = 'RESERVATION'
}

export enum NotificationType {
  Certificate = 'CERTIFICATE',
  DataExportRequest = 'DATA_EXPORT_REQUEST',
  DataImportRequest = 'DATA_IMPORT_REQUEST',
  DrugReservation = 'DRUG_RESERVATION',
  Feedback = 'FEEDBACK',
  Generic = 'GENERIC',
  Monitoring = 'MONITORING',
  Prescription = 'PRESCRIPTION',
  Relationship = 'RELATIONSHIP',
  Reservation = 'RESERVATION'
}

export type NotifyPatientOfPrescriptionsResult = {
  __typename?: 'NotifyPatientOfPrescriptionsResult';
  successful?: Maybe<Scalars['Boolean']['output']>;
};

export type NpsFeedback = Node & {
  __typename?: 'NpsFeedback';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  lastShownAt?: Maybe<Scalars['Timestamp']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  region: Region;
  role: Role;
  score?: Maybe<Scalars['Int']['output']>;
  session: NpsSession;
  status: NpsStatus;
  timesShown: Scalars['Int']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  user: User;
  year: Scalars['Int']['output'];
};

export type NpsFeedbacksResult = ComplexQueryReturn & {
  __typename?: 'NpsFeedbacksResult';
  nodes: Array<NpsFeedback>;
  pageInfo: PageInfo;
};

export type NpsFiltersInput = {
  regions?: InputMaybe<Array<Region>>;
  roles?: InputMaybe<Array<Role>>;
  session?: InputMaybe<NpsSession>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export enum NpsSession {
  January = 'JANUARY',
  July = 'JULY'
}

export type NpsStats = {
  __typename?: 'NpsStats';
  averageScore: Scalars['Float']['output'];
  detractors: Scalars['Int']['output'];
  npsScore: Scalars['Float']['output'];
  passives: Scalars['Int']['output'];
  promoters: Scalars['Int']['output'];
  totalVotes: Scalars['Int']['output'];
};

export enum NpsStatus {
  ClosedWithoutVote = 'CLOSED_WITHOUT_VOTE',
  Voted = 'VOTED'
}

export enum NrePrescriptionType {
  Pharmaceutical = 'PHARMACEUTICAL',
  Specialist = 'SPECIALIST'
}

export type NullableNodeType = Node & {
  __typename?: 'NullableNodeType';
  _id: Scalars['ID']['output'];
};

export type NumberInput = {
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberParam = Node & UserParamInterface & {
  __typename?: 'NumberParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: NumberPayload;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type NumberPayload = {
  __typename?: 'NumberPayload';
  value?: Maybe<Scalars['Float']['output']>;
};

export enum OtpUsage {
  DeleteAccount = 'DELETE_ACCOUNT',
  Login = 'LOGIN',
  RegisterAccount = 'REGISTER_ACCOUNT',
  ResetPassword = 'RESET_PASSWORD'
}

export type OnBehalfOfInput = {
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userSurname?: InputMaybe<Scalars['String']['input']>;
  userTaxCode?: InputMaybe<Scalars['String']['input']>;
};

export type OpenFromTo = {
  __typename?: 'OpenFromTo';
  /** timestamp returned by the InputDate component */
  from: Scalars['Int']['output'];
  /** timestamp returned by the InputDate component */
  to: Scalars['Int']['output'];
};

export type OpenFromToInput = {
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  day: DayOfWeek;
  openhours: Array<OpenFromTo>;
};

export type OpeningHoursInput = {
  day: DayOfWeek;
  openhours: Array<OpenFromToInput>;
};

export enum OperationType {
  Inserimento = 'Inserimento',
  Modifica = 'Modifica'
}

export type OptionType = {
  __typename?: 'OptionType';
  disabled?: Maybe<Scalars['Boolean']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OptionTypeInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type OutpatientService = Node & {
  __typename?: 'OutpatientService';
  _id: Scalars['ID']['output'];
  allExemptionsValid?: Maybe<Scalars['Boolean']['output']>;
  categoryCode: Scalars['String']['output'];
  categoryDesc: Scalars['String']['output'];
  ciclesNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  code: Scalars['String']['output'];
  codedDiagnosticQuestions?: Maybe<Array<CodedDiagnosticQuestion>>;
  description: Scalars['String']['output'];
  discretionaryExemptionCodes?: Maybe<Array<Scalars['String']['output']>>;
  endDate?: Maybe<Scalars['Timestamp']['output']>;
  flagPeso: Scalars['Boolean']['output'];
  groupsNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  incompatibilityCodes?: Maybe<Array<Scalars['String']['output']>>;
  incompatibilityRegionalCodes?: Maybe<Array<Scalars['String']['output']>>;
  isPngla?: Maybe<Scalars['Boolean']['output']>;
  maxOccurrences: Scalars['UnsignedInt']['output'];
  maxRepetitions?: Maybe<Scalars['UnsignedInt']['output']>;
  /** Minimum number of cicles for the service. The cicles number specific behaviors and logics are only active when both ciclesNumber and minCiclesNumber are set. */
  minCiclesNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  monthsForBooking: Scalars['UnsignedInt']['output'];
  noteMef?: Maybe<NoteMef>;
  rao?: Maybe<Array<Maybe<RaoRecommendation>>>;
  region: Region;
  regionalCode: Scalars['String']['output'];
  /** @deprecated use regionalCode */
  sissCode: Scalars['String']['output'];
  suggestedIncompatibilityCodes?: Maybe<Array<Scalars['String']['output']>>;
  type: ServiceType;
  validExemptionsCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type OutpatientServiceGroup = Node & {
  __typename?: 'OutpatientServiceGroup';
  _id: Scalars['ID']['output'];
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  name: Scalars['String']['output'];
  outpatientServices: Array<GroupOutpatientService>;
  owner?: Maybe<User>;
  type: OutpatientServiceGroupType;
  updatedAt: Scalars['Timestamp']['output'];
};

export type OutpatientServiceGroupInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  outpatientServices: Array<GroupOutpatientServiceInput>;
};

export enum OutpatientServiceGroupStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum OutpatientServiceGroupType {
  Custom = 'CUSTOM',
  Template = 'TEMPLATE'
}

export type OutpatientServiceInputArray = {
  values?: InputMaybe<Array<OutpatientServiceParamInput>>;
};

export type OutpatientServiceOutcome = Node & {
  __typename?: 'OutpatientServiceOutcome';
  _id: Scalars['ID']['output'];
  date: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  doctor: User;
  interpretation?: Maybe<OutpatientServiceOutcomeInterpretation>;
  isRegionalCode?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Array<OutpatientServiceOutcomeParameter>>;
  patient: User;
  region?: Maybe<Region>;
  report?: Maybe<MedicalReportV2>;
  serviceExamCode?: Maybe<Scalars['String']['output']>;
  serviceExamParameters?: Maybe<Array<OutpatientServiceOutcomeServiceExamParameter>>;
  serviceLoincCode?: Maybe<Scalars['String']['output']>;
};

export enum OutpatientServiceOutcomeInterpretation {
  Altered = 'ALTERED',
  Borderline = 'BORDERLINE',
  Na = 'NA',
  Normal = 'NORMAL'
}

export type OutpatientServiceOutcomeParameter = {
  __typename?: 'OutpatientServiceOutcomeParameter';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  interpretation?: Maybe<OutpatientServiceOutcomeInterpretation>;
  isRegionalCode?: Maybe<Scalars['Boolean']['output']>;
  loincCode: Scalars['String']['output'];
  maxValue?: Maybe<Scalars['String']['output']>;
  medicalReport?: Maybe<ParameterMedicalReportData>;
  minValue?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outpatientServiceOutcomeDate?: Maybe<Scalars['Timestamp']['output']>;
  outpatientServiceOutcomeId?: Maybe<Scalars['ID']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type OutpatientServiceOutcomeParameterInput = {
  interpretation?: InputMaybe<OutpatientServiceOutcomeInterpretation>;
  isRegionalCode?: InputMaybe<Scalars['Boolean']['input']>;
  loincCode: Scalars['String']['input'];
  maxValue?: InputMaybe<Scalars['String']['input']>;
  minValue?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type OutpatientServiceOutcomeParameterResult = {
  __typename?: 'OutpatientServiceOutcomeParameterResult';
  outpatientServiceOutcomeParameter: OutpatientServiceOutcomeParameter;
};

export type OutpatientServiceOutcomeResult = {
  __typename?: 'OutpatientServiceOutcomeResult';
  outpatientServiceOutcomes: Array<OutpatientServiceOutcome>;
};

export type OutpatientServiceOutcomeServiceExamParameter = {
  __typename?: 'OutpatientServiceOutcomeServiceExamParameter';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  interpretation?: Maybe<OutpatientServiceOutcomeInterpretation>;
  medicalReport?: Maybe<ParameterMedicalReportData>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outpatientServiceOutcomeDate?: Maybe<Scalars['Timestamp']['output']>;
  outpatientServiceOutcomeId?: Maybe<Scalars['ID']['output']>;
  serviceExamCode: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OutpatientServiceOutcomeServiceExamParameterInput = {
  interpretation?: InputMaybe<OutpatientServiceOutcomeInterpretation>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  serviceExamCode: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type OutpatientServiceOutcomeServiceExamParameterResult = {
  __typename?: 'OutpatientServiceOutcomeServiceExamParameterResult';
  outpatientServiceOutcomeServiceExamParameter: OutpatientServiceOutcomeServiceExamParameter;
};

export type OutpatientServiceOutcomesInput = {
  date: Scalars['Timestamp']['input'];
  doctor: Scalars['ID']['input'];
  interpretation?: InputMaybe<OutpatientServiceOutcomeInterpretation>;
  isRegionalCode?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Array<OutpatientServiceOutcomeParameterInput>>;
  patient: Scalars['ID']['input'];
  region?: InputMaybe<Region>;
  report?: InputMaybe<Scalars['ID']['input']>;
  serviceExamCode?: InputMaybe<Scalars['String']['input']>;
  serviceExamParameters?: InputMaybe<Array<OutpatientServiceOutcomeServiceExamParameterInput>>;
  serviceLoincCode?: InputMaybe<Scalars['String']['input']>;
};

export type OutpatientServiceParamInput = {
  allergensList?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryCode: Scalars['String']['input'];
  exemption?: InputMaybe<Scalars['String']['input']>;
  firstPaiDate?: InputMaybe<Scalars['Timestamp']['input']>;
  firstPaiPeriodicity?: InputMaybe<Scalars['UnsignedInt']['input']>;
  from?: InputMaybe<Scalars['Timestamp']['input']>;
  geneticDisease?: InputMaybe<Scalars['String']['input']>;
  importedFromFreenet?: InputMaybe<Scalars['Boolean']['input']>;
  lastPrescriptionDate?: InputMaybe<Scalars['Timestamp']['input']>;
  lastPrescriptionId?: InputMaybe<Scalars['ID']['input']>;
  loincCode?: InputMaybe<Scalars['String']['input']>;
  loincSearchable?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteMef?: InputMaybe<Scalars['String']['input']>;
  noteMefNumber?: InputMaybe<Scalars['String']['input']>;
  noteOptionMef?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['ID']['input']>;
  outpatientService: Scalars['String']['input'];
  patientNote?: InputMaybe<Scalars['String']['input']>;
  periodicity?: InputMaybe<Scalars['UnsignedInt']['input']>;
  prescriptionType?: InputMaybe<PrescriptionType>;
  problem?: InputMaybe<ProblemInput>;
  quantity?: InputMaybe<Scalars['UnsignedInt']['input']>;
  region: Region;
  sessionsNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  textualDiagnosis?: InputMaybe<Scalars['String']['input']>;
  therapeuticPlanCode?: InputMaybe<Scalars['String']['input']>;
  typeOfAccess?: InputMaybe<TypeOfAccess>;
};

export type OutpatientServiceParamInputRequired = {
  allergensList?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryCode: Scalars['String']['input'];
  exemption?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['Timestamp']['input'];
  geneticDisease?: InputMaybe<Scalars['String']['input']>;
  lastPrescriptionDate?: InputMaybe<Scalars['Timestamp']['input']>;
  lastPrescriptionId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteMefNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  noteOptionMef?: InputMaybe<Scalars['String']['input']>;
  outpatientService: Scalars['String']['input'];
  periodicity: Scalars['UnsignedInt']['input'];
  prescriptionType?: InputMaybe<PrescriptionType>;
  quantity?: InputMaybe<Scalars['UnsignedInt']['input']>;
  region: Region;
  therapeuticPlanCode?: InputMaybe<Scalars['String']['input']>;
  typeOfAccess?: InputMaybe<TypeOfAccess>;
};

export type OutpatientServiceParamPayload = {
  __typename?: 'OutpatientServiceParamPayload';
  allergensList?: Maybe<Array<Scalars['String']['output']>>;
  categoryCode: Scalars['String']['output'];
  exemption?: Maybe<Scalars['String']['output']>;
  exemptionForPrint?: Maybe<Scalars['String']['output']>;
  firstPaiDate?: Maybe<Scalars['Timestamp']['output']>;
  firstPaiPeriodicity?: Maybe<Scalars['UnsignedInt']['output']>;
  from?: Maybe<Scalars['Timestamp']['output']>;
  geneticDisease?: Maybe<Scalars['String']['output']>;
  lastPrescriptionDate?: Maybe<Scalars['Timestamp']['output']>;
  lastPrescriptionId?: Maybe<Scalars['ID']['output']>;
  loincCode?: Maybe<Scalars['String']['output']>;
  loincSearchable?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteMefNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  noteOptionMef?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<OutpatientServiceOutcome>;
  outpatientService: OutpatientService;
  patientNote?: Maybe<Scalars['String']['output']>;
  periodicity?: Maybe<Scalars['UnsignedInt']['output']>;
  prescriptionType?: Maybe<PrescriptionType>;
  problem?: Maybe<ProblemPayload>;
  quantity?: Maybe<Scalars['UnsignedInt']['output']>;
  region: Region;
  sessionsNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  textualDiagnosis?: Maybe<Scalars['String']['output']>;
  therapeuticPlanCode?: Maybe<Scalars['String']['output']>;
  typeOfAccess?: Maybe<TypeOfAccess>;
};

export type OutpatientServiceParamPayloadArray = {
  __typename?: 'OutpatientServiceParamPayloadArray';
  values?: Maybe<Array<OutpatientServiceParamPayload>>;
};

export type OutpatientServiceParamPayloadArrayRequired = {
  __typename?: 'OutpatientServiceParamPayloadArrayRequired';
  values: Array<OutpatientServiceParamPayload>;
};

export type OutpatientServiceParamPayloadRequired = {
  __typename?: 'OutpatientServiceParamPayloadRequired';
  allergensList?: Maybe<Array<Scalars['String']['output']>>;
  categoryCode: Scalars['String']['output'];
  exemption?: Maybe<Scalars['String']['output']>;
  firstPaiDate?: Maybe<Scalars['Timestamp']['output']>;
  firstPaiPeriodicity?: Maybe<Scalars['UnsignedInt']['output']>;
  from: Scalars['Timestamp']['output'];
  geneticDisease?: Maybe<Scalars['String']['output']>;
  lastPrescriptionDate?: Maybe<Scalars['Timestamp']['output']>;
  lastPrescriptionId?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteMefNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  noteOptionMef?: Maybe<Scalars['String']['output']>;
  outpatientService: OutpatientService;
  periodicity: Scalars['UnsignedInt']['output'];
  prescriptionType?: Maybe<PrescriptionType>;
  problem?: Maybe<ProblemPayload>;
  quantity?: Maybe<Scalars['UnsignedInt']['output']>;
  region: Region;
  sessionsNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  textualDiagnosis?: Maybe<Scalars['String']['output']>;
  therapeuticPlanCode?: Maybe<Scalars['String']['output']>;
  typeOfAccess?: Maybe<TypeOfAccess>;
};

export type OutpatientServiceParameter = Node & {
  __typename?: 'OutpatientServiceParameter';
  _id: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  loincCode: Scalars['String']['output'];
  parameters?: Maybe<Array<Maybe<OutpatientServiceParameter>>>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
};

export type OutpatientServiceParameterByLoinc = {
  __typename?: 'OutpatientServiceParameterByLoinc';
  isSearchable: Scalars['Boolean']['output'];
  loinc: Scalars['String']['output'];
  targetParameter?: Maybe<OutpatientServiceParameter>;
};

export type OutpatientServiceParameterReturn = ComplexQueryReturn & {
  __typename?: 'OutpatientServiceParameterReturn';
  nodes?: Maybe<Array<OutpatientServiceParameter>>;
  pageInfo: PageInfo;
};

export type OutpatientServicesCodedMotivations = {
  __typename?: 'OutpatientServicesCodedMotivations';
  codedMotivations?: Maybe<Array<Maybe<RegionalList>>>;
  outpatientServicesRegionalCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type OutpatientServicesParam = Node & UserParamInterface & {
  __typename?: 'OutpatientServicesParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: OutpatientServiceParamPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type OutpatientServicesPrescription = BasicPrescription & Node & {
  __typename?: 'OutpatientServicesPrescription';
  _id: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy?: Maybe<User>;
  creationMode: CreationMode;
  darkeningReason?: Maybe<DarkeningReason>;
  date: Scalars['Timestamp']['output'];
  doctorData?: Maybe<DoctorData>;
  downgradeReasons?: Maybe<Array<DowngradeReasons>>;
  enlistingIdPai?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  exceptions?: Maybe<Array<Exceptions>>;
  exemption?: Maybe<Exemption>;
  exemptionForPrint?: Maybe<Scalars['String']['output']>;
  flagOther?: Maybe<Scalars['Boolean']['output']>;
  icd9Description?: Maybe<Scalars['String']['output']>;
  icd9Status?: Maybe<PatientProblemStatus>;
  incomeSelfCertificationNumber?: Maybe<Scalars['String']['output']>;
  iupCode?: Maybe<Scalars['String']['output']>;
  mefCode?: Maybe<Scalars['String']['output']>;
  owner: User;
  paiLotNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  patient: User;
  personalDataSiss?: Maybe<PersonalDataSiss>;
  pinNrbe?: Maybe<Scalars['String']['output']>;
  prescriptionCode?: Maybe<Scalars['String']['output']>;
  prescriptionOutpatientServices: Array<PrescriptionOutpatientService>;
  printPdf?: Maybe<Document>;
  priorityClass?: Maybe<PriorityClass>;
  problemIcd9?: Maybe<Scalars['String']['output']>;
  processingDate?: Maybe<Scalars['Timestamp']['output']>;
  progressiveNumber: Scalars['UnsignedInt']['output'];
  regionalCodedMotivation?: Maybe<OptionType>;
  regionalCommunication?: Maybe<Array<Maybe<PrescriptionRegionalCommunication>>>;
  regionalOptions?: Maybe<PrescriptionRegionalOptions>;
  regionalStatus?: Maybe<RegionalPrescriptionStatus>;
  relatedRequests?: Maybe<Array<PatientRequestInstance>>;
  reservation?: Maybe<PrescriptionReservation>;
  showPatientInformation?: Maybe<ShowPatientInformation>;
  sissCounterPai?: Maybe<Scalars['String']['output']>;
  /** @deprecated use regionalStatus */
  sissPrescriptionStatus?: Maybe<SissPrescriptionStatus>;
  status: PrescriptionStatus;
  suggested?: Maybe<Scalars['Boolean']['output']>;
  suggestedCode?: Maybe<Scalars['String']['output']>;
  textualDiagnosis?: Maybe<Scalars['String']['output']>;
  therapeuticPlanCode?: Maybe<Scalars['String']['output']>;
  type: PrescriptionType;
  urgency?: Maybe<Scalars['Boolean']['output']>;
  visitType?: Maybe<VisitType>;
  withdrawalData?: Maybe<Array<WithdrawalData>>;
};

export type OutpatientServicesReturn = ComplexQueryReturn & {
  __typename?: 'OutpatientServicesReturn';
  nodes?: Maybe<Array<OutpatientService>>;
  pageInfo: PageInfo;
};

export type Owner = Node & {
  __typename?: 'Owner';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sex?: Maybe<Sex>;
  surname: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  count: Scalars['UnsignedInt']['output'];
  currentPage: Scalars['UnsignedInt']['output'];
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
};

export type PaginatedPatientRequestsResult = {
  __typename?: 'PaginatedPatientRequestsResult';
  nodes?: Maybe<Array<PatientRequestInstance>>;
  pageInfo: PageInfo;
};

export type Pai = Node & {
  __typename?: 'Pai';
  _id: Scalars['ID']['output'];
  alcohol?: Maybe<Scalars['String']['output']>;
  allergiesArray?: Maybe<Array<AllergiesPayload>>;
  availabilityNote?: Maybe<Scalars['String']['output']>;
  cancellation: Scalars['Boolean']['output'];
  chronicDrugs?: Maybe<Array<DrugParamPayload>>;
  chronicOutpatients?: Maybe<Array<OutpatientServiceParamPayloadRequired>>;
  clinicalRecommendations?: Maybe<Scalars['String']['output']>;
  coop: Scalars['String']['output'];
  coopName: Scalars['String']['output'];
  counselingServices?: Maybe<Array<SimpleService>>;
  deletedDrugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deletedOutpatientServices?: Maybe<Array<Maybe<DeletedOutpatientService>>>;
  deletedProblems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deletedVaccinations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  drugsAtcImported?: Maybe<Array<Scalars['String']['output']>>;
  exemptionsArray?: Maybe<Array<ExemptionsPayload>>;
  from: Scalars['Timestamp']['output'];
  goal: Scalars['String']['output'];
  height?: Maybe<Scalars['String']['output']>;
  hospitalizationServices?: Maybe<Array<SimpleService>>;
  imported: Scalars['Boolean']['output'];
  importedFromReport?: Maybe<Scalars['Boolean']['output']>;
  lifestyleNotes?: Maybe<Scalars['String']['output']>;
  medicalReport?: Maybe<MedicalReportV2>;
  name: Scalars['String']['output'];
  otherGoal?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  patient: User;
  phoneContacts?: Maybe<Array<PhoneContact>>;
  prescriptionsDate?: Maybe<Array<PaiPrescriptionDate>>;
  prescriptionsOutpatientServices?: Maybe<Array<PaiPrescriptionsOutpatientService>>;
  previousPai?: Maybe<Pai>;
  /** @deprecated use primaryProblemOptionType instead */
  primaryProblem?: Maybe<Scalars['String']['output']>;
  primaryProblemOptionType?: Maybe<OptionType>;
  prostheticServices?: Maybe<Array<SimpleService>>;
  publishedAt?: Maybe<Scalars['Timestamp']['output']>;
  relatedPrescriptionsInfo: RelatedPrescriptionsInfo;
  secondaryProblems?: Maybe<Array<OptionType>>;
  sissCounterPai: Scalars['String']['output'];
  sissEnlistingId: Scalars['String']['output'];
  sissReport?: Maybe<SissReport>;
  smoke?: Maybe<Scalars['String']['output']>;
  sportActivity?: Maybe<Scalars['String']['output']>;
  status: PaiStateCurrent;
  to: Scalars['Timestamp']['output'];
  vaccinationServices?: Maybe<Array<SimpleService>>;
  vaccinationsArray?: Maybe<Array<VaccinationsPayload>>;
  version: Scalars['UnsignedInt']['output'];
  weight?: Maybe<Scalars['String']['output']>;
};

export type PaiArchiveExternallyResult = {
  __typename?: 'PaiArchiveExternallyResult';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export enum PaiCoop {
  Horus = 'HORUS',
  Iml = 'IML'
}

export type PaiDataArchiveExternally = {
  operation: PaiOperation;
  paiId: Scalars['ID']['input'];
};

export type PaiDifferences = {
  __typename?: 'PaiDifferences';
  alcohol?: Maybe<Scalars['Boolean']['output']>;
  bodyHeight?: Maybe<Scalars['Boolean']['output']>;
  bodyWeight?: Maybe<Scalars['Boolean']['output']>;
  chronicDrugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  chronicDrugsHaveBeenDeleted?: Maybe<Scalars['Boolean']['output']>;
  isThereDifference?: Maybe<Scalars['Boolean']['output']>;
  lifestyleNotes?: Maybe<Scalars['Boolean']['output']>;
  prescribedOutpatientServices?: Maybe<Array<Maybe<DeletedOutpatientService>>>;
  problem?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  problemHaveBeenDeleted?: Maybe<Scalars['Boolean']['output']>;
  servicesHaveBeenDeleted?: Maybe<Scalars['Boolean']['output']>;
  smoke?: Maybe<Scalars['Boolean']['output']>;
  sportActivity?: Maybe<Scalars['Boolean']['output']>;
  vaccinations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vaccinationsHaveBeenDeleted?: Maybe<Scalars['Boolean']['output']>;
};

export type PaiDrug = {
  __typename?: 'PaiDrug';
  drug: FarmadatiDrug;
  note?: Maybe<Scalars['String']['output']>;
  posology: Scalars['String']['output'];
  range: RangeDate;
};

export type PaiDrugInput = {
  drug: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  posology: Scalars['String']['input'];
  range: RangeDateInput;
};

export type PaiExternalLogicLinkInput = {
  paiId: Scalars['ID']['input'];
};

export type PaiInputData = {
  base64: Scalars['String']['input'];
  paiId: Scalars['ID']['input'];
};

export enum PaiOperation {
  Addendum = 'ADDENDUM',
  Cancel = 'CANCEL',
  New = 'NEW',
  Replace = 'REPLACE'
}

export type PaiOutpatientService = Node & {
  __typename?: 'PaiOutpatientService';
  _id: Scalars['ID']['output'];
  from: Scalars['Timestamp']['output'];
  note?: Maybe<Scalars['String']['output']>;
  outpatientService: OutpatientService;
  periodicity: Scalars['UnsignedInt']['output'];
};

export type PaiOutpatientServiceForPrint = {
  __typename?: 'PaiOutpatientServiceForPrint';
  from: Scalars['Timestamp']['output'];
  note?: Maybe<Scalars['String']['output']>;
  outpatientService: OutpatientService;
  to: Scalars['Timestamp']['output'];
};

export type PaiOutpatientServiceInput = {
  from: Scalars['Timestamp']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  outpatientService: Scalars['ID']['input'];
  periodicity: Scalars['UnsignedInt']['input'];
};

export type PaiPatientsResult = ComplexQueryReturn & {
  __typename?: 'PaiPatientsResult';
  nodes?: Maybe<Array<User>>;
  pageInfo: PageInfo;
};

export type PaiPrescriptionDate = {
  __typename?: 'PaiPrescriptionDate';
  date: Scalars['Timestamp']['output'];
  lot: Scalars['UnsignedInt']['output'];
};

export type PaiPrescriptionLotData = {
  date: Scalars['Timestamp']['input'];
  lot: Scalars['UnsignedInt']['input'];
  patient: Scalars['ID']['input'];
  sissCounterPai: Scalars['String']['input'];
};

export type PaiPrescriptionsOutpatientService = {
  __typename?: 'PaiPrescriptionsOutpatientService';
  outpatientServiceRegionalCode: Scalars['String']['output'];
  prescriptionId: Scalars['ID']['output'];
  quantity?: Maybe<Scalars['UnsignedInt']['output']>;
};

export type PaiProblemInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status: PatientProblemStatus;
};

export type PaiRecap = {
  __typename?: 'PaiRecap';
  availabilityNote?: Maybe<Scalars['String']['output']>;
  deletedDrugs?: Maybe<Array<Scalars['String']['output']>>;
  deletedOutpatientServices?: Maybe<Array<DeletedOutpatientService>>;
  deletedProblems?: Maybe<Array<Scalars['String']['output']>>;
  deletedVaccinations?: Maybe<Array<Scalars['String']['output']>>;
  latestUserAdditionalInfo?: Maybe<LatestUserParams>;
  paiGoal?: Maybe<Scalars['String']['output']>;
  paiRecapParams?: Maybe<PaiRecapParams>;
  patient: User;
  patientPageAndPaiDifferences?: Maybe<PaiDifferences>;
  previousPai?: Maybe<Pai>;
};

export type PaiRecapParams = {
  __typename?: 'PaiRecapParams';
  alcohol?: Maybe<LifestyleInformationValue>;
  allergies?: Maybe<AllergiesPayloadArray>;
  bodyHeight?: Maybe<Scalars['Float']['output']>;
  bodyWeight?: Maybe<Scalars['Float']['output']>;
  chronicDrugs?: Maybe<DrugParamPayloadArray>;
  drugsAtcImported?: Maybe<Array<Scalars['String']['output']>>;
  exemptions?: Maybe<ExemptionsPayloadArray>;
  lifestyleNotes?: Maybe<StringPayload>;
  noDeclaredAllergies?: Maybe<BooleanPayload>;
  nonExistingOutpatients?: Maybe<OutpatientServiceParamPayloadArray>;
  patientId: Scalars['ID']['output'];
  prescribedOutpatientServices?: Maybe<OutpatientServiceParamPayloadArray>;
  smoke?: Maybe<LifestyleInformationValue>;
  sportActivity?: Maybe<LifestyleInformationValue>;
  vaccinations?: Maybe<VaccinationsPayloadArray>;
};

export type PaiRequirementsCompletion = {
  __typename?: 'PaiRequirementsCompletion';
  drugs: Scalars['Boolean']['output'];
  lifestyle: Scalars['Boolean']['output'];
  problems: Scalars['Boolean']['output'];
  services: Scalars['Boolean']['output'];
};

export enum PaiStateCurrent {
  Cancellation = 'CANCELLATION',
  Draft = 'DRAFT',
  DraftLost = 'DRAFT_LOST',
  Expired = 'EXPIRED',
  ExpiredDraft = 'EXPIRED_DRAFT',
  ExpiredDraftInvalid = 'EXPIRED_DRAFT_INVALID',
  FakePublished = 'FAKE_PUBLISHED',
  ImportedFromReportExpired = 'IMPORTED_FROM_REPORT_EXPIRED',
  ImportedFromReportPublished = 'IMPORTED_FROM_REPORT_PUBLISHED',
  Lost = 'LOST',
  Nothing = 'NOTHING',
  NotEnlisted = 'NOT_ENLISTED',
  Published = 'PUBLISHED',
  PublishedDraft = 'PUBLISHED_DRAFT'
}

export enum PaiTabName {
  Archive = 'ARCHIVE',
  Lost = 'LOST',
  Published = 'PUBLISHED',
  ToBePublished = 'TO_BE_PUBLISHED',
  ToBeRenewed = 'TO_BE_RENEWED'
}

export type ParameterLoincAndName = {
  __typename?: 'ParameterLoincAndName';
  loincCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ParameterMedicalReportData = {
  __typename?: 'ParameterMedicalReportData';
  _id?: Maybe<Scalars['ID']['output']>;
  author?: Maybe<MedicalReportAuthor>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  importDate?: Maybe<Scalars['Int']['output']>;
  importSource?: Maybe<DataImportTemplates>;
  source?: Maybe<MedicalReportsSourceType>;
};

export type ParsePrenotaArruolamentoResult = {
  __typename?: 'ParsePrenotaArruolamentoResult';
  message: PrenotaArruolamentoMessage;
  patient: User;
};

export type ParseSissAddPatientResultV2 = {
  __typename?: 'ParseSissAddPatientResultV2';
  exemptions?: Maybe<ExemptionsParam>;
  patient: User;
};

export type ParseSissCredentialResult = {
  __typename?: 'ParseSissCredentialResult';
  credential: Credential;
};

export type ParseSissDocumentResult = {
  __typename?: 'ParseSissDocumentResult';
  document?: Maybe<Scalars['String']['output']>;
};

export type ParseSissPaiResult = {
  __typename?: 'ParseSissPaiResult';
  pai: Pai;
};

export type ParseSissPatientResult = {
  __typename?: 'ParseSissPatientResult';
  patient: User;
};

export type ParseSissStatusResult = {
  __typename?: 'ParseSissStatusResult';
  status?: Maybe<VerificationStatusEnlistingEnum>;
};

export type ParseSissUserResult = {
  __typename?: 'ParseSissUserResult';
  exemptions?: Maybe<ExemptionsParam>;
  user: User;
};

export enum ParticularityLevel {
  Asl = 'ASL',
  National = 'NATIONAL',
  Regional = 'REGIONAL'
}

export type Partner = Node & {
  __typename?: 'Partner';
  _id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paymentGateway?: Maybe<Array<Maybe<PaymentGateway>>>;
  sells?: Maybe<Scalars['Boolean']['output']>;
  siteUrl?: Maybe<Scalars['String']['output']>;
};

export type PartnerCode = Node & {
  __typename?: 'PartnerCode';
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  coupons?: Maybe<Array<Coupon>>;
  partners: Array<Partner>;
  used: Scalars['Boolean']['output'];
};

export type PatientAdditionalInfo = {
  __typename?: 'PatientAdditionalInfo';
  upcomingReservations?: Maybe<Array<UpcomingReservation>>;
  userAppInfo?: Maybe<UserAppInfo>;
};

export type PatientAuthResponse = {
  __typename?: 'PatientAuthResponse';
  authId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  isActive: Scalars['Boolean']['output'];
  isSpid?: Maybe<Scalars['Boolean']['output']>;
  username: Scalars['String']['output'];
};

export type PatientCertificatesResult = ComplexQueryReturn & {
  __typename?: 'PatientCertificatesResult';
  nodes: Array<Certificate>;
  pageInfo: PageInfo;
};

export enum PatientClientType {
  App = 'APP',
  Webapp = 'WEBAPP'
}

export type PatientCsvRow = {
  capDomicilio?: InputMaybe<Scalars['String']['input']>;
  civicoDomicilio?: InputMaybe<Scalars['String']['input']>;
  codiceDistrettoAppartenenza?: InputMaybe<Scalars['String']['input']>;
  codiceDistrettoAssistenza?: InputMaybe<Scalars['String']['input']>;
  codiceFiscale: Scalars['String']['input'];
  codiceSanitario: Scalars['String']['input'];
  cognome: Scalars['String']['input'];
  comuneDomicilio?: InputMaybe<Scalars['String']['input']>;
  comuneNascita?: InputMaybe<Scalars['String']['input']>;
  /** at this time we do not use it */
  dataDecorrenzaIscrizione?: InputMaybe<Scalars['String']['input']>;
  /** at this time we do not use it */
  dataInizioSceltaMedico?: InputMaybe<Scalars['String']['input']>;
  dataNascita?: InputMaybe<Scalars['String']['input']>;
  /** at this time we do not use it */
  dataScadenzaIscrizione?: InputMaybe<Scalars['String']['input']>;
  dataUltimaVariazione?: InputMaybe<Scalars['String']['input']>;
  descAslAppartenenza?: InputMaybe<Scalars['String']['input']>;
  descAslAssistenza?: InputMaybe<Scalars['String']['input']>;
  descDistrettoAppartenenza?: InputMaybe<Scalars['String']['input']>;
  descDistrettoAssistenza?: InputMaybe<Scalars['String']['input']>;
  esenzioni?: InputMaybe<Array<Esenzione>>;
  frazioneDomicilio?: InputMaybe<Scalars['String']['input']>;
  indirizzoDomicilio?: InputMaybe<Scalars['String']['input']>;
  indirizzoResidenzaCittadino?: InputMaybe<Scalars['String']['input']>;
  istatComuneDomicilio?: InputMaybe<Scalars['String']['input']>;
  istatComuneNascita?: InputMaybe<Scalars['String']['input']>;
  nome: Scalars['String']['input'];
  origineDati?: InputMaybe<Scalars['String']['input']>;
  sesso?: InputMaybe<Scalars['String']['input']>;
  siglaAslAppartenenza?: InputMaybe<Scalars['String']['input']>;
  siglaAslAssistenza?: InputMaybe<Scalars['String']['input']>;
  /** at this time we do not use it */
  statoAssistito?: InputMaybe<Scalars['String']['input']>;
};

export type PatientDrugsResult = {
  __typename?: 'PatientDrugsResult';
  chronicDrugs?: Maybe<DrugsParam>;
  ordinaryDrugs?: Maybe<DrugsParam>;
};

export type PatientEmail = {
  __typename?: 'PatientEmail';
  address: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type PatientEmailResponse = {
  __typename?: 'PatientEmailResponse';
  address: Scalars['String']['output'];
  id: Scalars['String']['output'];
  primary: Scalars['Boolean']['output'];
};

export type PatientExemption = {
  __typename?: 'PatientExemption';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Timestamp']['output']>;
  flAmbitoFarmaceutico?: Maybe<Scalars['Boolean']['output']>;
  flAmbitoSpecialistico?: Maybe<Scalars['Boolean']['output']>;
  isAddedAutomatically?: Maybe<Scalars['Boolean']['output']>;
  protocolCode?: Maybe<Scalars['String']['output']>;
  regions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  startDate?: Maybe<Scalars['Timestamp']['output']>;
  type: ExemptionType;
};

export type PatientExemptionsForPrescriptionReturn = {
  __typename?: 'PatientExemptionsForPrescriptionReturn';
  exemptions: Array<PatientExemption>;
};

export type PatientInfo = {
  __typename?: 'PatientInfo';
  additionalNotes?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fiscalCode?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
};

export type PatientInfoInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
};

export type PatientLastAccessResponse = {
  __typename?: 'PatientLastAccessResponse';
  clientType: PatientClientType;
  clientVersion: Scalars['String']['output'];
  deviceType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastAccess: Scalars['Date']['output'];
};

export type PatientMedicalDevice = Node & {
  __typename?: 'PatientMedicalDevice';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy?: Maybe<User>;
  deviceCategory?: Maybe<Scalars['String']['output']>;
  deviceDescription?: Maybe<Scalars['String']['output']>;
  devicePlantDate?: Maybe<Scalars['Timestamp']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  patient: User;
  updatedAt: Scalars['Timestamp']['output'];
};

export type PatientNotes = {
  __typename?: 'PatientNotes';
  conditionExplanation?: Maybe<Scalars['String']['output']>;
  nextVisit?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Array<Scalars['String']['output']>>;
  therapyInstructions?: Maybe<Array<Scalars['String']['output']>>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type PatientPhone = {
  __typename?: 'PatientPhone';
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
};

export type PatientProblem = Node & {
  __typename?: 'PatientProblem';
  _id: Scalars['ID']['output'];
  attachments?: Maybe<Array<Document>>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  endDate?: Maybe<Scalars['Timestamp']['output']>;
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  importInfo?: Maybe<ImportInfo>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  note?: Maybe<Scalars['String']['output']>;
  patient: User;
  pregnancyId?: Maybe<Scalars['String']['output']>;
  problemCode?: Maybe<Scalars['String']['output']>;
  problemText?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Timestamp']['output']>;
  status?: Maybe<PatientProblemStatus>;
  tag?: Maybe<Tag>;
  type: PatientProblemType;
  updatedAt: Scalars['Timestamp']['output'];
};

export enum PatientProblemStatus {
  Attivo = 'ATTIVO',
  Cancellato = 'CANCELLATO',
  Cronico = 'CRONICO',
  Intermittente = 'INTERMITTENTE',
  Risolto = 'RISOLTO'
}

export enum PatientProblemType {
  FreeText = 'FREE_TEXT',
  Icd9 = 'ICD9',
  Siss = 'SISS'
}

export type PatientProblemsResult = {
  __typename?: 'PatientProblemsResult';
  nodes?: Maybe<Array<PatientProblem>>;
  pageInfo: PageInfo;
};

export enum PatientRegime {
  Ee = 'EE',
  Na = 'NA',
  Ne = 'NE',
  Nx = 'NX',
  Private = 'PRIVATE',
  Ssn = 'SSN',
  SsnTemporary = 'SSN_TEMPORARY',
  St = 'ST',
  Ue = 'UE'
}

export enum PatientRequestAction {
  Done = 'DONE',
  None = 'NONE',
  PrescribeDrug = 'PRESCRIBE_DRUG',
  PrescribeFreeDrug = 'PRESCRIBE_FREE_DRUG',
  PrescribeFreeService = 'PRESCRIBE_FREE_SERVICE',
  PrescribeService = 'PRESCRIBE_SERVICE',
  RenewDrug = 'RENEW_DRUG',
  RenewService = 'RENEW_SERVICE'
}

export type PatientRequestInstance = DrugsRequest | FreeDrugsRequest | FreeServicesRequest | ServicesRequest;

export type PatientRequestInterface = {
  _id: Scalars['ID']['output'];
  action: PatientRequestAction;
  createdAt: Scalars['Timestamp']['output'];
  deleteReason?: Maybe<DeleteReason>;
  deleteReasonNote?: Maybe<Scalars['String']['output']>;
  doctor: User;
  internalNote?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteToPatient?: Maybe<Scalars['String']['output']>;
  noteToPatientAttachment?: Maybe<Document>;
  patient: User;
  processingDate?: Maybe<Scalars['Timestamp']['output']>;
  /** @deprecated Use relatedPrescriptions instead */
  relatedPrescription?: Maybe<Prescription>;
  relatedPrescriptions?: Maybe<Array<Prescription>>;
  requestedBy?: Maybe<User>;
  requestedByAI?: Maybe<Scalars['Boolean']['output']>;
  status: PatientRequestStatus;
  type: PatientRequestType;
};

export type PatientRequestPayloadInput = {
  drugValues?: InputMaybe<Array<DrugParamInput>>;
  serviceValues?: InputMaybe<Array<OutpatientServiceParamInput>>;
};

export type PatientRequestResult = {
  __typename?: 'PatientRequestResult';
  patientRequest: PatientRequestInstance;
};

export type PatientRequestSettings = {
  __typename?: 'PatientRequestSettings';
  enabled: Scalars['Boolean']['output'];
  freeDrugs: Scalars['Boolean']['output'];
  freeServices: Scalars['Boolean']['output'];
  precompiledDrugs: Scalars['Boolean']['output'];
  precompiledServices: Scalars['Boolean']['output'];
};

export type PatientRequestSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  freeDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  freeServices?: InputMaybe<Scalars['Boolean']['input']>;
  precompiledDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  precompiledServices?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PatientRequestStatus {
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  Pending = 'PENDING'
}

export enum PatientRequestTab {
  Archive = 'ARCHIVE',
  Prescribe = 'PRESCRIBE',
  Renew = 'RENEW'
}

export enum PatientRequestType {
  Drugs = 'DRUGS',
  FreeDrugs = 'FREE_DRUGS',
  FreeServices = 'FREE_SERVICES',
  Services = 'SERVICES'
}

export type PatientRequestsRead = {
  __typename?: 'PatientRequestsRead';
  read: Scalars['Boolean']['output'];
};

export type PatientRequestsResult = {
  __typename?: 'PatientRequestsResult';
  patientRequests?: Maybe<Array<PatientRequestInstance>>;
};

export type PatientSummariesResult = ComplexQueryReturn & {
  __typename?: 'PatientSummariesResult';
  nodes: Array<PatientSummary>;
  pageInfo: PageInfo;
};

/** Patient Summary (PSS CDA2) module for generating and managing patient summary documents. */
export type PatientSummary = Node & {
  __typename?: 'PatientSummary';
  _id: Scalars['ID']['output'];
  cancelledAt?: Maybe<Scalars['Timestamp']['output']>;
  citizenConsent?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  fseLinkLogicoCDA?: Maybe<Scalars['String']['output']>;
  fseLinkLogicoPDF?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<PatientSummaryHistoryEntry>>;
  latestUserParams?: Maybe<LatestUserParams>;
  note?: Maybe<Scalars['String']['output']>;
  owner: User;
  paramsDiff?: Maybe<PatientSummaryParamsDiff>;
  patient: User;
  selectableParams?: Maybe<SelectedUserParams>;
  selectedParams: SelectedUserParams;
  signData?: Maybe<SignData>;
  signedPdfBase64?: Maybe<Scalars['String']['output']>;
  specialLaws?: Maybe<Array<ReasonForObscuration>>;
  status: PatientSummaryStatus;
  summaryDate?: Maybe<Scalars['Timestamp']['output']>;
  transmittedToFseAt?: Maybe<Scalars['Timestamp']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
  voluntaryObscuration?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * History entry for a previously transmitted Patient Summary version.
 * Stored when an already transmitted PSS is edited.
 */
export type PatientSummaryHistoryEntry = {
  __typename?: 'PatientSummaryHistoryEntry';
  _id: Scalars['ID']['output'];
  archivedAt: Scalars['Timestamp']['output'];
  cda2DocumentId?: Maybe<Scalars['String']['output']>;
  cda2SetId?: Maybe<Scalars['String']['output']>;
  cda2VersionNumber?: Maybe<Scalars['Int']['output']>;
  fseLinkLogicoCDA?: Maybe<Scalars['String']['output']>;
  fseLinkLogicoPDF?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  reasonForObscuration?: Maybe<Array<ReasonForObscuration>>;
  selectedParams: SelectedUserParams;
  signData?: Maybe<SignData>;
  signedPdfBase64?: Maybe<Scalars['String']['output']>;
  summaryDate?: Maybe<Scalars['Timestamp']['output']>;
  transmittedToFseAt?: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Diff between PSS saved params and current user params at load time.
 * Used by the frontend to highlight stale rows without recomputing on the client.
 */
export type PatientSummaryParamsDiff = {
  __typename?: 'PatientSummaryParamsDiff';
  changedDrugKeys: Array<ChangedDrugKey>;
  familyHistoryIds: Array<Scalars['ID']['output']>;
  lifestyleInformationsIds: Array<Scalars['ID']['output']>;
  measurementsIds: Array<Scalars['ID']['output']>;
  problemIds: Array<Scalars['ID']['output']>;
  vaccinationIds: Array<Scalars['ID']['output']>;
};

export type PatientSummaryPdfResult = {
  __typename?: 'PatientSummaryPdfResult';
  pdfBase64: Scalars['String']['output'];
  transmittedToFseAt: Scalars['Timestamp']['output'];
};

/** Status of Patient Summary document. */
export enum PatientSummaryStatus {
  Annullato = 'ANNULLATO',
  Bozza = 'BOZZA',
  DaTrasmettere = 'DA_TRASMETTERE',
  Trasmesso = 'TRASMESSO'
}

export type PatientsForMmgPagedResponse = {
  __typename?: 'PatientsForMmgPagedResponse';
  count: Scalars['Int']['output'];
  results: Array<PatientsForMmgResponse>;
};

export type PatientsForMmgResponse = {
  __typename?: 'PatientsForMmgResponse';
  createdAt: Scalars['Date']['output'];
  emails: Array<Scalars['String']['output']>;
  familyDoctorFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastAccess?: Maybe<PatientLastAccessResponse>;
  mmgUserId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  patientEmails: Array<PatientEmailResponse>;
  phones: Array<PatientPhone>;
  surname: Scalars['String']['output'];
  taxCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type PatientsListOptInputs = {
  tab?: InputMaybe<PatientsListTabs>;
};

export enum PatientsListTabs {
  ArchivedPatients = 'ARCHIVED_PATIENTS',
  DoctorPatients = 'DOCTOR_PATIENTS',
  GroupMedicinePatients = 'GROUP_MEDICINE_PATIENTS',
  NetworkMedicinePatients = 'NETWORK_MEDICINE_PATIENTS',
  PrivatePatients = 'PRIVATE_PATIENTS',
  WorkgroupAndPrivatePatients = 'WORKGROUP_AND_PRIVATE_PATIENTS'
}

export type PayReservationResult = {
  __typename?: 'PayReservationResult';
  paymentTransaction: PaymentTransaction;
  reservation: Reservation;
};

export enum PaymentGateway {
  Davinci = 'DAVINCI',
  Stripe = 'STRIPE',
  Tantosvago = 'TANTOSVAGO',
  Welbee = 'WELBEE'
}

export enum PaymentMethod {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  Check = 'CHECK',
  CreditCard = 'CREDIT_CARD'
}

export type PaymentSheetResult = {
  __typename?: 'PaymentSheetResult';
  customer: Scalars['String']['output'];
  ephemeralKey: Scalars['String']['output'];
  paymentIntent: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
};

export enum PaymentStatus {
  Authorized = 'AUTHORIZED',
  Onhold = 'ONHOLD',
  RequireAction = 'REQUIRE_ACTION',
  Success = 'SUCCESS'
}

export type PaymentTransaction = Node & {
  __typename?: 'PaymentTransaction';
  _id: Scalars['ID']['output'];
  amount: Scalars['Int']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  paymentGateway: PaymentGateway;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  refer: User;
  status: PaymentStatus;
  token?: Maybe<Scalars['String']['output']>;
  voucher?: Maybe<Scalars['String']['output']>;
  voucherType?: Maybe<CouponType>;
};

export type PendingPatientsResponse = {
  __typename?: 'PendingPatientsResponse';
  doctorTaxCode: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  user: User;
};

export type PersonalDataInput = {
  domicileAslData?: InputMaybe<AslDataInput>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDateNationalHealthService?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paiSyncDate?: InputMaybe<Scalars['Timestamp']['input']>;
  regionalIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  residenceAslData?: InputMaybe<AslDataInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  syncDate?: InputMaybe<Scalars['Timestamp']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalDataSiss = {
  __typename?: 'PersonalDataSiss';
  capDomicilioCittadino?: Maybe<Scalars['String']['output']>;
  capResidenzaCittadino?: Maybe<Scalars['String']['output']>;
  capResidenzaCittadinoMEF?: Maybe<Scalars['String']['output']>;
  capResidenzaCittadinoNAR?: Maybe<Scalars['String']['output']>;
  categoria?: Maybe<Scalars['String']['output']>;
  civicoDomicilioCittadino?: Maybe<Scalars['String']['output']>;
  civicoResidenzaCittadino?: Maybe<Scalars['String']['output']>;
  civicoResidenzaCittadinoMEF?: Maybe<Scalars['String']['output']>;
  civicoResidenzaCittadinoNAR?: Maybe<Scalars['String']['output']>;
  codiceDistrettoAppartenenza?: Maybe<Scalars['String']['output']>;
  codiceDistrettoAssistenza?: Maybe<Scalars['String']['output']>;
  codiceDistrettoResidenza?: Maybe<Scalars['String']['output']>;
  codiceDistrettoResidenzaMEF?: Maybe<Scalars['String']['output']>;
  codiceDistrettoResidenzaNAR?: Maybe<Scalars['String']['output']>;
  codiceFiscaleCittadino: Scalars['String']['output'];
  codiceFiscalePrecedenteCittadino?: Maybe<Scalars['String']['output']>;
  codiceSanitarioCittadino?: Maybe<Scalars['String']['output']>;
  cognomeCittadino: Scalars['String']['output'];
  comuneDomicilioCittadino?: Maybe<Scalars['String']['output']>;
  comuneNascitaCittadino: Scalars['String']['output'];
  comuneResidenzaCittadino?: Maybe<Scalars['String']['output']>;
  comuneResidenzaCittadinoMEF?: Maybe<Scalars['String']['output']>;
  comuneResidenzaCittadinoNAR?: Maybe<Scalars['String']['output']>;
  dataDecesso?: Maybe<Scalars['String']['output']>;
  dataDecorrenzaIscrizione?: Maybe<Scalars['String']['output']>;
  dataNascitaCittadino: Scalars['String']['output'];
  dataScadenzaIscrizione?: Maybe<Scalars['String']['output']>;
  dataUltimaVariazioneAmministrativi?: Maybe<Scalars['String']['output']>;
  dataUltimaVariazioneAnagrafici?: Maybe<Scalars['String']['output']>;
  dataUltimaVariazioneResidenza?: Maybe<Scalars['String']['output']>;
  dataUltimaVariazioneResidenzaMEF?: Maybe<Scalars['String']['output']>;
  dataUltimaVariazioneResidenzaNAR?: Maybe<Scalars['String']['output']>;
  dataValidazioneMef?: Maybe<Scalars['String']['output']>;
  descrizioneAsstAppartenenza?: Maybe<Scalars['String']['output']>;
  descrizioneAsstAssistenza?: Maybe<Scalars['String']['output']>;
  descrizioneAsstResidenza?: Maybe<Scalars['String']['output']>;
  descrizioneAsstResidenzaMEF?: Maybe<Scalars['String']['output']>;
  descrizioneAsstResidenzaNAR?: Maybe<Scalars['String']['output']>;
  descrizioneAtsAppartenenza?: Maybe<Scalars['String']['output']>;
  descrizioneAtsAssistenza?: Maybe<Scalars['String']['output']>;
  descrizioneAtsResidenza?: Maybe<Scalars['String']['output']>;
  descrizioneAtsResidenzaMEF?: Maybe<Scalars['String']['output']>;
  descrizioneAtsResidenzaNAR?: Maybe<Scalars['String']['output']>;
  descrizioneCategoria?: Maybe<Scalars['String']['output']>;
  descrizioneDistrettoAppartenenza?: Maybe<Scalars['String']['output']>;
  descrizioneDistrettoAssistenza?: Maybe<Scalars['String']['output']>;
  descrizioneDistrettoResidenza?: Maybe<Scalars['String']['output']>;
  descrizioneDistrettoResidenzaMEF?: Maybe<Scalars['String']['output']>;
  descrizioneDistrettoResidenzaNAR?: Maybe<Scalars['String']['output']>;
  descrizioneRSA?: Maybe<Scalars['String']['output']>;
  domicileCoordinates?: Maybe<Geolocalization>;
  frazioneDomicilioCittadino?: Maybe<Scalars['String']['output']>;
  frazioneResidenzaCittadino?: Maybe<Scalars['String']['output']>;
  idCasaRiposo?: Maybe<Scalars['String']['output']>;
  idComuneDomicilioCittadino?: Maybe<Scalars['String']['output']>;
  idComuneNascitaCittadino: Scalars['String']['output'];
  idComuneResidenzaCittadino?: Maybe<Scalars['String']['output']>;
  idComuneResidenzaCittadinoMEF?: Maybe<Scalars['String']['output']>;
  idComuneResidenzaCittadinoNAR?: Maybe<Scalars['String']['output']>;
  idProvenienza?: Maybe<Scalars['String']['output']>;
  indirizzoDomicilioCittadino?: Maybe<Scalars['String']['output']>;
  indirizzoResidenzaCittadino?: Maybe<Scalars['String']['output']>;
  indirizzoResidenzaCittadinoMEF?: Maybe<Scalars['String']['output']>;
  indirizzoResidenzaCittadinoNAR?: Maybe<Scalars['String']['output']>;
  nomeCittadino: Scalars['String']['output'];
  origineDati?: Maybe<Scalars['String']['output']>;
  provinciaDomicilioCittadino?: Maybe<Scalars['String']['output']>;
  provinciaNascitaCittadino?: Maybe<Scalars['String']['output']>;
  provinciaResidenzaCittadino?: Maybe<Scalars['String']['output']>;
  provinciaResidenzaCittadinoMEF?: Maybe<Scalars['String']['output']>;
  provinciaResidenzaCittadinoNAR?: Maybe<Scalars['String']['output']>;
  provinciaResidenzaCittadinoOverride?: Maybe<Scalars['String']['output']>;
  residenceCoordinates?: Maybe<Geolocalization>;
  sessoCittadino: Scalars['String']['output'];
  siglaAsstAppartenenza?: Maybe<Scalars['String']['output']>;
  siglaAsstAssistenza?: Maybe<Scalars['String']['output']>;
  siglaAsstResidenza?: Maybe<Scalars['String']['output']>;
  siglaAsstResidenzaMEF?: Maybe<Scalars['String']['output']>;
  siglaAsstResidenzaNAR?: Maybe<Scalars['String']['output']>;
  siglaAtsAppartenenza?: Maybe<Scalars['String']['output']>;
  siglaAtsAssistenza?: Maybe<Scalars['String']['output']>;
  siglaAtsResidenza?: Maybe<Scalars['String']['output']>;
  siglaAtsResidenzaMEF?: Maybe<Scalars['String']['output']>;
  siglaAtsResidenzaNAR?: Maybe<Scalars['String']['output']>;
  siglaAtsResidenzaOverride?: Maybe<Scalars['String']['output']>;
  statoAssistito?: Maybe<Scalars['String']['output']>;
  syncDate: Scalars['Timestamp']['output'];
  tipoRilevazione?: Maybe<Scalars['String']['output']>;
  validatoMef?: Maybe<Scalars['String']['output']>;
};

export type PersonalDataSissInput = {
  capDomicilioCittadino?: InputMaybe<Scalars['String']['input']>;
  capResidenzaCittadino?: InputMaybe<Scalars['String']['input']>;
  capResidenzaCittadinoMEF?: InputMaybe<Scalars['String']['input']>;
  capResidenzaCittadinoNAR?: InputMaybe<Scalars['String']['input']>;
  categoria?: InputMaybe<Scalars['String']['input']>;
  civicoDomicilioCittadino?: InputMaybe<Scalars['String']['input']>;
  civicoResidenzaCittadino?: InputMaybe<Scalars['String']['input']>;
  civicoResidenzaCittadinoMEF?: InputMaybe<Scalars['String']['input']>;
  civicoResidenzaCittadinoNAR?: InputMaybe<Scalars['String']['input']>;
  codiceDistrettoAppartenenza?: InputMaybe<Scalars['String']['input']>;
  codiceDistrettoAssistenza?: InputMaybe<Scalars['String']['input']>;
  codiceDistrettoResidenza?: InputMaybe<Scalars['String']['input']>;
  codiceDistrettoResidenzaMEF?: InputMaybe<Scalars['String']['input']>;
  codiceDistrettoResidenzaNAR?: InputMaybe<Scalars['String']['input']>;
  codiceFiscaleCittadino: Scalars['String']['input'];
  codiceFiscalePrecedenteCittadino?: InputMaybe<Scalars['String']['input']>;
  codiceSanitarioCittadino?: InputMaybe<Scalars['String']['input']>;
  cognomeCittadino: Scalars['String']['input'];
  comuneDomicilioCittadino?: InputMaybe<Scalars['String']['input']>;
  comuneNascitaCittadino?: InputMaybe<Scalars['String']['input']>;
  comuneResidenzaCittadino?: InputMaybe<Scalars['String']['input']>;
  comuneResidenzaCittadinoMEF?: InputMaybe<Scalars['String']['input']>;
  comuneResidenzaCittadinoNAR?: InputMaybe<Scalars['String']['input']>;
  dataDecesso?: InputMaybe<Scalars['String']['input']>;
  dataDecorrenzaIscrizione?: InputMaybe<Scalars['String']['input']>;
  dataNascitaCittadino?: InputMaybe<Scalars['String']['input']>;
  dataScadenzaIscrizione?: InputMaybe<Scalars['String']['input']>;
  dataUltimaVariazioneAmministrativi?: InputMaybe<Scalars['String']['input']>;
  dataUltimaVariazioneAnagrafici?: InputMaybe<Scalars['String']['input']>;
  dataUltimaVariazioneResidenza?: InputMaybe<Scalars['String']['input']>;
  dataUltimaVariazioneResidenzaMEF?: InputMaybe<Scalars['String']['input']>;
  dataUltimaVariazioneResidenzaNAR?: InputMaybe<Scalars['String']['input']>;
  dataValidazioneMef?: InputMaybe<Scalars['String']['input']>;
  descrizioneAsstAppartenenza?: InputMaybe<Scalars['String']['input']>;
  descrizioneAsstAssistenza?: InputMaybe<Scalars['String']['input']>;
  descrizioneAsstResidenza?: InputMaybe<Scalars['String']['input']>;
  descrizioneAsstResidenzaMEF?: InputMaybe<Scalars['String']['input']>;
  descrizioneAsstResidenzaNAR?: InputMaybe<Scalars['String']['input']>;
  descrizioneAtsAppartenenza?: InputMaybe<Scalars['String']['input']>;
  descrizioneAtsAssistenza?: InputMaybe<Scalars['String']['input']>;
  descrizioneAtsResidenza?: InputMaybe<Scalars['String']['input']>;
  descrizioneAtsResidenzaMEF?: InputMaybe<Scalars['String']['input']>;
  descrizioneAtsResidenzaNAR?: InputMaybe<Scalars['String']['input']>;
  descrizioneCategoria?: InputMaybe<Scalars['String']['input']>;
  descrizioneDistrettoAppartenenza?: InputMaybe<Scalars['String']['input']>;
  descrizioneDistrettoAssistenza?: InputMaybe<Scalars['String']['input']>;
  descrizioneDistrettoResidenza?: InputMaybe<Scalars['String']['input']>;
  descrizioneDistrettoResidenzaMEF?: InputMaybe<Scalars['String']['input']>;
  descrizioneDistrettoResidenzaNAR?: InputMaybe<Scalars['String']['input']>;
  descrizioneRSA?: InputMaybe<Scalars['String']['input']>;
  frazioneDomicilioCittadino?: InputMaybe<Scalars['String']['input']>;
  frazioneResidenzaCittadino?: InputMaybe<Scalars['String']['input']>;
  idCasaRiposo?: InputMaybe<Scalars['String']['input']>;
  idComuneDomicilioCittadino?: InputMaybe<Scalars['String']['input']>;
  idComuneNascitaCittadino?: InputMaybe<Scalars['String']['input']>;
  idComuneResidenzaCittadino?: InputMaybe<Scalars['String']['input']>;
  idComuneResidenzaCittadinoMEF?: InputMaybe<Scalars['String']['input']>;
  idComuneResidenzaCittadinoNAR?: InputMaybe<Scalars['String']['input']>;
  idProvenienza?: InputMaybe<Scalars['String']['input']>;
  indirizzoDomicilioCittadino?: InputMaybe<Scalars['String']['input']>;
  indirizzoResidenzaCittadino?: InputMaybe<Scalars['String']['input']>;
  indirizzoResidenzaCittadinoMEF?: InputMaybe<Scalars['String']['input']>;
  indirizzoResidenzaCittadinoNAR?: InputMaybe<Scalars['String']['input']>;
  nomeCittadino: Scalars['String']['input'];
  origineDati?: InputMaybe<Scalars['String']['input']>;
  provinciaDomicilioCittadino?: InputMaybe<Scalars['String']['input']>;
  provinciaNascitaCittadino?: InputMaybe<Scalars['String']['input']>;
  provinciaResidenzaCittadino?: InputMaybe<Scalars['String']['input']>;
  provinciaResidenzaCittadinoMEF?: InputMaybe<Scalars['String']['input']>;
  provinciaResidenzaCittadinoNAR?: InputMaybe<Scalars['String']['input']>;
  sessoCittadino?: InputMaybe<Scalars['String']['input']>;
  siglaAsstAppartenenza?: InputMaybe<Scalars['String']['input']>;
  siglaAsstAssistenza?: InputMaybe<Scalars['String']['input']>;
  siglaAsstResidenza?: InputMaybe<Scalars['String']['input']>;
  siglaAsstResidenzaMEF?: InputMaybe<Scalars['String']['input']>;
  siglaAsstResidenzaNAR?: InputMaybe<Scalars['String']['input']>;
  siglaAtsAppartenenza?: InputMaybe<Scalars['String']['input']>;
  siglaAtsAssistenza?: InputMaybe<Scalars['String']['input']>;
  siglaAtsResidenza?: InputMaybe<Scalars['String']['input']>;
  siglaAtsResidenzaMEF?: InputMaybe<Scalars['String']['input']>;
  siglaAtsResidenzaNAR?: InputMaybe<Scalars['String']['input']>;
  statoAssistito?: InputMaybe<Scalars['String']['input']>;
  tipoRilevazione?: InputMaybe<Scalars['String']['input']>;
  validatoMef?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalDataSissOverrideInput = {
  provinciaResidenzaCittadinoOverride?: InputMaybe<Scalars['String']['input']>;
  siglaAtsResidenzaOverride?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalDataType = {
  __typename?: 'PersonalDataType';
  deathDate?: Maybe<Scalars['Timestamp']['output']>;
  domicileAslData?: Maybe<AslData>;
  endDate?: Maybe<Scalars['String']['output']>;
  endDateNationalHealthService?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paiSyncDate?: Maybe<Scalars['Timestamp']['output']>;
  regionalIdentificationNumber?: Maybe<Scalars['String']['output']>;
  residenceAslData?: Maybe<AslData>;
  sanitaryCode?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  syncDate?: Maybe<Scalars['Timestamp']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
};

export type PhoneContact = {
  __typename?: 'PhoneContact';
  code: Scalars['String']['output'];
  frequency: Scalars['String']['output'];
  range: RangeDate;
};

export type PhoneContactInput = {
  code: Scalars['String']['input'];
  frequency: Scalars['String']['input'];
  range: RangeDateInput;
};

export type PhoneUser = {
  __typename?: 'PhoneUser';
  importedFromRegion?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  phone: Scalars['PhoneNumber']['output'];
  primary: Scalars['Boolean']['output'];
};

export type PhonesInput = {
  importedFromRegion?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['PhoneNumber']['input'];
  primary: Scalars['Boolean']['input'];
};

export type PhysiologicalUserParamsResult = {
  __typename?: 'PhysiologicalUserParamsResult';
  nodes?: Maybe<Array<NumberParam>>;
  pageInfo: PageInfo;
};

export enum PlanRequestType {
  Periodo = 'Periodo',
  Tutti = 'Tutti',
  Ultimo = 'Ultimo'
}

export enum PlanTypeDuration {
  Monthly = 'Monthly',
  Yearly = 'Yearly'
}

export type Playlist = {
  __typename?: 'Playlist';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
  videos: Array<Video>;
};

export type Position = {
  __typename?: 'Position';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type PositionInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export enum PosologyAifa100 {
  OncePerWeek_2_5Mg = 'ONCE_PER_WEEK_2_5MG',
  OncePerWeek_5Mg = 'ONCE_PER_WEEK_5MG',
  OncePerWeek_7_5Mg = 'ONCE_PER_WEEK_7_5MG',
  OncePerWeek_10Mg = 'ONCE_PER_WEEK_10MG',
  OncePerWeek_12_5Mg = 'ONCE_PER_WEEK_12_5MG',
  OncePerWeek_15Mg = 'ONCE_PER_WEEK_15MG',
  OralOncePerDay_2_5Mg = 'ORAL_ONCE_PER_DAY_2_5MG',
  OralOncePerDay_3Mg = 'ORAL_ONCE_PER_DAY_3MG',
  OralOncePerDay_5Mg = 'ORAL_ONCE_PER_DAY_5MG',
  OralOncePerDay_5Mg_10Mg = 'ORAL_ONCE_PER_DAY_5MG_10MG',
  OralOncePerDay_5Mg_100Mg = 'ORAL_ONCE_PER_DAY_5MG_100MG',
  OralOncePerDay_6_5Mg = 'ORAL_ONCE_PER_DAY_6_5MG',
  OralOncePerDay_7Mg = 'ORAL_ONCE_PER_DAY_7MG',
  OralOncePerDay_10Mg = 'ORAL_ONCE_PER_DAY_10MG',
  OralOncePerDay_10Mg_5Mg = 'ORAL_ONCE_PER_DAY_10MG_5MG',
  OralOncePerDay_12_5Mg = 'ORAL_ONCE_PER_DAY_12_5MG',
  OralOncePerDay_12_5Mg_30Mg = 'ORAL_ONCE_PER_DAY_12_5MG_30MG',
  OralOncePerDay_12_5Mg_45Mg = 'ORAL_ONCE_PER_DAY_12_5MG_45MG',
  OralOncePerDay_14Mg = 'ORAL_ONCE_PER_DAY_14MG',
  OralOncePerDay_15Mg = 'ORAL_ONCE_PER_DAY_15MG',
  OralOncePerDay_15Mg_100Mg = 'ORAL_ONCE_PER_DAY_15MG_100MG',
  OralOncePerDay_25Mg = 'ORAL_ONCE_PER_DAY_25MG',
  OralOncePerDay_25Mg_5Mg = 'ORAL_ONCE_PER_DAY_25MG_5MG',
  OralOncePerDay_25Mg_30Mg = 'ORAL_ONCE_PER_DAY_25MG_30MG',
  OralOncePerDay_25Mg_45Mg = 'ORAL_ONCE_PER_DAY_25MG_45MG',
  OralOncePerDay_50Mg = 'ORAL_ONCE_PER_DAY_50MG',
  OralOncePerDay_100Mg = 'ORAL_ONCE_PER_DAY_100MG',
  OralOncePerDay_100Mg_1000Mg = 'ORAL_ONCE_PER_DAY_100MG_1000MG',
  OralOncePerDay_100Mg_1500Mg = 'ORAL_ONCE_PER_DAY_100MG_1500MG',
  OralOncePerDay_100Mg_2000Mg = 'ORAL_ONCE_PER_DAY_100MG_2000MG',
  OralOncePerDay_300Mg = 'ORAL_ONCE_PER_DAY_300MG',
  OralTwicePerDay_2_5Mg_850Mg = 'ORAL_TWICE_PER_DAY_2_5MG_850MG',
  OralTwicePerDay_2_5Mg_1000Mg = 'ORAL_TWICE_PER_DAY_2_5MG_1000MG',
  OralTwicePerDay_5Mg_850Mg = 'ORAL_TWICE_PER_DAY_5MG_850MG',
  OralTwicePerDay_5Mg_1000Mg = 'ORAL_TWICE_PER_DAY_5MG_1000MG',
  OralTwicePerDay_7_5Mg_1000Mg = 'ORAL_TWICE_PER_DAY_7_5MG_1000MG',
  OralTwicePerDay_12_5Mg_850Mg = 'ORAL_TWICE_PER_DAY_12_5MG_850MG',
  OralTwicePerDay_12_5Mg_1000Mg = 'ORAL_TWICE_PER_DAY_12_5MG_1000MG',
  OralTwicePerDay_50Mg_50Mg = 'ORAL_TWICE_PER_DAY_50MG_50MG',
  OralTwicePerDay_50Mg_850Mg = 'ORAL_TWICE_PER_DAY_50MG_850MG',
  OralTwicePerDay_50Mg_1000Mg = 'ORAL_TWICE_PER_DAY_50MG_1000MG',
  OralTwicePerDay_150Mg_850Mg = 'ORAL_TWICE_PER_DAY_150MG_850MG',
  OralTwicePerDay_150Mg_1000Mg = 'ORAL_TWICE_PER_DAY_150MG_1000MG',
  SubCutaneousOncePerDay_0_6Mg = 'SUB_CUTANEOUS_ONCE_PER_DAY_0_6MG',
  SubCutaneousOncePerDay_1_2Mg = 'SUB_CUTANEOUS_ONCE_PER_DAY_1_2MG',
  SubCutaneousOncePerDay_1_8Mg = 'SUB_CUTANEOUS_ONCE_PER_DAY_1_8MG',
  SubCutaneousOncePerDay_10Mcg = 'SUB_CUTANEOUS_ONCE_PER_DAY_10MCG',
  SubCutaneousOncePerDay_20Mcg = 'SUB_CUTANEOUS_ONCE_PER_DAY_20MCG',
  SubCutaneousOncePerWeek_0_25Mg = 'SUB_CUTANEOUS_ONCE_PER_WEEK_0_25MG',
  SubCutaneousOncePerWeek_0_50Mg = 'SUB_CUTANEOUS_ONCE_PER_WEEK_0_50MG',
  SubCutaneousOncePerWeek_0_75Mg = 'SUB_CUTANEOUS_ONCE_PER_WEEK_0_75MG',
  SubCutaneousOncePerWeek_1_0Mg = 'SUB_CUTANEOUS_ONCE_PER_WEEK_1_0MG',
  SubCutaneousOncePerWeek_1_5Mg = 'SUB_CUTANEOUS_ONCE_PER_WEEK_1_5MG',
  SubCutaneousOncePerWeek_2Mg = 'SUB_CUTANEOUS_ONCE_PER_WEEK_2MG',
  SubCutaneousOncePerWeek_3_0Mg = 'SUB_CUTANEOUS_ONCE_PER_WEEK_3_0MG',
  SubCutaneousOncePerWeek_4_5Mg = 'SUB_CUTANEOUS_ONCE_PER_WEEK_4_5MG',
  SubCutaneousTwicePerDay_5Mcg = 'SUB_CUTANEOUS_TWICE_PER_DAY_5MCG',
  SubCutaneousTwicePerDay_10Mcg = 'SUB_CUTANEOUS_TWICE_PER_DAY_10MCG'
}

export enum PosologyNaoDoacEnum {
  Posology_2_5MgTwicePerDay = 'POSOLOGY_2_5MG_TWICE_PER_DAY',
  Posology_5MgTwicePerDay = 'POSOLOGY_5MG_TWICE_PER_DAY',
  Posology_15MgOncePerDay = 'POSOLOGY_15MG_ONCE_PER_DAY',
  Posology_20MgOncePerDay = 'POSOLOGY_20MG_ONCE_PER_DAY',
  Posology_30MgOncePerDay = 'POSOLOGY_30MG_ONCE_PER_DAY',
  Posology_60MgOncePerDay = 'POSOLOGY_60MG_ONCE_PER_DAY',
  Posology_110MgTwicePerDay = 'POSOLOGY_110MG_TWICE_PER_DAY',
  Posology_150MgTwicePerDay = 'POSOLOGY_150MG_TWICE_PER_DAY'
}

/** Result of a pre-save diff between edited PSS params and current user params. */
export type PreSaveDiffResult = {
  __typename?: 'PreSaveDiffResult';
  changedDrugKeys: Array<ChangedDrugKey>;
  familyHistoryIds: Array<Scalars['ID']['output']>;
  hasDiff: Scalars['Boolean']['output'];
  lifestyleInformationsIds: Array<Scalars['ID']['output']>;
  measurementsIds: Array<Scalars['ID']['output']>;
  problemIds: Array<Scalars['ID']['output']>;
  vaccinationIds: Array<Scalars['ID']['output']>;
};

export type PregnanciesInput = {
  birthDate?: InputMaybe<Scalars['Timestamp']['input']>;
  birthType?: InputMaybe<BirthType>;
  isRisky?: InputMaybe<Scalars['Boolean']['input']>;
  lastPeriodDate?: InputMaybe<Scalars['Timestamp']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  postPartumDepression?: InputMaybe<Scalars['Boolean']['input']>;
  pregnancyId: Scalars['ID']['input'];
  startingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<PregnancyStatus>;
};

export type PregnanciesInputArray = {
  values?: InputMaybe<Array<PregnanciesInput>>;
};

export type PregnanciesParam = Node & UserParamInterface & {
  __typename?: 'PregnanciesParam';
  _id: Scalars['ID']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: PregnanciesPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type PregnanciesPayload = {
  __typename?: 'PregnanciesPayload';
  birthDate?: Maybe<Scalars['Timestamp']['output']>;
  birthType?: Maybe<BirthType>;
  isRisky?: Maybe<Scalars['Boolean']['output']>;
  lastPeriodDate?: Maybe<Scalars['Timestamp']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  postPartumDepression?: Maybe<Scalars['Boolean']['output']>;
  pregnancyId: Scalars['ID']['output'];
  startingDate?: Maybe<Scalars['Timestamp']['output']>;
  status?: Maybe<PregnancyStatus>;
};

export type PregnanciesPayloadArray = {
  __typename?: 'PregnanciesPayloadArray';
  values?: Maybe<Array<PregnanciesPayload>>;
};

export type PregnancyAssessmentsInput = {
  assessmentDate?: InputMaybe<Scalars['Timestamp']['input']>;
  assessmentResult?: InputMaybe<Scalars['String']['input']>;
  assessmentType?: InputMaybe<Scalars['String']['input']>;
};

export type PregnancyAssessmentsOutput = {
  __typename?: 'PregnancyAssessmentsOutput';
  assessmentDate?: Maybe<Scalars['Timestamp']['output']>;
  assessmentResult?: Maybe<Scalars['String']['output']>;
  assessmentType?: Maybe<Scalars['String']['output']>;
};

export enum PregnancyStatus {
  Delivered = 'DELIVERED',
  ElectiveAbortion = 'ELECTIVE_ABORTION',
  InProgress = 'IN_PROGRESS',
  SpontaneousAbortion = 'SPONTANEOUS_ABORTION'
}

export enum PrenotaArruolamentoMessage {
  ArruolatoAltroGestore = 'ARRUOLATO_ALTRO_GESTORE',
  ArruolatoGestore = 'ARRUOLATO_GESTORE',
  Ok = 'OK',
  PrenotatoAltroGestore = 'PRENOTATO_ALTRO_GESTORE',
  PrenotatoGestore = 'PRENOTATO_GESTORE'
}

export type Prescription = DrugsPrescription | FreePrescription | HospitalizationPrescription | OutpatientServicesPrescription | TransportPrescription;

export type PrescriptionDrug = {
  __typename?: 'PrescriptionDrug';
  deliveryMethod?: Maybe<DeliveryMethod>;
  drug: FarmadatiDrug;
  icd9Description?: Maybe<Scalars['String']['output']>;
  icd9Status?: Maybe<PatientProblemStatus>;
  isChronicDrug?: Maybe<Scalars['Boolean']['output']>;
  notaCuf?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteToPrint?: Maybe<Scalars['String']['output']>;
  posology: Scalars['String']['output'];
  prescribePA?: Maybe<Scalars['Boolean']['output']>;
  quantity: Scalars['UnsignedInt']['output'];
  structuredPosology?: Maybe<StructuredPosology>;
  substitutability?: Maybe<Substitutability>;
};

export type PrescriptionDrugInput = {
  additionalNote?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  descriptonBackup?: InputMaybe<Scalars['String']['input']>;
  drugProductCode: Scalars['String']['input'];
  durationOfTreatment?: InputMaybe<Scalars['String']['input']>;
  employmentMode?: InputMaybe<Scalars['String']['input']>;
  flagOther?: InputMaybe<Scalars['Boolean']['input']>;
  geCodeBackup?: InputMaybe<Scalars['String']['input']>;
  geDescriptionBackup?: InputMaybe<Scalars['String']['input']>;
  icd9Description?: InputMaybe<Scalars['String']['input']>;
  icd9Status?: InputMaybe<PatientProblemStatus>;
  ignoredInteractions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isChronicDrug?: InputMaybe<Scalars['Boolean']['input']>;
  notaCuf?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteToPrint?: InputMaybe<Scalars['String']['input']>;
  numRepeatability?: InputMaybe<Scalars['String']['input']>;
  posology: Scalars['String']['input'];
  preparation?: InputMaybe<Scalars['String']['input']>;
  prescribePA?: InputMaybe<Scalars['Boolean']['input']>;
  problemIcd9?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['UnsignedInt']['input'];
  regionalOptions?: InputMaybe<DrugRegionalOptionsInput>;
  structuredPosology: StructuredPosologyInput;
  substitutability?: InputMaybe<Substitutability>;
  validity?: InputMaybe<Scalars['String']['input']>;
};

export enum PrescriptionExceptionCode {
  AslCodeRequired = 'ASL_CODE_REQUIRED',
  AslProvinceNotCongruent = 'ASL_PROVINCE_NOT_CONGRUENT',
  CannotRetrieveDrugRepeatability = 'CANNOT_RETRIEVE_DRUG_REPEATABILITY',
  CyclicPrescriptionQuantityMustBeOne = 'CYCLIC_PRESCRIPTION_QUANTITY_MUST_BE_ONE',
  DoctorNotFound = 'DOCTOR_NOT_FOUND',
  DrugsHaveDifferentCategories = 'DRUGS_HAVE_DIFFERENT_CATEGORIES',
  DrugCannotBePrescribed = 'DRUG_CANNOT_BE_PRESCRIBED',
  DrugClassNotAllowed = 'DRUG_CLASS_NOT_ALLOWED',
  DrugNoLongerInCommerce = 'DRUG_NO_LONGER_IN_COMMERCE',
  DrugRequiresAdditionalTextualInfo = 'DRUG_REQUIRES_ADDITIONAL_TEXTUAL_INFO',
  DrugRequiresAifaNote = 'DRUG_REQUIRES_AIFA_NOTE',
  ExemptionInvalid = 'EXEMPTION_INVALID',
  ExemptionInvalidForAge = 'EXEMPTION_INVALID_FOR_AGE',
  FiscalCodeHasBeenReplaced = 'FISCAL_CODE_HAS_BEEN_REPLACED',
  FiscalCodeInvalid = 'FISCAL_CODE_INVALID',
  InternalError = 'INTERNAL_ERROR',
  NonSubstitutabilityRequired = 'NON_SUBSTITUTABILITY_REQUIRED',
  Note_99RequiresTherapeuticPlan = 'NOTE_99_REQUIRES_THERAPEUTIC_PLAN',
  OperatorNotFound = 'OPERATOR_NOT_FOUND',
  ProductNotCoherentWithEquivalenceGroup = 'PRODUCT_NOT_COHERENT_WITH_EQUIVALENCE_GROUP',
  ProvinceCodeRequired = 'PROVINCE_CODE_REQUIRED',
  QuantityExceedsTherapeuticPlanLimit = 'QUANTITY_EXCEEDS_THERAPEUTIC_PLAN_LIMIT',
  RequiresTherapeuticPlanProtocol = 'REQUIRES_THERAPEUTIC_PLAN_PROTOCOL',
  RequiresValidTherapeuticPlanProtocol = 'REQUIRES_VALID_THERAPEUTIC_PLAN_PROTOCOL',
  SebServiceUnavailable = 'SEB_SERVICE_UNAVAILABLE',
  SubjectNotAssistedBySsn = 'SUBJECT_NOT_ASSISTED_BY_SSN',
  UserNotAuthorized = 'USER_NOT_AUTHORIZED',
  WhitePrescriptionNarcoticsBlocked = 'WHITE_PRESCRIPTION_NARCOTICS_BLOCKED'
}

export type PrescriptionInput = {
  clinicalAdvice?: InputMaybe<Scalars['String']['input']>;
  darkeningReason?: InputMaybe<DarkeningReason>;
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  enlistingIdPai?: InputMaybe<Scalars['String']['input']>;
  exemption?: InputMaybe<Scalars['String']['input']>;
  flagOther?: InputMaybe<Scalars['Boolean']['input']>;
  freeDescription?: InputMaybe<Scalars['String']['input']>;
  hospitalAdmissionForm?: InputMaybe<HospitalAdmissionFormInput>;
  hospitalizationWard?: InputMaybe<Scalars['String']['input']>;
  icd9Description?: InputMaybe<Scalars['String']['input']>;
  icd9Note?: InputMaybe<Scalars['String']['input']>;
  icd9Status?: InputMaybe<PatientProblemStatus>;
  iupCode?: InputMaybe<Scalars['String']['input']>;
  notaCuf?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  prescriptionCode?: InputMaybe<Scalars['String']['input']>;
  prescriptionDrugs?: InputMaybe<Array<PrescriptionDrugInput>>;
  prescriptionOutpatientServices?: InputMaybe<Array<PrescriptionOutpatientServiceInput>>;
  prescriptionToReplace?: InputMaybe<Scalars['ID']['input']>;
  prescriptionTransportData?: InputMaybe<PrescriptionTransportDataInput>;
  priorityClass?: InputMaybe<PriorityClass>;
  problem?: InputMaybe<ProblemInput>;
  problemIcd9?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['UnsignedInt']['input']>;
  reasonForHospitalization?: InputMaybe<Scalars['String']['input']>;
  regionalCodedMotivation?: InputMaybe<OptionTypeInput>;
  regionalOptions?: InputMaybe<PrescriptionRegionalOptionsInput>;
  relatedRequests?: InputMaybe<Array<Scalars['ID']['input']>>;
  repeatable?: InputMaybe<Scalars['Boolean']['input']>;
  showPatientInformation?: InputMaybe<ShowPatientInformation>;
  sissCounterPai?: InputMaybe<Scalars['String']['input']>;
  suggested?: InputMaybe<Scalars['Boolean']['input']>;
  suggestedCode?: InputMaybe<Scalars['String']['input']>;
  textualDiagnosis?: InputMaybe<Scalars['String']['input']>;
  textualHospitalAdmissionForm?: InputMaybe<Scalars['String']['input']>;
  therapeuticPlanCode?: InputMaybe<Scalars['String']['input']>;
  type: PrescriptionType;
  urgency?: InputMaybe<Scalars['Boolean']['input']>;
  visitType?: InputMaybe<VisitType>;
};

export enum PrescriptionObjectType {
  Drugs = 'DRUGS',
  FreePrescription = 'FREE_PRESCRIPTION',
  Hospitalization = 'HOSPITALIZATION',
  OutpatientServices = 'OUTPATIENT_SERVICES',
  Transport = 'TRANSPORT'
}

export type PrescriptionOfHospitalization = {
  __typename?: 'PrescriptionOfHospitalization';
  hospitalizationWard: Scalars['String']['output'];
  reasonForHospitalization: Scalars['String']['output'];
};

export type PrescriptionOfHospitalizationInput = {
  hospitalAdmissionForm?: InputMaybe<HospitalAdmissionFormInput>;
  hospitalizationWard?: InputMaybe<Scalars['String']['input']>;
  prescriptionId?: InputMaybe<Scalars['String']['input']>;
  reasonForHospitalization: Scalars['String']['input'];
  textualDiagnosis?: InputMaybe<Scalars['String']['input']>;
};

export type PrescriptionOutpatientService = {
  __typename?: 'PrescriptionOutpatientService';
  allergensList?: Maybe<Array<Scalars['String']['output']>>;
  fromDate?: Maybe<Scalars['UnsignedInt']['output']>;
  geneticDisease?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteMef?: Maybe<Scalars['UnsignedInt']['output']>;
  noteMefNumber?: Maybe<Scalars['String']['output']>;
  noteOptionMef?: Maybe<Scalars['String']['output']>;
  outpatientService: OutpatientService;
  periodicity?: Maybe<Scalars['UnsignedInt']['output']>;
  quantity: Scalars['UnsignedInt']['output'];
  sessionsNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  typeOfAccess?: Maybe<TypeOfAccess>;
};

export type PrescriptionOutpatientServiceInput = {
  allergensList?: InputMaybe<Array<Scalars['String']['input']>>;
  clinicalAdvice?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['UnsignedInt']['input']>;
  geneticDisease?: InputMaybe<Scalars['String']['input']>;
  loincCode?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteMefNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  noteOptionMef?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['ID']['input']>;
  outpatientService: Scalars['ID']['input'];
  periodicity?: InputMaybe<Scalars['UnsignedInt']['input']>;
  problem?: InputMaybe<ProblemInput>;
  quantity: Scalars['UnsignedInt']['input'];
  sessionsNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  textualDiagnosis?: InputMaybe<Scalars['String']['input']>;
  typeOfAccess?: InputMaybe<TypeOfAccess>;
};

export enum PrescriptionReason {
  GelForScalp = 'GEL_FOR_SCALP',
  Other = 'OTHER'
}

export type PrescriptionRegionalCommunication = {
  __typename?: 'PrescriptionRegionalCommunication';
  id?: Maybe<PrescriptionRegionalCommunicationsIds>;
  prescriptionReason?: Maybe<PrescriptionReason>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum PrescriptionRegionalCommunicationsIds {
  Dpc = 'DPC',
  RegionalCommunication = 'REGIONAL_COMMUNICATION',
  Warnings = 'WARNINGS'
}

export type PrescriptionRegionalOptions = {
  __typename?: 'PrescriptionRegionalOptions';
  isTdl?: Maybe<Scalars['Boolean']['output']>;
  prescriptionReason?: Maybe<PrescriptionReason>;
  sartaniCode?: Maybe<Scalars['String']['output']>;
  vitamineDCode?: Maybe<Scalars['String']['output']>;
};

export type PrescriptionRegionalOptionsInput = {
  isTdl?: InputMaybe<Scalars['Boolean']['input']>;
  prescriptionReason?: InputMaybe<PrescriptionReason>;
  sartaniCode?: InputMaybe<Scalars['String']['input']>;
  vitamineDCode?: InputMaybe<Scalars['String']['input']>;
};

export type PrescriptionReservation = Node & {
  __typename?: 'PrescriptionReservation';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  facility?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  prescription: Scalars['ID']['output'];
  provisionPeriod?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['UnsignedInt']['output']>;
};

export type PrescriptionReservationResult = {
  __typename?: 'PrescriptionReservationResult';
  prescriptionReservation: PrescriptionReservation;
};

export type PrescriptionResult = {
  __typename?: 'PrescriptionResult';
  prescription?: Maybe<Prescription>;
};

export enum PrescriptionStatus {
  Draft = 'DRAFT',
  Error = 'ERROR',
  External = 'EXTERNAL',
  Narcotics = 'NARCOTICS',
  Printed = 'PRINTED',
  SentTelematically = 'SENT_TELEMATICALLY',
  Transmitted = 'TRANSMITTED',
  Validated = 'VALIDATED'
}

export type PrescriptionTransportData = {
  __typename?: 'PrescriptionTransportData';
  arrivalAddress: TransportDataAddress;
  condition: TransportDataCoded;
  departureAddress: TransportDataAddress;
  motivation: TransportDataCoded;
  repeatability: Scalars['UnsignedInt']['output'];
  type: TransportDataCoded;
};

export type PrescriptionTransportDataInput = {
  arrivalAddress: TransportDataAddressInput;
  condition: TransportDataCodedInput;
  departureAddress: TransportDataAddressInput;
  motivation: TransportDataCodedInput;
  repeatability: Scalars['UnsignedInt']['input'];
  type: TransportDataCodedInput;
};

export enum PrescriptionType {
  Bianca = 'BIANCA',
  BiancaDem = 'BIANCA_DEM',
  HeavyNarcotic = 'HEAVY_NARCOTIC',
  Rossa = 'ROSSA',
  RossaDem = 'ROSSA_DEM'
}

export type PrescriptionsCountResult = {
  __typename?: 'PrescriptionsCountResult';
  _id: PrescriptionStatus;
  count: Scalars['UnsignedInt']['output'];
};

export type PrescriptionsResult = {
  __typename?: 'PrescriptionsResult';
  prescriptions?: Maybe<Array<Prescription>>;
};

export type PreviewAmtPatientsFileReturn = {
  __typename?: 'PreviewAmtPatientsFileReturn';
  invalidPatientsSample: Array<AmtCsvPatient>;
  totalInvalidPatients: Scalars['Int']['output'];
  totalValidPatients: Scalars['Int']['output'];
  validPatientsSample: Array<AmtCsvPatient>;
};

export type PreviousBillingData = {
  author: BillingAuthor;
  code: BillingCode;
  date: Scalars['Timestamp']['input'];
};

export type PreviousInfection = {
  __typename?: 'PreviousInfection';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type PreviousInfectionInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export enum PriorityClass {
  B = 'B',
  D = 'D',
  P = 'P',
  U = 'U'
}

export type ProblemInput = {
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  importedFromFreenet?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  problemCode?: InputMaybe<Scalars['String']['input']>;
  problemText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<PatientProblemStatus>;
  tag?: InputMaybe<Scalars['ID']['input']>;
};

export type ProblemPayload = {
  __typename?: 'ProblemPayload';
  attachments?: Maybe<Array<Document>>;
  endDate?: Maybe<Scalars['Timestamp']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  pregnancyId?: Maybe<Scalars['String']['output']>;
  problem?: Maybe<SissValue>;
  problemText?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Timestamp']['output']>;
  status?: Maybe<PatientProblemStatus>;
  tag?: Maybe<Tag>;
};

export enum ProblemTab {
  AttivoCronico = 'ATTIVO_CRONICO',
  AttivoCronicoIntermittente = 'ATTIVO_CRONICO_INTERMITTENTE',
  Intermittente = 'INTERMITTENTE',
  Pai = 'PAI',
  Risolto = 'RISOLTO'
}

export type ProfessionsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  exposedToToxicAgents?: InputMaybe<Scalars['String']['input']>;
  istatCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionsInputArray = {
  values?: InputMaybe<Array<ProfessionsInput>>;
};

export type ProfessionsParam = Node & UserParamInterface & {
  __typename?: 'ProfessionsParam';
  _id: Scalars['ID']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: ProfessionsPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type ProfessionsPayload = {
  __typename?: 'ProfessionsPayload';
  description?: Maybe<Scalars['String']['output']>;
  exposedToToxicAgents?: Maybe<Scalars['String']['output']>;
  istatCode?: Maybe<Scalars['String']['output']>;
};

export type ProfessionsPayloadArray = {
  __typename?: 'ProfessionsPayloadArray';
  values?: Maybe<Array<ProfessionsPayload>>;
};

export type ProsthesisInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  plantDate?: InputMaybe<Scalars['Timestamp']['input']>;
  prosthesis?: InputMaybe<Scalars['String']['input']>;
};

export type ProsthesisInputArray = {
  values?: InputMaybe<Array<ProsthesisInput>>;
};

export type ProsthesisParam = Node & UserParamInterface & {
  __typename?: 'ProsthesisParam';
  _id: Scalars['ID']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: ProsthesisPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type ProsthesisPayload = {
  __typename?: 'ProsthesisPayload';
  notes?: Maybe<Scalars['String']['output']>;
  plantDate?: Maybe<Scalars['Timestamp']['output']>;
  prosthesis?: Maybe<SissValue>;
};

export type ProsthesisPayloadArray = {
  __typename?: 'ProsthesisPayloadArray';
  values?: Maybe<Array<ProsthesisPayload>>;
};

/**
 * Aggregated user parameters needed for Patient Summary creation and editing.
 * A single call replaces 6 individual FE queries (problems, drugs, vaccinations,
 * anamnesis, lifestyle, additionalInfo).
 */
export type PssUserParams = {
  __typename?: 'PssUserParams';
  additionalInfo?: Maybe<LatestUserParams>;
  drugs: PatientDrugsResult;
  familyHistory: Array<Anamnesis>;
  problems: Array<PatientProblem>;
  selectableParams: SelectedUserParams;
  vaccinations: Array<Vaccination>;
};

export type PublicUser = Node & {
  __typename?: 'PublicUser';
  _id: Scalars['ID']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  officeAddress?: Maybe<StructuredAddress>;
  role: Role;
  stripeAccountVerified?: Maybe<Scalars['Boolean']['output']>;
  surname: Scalars['String']['output'];
};

export type PublishCovidTestResponse = {
  __typename?: 'PublishCovidTestResponse';
  id: Scalars['ID']['output'];
};

export type PublishVaccinationResponse = {
  __typename?: 'PublishVaccinationResponse';
  id: Scalars['ID']['output'];
};

export type PushNotificationSettings = {
  __typename?: 'PushNotificationSettings';
  accountActivated?: Maybe<Scalars['Boolean']['output']>;
  appointment?: Maybe<Scalars['Boolean']['output']>;
  chat?: Maybe<Scalars['Boolean']['output']>;
  disabledWhenBusy?: Maybe<Scalars['Boolean']['output']>;
  doctorCommunication?: Maybe<Scalars['Boolean']['output']>;
  drugAssumption?: Maybe<Scalars['Boolean']['output']>;
  drugStock?: Maybe<Scalars['Boolean']['output']>;
  prescription?: Maybe<Scalars['Boolean']['output']>;
};

export type PushNotificationSettingsInput = {
  accountActivated?: InputMaybe<Scalars['Boolean']['input']>;
  appointment?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<Scalars['Boolean']['input']>;
  disabledWhenBusy?: InputMaybe<Scalars['Boolean']['input']>;
  doctorCommunication?: InputMaybe<Scalars['Boolean']['input']>;
  drugAssumption?: InputMaybe<Scalars['Boolean']['input']>;
  drugStock?: InputMaybe<Scalars['Boolean']['input']>;
  prescription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  abortMultipartUpload?: Maybe<MultiregionBooleanResult>;
  activePrincipleInteractions: ActivePrincipleInteractionsResult;
  addPatientReqSiss: ReqSissResult;
  adminSwitchingDoctor: AuthData;
  /** only after riscontraFirmaMarcaReqSiss */
  aggiornaPaiReqSiss: ReqSissResult;
  allUnreadMessagesCount: Scalars['Int']['output'];
  ambulatoryTest: AmbulatoryTest;
  ambulatoryTests: AmbulatoryTestsResult;
  anamneses: AnamnesesResult;
  /** only after pubblicaPaiReqSiss */
  annullaPaiReqSiss: ReqSissResult;
  annullaPrescrizioneBiancaReqSiss: ReqSissResult;
  annullaPrescrizioneReqSiss: ReqSissResult;
  annullamentoPianoTerapeuticoAifaReqSiss: ReqSissResult;
  areSantagostinoReportsDownloadEnabled?: Maybe<Scalars['Boolean']['output']>;
  assistedUsers?: Maybe<AssistedUsersReturn>;
  authExists?: Maybe<AuthExistsReturn>;
  authLogs?: Maybe<AuthLogsReturn>;
  authProviders: Array<FreenetAuthProvider>;
  authUsers: AuthUsersReturn;
  authentications?: Maybe<AuthenticationsReturn>;
  authenticationsByUser?: Maybe<AuthenticationsReturn>;
  authorizedDoctors: Array<AuthorizedDoctor>;
  availabilitySlots?: Maybe<Array<Slot>>;
  availabilitySlotsForDay?: Maybe<AvailabilitySlotsForDay>;
  availabilitySlotsForSpeciality?: Maybe<Array<Slot>>;
  availabilitySlotsForSpecialityNoAuth?: Maybe<Array<Slot>>;
  calendarEvent: CalendarEvent;
  canCreateDrugReservation: Scalars['Boolean']['output'];
  canSeePatient: CanSeePatientResult;
  cancelDrugReservationOptionsPatient: Array<Scalars['String']['output']>;
  cancelPaymentIntent: StripeCancelIntentResponse;
  cancellaCertificatoMalattiaReqSiss: ReqSissResult;
  certificate: Certificate;
  certificateTemplates: Array<CertificateTemplate>;
  certificates: PatientCertificatesResult;
  chatById?: Maybe<Chat>;
  chatByPatientId?: Maybe<Chat>;
  checkBookingWorkgroupGeolocation: CheckBookingWorkgroupGeolocationResult;
  checkCouponValidity: Coupon;
  checkDiscountCode?: Maybe<Scalars['Boolean']['output']>;
  checkReportHasCda: Scalars['Boolean']['output'];
  checkUpdate?: Maybe<Scalars['Boolean']['output']>;
  clinicOwnedByMyself?: Maybe<ClinicGroup>;
  clinicWorkgroupsClosures: Array<ClinicWorkgroupClosure>;
  clinicsForAdmin: Array<ClinicGroup>;
  completeMultipartUpload?: Maybe<MultiregionStringResult>;
  consultaDocumentiFascicoloReqSiss: ReqSissResult;
  consultaStatoReqSiss: ReqSissResult;
  countCommunicationRecipients?: Maybe<CountCommunicationRecipientsResult>;
  countMedicalReportV2: CountMedicalReportV2;
  countPatientsWithoutAppOrAlreadyInvited: Scalars['UnsignedInt']['output'];
  countWorkgroupMedicalReports: CountMedicalReportV2;
  createMultipartUpload: CreateMultipartUploadResponse;
  createPaymentIntent: StripeIntentResponse;
  createPrescriptionsReqSiss: ReqSissResult;
  cronJobs: CronJobs;
  currentUserVirtualCareSubscriptions: Array<VirtualCareSubscriptionDetailed>;
  dataExportRequests: DataExportRequests;
  dataImportInProgress: Scalars['Boolean']['output'];
  dataImportRequests: DataImportRequests;
  dataMigrationStatus: Array<Maybe<DataMigration>>;
  daysWhenThereIsAnEvent: Array<EventDayCounter>;
  /** @deprecated moved to inclinic-gateway */
  decryptTantoSvagoSSO: TantoSvagoFields;
  dedupedProblems?: Maybe<Array<PatientProblem>>;
  diaries: DiariesResult;
  diariesMonitoring: Array<Maybe<DiaryMonitoring>>;
  diary: Diary;
  diaryLogs?: Maybe<DiaryLogResult>;
  /**
   * only after prenotaArruolamentoReqSiss and verificaPresaInCaricoAttivaReqSiss
   * motivation is '01', '02', '03', '04', '99', '92', '93', '95', '91', '94' if SissEnlistingStatus is Arruolato
   * or '01', '02', '99' if SissEnlistingStatus is Prenotato
   */
  disarruolaReqSiss: ReqSissResult;
  doOperatorsBelongInSameWorkgroup: Scalars['Boolean']['output'];
  doctorPatientSetting?: Maybe<DoctorPatientSetting>;
  doctorsInMyCooperative?: Maybe<UsersResult>;
  doctorsV2?: Maybe<UsersResult>;
  /** if last = true return the last document of the filter */
  documents?: Maybe<Array<Document>>;
  documentsV2: DocumentsResult;
  downloadSheet?: Maybe<Scalars['String']['output']>;
  drugPrescriptionsInteractions: DrugPrescriptionsInteractionsResult;
  drugReservation: DrugReservation;
  drugReservations: DrugReservationsResult;
  drugReservationsCount: Scalars['Int']['output'];
  drugstore: Drugstore;
  drugstores: DrugstoresResult;
  elencoProtocolliPianiTerapeuticiAifaReqSiss: ReqSissResult;
  exemptions?: Maybe<ExemptionsReturn>;
  existingPai: MultiregionBooleanResult;
  feedbackById: UserbackFeedback;
  findActivePrinciples: ActivePrinciplesPaginateResult;
  findActivePrinciplesInteractions: ApInteractionsPaginateResult;
  findAuthenticationById?: Maybe<Authentication>;
  findAuthenticationByIdWithDeleted?: Maybe<Authentication>;
  findDiseaseCertificate: RegionCertificateResult;
  findDrugByCode?: Maybe<FarmadatiDrug>;
  findDrugsByEquivalenceGroup: DrugsPaginateResult;
  findExemptions: ExemptionPaginateResult;
  findIdentityValidationById: IdentityValidationWithSignedUrl;
  findLatestLifestyleInformations: Array<LifestyleInformation>;
  findLatestMeasurements: Array<Measurement>;
  findMedicalInstruction?: Maybe<MedicalInstruction>;
  findMedicalInstructionForPatient?: Maybe<MedicalInstruction>;
  findParametersByLoincCodes: Array<OutpatientServiceParameterByLoinc>;
  findPatientsForMmg: PatientsForMmgPagedResponse;
  /** only after prenotaArruolamentoReqSiss or sissEnlistingStatus on relationship is */
  firmaPaiReqSiss: ReqSissResult;
  firstAvailableSlot?: Maybe<Array<Slot>>;
  generatePaiAnnullativoPdf: Scalars['String']['output'];
  generatePaiPdf: Scalars['String']['output'];
  generateTokBoxToken: Scalars['String']['output'];
  getAgendaSettings?: Maybe<AgendaSettings>;
  getAiResponseFromChat: ChatAnalysis;
  getAllLabels: Array<Scalars['String']['output']>;
  getAmbulatory: Workgroup;
  getAmbulatoryById: Workgroup;
  getAnnualRecurringRevenue: GetAnnualRecurringRevenueReturn;
  getAvailabilitySlotById: Slot;
  getBillingById?: Maybe<Billing>;
  getBillingItemTemplates: BillingItemTemplatesResponse;
  getBillings?: Maybe<BillingsByOwnerResponse>;
  getBlacklistEntries: BlacklistEntriesResult;
  getCaregiverAssistedUsers?: Maybe<Array<AssistedUser>>;
  getCatalogueCode: GetCatalogueCodeResponse;
  getCertificateTemplateByType: CertificateTemplate;
  getChatModerationAiConfig: ChatModerationAiConfig;
  getCities: Array<City>;
  getClinicReservations: Array<Reservation>;
  getConsents: Array<MultiregionConsent>;
  getCovidTestCodes: Array<CovidTestCode>;
  getCreatedByUsers?: Maybe<Array<User>>;
  getCurrentPaiInfo: CurrentPaiInfo;
  getDefaultTypeOfAccess?: Maybe<TypeOfAccess>;
  getDeliveryMethodAtcCodes: Array<Scalars['String']['output']>;
  getDeliveryRegimes: Array<DeliveryRegime>;
  getDistricts: Array<District>;
  getDoctorSpecialities?: Maybe<Array<Speciality>>;
  getDoctorSpecialitiesV2: SpecialityResults;
  getDoctorSpecialityPrice: Scalars['UnsignedInt']['output'];
  getDosages: Array<Dosage>;
  getFamilyRelationshipById?: Maybe<Array<Relationship>>;
  getIdentityValidations: IdentityValidationPageResponse;
  getInvoices: GetInvoicesReturn;
  getLastValidMedicalReportOfType?: Maybe<MedicalReportV2>;
  /** @deprecated plaese use getLicencesdWorkgroup that came with pagination */
  getLicensedAmbulatories?: Maybe<Array<Workgroup>>;
  getLicensedWorkgroups: WorkgroupResult;
  getLinkedUsersInfo: Array<User>;
  getMedicalDocument: GetMedicalDocumentResponse;
  getMedicalDocuments: MultiregionBooleanResult;
  getMonthlyInvoiceTotals: Array<TotalByMonth>;
  getMySmsMonthlyInfo?: Maybe<SmsMonthlyLimitInfoResult>;
  getNextIdentityValidationToVerify: IdentityValidationPatient;
  getOutpatientServicesCodedMotivations?: Maybe<Array<Maybe<OutpatientServicesCodedMotivations>>>;
  getPatient?: Maybe<User>;
  getPatientAuth: Array<PatientAuthResponse>;
  getPatientOutpatientServiceOutcomeParameters: ComplexOutpatientServiceOutcomeParametersResult;
  getPatientOutpatientServiceOutcomeServiceExamParameters: ComplexOutpatientServiceOutcomeServiceExamParametersResult;
  getPatientUniqueOutpatientServiceOutcomes: UniqueOutpatientServiceOutcomesResult;
  getPatientVirtualCareSubscription: Array<VirtualCareSubscriptionDetailed>;
  getPlanInfoFromTaxCode: GetPlanInfoFromTaxCodeResponse;
  getPresignedUrlForUpload: GetPresignedUrlForUploadResponse;
  getPreviousInfections: Array<PreviousInfection>;
  getRegionalAddresses: Array<Maybe<RegionalAddress>>;
  getRegionalAddressesAutocomplete?: Maybe<RegionalAddressesResult>;
  getRegionalList: Array<Maybe<RegionalList>>;
  getRelationshipById?: Maybe<Relationship>;
  getRelationshipRequest?: Maybe<Array<Maybe<Relationship>>>;
  getReportOutpatientServiceOutcomes: OutpatientServiceOutcomeResult;
  /** @deprecated use reservationBySecret in inclinic-gateway */
  getReservationBySecret?: Maybe<Reservation>;
  getReservationByVideoSessionId: Reservation;
  getRetoolClinics: Array<RetoolClinic>;
  getRiskCategories: Array<RiskCategory>;
  getRiskConditions: Array<RiskCondition>;
  getSantagostinoSettings?: Maybe<GetSantagostinoSettingsResponse>;
  getSentRelationshipRequest?: Maybe<Array<Maybe<Relationship>>>;
  getSignupRequest?: Maybe<SignupRequest>;
  getSissPDLRequestsFromMedicalReport: Array<MedicalReportDocumentXmlRequest>;
  getSomministrationMethods: Array<SomministrationMethod>;
  getSomministrationMotivations: Array<SomministrationMotivation>;
  getSomministrationPlaces: Array<SomministrationPlace>;
  getSomministrationSites: Array<SomministrationSite>;
  getSpecialityTemplateById: SpecialityTemplate;
  getSpecialityTemplateList?: Maybe<Array<SpecialityTemplate>>;
  getSpecialityTemplates?: Maybe<Array<SpecialityTemplate>>;
  getSpecialityTemplatesByMacroSpeciality?: Maybe<Array<SpecialityTemplate>>;
  getSpecialityTemplatesForPatient?: Maybe<Array<SpecialityTemplate>>;
  getStripeSubscription: GetStripeSubscriptionReturn;
  getStructuredData?: Maybe<Scalars['String']['output']>;
  getStructuredList?: Maybe<Scalars['String']['output']>;
  getStructuredReport?: Maybe<GetStructuredReportOutput>;
  getSubscriptionPlanUsersByUserId: Array<SubscriptionPlanUser>;
  getTableNamesOttieniTabella?: Maybe<Array<Scalars['String']['output']>>;
  getTranscriptionRaw: Scalars['String']['output'];
  getTranscriptionStatus: TranscriptionJob;
  getTriageAiConfig: TriageAiConfig;
  getTypes: Array<MultiregionDocumentType>;
  getUnlicensedAmbulatories?: Maybe<Array<Workgroup>>;
  getUsedNres?: Maybe<Array<Maybe<GetUsedNresOutput>>>;
  getVaccinationPregnancyStatus: Array<VaccinationPregnancyStatus>;
  getVaccineLots: Array<VaccineLot>;
  getVaccines: Array<Vaccine>;
  getVirtualCarePlanByPlanId?: Maybe<VirtualCarePlanDetailed>;
  getVirtualCarePlanSubscriptionBySubscriptionId?: Maybe<VirtualCareSubscriptionDetailed>;
  getWorkgroupPatientRequests: PaginatedPatientRequestsResult;
  getWorkgroupsOperatorsByOperatorId: Array<Maybe<User>>;
  getWorkgroupsSpecialities?: Maybe<Array<Speciality>>;
  hasDoctorUnreadMessages: Scalars['Boolean']['output'];
  hasPrescriptions: HasPrescriptionsResult;
  hasUnreadFeedbacks: Scalars['Boolean']['output'];
  hasValidNres: HasValidNresOutput;
  hasWebpushFcmToken: Scalars['Boolean']['output'];
  historicalUserParams: HistoricalUserParamsResult;
  hospitalAdmissionForm: HospitalAdmissionForm;
  hospitalAdmissionForms: HospitalAdmissionFormsResult;
  identificaCittadinoReqSiss: ReqSissResult;
  identificaPrescrizioneReqSiss: ReqSissResult;
  importAndSyncDrugs?: Maybe<Scalars['Boolean']['output']>;
  importedUserNotes: Array<ImportedUserNote>;
  invioCertificatoMalattiaReqSiss: ReqSissResult;
  isDoctorAvailableForReservation: Scalars['Boolean']['output'];
  isRegistered: IsRegisteredResult;
  lastPai: LastPaiResult;
  latestOutpatientServiceOutcomes: Array<OutpatientServiceOutcome>;
  latestOutpatientServiceOutcomesByServiceExam: Array<OutpatientServiceOutcome>;
  latestOutpatientServiceOutcomesByServiceExamMultiple: Array<OutpatientServiceOutcome>;
  latestOutpatientServiceOutcomesMultiple: Array<OutpatientServiceOutcome>;
  latestUserParams?: Maybe<LatestUserParams>;
  lifestyleInformations: LifestyleInformationsResult;
  listMultipartUploads?: Maybe<Array<Maybe<ListMultipartUploadResult>>>;
  listPatients?: Maybe<UsersResult>;
  listTranscriptions: TranscriptionListResponse;
  login: AuthData;
  loginV2: AuthData;
  logoutOAuth2?: Maybe<Scalars['Boolean']['output']>;
  /** only after firmaPaiReqSiss */
  marcaPaiReqSiss: ReqSissResult;
  me: User;
  measurements: MeasurementsResult;
  medicalInstructionsByDoctor: Array<MedicalInstruction>;
  /** @deprecated No longer supported */
  medicalReport?: Maybe<MedicalReport>;
  medicalReportV2?: Maybe<MedicalReportV2>;
  /** @deprecated No longer supported */
  medicalReports: MedicalReportsReturn;
  medicalReportsV2: MedicalReportsV2Return;
  /**
   * Usage:
   * past, timestamp and size are used for pagination
   *
   * @chatId: id of the chat
   *
   * @past: direction of the cursor
   *       true means 'fetch at most **size** messages sent BEFORE **timestamp**'
   *       false means 'fetch at most **size** messages sent AFTER **timestamp**'
   *
   * @timestamp: timestamp cursor
   *
   * @size: limit the number of messages from the timestamp
   */
  messages: Array<ChatMessage>;
  messagesV2: ChatMessageReturn;
  migrateToken: AuthData;
  multipleDownloadMedicalDocuments: MultiregionBooleanResult;
  myAuth?: Maybe<Authentication>;
  myCalendarEvents: MyCalendarEventsResult;
  myChats: Array<Chat>;
  myChatsV2: MyChatsV2Result;
  myCommunications?: Maybe<CommunicationsResult>;
  myCoupons?: Maybe<Array<Coupon>>;
  myDoctors?: Maybe<Array<Maybe<User>>>;
  myFeedbacks: MyFeedbacksResult;
  myMedicalInstructions: Array<MedicalInstruction>;
  myNotifications: Array<Notification>;
  myPatientRequests: PaginatedPatientRequestsResult;
  myPatientRequestsCount: Scalars['Int']['output'];
  myRelatives: Array<Relative>;
  myReservationsV2: ReservationsResult;
  mySettings?: Maybe<UserSettings>;
  mySpecialtyTemplatesWithMySettings: Array<EditableSpeciality>;
  myTags: MyTagsResult;
  myVideocallLogs: Array<VideocallLogType>;
  notificationById?: Maybe<Notification>;
  notificationsForUser: Array<Notification>;
  npsFeedbacks: NpsFeedbacksResult;
  npsStats: NpsStats;
  /** only after verificaArruolabilitaReqSiss */
  ottieniPatologieReqSiss: ReqSissResult;
  ottieniTabellaReqSiss?: Maybe<Array<ReqSissResult>>;
  outpatientServiceGroup?: Maybe<OutpatientServiceGroup>;
  outpatientServiceGroupCategories?: Maybe<Array<Scalars['String']['output']>>;
  outpatientServiceGroups?: Maybe<Array<OutpatientServiceGroup>>;
  outpatientServiceGroupsPaginated: ComplexOutpatientServiceGroupsResult;
  outpatientServices?: Maybe<OutpatientServicesReturn>;
  pai?: Maybe<Pai>;
  paiAndUserParamsDifferences: PaiDifferences;
  paiArchive?: Maybe<MyPaisReturn>;
  paiPatients: PaiPatientsResult;
  paiRecap: PaiRecap;
  paisByPatient?: Maybe<MyPaisReturn>;
  paisByTab?: Maybe<MyPaisReturn>;
  partners?: Maybe<Array<Maybe<Partner>>>;
  patientDrugs: PatientDrugsResult;
  patientExemptions?: Maybe<ExemptionsForPatientReturn>;
  patientExemptionsForPrescription?: Maybe<PatientExemptionsForPrescriptionReturn>;
  patientMedicalDevices: Array<PatientMedicalDevice>;
  patientPrescription: PrescriptionResult;
  patientPrescriptions: ComplexPrescriptionsResult;
  patientRequestsById: PatientRequestsResult;
  /** Get all patient summaries for a patient with pagination and filtering. */
  patientSummaries: PatientSummariesResult;
  /** Get a specific patient summary by ID. */
  patientSummary?: Maybe<PatientSummary>;
  /**
   * Get PDF for a specific patient summary publication.
   * If historyId is null, returns the current transmitted PDF.
   * If historyId is provided, returns the PDF from that history entry.
   */
  patientSummaryPdf?: Maybe<PatientSummaryPdfResult>;
  /**
   * Compute a diff between the edited selected params and the current user params
   * from the database. Used to populate the pre-save confirmation dialog.
   */
  patientSummaryPreSaveDiff: PreSaveDiffResult;
  /**
   * Load all current user params needed by the PSS page in a single call.
   * Used in create mode alone, and in edit mode in parallel with patientSummary.
   */
  patientSummaryUserParams: PssUserParams;
  patientWorkgroupPermissions: RolesPermissionsMap;
  patientsEnlisted: PaiPatientsResult;
  pendingDrugReservationsForPatient: Array<DrugReservation>;
  pendingPatients: Array<PendingPatientsResponse>;
  physiologicalUserParams: PhysiologicalUserParamsResult;
  /** only after verificaArruolabilitaReqSiss */
  prenotaArruolamentoReqSiss: ReqSissResult;
  prepareOAuth2URL: Scalars['String']['output'];
  prescription: PrescriptionResult;
  prescriptions: ComplexPrescriptionsResult;
  prescriptionsCount: Array<PrescriptionsCountResult>;
  prescriptionsWithoutPrivacy: PrescriptionsResult;
  previewDiscountCode: StripeDiscountPreview;
  problems?: Maybe<Array<PatientProblem>>;
  /** only after riscontraFirmaMarcaReqSiss */
  pubblicaPaiReqSiss: ReqSissResult;
  quickAnswer?: Maybe<QuickAnswer>;
  quickAnswers: QuickAnswersResult;
  receivePaiDataFromMillewin: MultiregionBooleanResult;
  refreshToken: AuthData;
  registraPrescrizioniBiancheReqSiss: ReqSissResult;
  /** if you use the id field, the other filters will be ignored */
  relationship?: Maybe<Relationship>;
  relationships?: Maybe<RelationshipsResult>;
  reservation: Reservation;
  reservationWithoutFilters: Reservation;
  rettificaCertificatoMalattiaReqSiss: ReqSissResult;
  ricercaCertificatiMalattiaReqSiss: ReqSissResult;
  richiestaPromemoriaReqSiss: ReqSissResult;
  rilevaCartaCittadinoReqSiss: ReqSissResult;
  rilevaCartaOperatoreReqSiss: ReqSissResult;
  /** only after riscontraFirmaMarcaReqSiss */
  rinnovaPaiReqSiss: ReqSissResult;
  /** only after marcaPaiReqSiss */
  riscontraFirmaMarcaReqSiss: ReqSissResult;
  sampleVideos: Array<Playlist>;
  searchDrugs: DrugsPaginateResult;
  searchParameters?: Maybe<OutpatientServiceParameterReturn>;
  searchPatient: Array<User>;
  sendToken?: Maybe<MultiregionThreeStateResult>;
  shouldShowNpsModal: Scalars['Boolean']['output'];
  showSantagostinoConsentCard?: Maybe<Scalars['Boolean']['output']>;
  signDocumentUrl: SignDocumentUrlResponse;
  simpleLogin: Scalars['String']['output'];
  sissValues?: Maybe<SissValuesResult>;
  sissValuesIcd9?: Maybe<SissValuesResult>;
  slotRecurrency?: Maybe<Scalars['Int']['output']>;
  /** only after riscontraFirmaMarcaReqSiss */
  sostituisciPaiReqSiss: ReqSissResult;
  substitutePaisByTab?: Maybe<MyPaisReturn>;
  substitutePatientRequests: PaginatedPatientRequestsResult;
  switchToAssistedUser: AuthData;
  syncDrugs?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated only for test purposes */
  testEmail?: Maybe<Scalars['Boolean']['output']>;
  testVirtualCareEmail?: Maybe<Scalars['Boolean']['output']>;
  therapeuticPlan: TherapeuticPlan;
  therapeuticPlans: ComplexTherapeuticPlansResult;
  translationsApp: Scalars['JSON']['output'];
  trasmissionePianiTerapeuticiAifaReqSiss: ReqSissResult;
  unreadFeedbacks: UnreadFeedbacksResponse;
  unreadPatientRequests: Scalars['Boolean']['output'];
  upcomingAvailabilitiesHiddenOnAgenda?: Maybe<Scalars['Boolean']['output']>;
  upcomingReservationsHiddenOnAgenda?: Maybe<Scalars['Boolean']['output']>;
  /** Rileva eventuali credenziali regionali dell'utente e la salva nel database. Sostituisce rilevaCartaOperatoreSissCloud */
  updateUserGeneralCredential: Credential;
  /** fullName is concat($surname, ' ', $name) */
  userById?: Maybe<User>;
  userExists?: Maybe<UserBasic>;
  userFeatureState?: Maybe<UserFeatureState>;
  usersForAdmin?: Maybe<UsersResult>;
  vaccination: Vaccination;
  vaccinations: VaccinationsResult;
  validaFlussoCda2ReqSiss: ReqSissResult;
  validateEmail?: Maybe<Scalars['Boolean']['output']>;
  validateTaxCodesForBulkWorkgroupAdd: ValidateTaxCodesForBulkWorkgroupAddResult;
  verificaArruolabilitaReqSiss: ReqSissResult;
  /** before disarruolaReqSiss */
  verificaPresaInCaricoAttivaReqSiss: ReqSissResult;
  verificaPrescrizioneParseSiss: RegionalPrescriptionStatus;
  verificaPrescrizioneSissCloud: RegionalPrescriptionStatus;
  verifyCredentials: VerifyCredentialsResult;
  verifyPaymentIntentStatus?: Maybe<Scalars['String']['output']>;
  verifyPrescription: RegionalPrescriptionStatus;
  verifyToken?: Maybe<Scalars['Boolean']['output']>;
  virtualCarePlans: Array<Maybe<VirtualCarePlanDetailed>>;
  visualizzaPrescrittoRBReqSiss: ReqSissResult;
  visualizzaTestoRefertoReqSiss: ReqSissResult;
  visualizzazionePianoTerapeuticoAifaReqSiss: ReqSissResult;
  workgroupAgendaList: Array<WorkgroupAgendaView>;
  workgroupImpersonationList: Array<WorkgroupImpersonationView>;
  workgroupManagementList: Array<WorkgroupManagementView>;
  workgroupMedicalReports: MedicalReportsV2Return;
  workgroupOperator?: Maybe<User>;
  workgroupOperatorSpecialtyTemplatesWithSettings: Array<EditableSpeciality>;
  workgroupOperatorsByPermission: Array<WorkgroupOperatorBasic>;
  workgroupPatientsTabs: WorkgroupPatientsTabs;
  workgroupPermissionAreas: Array<RolesPermissionsAreas>;
  workgroupPrescriptions: ComplexPrescriptionsResult;
  workgroups: Array<Workgroup>;
  workgroupsForAdmin?: Maybe<WorkgroupsResult>;
};


export type QueryAbortMultipartUploadArgs = {
  category: DocumentCategory;
  key: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};


export type QueryActivePrincipleInteractionsArgs = {
  newActivePrinciples: Scalars['String']['input'];
  patientActivePrinciples: Array<Scalars['String']['input']>;
};


export type QueryAddPatientReqSissArgs = {
  patientTaxCode: Scalars['String']['input'];
};


export type QueryAdminSwitchingDoctorArgs = {
  doctorId: Scalars['ID']['input'];
};


export type QueryAggiornaPaiReqSissArgs = {
  paiId: Scalars['ID']['input'];
};


export type QueryAllUnreadMessagesCountArgs = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  origins?: InputMaybe<Array<InputMaybe<ChatOrigin>>>;
};


export type QueryAmbulatoryTestArgs = {
  ambulatoryTestId: Scalars['ID']['input'];
};


export type QueryAmbulatoryTestsArgs = {
  input: ComplexQueryInput;
  patientId: Scalars['ID']['input'];
};


export type QueryAnamnesesArgs = {
  input: ComplexQueryInput;
  patientId: Scalars['ID']['input'];
  type?: InputMaybe<AnamnesisRecordType>;
};


export type QueryAnnullaPaiReqSissArgs = {
  paiId: Scalars['ID']['input'];
};


export type QueryAnnullaPrescrizioneBiancaReqSissArgs = {
  prescriptionId: Scalars['ID']['input'];
};


export type QueryAnnullaPrescrizioneReqSissArgs = {
  prescriptionId: Scalars['ID']['input'];
};


export type QueryAnnullamentoPianoTerapeuticoAifaReqSissArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryAreSantagostinoReportsDownloadEnabledArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryAssistedUsersArgs = {
  input: ComplexQueryInput;
  verified: AssistedUserVerifiedStatus;
};


export type QueryAuthExistsArgs = {
  username: Scalars['Username']['input'];
};


export type QueryAuthLogsArgs = {
  input: ComplexQueryInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAuthUsersArgs = {
  input: ComplexQueryInput;
};


export type QueryAuthenticationsArgs = {
  input: ComplexQueryInput;
  tab: AuthTab;
};


export type QueryAuthenticationsByUserArgs = {
  input: ComplexQueryInput;
  userId: Scalars['ID']['input'];
};


export type QueryAvailabilitySlotsArgs = {
  doctorId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  showcase?: InputMaybe<SpecialityShowcase>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  workgroups?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAvailabilitySlotsForDayArgs = {
  day: Scalars['Timestamp']['input'];
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  findFirstAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  showWorkgroupsAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  showcase?: InputMaybe<SpecialityShowcase>;
  specialityTemplateId: Scalars['ID']['input'];
  workgroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAvailabilitySlotsForSpecialityArgs = {
  doctorId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  showcase?: InputMaybe<SpecialityShowcase>;
  specialityTemplateId: Scalars['ID']['input'];
  startDate: Scalars['Timestamp']['input'];
  workgroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAvailabilitySlotsForSpecialityNoAuthArgs = {
  doctorSpecialityPairs?: InputMaybe<Array<DoctorSpecialityPairInput>>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  showcase?: InputMaybe<SpecialityShowcase>;
  startDate: Scalars['Timestamp']['input'];
  workgroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCalendarEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCanCreateDrugReservationArgs = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  patientId: Scalars['ObjectId']['input'];
};


export type QueryCanSeePatientArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryCancelPaymentIntentArgs = {
  paymentIntent: Scalars['String']['input'];
};


export type QueryCancellaCertificatoMalattiaReqSissArgs = {
  certificateId: Scalars['ID']['input'];
};


export type QueryCertificateArgs = {
  certificateId: Scalars['ID']['input'];
};


export type QueryCertificatesArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: ComplexQueryInput;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryChatByIdArgs = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryChatByPatientIdArgs = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  patientId: Scalars['ID']['input'];
};


export type QueryCheckCouponValidityArgs = {
  code: Scalars['String']['input'];
  macroSpeciality?: InputMaybe<MacroSpeciality>;
  specialitiesTemplate?: InputMaybe<Scalars['ID']['input']>;
  userTaxCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckDiscountCodeArgs = {
  promoCode: Scalars['String']['input'];
};


export type QueryCheckReportHasCdaArgs = {
  report: GetStructuredReportInput;
};


export type QueryClinicWorkgroupsClosuresArgs = {
  clinicId: Scalars['String']['input'];
};


export type QueryClinicsForAdminArgs = {
  input: ComplexQueryInput;
};


export type QueryCompleteMultipartUploadArgs = {
  category: DocumentCategory;
  key: Scalars['String']['input'];
  parts: Array<Scalars['String']['input']>;
  uploadId: Scalars['String']['input'];
};


export type QueryConsultaDocumentiFascicoloReqSissArgs = {
  authorOnly?: InputMaybe<Scalars['Boolean']['input']>;
  documentType?: InputMaybe<MultiregionDocumentType>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  patientId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryConsultaStatoReqSissArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryCountCommunicationRecipientsArgs = {
  communicationInput: CommunicationInput;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCountMedicalReportV2Args = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCountWorkgroupMedicalReportsArgs = {
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCreateMultipartUploadArgs = {
  category: DocumentCategory;
  duration?: InputMaybe<Scalars['UnsignedInt']['input']>;
  length: Scalars['UnsignedInt']['input'];
};


export type QueryCreatePaymentIntentArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  reservationStart?: InputMaybe<Scalars['Timestamp']['input']>;
  specialityTemplateId: Scalars['ID']['input'];
  stripeConnectedId: Scalars['String']['input'];
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCreatePrescriptionsReqSissArgs = {
  aslCodeOverride?: InputMaybe<Scalars['String']['input']>;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  prescriptionIds: Array<Scalars['ID']['input']>;
};


export type QueryCronJobsArgs = {
  input: ComplexQueryInput;
};


export type QueryDataExportRequestsArgs = {
  input: ComplexQueryInput;
};


export type QueryDataImportRequestsArgs = {
  input: ComplexQueryInput;
};


export type QueryDaysWhenThereIsAnEventArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['Timestamp']['input'];
  startDate: Scalars['Timestamp']['input'];
};


export type QueryDecryptTantoSvagoSsoArgs = {
  sso: Scalars['String']['input'];
};


export type QueryDedupedProblemsArgs = {
  dateFrom?: InputMaybe<Scalars['Timestamp']['input']>;
  dateTo?: InputMaybe<Scalars['Timestamp']['input']>;
  patientId: Scalars['ID']['input'];
  problemCode?: InputMaybe<Scalars['String']['input']>;
  problemTab?: InputMaybe<ProblemTab>;
};


export type QueryDiariesArgs = {
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GroupedDiaryType>;
};


export type QueryDiariesMonitoringArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryDiaryArgs = {
  diaryId: Scalars['ID']['input'];
};


export type QueryDiaryLogsArgs = {
  dateFrom?: InputMaybe<Scalars['Timestamp']['input']>;
  dateTo?: InputMaybe<Scalars['Timestamp']['input']>;
  input: ComplexQueryInput;
  patientId: Scalars['ID']['input'];
};


export type QueryDisarruolaReqSissArgs = {
  motivation: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
  status?: InputMaybe<VerificationStatusEnlistingEnum>;
};


export type QueryDoOperatorsBelongInSameWorkgroupArgs = {
  operatorIds: Array<Scalars['ID']['input']>;
};


export type QueryDoctorPatientSettingArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryDoctorsInMyCooperativeArgs = {
  input: ComplexQueryInput;
};


export type QueryDoctorsV2Args = {
  input: ComplexQueryInput;
};


export type QueryDocumentsArgs = {
  categories?: InputMaybe<Array<DocumentCategory>>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Boolean']['input']>;
  reservationId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryDocumentsV2Args = {
  categories?: InputMaybe<Array<DocumentCategory>>;
  input: ComplexQueryInput;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  reservationId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryDownloadSheetArgs = {
  filename: Scalars['String']['input'];
  type: DrugSheetType;
};


export type QueryDrugPrescriptionsInteractionsArgs = {
  drugCodesCard: Array<DrugPrescriptionsInteractionsInput>;
};


export type QueryDrugReservationArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryDrugReservationsArgs = {
  input: ComplexQueryInput;
  tab?: InputMaybe<DrugReservationsTab>;
};


export type QueryDrugReservationsCountArgs = {
  tab: DrugReservationsTab;
};


export type QueryDrugstoreArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDrugstoresArgs = {
  input: ComplexQueryInput;
  location?: InputMaybe<LocationInput>;
};


export type QueryElencoProtocolliPianiTerapeuticiAifaReqSissArgs = {
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  patientId: Scalars['ID']['input'];
  planType: PlanRequestType;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryExemptionsArgs = {
  input?: InputMaybe<ComplexQueryInput>;
};


export type QueryExistingPaiArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeedbackByIdArgs = {
  feedbackId: Scalars['String']['input'];
};


export type QueryFindActivePrinciplesArgs = {
  input: ComplexQueryInput;
};


export type QueryFindActivePrinciplesInteractionsArgs = {
  input?: InputMaybe<FarmadatiAPsInteractionsInput>;
};


export type QueryFindAuthenticationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindAuthenticationByIdWithDeletedArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindDiseaseCertificateArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  certificateId: Scalars['ID']['input'];
};


export type QueryFindDrugByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryFindDrugsByEquivalenceGroupArgs = {
  input: FarmadatiDrugsByEquivalenceGroupInput;
  withExemptions?: InputMaybe<Scalars['Boolean']['input']>;
  withPrice?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFindExemptionsArgs = {
  input?: InputMaybe<FarmadatiExemptionInput>;
};


export type QueryFindIdentityValidationByIdArgs = {
  identityValidationId: Scalars['String']['input'];
};


export type QueryFindLatestLifestyleInformationsArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryFindLatestMeasurementsArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryFindMedicalInstructionArgs = {
  instructionRequestType: InstructionRequestType;
  prescriptionType?: InputMaybe<InstructionPrescriptionType>;
  specialityTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryFindMedicalInstructionForPatientArgs = {
  doctorId: Scalars['ID']['input'];
  instructionRequestType: InstructionRequestType;
  prescriptionType?: InputMaybe<InstructionPrescriptionType>;
  specialityTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryFindParametersByLoincCodesArgs = {
  loincCodes: Array<Scalars['String']['input']>;
};


export type QueryFindPatientsForMmgArgs = {
  input: ComplexQueryInput;
};


export type QueryFirmaPaiReqSissArgs = {
  base64: Scalars['String']['input'];
  paiId: Scalars['ID']['input'];
};


export type QueryFirstAvailableSlotArgs = {
  doctorSpecialityPairs?: InputMaybe<Array<DoctorSpecialityPairInput>>;
  showcase?: InputMaybe<SpecialityShowcase>;
};


export type QueryGeneratePaiAnnullativoPdfArgs = {
  paiId: Scalars['ID']['input'];
};


export type QueryGeneratePaiPdfArgs = {
  isForFse?: InputMaybe<Scalars['Boolean']['input']>;
  paiId: Scalars['ID']['input'];
};


export type QueryGenerateTokBoxTokenArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryGetAgendaSettingsArgs = {
  doctorId: Scalars['ID']['input'];
};


export type QueryGetAiResponseFromChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryGetAmbulatoryArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetAmbulatoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAnnualRecurringRevenueArgs = {
  year: Scalars['Int']['input'];
};


export type QueryGetAvailabilitySlotByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBillingByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetBillingItemTemplatesArgs = {
  input: ComplexQueryInput;
};


export type QueryGetBillingsArgs = {
  input: ComplexQueryInput;
};


export type QueryGetBlacklistEntriesArgs = {
  input: ComplexQueryInput;
};


export type QueryGetCatalogueCodeArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  input: GetCatalogueCodeInput;
};


export type QueryGetCertificateTemplateByTypeArgs = {
  certificateType: CertificateType;
};


export type QueryGetCitiesArgs = {
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClinicReservationsArgs = {
  endDate: Scalars['Timestamp']['input'];
  startDate: Scalars['Timestamp']['input'];
  workgroupId: Scalars['ID']['input'];
};


export type QueryGetConsentsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  patientId: Scalars['ID']['input'];
};


export type QueryGetCovidTestCodesArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetCreatedByUsersArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryGetCurrentPaiInfoArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryGetDefaultTypeOfAccessArgs = {
  patientId: Scalars['ID']['input'];
  serviceId: Scalars['ID']['input'];
};


export type QueryGetDeliveryRegimesArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetDistrictsArgs = {
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDoctorSpecialitiesArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetDoctorSpecialitiesV2Args = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<QueryPagination>;
  showcase?: InputMaybe<SpecialityShowcase>;
};


export type QueryGetDoctorSpecialityPriceArgs = {
  doctorId: Scalars['ID']['input'];
  specialityTemplateId: Scalars['ID']['input'];
};


export type QueryGetDosagesArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetFamilyRelationshipByIdArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryGetIdentityValidationsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortingDirection>;
  status?: InputMaybe<IdentityValidationStatus>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetInvoicesArgs = {
  input: ComplexQueryInput;
};


export type QueryGetLastValidMedicalReportOfTypeArgs = {
  documentType: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
};


export type QueryGetLicensedWorkgroupsArgs = {
  input: ComplexQueryInput;
};


export type QueryGetLinkedUsersInfoArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryGetMedicalDocumentArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  input: GetMedicalDocumentInput;
};


export type QueryGetMedicalDocumentsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  input: GetMedicalDocumentsInput;
};


export type QueryGetMonthlyInvoiceTotalsArgs = {
  year: Scalars['Int']['input'];
};


export type QueryGetMySmsMonthlyInfoArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetNextIdentityValidationToVerifyArgs = {
  currentIdentityValidationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPatientArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryGetPatientAuthArgs = {
  mmgUserId?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
};


export type QueryGetPatientOutpatientServiceOutcomeParametersArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<ComplexQueryInput>;
  loincCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  patientId: Scalars['ID']['input'];
};


export type QueryGetPatientOutpatientServiceOutcomeServiceExamParametersArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<ComplexQueryInput>;
  patientId: Scalars['ID']['input'];
  serviceExamCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetPatientUniqueOutpatientServiceOutcomesArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
};


export type QueryGetPatientVirtualCareSubscriptionArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetPlanInfoFromTaxCodeArgs = {
  taxCode: Scalars['String']['input'];
};


export type QueryGetPresignedUrlForUploadArgs = {
  category: DocumentCategory;
  duration?: InputMaybe<Scalars['UnsignedInt']['input']>;
};


export type QueryGetPreviousInfectionsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetRegionalAddressesArgs = {
  type?: InputMaybe<RegionalStructureTypes>;
};


export type QueryGetRegionalAddressesAutocompleteArgs = {
  input: ComplexQueryInput;
  opts?: InputMaybe<GetRegionalAddressesOpts>;
};


export type QueryGetRegionalListArgs = {
  types: Array<RegionalListsTypes>;
};


export type QueryGetRelationshipByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetReportOutpatientServiceOutcomesArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['ID']['input'];
};


export type QueryGetReservationBySecretArgs = {
  secret: Scalars['String']['input'];
};


export type QueryGetReservationByVideoSessionIdArgs = {
  videoSessionId: Scalars['String']['input'];
};


export type QueryGetRetoolClinicsArgs = {
  endIntervalMilliseconds: Scalars['Timestamp']['input'];
  startIntervalMilliseconds: Scalars['Timestamp']['input'];
};


export type QueryGetRiskCategoriesArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetRiskConditionsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetSignupRequestArgs = {
  otp: Scalars['String']['input'];
  username: Scalars['Username']['input'];
};


export type QueryGetSissPdlRequestsFromMedicalReportArgs = {
  forceDownloadAgain?: InputMaybe<Scalars['Boolean']['input']>;
  medicalReportId: Scalars['String']['input'];
};


export type QueryGetSomministrationMethodsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetSomministrationMotivationsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetSomministrationPlacesArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetSomministrationSitesArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetSpecialityTemplateByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSpecialityTemplateListArgs = {
  channel?: InputMaybe<ReservationChannel>;
};


export type QueryGetSpecialityTemplatesArgs = {
  macroSpeciality?: InputMaybe<Array<MacroSpeciality>>;
  onlySpecialitiesEnabledForPartners?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  showOnSpecialitiesList?: InputMaybe<Scalars['Boolean']['input']>;
  specialityTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  specialityTemplateNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetSpecialityTemplatesByMacroSpecialityArgs = {
  location?: InputMaybe<LocationInput>;
  macroSpecialities?: InputMaybe<Array<MacroSpeciality>>;
};


export type QueryGetSpecialityTemplatesForPatientArgs = {
  channels?: InputMaybe<Array<ReservationChannel>>;
  doctorId: Scalars['ID']['input'];
  showcase?: InputMaybe<SpecialityShowcase>;
};


export type QueryGetStripeSubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QueryGetStructuredReportArgs = {
  report: GetStructuredReportInput;
};


export type QueryGetSubscriptionPlanUsersByUserIdArgs = {
  userId: Scalars['ObjectId']['input'];
};


export type QueryGetTranscriptionRawArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryGetTranscriptionStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryGetTypesArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetUsedNresArgs = {
  fromDate?: InputMaybe<Scalars['UnsignedInt']['input']>;
  prescriptionType?: InputMaybe<NrePrescriptionType>;
  toDate?: InputMaybe<Scalars['UnsignedInt']['input']>;
};


export type QueryGetVaccinationPregnancyStatusArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetVaccineLotsArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  vaccineId: Scalars['String']['input'];
};


export type QueryGetVaccinesArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
};


export type QueryGetVirtualCarePlanByPlanIdArgs = {
  planId: Scalars['String']['input'];
};


export type QueryGetVirtualCarePlanSubscriptionBySubscriptionIdArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QueryGetWorkgroupPatientRequestsArgs = {
  input: ComplexQueryInput;
  opts: MyPatientRequestsInput;
};


export type QueryGetWorkgroupsOperatorsByOperatorIdArgs = {
  operatorId: Scalars['ID']['input'];
  roles?: InputMaybe<Array<Role>>;
  workgroupType?: InputMaybe<WorkgroupType>;
};


export type QueryHasDoctorUnreadMessagesArgs = {
  doctorId: Scalars['ID']['input'];
};


export type QueryHasPrescriptionsArgs = {
  patientId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<PrescriptionStatus>>;
};


export type QueryHasValidNresArgs = {
  lotIdentifier?: InputMaybe<Scalars['Int']['input']>;
  numberOfDemPrescription: Scalars['Int']['input'];
  numberOfRedPrescription: Scalars['Int']['input'];
  ownerId: Scalars['String']['input'];
};


export type QueryHasWebpushFcmTokenArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};


export type QueryHistoricalUserParamsArgs = {
  dateFrom?: InputMaybe<Scalars['Timestamp']['input']>;
  dateTo?: InputMaybe<Scalars['Timestamp']['input']>;
  input: ComplexQueryInput;
  patientId: Scalars['ID']['input'];
};


export type QueryHospitalAdmissionFormArgs = {
  hospitalAdmissionFormId: Scalars['ID']['input'];
};


export type QueryHospitalAdmissionFormsArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: ComplexQueryInput;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIdentificaCittadinoReqSissArgs = {
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIdentificaPrescrizioneReqSissArgs = {
  iup?: InputMaybe<Scalars['String']['input']>;
  nrbe?: InputMaybe<Scalars['String']['input']>;
  nre?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  pinNrbe?: InputMaybe<Scalars['String']['input']>;
};


export type QueryImportedUserNotesArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  patientId: Scalars['ID']['input'];
};


export type QueryInvioCertificatoMalattiaReqSissArgs = {
  certificateId: Scalars['ID']['input'];
};


export type QueryIsDoctorAvailableForReservationArgs = {
  doctorId: Scalars['ID']['input'];
  endTime: Scalars['Timestamp']['input'];
  startTime: Scalars['Timestamp']['input'];
};


export type QueryLastPaiArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryLatestOutpatientServiceOutcomesArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  loincCode: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
};


export type QueryLatestOutpatientServiceOutcomesByServiceExamArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  patientId: Scalars['ID']['input'];
  serviceExamCode: Scalars['String']['input'];
};


export type QueryLatestOutpatientServiceOutcomesByServiceExamMultipleArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  patientId: Scalars['ID']['input'];
  serviceExamCodes: Array<Scalars['String']['input']>;
};


export type QueryLatestOutpatientServiceOutcomesMultipleArgs = {
  limit: Scalars['Int']['input'];
  loincCodes: Array<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
};


export type QueryLatestUserParamsArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryLifestyleInformationsArgs = {
  input: ComplexQueryInput;
  patientId: Scalars['ID']['input'];
};


export type QueryListMultipartUploadsArgs = {
  category: DocumentCategory;
};


export type QueryListPatientsArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  input: ComplexQueryInput;
  tabName?: InputMaybe<PatientsListTabs>;
  workgroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['Username']['input'];
};


export type QueryLoginV2Args = {
  password: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['Username']['input'];
};


export type QueryLogoutOAuth2Args = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type QueryMarcaPaiReqSissArgs = {
  paiId: Scalars['ID']['input'];
};


export type QueryMeasurementsArgs = {
  dateFrom?: InputMaybe<Scalars['Timestamp']['input']>;
  dateTo?: InputMaybe<Scalars['Timestamp']['input']>;
  input: ComplexQueryInput;
  patientId: Scalars['ID']['input'];
  types?: InputMaybe<Array<MeasurementType>>;
};


export type QueryMedicalInstructionsByDoctorArgs = {
  doctorId: Scalars['ID']['input'];
};


export type QueryMedicalReportArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryMedicalReportV2Args = {
  reportId: Scalars['ID']['input'];
};


export type QueryMedicalReportsArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: ComplexQueryInput;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMedicalReportsV2Args = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: ComplexQueryInput;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMessagesArgs = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  chatId: Scalars['ID']['input'];
  past: Scalars['Boolean']['input'];
  size: Scalars['Int']['input'];
  timestamp: Scalars['Timestamp']['input'];
};


export type QueryMessagesV2Args = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  chatId: Scalars['ID']['input'];
  input: ComplexQueryInput;
};


export type QueryMigrateTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryMultipleDownloadMedicalDocumentsArgs = {
  input: MultipleDownloadMedicalDocumentsInput;
};


export type QueryMyCalendarEventsArgs = {
  categories?: InputMaybe<Array<EventCategory>>;
  category?: InputMaybe<EventCategory>;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  endTime?: InputMaybe<Scalars['Timestamp']['input']>;
  startTime?: InputMaybe<Scalars['Timestamp']['input']>;
  workgroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryMyChatsArgs = {
  origins?: InputMaybe<Array<InputMaybe<ChatOrigin>>>;
  usersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryMyChatsV2Args = {
  actingOnBehalfOf?: InputMaybe<Scalars['ObjectId']['input']>;
  input: ComplexQueryInput;
  origins?: InputMaybe<Array<InputMaybe<ChatOrigin>>>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMyCommunicationsArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: ComplexQueryInput;
};


export type QueryMyCouponsArgs = {
  specialityTemplate?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyFeedbacksArgs = {
  input?: InputMaybe<ComplexQueryInput>;
  tab: FeedbacksQueryTab;
};


export type QueryMyMedicalInstructionsArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyNotificationsArgs = {
  query?: InputMaybe<ComplexQueryInput>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyPatientRequestsArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: ComplexQueryInput;
  opts: MyPatientRequestsInput;
};


export type QueryMyPatientRequestsCountArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: ComplexQueryInput;
  opts: MyPatientRequestsInput;
};


export type QueryMyReservationsV2Args = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  input: ComplexQueryInput;
  origins?: InputMaybe<Array<ReservationOrigin>>;
  patients?: InputMaybe<Array<Scalars['ID']['input']>>;
  specialityTemplateId?: InputMaybe<Scalars['ID']['input']>;
  specialityTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  type: ReservationType;
  workgroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryMySpecialtyTemplatesWithMySettingsArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  onlyActivated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMyTagsArgs = {
  input: ComplexQueryInput;
};


export type QueryNotificationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationsForUserArgs = {
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryNpsFeedbacksArgs = {
  input?: InputMaybe<ComplexQueryInput>;
};


export type QueryNpsStatsArgs = {
  filters?: InputMaybe<NpsFiltersInput>;
};


export type QueryOttieniPatologieReqSissArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryOttieniTabellaReqSissArgs = {
  tablesName: Array<Scalars['String']['input']>;
};


export type QueryOutpatientServiceGroupArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  groupId: Scalars['ID']['input'];
};


export type QueryOutpatientServiceGroupCategoriesArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOutpatientServiceGroupsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  status: OutpatientServiceGroupStatus;
};


export type QueryOutpatientServiceGroupsPaginatedArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: ComplexQueryInput;
  status: OutpatientServiceGroupStatus;
};


export type QueryOutpatientServicesArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  input: ComplexQueryInput;
};


export type QueryPaiArgs = {
  paiId: Scalars['ID']['input'];
};


export type QueryPaiAndUserParamsDifferencesArgs = {
  paiId: Scalars['ID']['input'];
};


export type QueryPaiArchiveArgs = {
  input: ComplexQueryInput;
  patientId: Scalars['ID']['input'];
};


export type QueryPaiPatientsArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: ComplexQueryInput;
  status: Array<SissEnlistingStatus>;
};


export type QueryPaiRecapArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryPaisByPatientArgs = {
  input: ComplexQueryInput;
  patientId: Scalars['ID']['input'];
};


export type QueryPaisByTabArgs = {
  input: ComplexQueryInput;
  tabName: PaiTabName;
};


export type QueryPartnersArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPatientDrugsArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryPatientExemptionsArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryPatientExemptionsForPrescriptionArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryPatientMedicalDevicesArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryPatientPrescriptionArgs = {
  prescriptionId: Scalars['ID']['input'];
};


export type QueryPatientPrescriptionsArgs = {
  input?: InputMaybe<ComplexQueryInput>;
  status?: InputMaybe<Array<PrescriptionStatus>>;
};


export type QueryPatientRequestsByIdArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPatientSummariesArgs = {
  input: ComplexQueryInput;
  patientId: Scalars['ID']['input'];
};


export type QueryPatientSummaryArgs = {
  patientSummaryId: Scalars['ID']['input'];
};


export type QueryPatientSummaryPdfArgs = {
  historyId?: InputMaybe<Scalars['ID']['input']>;
  patientSummaryId: Scalars['ID']['input'];
};


export type QueryPatientSummaryPreSaveDiffArgs = {
  editedSelectedParams: SelectedUserParamsInput;
  patientId: Scalars['ID']['input'];
};


export type QueryPatientSummaryUserParamsArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryPatientWorkgroupPermissionsArgs = {
  hasItsOwnPatients: Scalars['Boolean']['input'];
  patientId: Scalars['ID']['input'];
};


export type QueryPatientsEnlistedArgs = {
  ats?: InputMaybe<Ats>;
  input: ComplexQueryInput;
};


export type QueryPhysiologicalUserParamsArgs = {
  dateFrom?: InputMaybe<Scalars['Timestamp']['input']>;
  dateTo?: InputMaybe<Scalars['Timestamp']['input']>;
  input: ComplexQueryInput;
  patientId: Scalars['ID']['input'];
};


export type QueryPrenotaArruolamentoReqSissArgs = {
  patientId: Scalars['ID']['input'];
  primaryDisease?: InputMaybe<Scalars['String']['input']>;
  secondaryDiseases?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPrepareOAuth2UrlArgs = {
  currentUrl?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPrescriptionArgs = {
  prescriptionId: Scalars['ID']['input'];
};


export type QueryPrescriptionsArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<ComplexQueryInput>;
  objectType?: InputMaybe<PrescriptionObjectType>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  prescriptionsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
  sissCounterPai?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<PrescriptionStatus>>;
};


export type QueryPrescriptionsCountArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  includeWorkgroups?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPrescriptionsWithoutPrivacyArgs = {
  prescriptionsIds: Array<Scalars['ID']['input']>;
};


export type QueryPreviewDiscountCodeArgs = {
  price: Scalars['Int']['input'];
  promoCode: Scalars['String']['input'];
};


export type QueryProblemsArgs = {
  dateFrom?: InputMaybe<Scalars['Timestamp']['input']>;
  dateTo?: InputMaybe<Scalars['Timestamp']['input']>;
  patientId: Scalars['ID']['input'];
  problemCode?: InputMaybe<Scalars['String']['input']>;
  problemTab?: InputMaybe<ProblemTab>;
};


export type QueryPubblicaPaiReqSissArgs = {
  paiId: Scalars['ID']['input'];
};


export type QueryQuickAnswerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReceivePaiDataFromMillewinArgs = {
  patientTaxCode: Scalars['String']['input'];
};


export type QueryRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type QueryRegistraPrescrizioniBiancheReqSissArgs = {
  prescriptionIds: Array<Scalars['ID']['input']>;
};


export type QueryRelationshipArgs = {
  childId?: InputMaybe<Scalars['ID']['input']>;
  familyDoctor?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<RelationshipType>;
};


export type QueryRelationshipsArgs = {
  input: ComplexQueryInput;
};


export type QueryReservationArgs = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryReservationWithoutFiltersArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRettificaCertificatoMalattiaReqSissArgs = {
  certificateId: Scalars['ID']['input'];
  validityEndDate: Scalars['Timestamp']['input'];
};


export type QueryRicercaCertificatiMalattiaReqSissArgs = {
  certificateId: Scalars['ID']['input'];
};


export type QueryRichiestaPromemoriaReqSissArgs = {
  prescriptionId: Scalars['ID']['input'];
};


export type QueryRinnovaPaiReqSissArgs = {
  paiId: Scalars['ID']['input'];
};


export type QueryRiscontraFirmaMarcaReqSissArgs = {
  paiId: Scalars['ID']['input'];
};


export type QuerySearchDrugsArgs = {
  filterOutSupplementDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  input: ComplexQueryInput;
  withExemptions?: InputMaybe<Scalars['Boolean']['input']>;
  withPrice?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchParametersArgs = {
  discardParameters?: InputMaybe<Scalars['Boolean']['input']>;
  input: ComplexQueryInput;
};


export type QuerySearchPatientArgs = {
  doctorTaxCode: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  surname?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySendTokenArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  type: TokenType;
};


export type QuerySignDocumentUrlArgs = {
  documentId: Scalars['ID']['input'];
};


export type QuerySissValuesArgs = {
  input: ComplexQueryInput;
  type: SissValueType;
};


export type QuerySissValuesIcd9Args = {
  forceIcd9?: InputMaybe<Scalars['Boolean']['input']>;
  input: ComplexQueryInput;
};


export type QuerySlotRecurrencyArgs = {
  doctorId: Scalars['ID']['input'];
  recurringId: Scalars['String']['input'];
};


export type QuerySostituisciPaiReqSissArgs = {
  paiId: Scalars['ID']['input'];
};


export type QuerySubstitutePaisByTabArgs = {
  doctorId: Scalars['ID']['input'];
  input: ComplexQueryInput;
  tabName: PaiTabName;
};


export type QuerySubstitutePatientRequestsArgs = {
  doctorId: Scalars['ID']['input'];
  input: ComplexQueryInput;
  opts: MyPatientRequestsInput;
};


export type QuerySwitchToAssistedUserArgs = {
  assistedUserId: Scalars['ID']['input'];
};


export type QueryTestEmailArgs = {
  reservationId: Scalars['String']['input'];
};


export type QueryTestVirtualCareEmailArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QueryTherapeuticPlanArgs = {
  therapeuticPlanId: Scalars['ID']['input'];
};


export type QueryTherapeuticPlansArgs = {
  input?: InputMaybe<ComplexQueryInput>;
  patientId: Scalars['ID']['input'];
};


export type QueryTranslationsAppArgs = {
  lang?: InputMaybe<LanguageApp>;
};


export type QueryTrasmissionePianiTerapeuticiAifaReqSissArgs = {
  doctorEmail?: InputMaybe<Scalars['String']['input']>;
  doctorPhone?: InputMaybe<Scalars['String']['input']>;
  evaluation97?: InputMaybe<TherapeuticPlanAifa97EvaluationInput>;
  evaluation100?: InputMaybe<TherapeuticPlanAifa100EvaluationInput>;
  followUp97?: InputMaybe<TherapeuticPlanAifa97FollowUpInput>;
  followUp100?: InputMaybe<TherapeuticPlanAifa100FollowUpInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  patient: Scalars['ID']['input'];
  paxlovid?: InputMaybe<TherapeuticPlanPaxlovidInput>;
  startDate: Scalars['Int']['input'];
};


export type QueryUnreadPatientRequestsArgs = {
  opts?: InputMaybe<UnreadPatientRequestInput>;
};


export type QueryUpcomingAvailabilitiesHiddenOnAgendaArgs = {
  closingTime: Scalars['String']['input'];
  doctorId?: InputMaybe<Scalars['ObjectId']['input']>;
  hiddenDays: Array<Scalars['Int']['input']>;
  openingTime: Scalars['String']['input'];
};


export type QueryUpcomingReservationsHiddenOnAgendaArgs = {
  closingTime: Scalars['String']['input'];
  doctorId?: InputMaybe<Scalars['ObjectId']['input']>;
  hiddenDays: Array<Scalars['Int']['input']>;
  openingTime: Scalars['String']['input'];
};


export type QueryUserByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserExistsArgs = {
  taxCode: Scalars['String']['input'];
};


export type QueryUserFeatureStateArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUsersForAdminArgs = {
  input: ComplexQueryInput;
  partnersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  roles: Array<Role>;
};


export type QueryVaccinationArgs = {
  vaccinationId: Scalars['ID']['input'];
};


export type QueryVaccinationsArgs = {
  input: ComplexQueryInput;
  patientId: Scalars['ID']['input'];
};


export type QueryValidaFlussoCda2ReqSissArgs = {
  paiId: Scalars['ID']['input'];
};


export type QueryValidateEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryValidateTaxCodesForBulkWorkgroupAddArgs = {
  taxCodes: Array<Scalars['String']['input']>;
};


export type QueryVerificaArruolabilitaReqSissArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryVerificaPresaInCaricoAttivaReqSissArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryVerificaPrescrizioneParseSissArgs = {
  iup?: InputMaybe<Scalars['String']['input']>;
  nre?: InputMaybe<Scalars['String']['input']>;
  xml: Scalars['String']['input'];
};


export type QueryVerificaPrescrizioneSissCloudArgs = {
  iup?: InputMaybe<Scalars['String']['input']>;
  nre?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
};


export type QueryVerifyCredentialsArgs = {
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
};


export type QueryVerifyPaymentIntentStatusArgs = {
  paymentIntent: Scalars['String']['input'];
};


export type QueryVerifyPrescriptionArgs = {
  input: InputVerifyPrescription;
};


export type QueryVerifyTokenArgs = {
  auth?: InputMaybe<RegionalSystemLogin>;
  token: Scalars['String']['input'];
  type: TokenType;
};


export type QueryVirtualCarePlansArgs = {
  promoCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVisualizzaPrescrittoRbReqSissArgs = {
  nrbe: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
};


export type QueryVisualizzaTestoRefertoReqSissArgs = {
  uri: Scalars['String']['input'];
};


export type QueryVisualizzazionePianoTerapeuticoAifaReqSissArgs = {
  numProtocollo: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
};


export type QueryWorkgroupAgendaListArgs = {
  fromApp?: InputMaybe<Scalars['Boolean']['input']>;
  operatorId: Scalars['ID']['input'];
};


export type QueryWorkgroupImpersonationListArgs = {
  operatorId: Scalars['ID']['input'];
};


export type QueryWorkgroupManagementListArgs = {
  operatorId: Scalars['ID']['input'];
};


export type QueryWorkgroupMedicalReportsArgs = {
  input: ComplexQueryInput;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkgroupOperatorArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryWorkgroupOperatorSpecialtyTemplatesWithSettingsArgs = {
  onlyActivated?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryWorkgroupOperatorsByPermissionArgs = {
  operatorId: Scalars['ID']['input'];
  permissionArea: RolesPermissionsAreas;
  roles?: InputMaybe<Array<Role>>;
};


export type QueryWorkgroupPatientsTabsArgs = {
  operatorId: Scalars['ID']['input'];
};


export type QueryWorkgroupPermissionAreasArgs = {
  actingOnBehalfOfId?: InputMaybe<Scalars['ID']['input']>;
  operatorId: Scalars['ID']['input'];
};


export type QueryWorkgroupPrescriptionsArgs = {
  input?: InputMaybe<ComplexQueryInput>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<PrescriptionStatus>>;
};


export type QueryWorkgroupsArgs = {
  fromApp?: InputMaybe<Scalars['Boolean']['input']>;
  operatorId: Scalars['ID']['input'];
};


export type QueryWorkgroupsForAdminArgs = {
  input: ComplexQueryInput;
};

export type QueryFilters = {
  comparison?: InputMaybe<Comparison>;
  extraValue?: InputMaybe<Scalars['Int']['input']>;
  field: Scalars['String']['input'];
  value: Scalars['FilterableValueScalar']['input'];
};

export type QueryPagination = {
  limit: Scalars['UnsignedInt']['input'];
  skip: Scalars['UnsignedInt']['input'];
};

export type QuerySorting = {
  field: Scalars['String']['input'];
  value: SortingDirection;
};

export type QuickAnswer = Node & {
  __typename?: 'QuickAnswer';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  keyword: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type QuickAnswersResult = {
  __typename?: 'QuickAnswersResult';
  nodes: Array<QuickAnswer>;
};

export type RangeDate = {
  __typename?: 'RangeDate';
  from: Scalars['Timestamp']['output'];
  to: Scalars['Timestamp']['output'];
};

export type RangeDateInput = {
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
};

export type RaoRecommendation = {
  __typename?: 'RaoRecommendation';
  clinicalAdvice: Scalars['String']['output'];
  /**
   * Sometimes the same priority letter (E.g. B) represents different waiting times for different rao classes.
   * Using 'maxWaitingTime' we can show the active one
   */
  maxWaitingTime?: Maybe<Scalars['String']['output']>;
  orderPosition: Scalars['UnsignedInt']['output'];
  priority: Scalars['String']['output'];
  /** if true, priority described in priority must not be selectable */
  priorityDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** only for mmg; only for pediatric and not for MMGs; for both (default) */
  type: RaoType;
};

export enum RaoType {
  Both = 'BOTH',
  Mmg = 'MMG',
  Pls = 'PLS'
}

export enum ReactionType {
  Edema = 'EDEMA',
  Itching = 'ITCHING',
  Other = 'OTHER',
  Shock = 'SHOCK',
  Urticaria = 'URTICARIA'
}

/**
 * Reason for obscuration of sensitive data in Patient Summary.
 * Based on CS-RPREST-SIAA_01_V1.3 specification section 8.5.
 */
export enum ReasonForObscuration {
  DrugAddiction = 'DRUG_ADDICTION',
  Hiv = 'HIV',
  Violence = 'VIOLENCE',
  VoluntaryByCitizen = 'VOLUNTARY_BY_CITIZEN',
  VoluntaryTerminationOfPregnancy = 'VOLUNTARY_TERMINATION_OF_PREGNANCY'
}

export type RefundBillingInput = {
  auth?: InputMaybe<RegionalSystemLogin>;
  billing: BillingInput;
  id: Scalars['ID']['input'];
};

export enum Region {
  Abruzzo = 'ABRUZZO',
  Basilicata = 'BASILICATA',
  Calabria = 'CALABRIA',
  Campania = 'CAMPANIA',
  EmiliaRomagna = 'EMILIA_ROMAGNA',
  FriuliVeneziaGiulia = 'FRIULI_VENEZIA_GIULIA',
  Lazio = 'LAZIO',
  Liguria = 'LIGURIA',
  Lombardia = 'LOMBARDIA',
  Marche = 'MARCHE',
  Molise = 'MOLISE',
  Piemonte = 'PIEMONTE',
  ProvinciaAutonomaBolzano = 'PROVINCIA_AUTONOMA_BOLZANO',
  ProvinciaAutonomaTrento = 'PROVINCIA_AUTONOMA_TRENTO',
  Puglia = 'PUGLIA',
  Sardegna = 'SARDEGNA',
  Sicilia = 'SICILIA',
  Toscana = 'TOSCANA',
  TrentinoAltoAdige = 'TRENTINO_ALTO_ADIGE',
  Umbria = 'UMBRIA',
  Unknown = 'UNKNOWN',
  ValleDAosta = 'VALLE_D_AOSTA',
  Veneto = 'VENETO'
}

export type RegionCertificateResult = {
  __typename?: 'RegionCertificateResult';
  certificate: Certificate;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RegionalAddress = Node & {
  __typename?: 'RegionalAddress';
  _id: Scalars['ID']['output'];
  address: StructuredAddress;
  agencyCode?: Maybe<Scalars['String']['output']>;
  agencyName?: Maybe<Scalars['String']['output']>;
  assistanceType?: Maybe<Scalars['String']['output']>;
  closingDate?: Maybe<Scalars['UnsignedInt']['output']>;
  code: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  healthFacilityTypeCode?: Maybe<Scalars['String']['output']>;
  healthFacilityTypeDescription?: Maybe<Scalars['String']['output']>;
  isInClinicAssistance?: Maybe<Scalars['Boolean']['output']>;
  isOutsideOfClinicOrDomesticAssistance?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  isResidentialAssistance?: Maybe<Scalars['Boolean']['output']>;
  isSemiResidentialAssistance?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  openingDate?: Maybe<Scalars['UnsignedInt']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Region;
  structureCode?: Maybe<Scalars['String']['output']>;
  structureType?: Maybe<RegionalStructureTypes>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['UnsignedInt']['output']>;
};

export type RegionalAddressesResult = ComplexQueryReturn & {
  __typename?: 'RegionalAddressesResult';
  nodes?: Maybe<Array<RegionalAddress>>;
  pageInfo: PageInfo;
};

export type RegionalList = {
  __typename?: 'RegionalList';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Timestamp']['output']>;
  region?: Maybe<Region>;
  startDate?: Maybe<Scalars['Timestamp']['output']>;
  type: RegionalListsTypes;
};

export enum RegionalListsTypes {
  CovidMotivation = 'COVID_MOTIVATION',
  CovidOutpatientService = 'COVID_OUTPATIENT_SERVICE',
  DeliveryRegimes = 'DELIVERY_REGIMES',
  DematInhibitedAicCodes = 'DEMAT_INHIBITED_AIC_CODES',
  LoincCatalogueTranscode = 'LOINC_CATALOGUE_TRANSCODE',
  SomministrationMethods = 'SOMMINISTRATION_METHODS',
  SomministrationMotivations = 'SOMMINISTRATION_MOTIVATIONS',
  SomministrationPlaces = 'SOMMINISTRATION_PLACES',
  SomministrationSites = 'SOMMINISTRATION_SITES',
  TransportAddressType = 'TRANSPORT_ADDRESS_TYPE',
  TransportCondition = 'TRANSPORT_CONDITION',
  TransportMotivation = 'TRANSPORT_MOTIVATION',
  TransportType = 'TRANSPORT_TYPE',
  VaccinationsPregnancyStatus = 'VACCINATIONS_PREGNANCY_STATUS',
  VaccinationsPreviousInfections = 'VACCINATIONS_PREVIOUS_INFECTIONS'
}

export enum RegionalPrescriptionStatus {
  Booked = 'BOOKED',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Prescribed = 'PRESCRIBED',
  Provided = 'PROVIDED'
}

export enum RegionalStructureTypes {
  Agency = 'AGENCY',
  Association = 'ASSOCIATION',
  Hospital = 'HOSPITAL',
  Rehabilitation = 'REHABILITATION',
  Territorial = 'TERRITORIAL'
}

export type RegionalSystemConfig = {
  __typename?: 'RegionalSystemConfig';
  regionalSystemUrl: Scalars['String']['output'];
  urlForForgottenRegionalSystemPassword: Scalars['String']['output'];
  urlForForgottenRegionalSystemUsername: Scalars['String']['output'];
};

export enum RegionalSystemCredentialsTypes {
  Ade = 'ADE',
  Aura = 'AURA',
  RegionalPlatform = 'REGIONAL_PLATFORM',
  Sar = 'SAR',
  Sirpe = 'SIRPE',
  Siss = 'SISS',
  Sogei = 'SOGEI',
  Sole = 'SOLE',
  Soresa = 'SORESA'
}

export type RegionalSystemLogin = {
  password?: InputMaybe<Scalars['String']['input']>;
  pincode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RegionalSystemCredentialsTypes>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum RegionalSystemServices {
  Billing = 'BILLING',
  CovidTests = 'COVID_TESTS',
  DiseaseCertificates = 'DISEASE_CERTIFICATES',
  Exemptions = 'EXEMPTIONS',
  MedicalDocuments = 'MEDICAL_DOCUMENTS',
  Pais = 'PAIS',
  Patients = 'PATIENTS',
  PatientSummary = 'PATIENT_SUMMARY',
  Prescriptions = 'PRESCRIPTIONS',
  RegionalData = 'REGIONAL_DATA',
  Reports = 'REPORTS',
  TherapeuticPlans = 'THERAPEUTIC_PLANS',
  Users = 'USERS',
  Vaccinations = 'VACCINATIONS',
  WhitePrescriptions = 'WHITE_PRESCRIPTIONS'
}

export type RelatedPrescriptionsInfo = {
  __typename?: 'RelatedPrescriptionsInfo';
  prescriptionsCount: Scalars['UnsignedInt']['output'];
  servicesPrescribedCount: Scalars['UnsignedInt']['output'];
  servicesPrescribedPercentage: Scalars['UnsignedInt']['output'];
};

export type Relationship = Node & {
  __typename?: 'Relationship';
  _id: Scalars['ID']['output'];
  caregiverTutor?: Maybe<Scalars['Boolean']['output']>;
  child: User;
  childAcceptedAt?: Maybe<Scalars['Long']['output']>;
  createdBy: Owner;
  familyDoctor: Scalars['Boolean']['output'];
  /**
   * @fseAccessGranted tells if the patient has granted access to fascicolo sanitario elettronico.
   * Possible values:
   *   - null: means unknown, the patient has neither granted nor declined the access
   *   - true: the patient has granted the access
   *   - false: the patient has declined the access
   */
  fseAccessGranted?: Maybe<Scalars['Boolean']['output']>;
  listName: Scalars['String']['output'];
  parent: User;
  parentAcceptedAt?: Maybe<Scalars['Long']['output']>;
  type: RelationshipType;
};

/**
 * Patients can be linked through relationship to many doctors.Every Doctor needs that patient to be in a different list.
 *   Active = Currently being monitored
 * Archived = Monitoring ended
 * Pending = added by ats
 * Stardard = no specific list
 */
export enum RelationshipPatientList {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Pending = 'PENDING',
  Standard = 'STANDARD'
}

export enum RelationshipType {
  AuntOrUncleNephew = 'AUNT_OR_UNCLE_NEPHEW',
  Cousin = 'COUSIN',
  DoctorDoctor = 'DOCTOR_DOCTOR',
  DoctorPatient = 'DOCTOR_PATIENT',
  GrandparentNephew = 'GRANDPARENT_NEPHEW',
  NephewOfAuntOrUncle = 'NEPHEW_OF_AUNT_OR_UNCLE',
  NephewOfGrandparent = 'NEPHEW_OF_GRANDPARENT',
  Other = 'OTHER',
  Parent = 'PARENT',
  Sibling = 'SIBLING',
  SonOrDaughter = 'SON_OR_DAUGHTER',
  Spouse = 'SPOUSE',
  TutorCaregiverNoFamily = 'TUTOR_CAREGIVER_NO_FAMILY',
  TutorMinorNoParent = 'TUTOR_MINOR_NO_PARENT'
}

export type RelationshipsResult = ComplexQueryReturn & {
  __typename?: 'RelationshipsResult';
  nodes?: Maybe<Array<Relationship>>;
  pageInfo: PageInfo;
};

export type Relative = Node & {
  __typename?: 'Relative';
  _id: Scalars['ID']['output'];
  birthCity?: Maybe<Scalars['String']['output']>;
  birthCountry: Scalars['String']['output'];
  birthDate: Scalars['Timestamp']['output'];
  birthDistrict?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sex: Sex;
  surname: Scalars['String']['output'];
  taxCode: Scalars['String']['output'];
};

export type Report = {
  __typename?: 'Report';
  consultationStatus?: Maybe<ConsultationStatus>;
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Document>>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type ReportInput = {
  consultationStatus?: InputMaybe<ConsultationStatus>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<Scalars['ID']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type ReqSissResult = {
  __typename?: 'ReqSissResult';
  xml: Scalars['String']['output'];
};

export type RequestOptions = {
  key: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type RequestOtpGenerationResult = {
  __typename?: 'RequestOtpGenerationResult';
  success: Scalars['Boolean']['output'];
  waitUntil?: Maybe<Scalars['Timestamp']['output']>;
};

export type RequestParamsType = TherapeuticPlanAifa97Evaluation | TherapeuticPlanAifa97FollowUp | TherapeuticPlanAifa100Evaluation | TherapeuticPlanAifa100FollowUp | TherapeuticPlanPaxlovid;

export type Reservation = Node & {
  __typename?: 'Reservation';
  _id: Scalars['ID']['output'];
  /**
   * The user who accepted the reservation (changed status from PENDING to ONGOING).
   * Not required to keep backward compatibility
   */
  acceptedBy?: Maybe<User>;
  additionalInformation?: Maybe<AdditionalInformation>;
  billingInformation?: Maybe<BillingInformation>;
  billingPrice?: Maybe<Scalars['Int']['output']>;
  channel: ReservationChannel;
  createdAt: Scalars['Timestamp']['output'];
  /**
   * The user who run the mutation to create the reservation (context.currentUser).
   * Not required to keep backward compatibility
   */
  createdBy?: Maybe<User>;
  deleteAppointmentReasonType?: Maybe<DeleteAppointmentReason>;
  deleteMotivation?: Maybe<Scalars['String']['output']>;
  deleteUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** can be null as it has not been accepted yet by a doctor */
  doctor?: Maybe<User>;
  doctorCut?: Maybe<Scalars['Int']['output']>;
  /** duration value in sec */
  duration?: Maybe<Scalars['UnsignedInt']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /**
   * The user who changed the state of the reservation to ENDED, REFUNDED or DELETED.
   * Not required to keep backward compatibility
   */
  endedBy?: Maybe<User>;
  /** This flag is set when the reservation is ended automatically from a job (updateReservationStatusIfExpired). */
  endedBySystem?: Maybe<Scalars['Boolean']['output']>;
  homeVisit?: Maybe<HomeVisit>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  minorKidAge?: Maybe<Scalars['Int']['output']>;
  onBehalfOf?: Maybe<User>;
  owner?: Maybe<User>;
  patient: User;
  paymentTransactions?: Maybe<Array<Maybe<PaymentTransaction>>>;
  phone?: Maybe<Scalars['String']['output']>;
  price: Scalars['UnsignedInt']['output'];
  productCode?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
  reportInternalNotesAuthor?: Maybe<User>;
  reservationCode?: Maybe<Scalars['String']['output']>;
  reservationOrigin?: Maybe<ReservationOrigin>;
  reservationSecret?: Maybe<Scalars['String']['output']>;
  specialityTemplate: SpecialityTemplateReservation;
  startTime?: Maybe<Scalars['Long']['output']>;
  status: ReservationStatus;
  videoSessionId?: Maybe<Scalars['String']['output']>;
  viewers?: Maybe<Array<Scalars['ID']['output']>>;
  workgroup?: Maybe<Workgroup>;
  workgroupId?: Maybe<Scalars['ID']['output']>;
};

export enum ReservationChannel {
  Call = 'CALL',
  Chat = 'CHAT',
  Studio = 'STUDIO',
  Video = 'VIDEO'
}

export enum ReservationMailType {
  AcceptedReservation = 'ACCEPTED_RESERVATION',
  DeleteReservationClinic = 'DELETE_RESERVATION_CLINIC',
  DeleteReservationUser = 'DELETE_RESERVATION_USER',
  EditReservationClinic = 'EDIT_RESERVATION_CLINIC',
  EditReservationUser = 'EDIT_RESERVATION_USER',
  NewReservationClinic = 'NEW_RESERVATION_CLINIC',
  NewReservationUser = 'NEW_RESERVATION_USER',
  NotifyUserJoinCall = 'NOTIFY_USER_JOIN_CALL',
  Reminder_24 = 'REMINDER_24',
  Reminder_48 = 'REMINDER_48'
}

export enum ReservationOrigin {
  Acuore = 'ACUORE',
  Ai = 'AI',
  Argento = 'ARGENTO',
  Cassalombarda = 'CASSALOMBARDA',
  Inclinic = 'INCLINIC',
  Mmg = 'MMG',
  MmgPatient = 'MMG_PATIENT',
  Morato = 'MORATO',
  Sisalute = 'SISALUTE',
  TantoSvago = 'TANTO_SVAGO',
  Unisalute = 'UNISALUTE',
  Virtualcare = 'VIRTUALCARE',
  Welfare = 'WELFARE'
}

export enum ReservationStatus {
  Deleted = 'DELETED',
  Ended = 'ENDED',
  Ongoing = 'ONGOING',
  PaymentAuthorized = 'PAYMENT_AUTHORIZED',
  Pending = 'PENDING',
  PendingPayment = 'PENDING_PAYMENT',
  Refunded = 'REFUNDED'
}

export enum ReservationType {
  All = 'ALL',
  ClinicComplete = 'CLINIC_COMPLETE',
  ClinicPendingApproval = 'CLINIC_PENDING_APPROVAL',
  ClinicToday = 'CLINIC_TODAY',
  ClinicUpcoming = 'CLINIC_UPCOMING',
  Complete = 'COMPLETE',
  PendingApproval = 'PENDING_APPROVAL',
  Upcoming = 'UPCOMING'
}

export type ReservationUpdated = {
  __typename?: 'ReservationUpdated';
  reservation: Reservation;
};

export type ReservationsResult = ComplexQueryReturn & {
  __typename?: 'ReservationsResult';
  nodes?: Maybe<Array<Reservation>>;
  pageInfo: PageInfo;
};

export type ReservationsSettings = {
  __typename?: 'ReservationsSettings';
  nurseReservationsEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ReservationsSettingsInput = {
  nurseReservationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResponseSubmitTherapeuticPlan = {
  __typename?: 'ResponseSubmitTherapeuticPlan';
  argument: Scalars['String']['output'];
  document?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isContinuous?: Maybe<Scalars['Boolean']['output']>;
  planType?: Maybe<TherapeuticPlanType>;
  requestParams?: Maybe<RequestParamsType>;
  startDate: Scalars['Int']['output'];
};

export type RetoolClinic = {
  __typename?: 'RetoolClinic';
  deleteMotivations?: Maybe<Scalars['String']['output']>;
  deletedReservations: Scalars['Int']['output'];
  groupName: Scalars['String']['output'];
  inclinicFee: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  reservationsAccepted: Scalars['Int']['output'];
  reservationsToBeAccepted?: Maybe<Scalars['Int']['output']>;
  stripeReservationsSum: Scalars['Int']['output'];
  tantoSvagoReservationsSum: Scalars['Int']['output'];
  totalAccounted: Scalars['Int']['output'];
  totalReservations: Scalars['Int']['output'];
  welbeeReservationsSum: Scalars['Int']['output'];
};

export type RiskCategory = {
  __typename?: 'RiskCategory';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type RiskCategoryInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type RiskCondition = {
  __typename?: 'RiskCondition';
  dependentRiskCategoryId?: Maybe<Scalars['String']['output']>;
  exemptionsPathologies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type RiskConditionInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export enum RiskLevelEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum Role {
  Admin = 'ADMIN',
  AppPatient = 'APP_PATIENT',
  AuxiliaryNurse = 'AUXILIARY_NURSE',
  Booker = 'BOOKER',
  BookingCoordinator = 'BOOKING_COORDINATOR',
  Clinic = 'CLINIC',
  Doctor = 'DOCTOR',
  Nurse = 'NURSE',
  Patient = 'PATIENT',
  Secretary = 'SECRETARY'
}

export type RolesPermissions = {
  __typename?: 'RolesPermissions';
  AUXILIARY_NURSE?: Maybe<RolesPermissionsMap>;
  DOCTOR?: Maybe<RolesPermissionsMap>;
  SECRETARY?: Maybe<RolesPermissionsMap>;
};

export enum RolesPermissionsAreas {
  Certificates = 'CERTIFICATES',
  ClinicalDiary = 'CLINICAL_DIARY',
  Communications = 'COMMUNICATIONS',
  MedicalDocuments = 'MEDICAL_DOCUMENTS',
  Pai = 'PAI',
  PatientPage = 'PATIENT_PAGE',
  Prescriptions = 'PRESCRIPTIONS',
  Requests = 'REQUESTS',
  TherapeuticPlan = 'THERAPEUTIC_PLAN'
}

export type RolesPermissionsInput = {
  AUXILIARY_NURSE?: InputMaybe<RolesPermissionsMapInput>;
  DOCTOR?: InputMaybe<RolesPermissionsMapInput>;
  SECRETARY?: InputMaybe<RolesPermissionsMapInput>;
};

export type RolesPermissionsMap = {
  __typename?: 'RolesPermissionsMap';
  CERTIFICATES?: Maybe<Scalars['Boolean']['output']>;
  CLINICAL_DIARY?: Maybe<Scalars['Boolean']['output']>;
  COMMUNICATIONS?: Maybe<Scalars['Boolean']['output']>;
  MEDICAL_DOCUMENTS?: Maybe<Scalars['Boolean']['output']>;
  PAI?: Maybe<Scalars['Boolean']['output']>;
  PATIENT_PAGE?: Maybe<Scalars['Boolean']['output']>;
  PRESCRIPTIONS?: Maybe<Scalars['Boolean']['output']>;
  REQUESTS?: Maybe<Scalars['Boolean']['output']>;
  THERAPEUTIC_PLAN?: Maybe<Scalars['Boolean']['output']>;
};

export type RolesPermissionsMapInput = {
  CERTIFICATES?: InputMaybe<Scalars['Boolean']['input']>;
  CLINICAL_DIARY?: InputMaybe<Scalars['Boolean']['input']>;
  COMMUNICATIONS?: InputMaybe<Scalars['Boolean']['input']>;
  MEDICAL_DOCUMENTS?: InputMaybe<Scalars['Boolean']['input']>;
  PAI?: InputMaybe<Scalars['Boolean']['input']>;
  PATIENT_PAGE?: InputMaybe<Scalars['Boolean']['input']>;
  PRESCRIPTIONS?: InputMaybe<Scalars['Boolean']['input']>;
  REQUESTS?: InputMaybe<Scalars['Boolean']['input']>;
  THERAPEUTIC_PLAN?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RoutesOfAdministration {
  Aerosol = 'AEROSOL',
  AppLocale = 'APP_LOCALE',
  Bu = 'BU',
  Ev = 'EV',
  Ia = 'IA',
  Id = 'ID',
  Im = 'IM',
  In = 'IN',
  It = 'IT',
  Iv = 'IV',
  Lo = 'LO',
  Oc = 'OC',
  Os = 'OS',
  Ot = 'OT',
  Re = 'RE',
  Sc = 'SC',
  Sl = 'SL',
  Td = 'TD',
  Va = 'VA'
}

export type SissoAuth2Object = {
  __typename?: 'SISSOAuth2Object';
  accessToken: Scalars['String']['output'];
  expirationDate: Scalars['Timestamp']['output'];
  refreshToken: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
};

export type SafeComplexQueryInput = {
  pagination?: InputMaybe<QueryPagination>;
  sorting?: InputMaybe<QuerySorting>;
};

export type SantagostinoPatient = {
  __typename?: 'SantagostinoPatient';
  isSantagostinoPatient: Scalars['Boolean']['output'];
  showReport: Scalars['Boolean']['output'];
  taxcode: Scalars['String']['output'];
};

export type SantagostinoSettings = {
  __typename?: 'SantagostinoSettings';
  showConsent: Scalars['Boolean']['output'];
  showReport: Scalars['Boolean']['output'];
};

/** Result of saving PSS edits back to user params. */
export type SaveBackToUserParamsResult = {
  __typename?: 'SaveBackToUserParamsResult';
  newDrugIds: Array<NewEntryId>;
  newFamilyHistoryIds: Array<NewEntryId>;
  newProblemIds: Array<NewEntryId>;
  success: Scalars['Boolean']['output'];
};

export type SaveIdentityDocumentResponse = {
  __typename?: 'SaveIdentityDocumentResponse';
  document: Document;
};

export type SaveSpecialityInput = {
  /** This value is expressed as seconds */
  allowBookingAfter?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** This value is expressed as seconds */
  denyBookingAfter?: InputMaybe<Scalars['UnsignedInt']['input']>;
  duration: Scalars['UnsignedInt']['input'];
  price: Scalars['UnsignedInt']['input'];
  priceFirstVisit: Scalars['UnsignedInt']['input'];
  specialityTemplate: Scalars['ID']['input'];
};

/** Selected allergy with original data preserved. */
export type SelectedAllergy = SelectedParamBase & {
  __typename?: 'SelectedAllergy';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: AllergiesPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedAllergyInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: AllergiesInput;
  userParamName: Scalars['String']['input'];
};

/** Selected celiac disease issue with original data preserved. */
export type SelectedCeliacDiseaseIssue = SelectedParamBase & {
  __typename?: 'SelectedCeliacDiseaseIssue';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: CeliacDiseaseIssuesPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedCeliacDiseaseIssueInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: CeliacDiseaseIssuesInput;
  userParamName: Scalars['String']['input'];
};

/** Selected drug with original data preserved. */
export type SelectedDrug = SelectedParamBase & {
  __typename?: 'SelectedDrug';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: DrugParamPayload;
  userParamName: Scalars['String']['output'];
};

/**
 * Input types for creating/updating patient summary.
 * _id is optional to support new entries not yet persisted to DB.
 */
export type SelectedDrugInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  _tempId?: InputMaybe<Scalars['String']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: DrugParamInput;
  userParamName: Scalars['String']['input'];
};

/** Selected exemption with original data preserved. */
export type SelectedExemption = SelectedParamBase & {
  __typename?: 'SelectedExemption';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: ExemptionsPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedExemptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: ExemptionsInput;
  userParamName: Scalars['String']['input'];
};

/** Selected family anamnesis with original data from the anamnesis collection. */
export type SelectedFamilyAnamnesis = {
  __typename?: 'SelectedFamilyAnamnesis';
  _id?: Maybe<Scalars['ID']['output']>;
  _tempId?: Maybe<Scalars['String']['output']>;
  checked: Scalars['Boolean']['output'];
  originalData: SelectedFamilyAnamnesisPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedFamilyAnamnesisInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  _tempId?: InputMaybe<Scalars['String']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: SelectedFamilyAnamnesisPayloadInput;
};

/**
 * Family anamnesis row persisted in the anamnesis collection (type FAMILY).
 * Mirrors the pattern used for vaccinations vs embedded user params.
 */
export type SelectedFamilyAnamnesisPayload = {
  __typename?: 'SelectedFamilyAnamnesisPayload';
  date: Scalars['Timestamp']['output'];
  value: Scalars['String']['output'];
};

export type SelectedFamilyAnamnesisPayloadInput = {
  date: Scalars['Timestamp']['input'];
  value: Scalars['String']['input'];
};

/** Selected intolerance with original data preserved. */
export type SelectedIntolerance = SelectedParamBase & {
  __typename?: 'SelectedIntolerance';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: IntolerancesPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedIntoleranceInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: IntolerancesInput;
  userParamName: Scalars['String']['input'];
};

/** Selected lifestyle information with original data preserved. */
export type SelectedLifestyleInformation = {
  __typename?: 'SelectedLifestyleInformation';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  originalData: SelectedLifestyleInformationPayload;
};

export type SelectedLifestyleInformationInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  _tempId?: InputMaybe<Scalars['String']['input']>;
  checked: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  originalData: LifestyleInformationPssInput;
};

export type SelectedLifestyleInformationPayload = {
  __typename?: 'SelectedLifestyleInformationPayload';
  value: LifestyleInformationValue;
};

/** Selected medical device with original data preserved. */
export type SelectedMedicalDevice = SelectedParamBase & {
  __typename?: 'SelectedMedicalDevice';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: MedicalDevicesPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedMedicalDeviceInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: MedicalDevicesInput;
  userParamName: Scalars['String']['input'];
};

/** Selected missing organ with original data preserved. */
export type SelectedMissingOrgan = SelectedParamBase & {
  __typename?: 'SelectedMissingOrgan';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: StringPlusDatePayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedMissingOrganInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: StringPlusDateInput;
  userParamName: Scalars['String']['input'];
};

/** Selected motor capacity with original data preserved. */
export type SelectedMotorCapacity = SelectedParamBase & {
  __typename?: 'SelectedMotorCapacity';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: MotorCapacityPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedMotorCapacityInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: MotorCapacityInput;
  userParamName: Scalars['String']['input'];
};

/** Selected number parameter with original data preserved. */
export type SelectedNumberParam = {
  __typename?: 'SelectedNumberParam';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  originalData: NumberPayload;
};

export type SelectedNumberParamInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  originalData: NumberInput;
};

/**
 * Base interface for all selected parameter types.
 * Contains common fields shared across all selected parameters.
 */
export type SelectedParamBase = {
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  userParamName: Scalars['String']['output'];
};

/** Selected pregnancy with original data preserved. */
export type SelectedPregnancy = SelectedParamBase & {
  __typename?: 'SelectedPregnancy';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: PregnanciesPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedPregnancyInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: PregnanciesInput;
  userParamName: Scalars['String']['input'];
};

/** Selected problem with original data preserved. */
export type SelectedProblem = SelectedParamBase & {
  __typename?: 'SelectedProblem';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: ProblemPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedProblemInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  _tempId?: InputMaybe<Scalars['String']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: ProblemInput;
  userParamName: Scalars['String']['input'];
};

/** Selected profession with original data preserved. */
export type SelectedProfession = SelectedParamBase & {
  __typename?: 'SelectedProfession';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: ProfessionsPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedProfessionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: ProfessionsInput;
  userParamName: Scalars['String']['input'];
};

/** Selected prosthesis with original data preserved. */
export type SelectedProsthesis = SelectedParamBase & {
  __typename?: 'SelectedProsthesis';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: ProsthesisPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedProsthesisInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: ProsthesisInput;
  userParamName: Scalars['String']['input'];
};

/** Selected service with original data preserved. */
export type SelectedService = SelectedParamBase & {
  __typename?: 'SelectedService';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: OutpatientServiceParamPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedServiceInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: OutpatientServiceParamInput;
  userParamName: Scalars['String']['input'];
};

/** Selected string parameter with original data preserved. */
export type SelectedStringParam = SelectedParamBase & {
  __typename?: 'SelectedStringParam';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  originalData: StringPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedStringParamInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  _tempId?: InputMaybe<Scalars['String']['input']>;
  checked: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  originalData: StringInput;
  userParamName: Scalars['String']['input'];
};

/** Selected surgical procedure with original data preserved. */
export type SelectedSurgicalProcedure = SelectedParamBase & {
  __typename?: 'SelectedSurgicalProcedure';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: SurgicalProceduresPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedSurgicalProcedureInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: SurgicalProceduresInput;
  userParamName: Scalars['String']['input'];
};

/** Selected transplant with original data preserved. */
export type SelectedTransplant = SelectedParamBase & {
  __typename?: 'SelectedTransplant';
  _id: Scalars['ID']['output'];
  checked: Scalars['Boolean']['output'];
  originalData: StringPlusDatePayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedTransplantInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: StringPlusDateInput;
  userParamName: Scalars['String']['input'];
};

/**
 * Complete structure of all selected user parameters.
 * Represents the full selection state saved in the database.
 */
export type SelectedUserParams = {
  __typename?: 'SelectedUserParams';
  alcohol?: Maybe<SelectedLifestyleInformation>;
  allergies?: Maybe<Array<SelectedAllergy>>;
  bloodType?: Maybe<SelectedLifestyleInformation>;
  bodyHeight?: Maybe<SelectedNumberParam>;
  bodyWeight?: Maybe<SelectedNumberParam>;
  celiacDiseaseIssues?: Maybe<Array<SelectedCeliacDiseaseIssue>>;
  chronicDrugs?: Maybe<Array<SelectedDrug>>;
  chronicServices?: Maybe<Array<SelectedService>>;
  drugAddiction?: Maybe<SelectedLifestyleInformation>;
  exemptions?: Maybe<Array<SelectedExemption>>;
  familyHistory?: Maybe<Array<SelectedFamilyAnamnesis>>;
  intolerances?: Maybe<Array<SelectedIntolerance>>;
  lifestyleNotes?: Maybe<SelectedStringParam>;
  manualExemptions?: Maybe<Array<SelectedExemption>>;
  medicalDevices?: Maybe<Array<SelectedMedicalDevice>>;
  missingOrgans?: Maybe<Array<SelectedMissingOrgan>>;
  motorCapacity?: Maybe<SelectedMotorCapacity>;
  ordinaryServices?: Maybe<Array<SelectedService>>;
  pregnancies?: Maybe<Array<SelectedPregnancy>>;
  problems?: Maybe<Array<SelectedProblem>>;
  professions?: Maybe<Array<SelectedProfession>>;
  prosthesis?: Maybe<Array<SelectedProsthesis>>;
  smoke?: Maybe<SelectedLifestyleInformation>;
  sportActivity?: Maybe<SelectedLifestyleInformation>;
  surgicalProcedures?: Maybe<Array<SelectedSurgicalProcedure>>;
  transplants?: Maybe<Array<SelectedTransplant>>;
  vaccinations?: Maybe<Array<SelectedVaccination>>;
};

export type SelectedUserParamsInput = {
  alcohol?: InputMaybe<SelectedLifestyleInformationInput>;
  allergies?: InputMaybe<Array<SelectedAllergyInput>>;
  bloodType?: InputMaybe<SelectedLifestyleInformationInput>;
  bodyHeight?: InputMaybe<SelectedNumberParamInput>;
  bodyWeight?: InputMaybe<SelectedNumberParamInput>;
  celiacDiseaseIssues?: InputMaybe<Array<SelectedCeliacDiseaseIssueInput>>;
  chronicDrugs?: InputMaybe<Array<SelectedDrugInput>>;
  chronicServices?: InputMaybe<Array<SelectedServiceInput>>;
  drugAddiction?: InputMaybe<SelectedLifestyleInformationInput>;
  exemptions?: InputMaybe<Array<SelectedExemptionInput>>;
  familyHistory?: InputMaybe<Array<SelectedFamilyAnamnesisInput>>;
  intolerances?: InputMaybe<Array<SelectedIntoleranceInput>>;
  lifestyleNotes?: InputMaybe<SelectedStringParamInput>;
  manualExemptions?: InputMaybe<Array<SelectedExemptionInput>>;
  medicalDevices?: InputMaybe<Array<SelectedMedicalDeviceInput>>;
  missingOrgans?: InputMaybe<Array<SelectedMissingOrganInput>>;
  motorCapacity?: InputMaybe<SelectedMotorCapacityInput>;
  ordinaryServices?: InputMaybe<Array<SelectedServiceInput>>;
  pregnancies?: InputMaybe<Array<SelectedPregnancyInput>>;
  problems?: InputMaybe<Array<SelectedProblemInput>>;
  professions?: InputMaybe<Array<SelectedProfessionInput>>;
  prosthesis?: InputMaybe<Array<SelectedProsthesisInput>>;
  smoke?: InputMaybe<SelectedLifestyleInformationInput>;
  sportActivity?: InputMaybe<SelectedLifestyleInformationInput>;
  surgicalProcedures?: InputMaybe<Array<SelectedSurgicalProcedureInput>>;
  transplants?: InputMaybe<Array<SelectedTransplantInput>>;
  vaccinations?: InputMaybe<Array<SelectedVaccinationInput>>;
};

/**
 * Selected vaccination with original data preserved.
 * _id is optional to support new vaccinations created during PSS creation.
 * Does not implement SelectedParamBase because _id is optional.
 */
export type SelectedVaccination = {
  __typename?: 'SelectedVaccination';
  _id?: Maybe<Scalars['ID']['output']>;
  _tempId?: Maybe<Scalars['String']['output']>;
  checked: Scalars['Boolean']['output'];
  originalData: SelectedVaccinationPayload;
  userParamName: Scalars['String']['output'];
};

export type SelectedVaccinationInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  _tempId?: InputMaybe<Scalars['String']['input']>;
  checked: Scalars['Boolean']['input'];
  originalData: SelectedVaccinationPayloadInput;
  userParamName: Scalars['String']['input'];
};

/** Minimal vaccination payload with only fields needed for CDA2 generation. */
export type SelectedVaccinationPayload = {
  __typename?: 'SelectedVaccinationPayload';
  dosage?: Maybe<IdText>;
  drugAicCode?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  reaction?: Maybe<Scalars['String']['output']>;
  somministrationDate?: Maybe<Scalars['Timestamp']['output']>;
  somministrationMethod?: Maybe<IdText>;
  somministrationPlace?: Maybe<IdText>;
  somministrationSite?: Maybe<IdText>;
  vaccine?: Maybe<Vaccine>;
  vaccineLot?: Maybe<VaccineLotPayload>;
};

/** Minimal vaccination payload input with only fields needed for CDA2 generation. */
export type SelectedVaccinationPayloadInput = {
  dosage?: InputMaybe<IdTextInput>;
  drugAicCode?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Scalars['String']['input']>;
  somministrationDate?: InputMaybe<Scalars['Timestamp']['input']>;
  somministrationMethod?: InputMaybe<IdTextInput>;
  somministrationPlace?: InputMaybe<IdTextInput>;
  somministrationSite?: InputMaybe<IdTextInput>;
  vaccine?: InputMaybe<VaccineInput>;
  vaccineLot?: InputMaybe<VaccineLotPayloadInput>;
};

export type SendBillingInput = {
  auth?: InputMaybe<RegionalSystemLogin>;
  billing: BillingInput;
  doctor: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  patient: Scalars['ID']['input'];
};

export type SendCommunicationResult = {
  __typename?: 'SendCommunicationResult';
  communication: Communication;
  smsLimitExceeded?: Maybe<Scalars['Boolean']['output']>;
};

export type SendInvitationsInput = {
  msg: Scalars['String']['input'];
};

export enum SendPdfEmailMethod {
  Clear = 'CLEAR',
  Protected = 'PROTECTED'
}

export type SendPdfEmailSettings = {
  __typename?: 'SendPdfEmailSettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  method?: Maybe<SendPdfEmailMethod>;
};

export type SendPdfEmailSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<SendPdfEmailMethod>;
};

export enum ServiceType {
  Ambulatorio = 'AMBULATORIO',
  Laboratorio = 'LABORATORIO'
}

export type ServicesRequest = Node & PatientRequestInterface & {
  __typename?: 'ServicesRequest';
  _id: Scalars['ID']['output'];
  action: PatientRequestAction;
  createdAt: Scalars['Timestamp']['output'];
  deleteReason?: Maybe<DeleteReason>;
  deleteReasonNote?: Maybe<Scalars['String']['output']>;
  doctor: User;
  internalNote?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteToPatient?: Maybe<Scalars['String']['output']>;
  noteToPatientAttachment?: Maybe<Document>;
  patient: User;
  payload: OutpatientServiceParamPayloadArrayRequired;
  processingDate?: Maybe<Scalars['Timestamp']['output']>;
  /** @deprecated Use relatedPrescriptions instead */
  relatedPrescription?: Maybe<Prescription>;
  relatedPrescriptions?: Maybe<Array<Prescription>>;
  requestedBy?: Maybe<User>;
  requestedByAI?: Maybe<Scalars['Boolean']['output']>;
  status: PatientRequestStatus;
  type: PatientRequestType;
};

export type SetSantagostinoConsentInput = {
  consent: Scalars['Boolean']['input'];
};

export type SetSantagostinoConsentResponse = {
  __typename?: 'SetSantagostinoConsentResponse';
  showReport: Scalars['Boolean']['output'];
};

export type Settings = {
  __typename?: 'Settings';
  connectEnabled?: Maybe<Scalars['Boolean']['output']>;
  drugInteractionsEnabled?: Maybe<Scalars['Boolean']['output']>;
  freenetEnabled?: Maybe<Scalars['Boolean']['output']>;
  nonPayingUser?: Maybe<Scalars['Boolean']['output']>;
  paiCentralEnabled?: Maybe<Scalars['Boolean']['output']>;
  paiMillewinConnected?: Maybe<Scalars['Boolean']['output']>;
  prescriptionsRequestsEnabled?: Maybe<Scalars['Boolean']['output']>;
  sissCloudEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Stamp is enabled by default */
  stampDisabled?: Maybe<Scalars['Boolean']['output']>;
  studentVerificationStatus?: Maybe<StudentVerificationStatus>;
  telemonitoringCentralEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type SettingsInput = {
  agendaSettings?: InputMaybe<AgendaSettingsInput>;
  connectEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  drugInteractionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  freenetEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  nonPayingUser?: InputMaybe<Scalars['Boolean']['input']>;
  paiCentralEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  paiMillewinConnected?: InputMaybe<Scalars['Boolean']['input']>;
  prescriptionsRequestsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationSettings?: InputMaybe<PushNotificationSettingsInput>;
  sissCloudEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  studentVerificationStatus?: InputMaybe<StudentVerificationStatus>;
  telemonitoringCentralEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetupIntentInput = {
  address?: InputMaybe<AddressInput>;
  billingDetails?: InputMaybe<BillingDetailsInput>;
  price: Scalars['Int']['input'];
  promoCode: Scalars['String']['input'];
};

export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE'
}

export enum ShowPatientInformation {
  Oscura = 'OSCURA',
  Si = 'SI',
  SoloIniziali = 'SOLO_INIZIALI'
}

export type SignAndTransmitPssToFseInput = {
  otp: Scalars['String']['input'];
  patientSummaryId: Scalars['ID']['input'];
};

export type SignAndTransmitPssToFseResult = {
  __typename?: 'SignAndTransmitPssToFseResult';
  patientSummary: PatientSummary;
  transmitted: Scalars['Boolean']['output'];
};

/** Digital signature metadata from PAdES signing process. */
export type SignData = {
  __typename?: 'SignData';
  endDate?: Maybe<Scalars['String']['output']>;
  issuerDN?: Maybe<Scalars['String']['output']>;
  signingTime?: Maybe<Scalars['String']['output']>;
  subjectDN?: Maybe<Scalars['String']['output']>;
  subjectID?: Maybe<Scalars['String']['output']>;
};

export type SignDocumentUrlResponse = {
  __typename?: 'SignDocumentUrlResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export enum SignatureType {
  LegaleOperatore = 'LEGALE_OPERATORE',
  Operatore = 'OPERATORE'
}

export type SignedPaiId = {
  __typename?: 'SignedPaiId';
  _id: Scalars['ID']['output'];
};

export type SignupAssistedUserPayload = {
  birthCity: Scalars['String']['input'];
  birthDate: Scalars['Timestamp']['input'];
  birthDistrict: Scalars['String']['input'];
  documentType: AuthenticationDocumentsType;
  documents: Array<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  homeAddress?: InputMaybe<StructuredAddressInput>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  relationshipType: RelationshipType;
  sex: Sex;
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SignupAssistedUserResponse = {
  __typename?: 'SignupAssistedUserResponse';
  assistedUserHasBeenCreated: Scalars['Boolean']['output'];
};

export type SignupDoctorPayload = {
  ats?: InputMaybe<Scalars['ID']['input']>;
  birthCity?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Company>;
  confirmPassword: Scalars['String']['input'];
  healthProtectionAgency?: InputMaybe<Scalars['String']['input']>;
  homeAddress?: InputMaybe<StructuredAddressInput>;
  macroSpeciality?: InputMaybe<MacroSpeciality>;
  name: Scalars['String']['input'];
  nationalMedicineBoardNumber?: InputMaybe<Scalars['String']['input']>;
  nationalMedicineBoardPlace?: InputMaybe<Scalars['String']['input']>;
  newsletterEnable?: InputMaybe<Scalars['Boolean']['input']>;
  officeAddress?: InputMaybe<StructuredAddressInput>;
  otp: Scalars['String']['input'];
  partner?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  privacyDavinci?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPartner?: InputMaybe<Scalars['Boolean']['input']>;
  region: Region;
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
  type: AuthType;
  usage: OtpUsage;
  username: Scalars['Username']['input'];
  verifiedMode?: InputMaybe<VerifiedMode>;
};

export type SignupRequest = Node & {
  __typename?: 'SignupRequest';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  documents?: Maybe<Array<Document>>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  privacyDavinci?: Maybe<Scalars['Boolean']['output']>;
  privacyPartner?: Maybe<Scalars['Boolean']['output']>;
  step: SignupStep;
  surname?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AuthType>;
  username?: Maybe<Scalars['Username']['output']>;
};

export type SignupRequestInput = {
  finish?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  privacyDavinci?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPartner?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthType>;
};

export type SignupRequestReturn = {
  __typename?: 'SignupRequestReturn';
  refreshToken?: Maybe<Scalars['String']['output']>;
  signupRequest?: Maybe<SignupRequest>;
  token?: Maybe<Scalars['String']['output']>;
  tokenExpiration?: Maybe<Scalars['Int']['output']>;
};

export enum SignupStep {
  DataInsert = 'DATA_INSERT',
  Document = 'DOCUMENT',
  NotStarted = 'NOT_STARTED',
  TaxCode = 'TAX_CODE'
}

export type SimpleService = {
  __typename?: 'SimpleService';
  code: Scalars['String']['output'];
  from: Scalars['Timestamp']['output'];
  to?: Maybe<Scalars['Timestamp']['output']>;
};

export type SimpleServicesInput = {
  code: Scalars['String']['input'];
  from: Scalars['Timestamp']['input'];
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type SingupPatientPayload = {
  ats?: InputMaybe<Scalars['ID']['input']>;
  birthCity?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Company>;
  confirmPassword: Scalars['String']['input'];
  healthProtectionAgency?: InputMaybe<Scalars['String']['input']>;
  homeAddress?: InputMaybe<StructuredAddressInput>;
  name: Scalars['String']['input'];
  newsletterEnable?: InputMaybe<Scalars['Boolean']['input']>;
  otp: Scalars['String']['input'];
  partner?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone: Scalars['PhoneNumber']['input'];
  privacyDavinci?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPartner?: InputMaybe<Scalars['Boolean']['input']>;
  region: Region;
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
  type: AuthType;
  usage: OtpUsage;
  username: Scalars['Username']['input'];
  verifiedMode?: InputMaybe<VerifiedMode>;
};

export type SissAttachment = {
  __typename?: 'SissAttachment';
  format: Scalars['String']['output'];
  label: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export enum SissDocumentType {
  Jpeg = 'JPEG',
  Pdf = 'PDF',
  Text = 'TEXT',
  Zip = 'ZIP'
}

export type SissEnlisting = {
  __typename?: 'SissEnlisting';
  ats?: Maybe<Ats>;
  careAgreementDate?: Maybe<Scalars['Int']['output']>;
  enlistingCooperative?: Maybe<PaiCoop>;
  motivationStatus?: Maybe<Scalars['String']['output']>;
  protocolId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SissEnlistingStatus>;
};

export enum SissEnlistingStatus {
  Arruolabile = 'ARRUOLABILE',
  Arruolato = 'ARRUOLATO',
  Disarruolato = 'DISARRUOLATO',
  NonArruolabile = 'NON_ARRUOLABILE',
  NonClassificato = 'NON_CLASSIFICATO',
  NonVerificato = 'NON_VERIFICATO',
  Prenotato = 'PRENOTATO'
}

export type SissPaiResult = {
  __typename?: 'SissPaiResult';
  current: Pai;
};

export enum SissPrescriptionStatus {
  Accettato = 'ACCETTATO',
  Annullato = 'ANNULLATO',
  Erogato = 'EROGATO',
  Prenotato = 'PRENOTATO',
  Prescritto = 'PRESCRITTO',
  Rendicontato = 'RENDICONTATO'
}

export type SissReport = {
  __typename?: 'SissReport';
  _id: Scalars['ID']['output'];
  cda2?: Maybe<Document>;
  document?: Maybe<Document>;
  patient: Scalars['ID']['output'];
  signatureType?: Maybe<SignatureType>;
  signedDocument?: Maybe<Document>;
  uriCda2?: Maybe<Scalars['String']['output']>;
  uriPdf?: Maybe<Scalars['String']['output']>;
};

export type SissSessionResult = {
  __typename?: 'SissSessionResult';
  sessionId: Scalars['String']['output'];
};

export type SissValue = Node & {
  __typename?: 'SissValue';
  _id: Scalars['ID']['output'];
  chronic: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  isMdsAllowed?: Maybe<Scalars['Boolean']['output']>;
  type: SissValueType;
};

export enum SissValueType {
  Disease = 'DISEASE',
  Methods = 'METHODS',
  Operations = 'OPERATIONS',
  Prosthetics = 'PROSTHETICS'
}

export type SissValuesResult = ComplexQueryReturn & {
  __typename?: 'SissValuesResult';
  nodes: Array<SissValue>;
  pageInfo: PageInfo;
};

export type Slot = {
  __typename?: 'Slot';
  _id?: Maybe<Scalars['ID']['output']>;
  allSpecialityTemplates?: Maybe<Scalars['Boolean']['output']>;
  doctor?: Maybe<User>;
  /** duration value in sec */
  duration?: Maybe<Scalars['Int']['output']>;
  end: Scalars['Timestamp']['output'];
  isAvailableToMyPatient: Scalars['Boolean']['output'];
  isAvailableToWorkgroupPatient?: Maybe<Scalars['Boolean']['output']>;
  recurringId?: Maybe<Scalars['String']['output']>;
  slotSpecialities?: Maybe<Array<SlotSpeciality>>;
  /** @deprecated Use slotSpecialities instead */
  specialityTemplates?: Maybe<Array<Maybe<SpecialityTemplate>>>;
  start: Scalars['Timestamp']['output'];
  workgroup?: Maybe<Workgroup>;
};

export type SlotInput = {
  /** duration value in sec */
  duration?: InputMaybe<Scalars['Int']['input']>;
  end: Scalars['Timestamp']['input'];
  recurringId?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['Timestamp']['input'];
  workgroup?: InputMaybe<Scalars['ID']['input']>;
};

export type SlotSpeciality = {
  __typename?: 'SlotSpeciality';
  selectedShowcase?: Maybe<SpecialityShowcase>;
  template?: Maybe<SpecialityTemplate>;
};

export type SlotSpecialityInput = {
  selectedShowcase: SpecialityShowcase;
  template: Scalars['ID']['input'];
};

export type SmsMonthlyLimitInfoResult = {
  __typename?: 'SmsMonthlyLimitInfoResult';
  smsLeft: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
  userSmsLimit: Scalars['Int']['output'];
};

export type SomministrationMethod = {
  __typename?: 'SomministrationMethod';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SomministrationMethodInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type SomministrationMotivation = {
  __typename?: 'SomministrationMotivation';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SomministrationMotivationInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type SomministrationPlace = {
  __typename?: 'SomministrationPlace';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SomministrationPlaceInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type SomministrationSite = {
  __typename?: 'SomministrationSite';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SomministrationSiteInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export enum SortingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Speciality = {
  __typename?: 'Speciality';
  _id: Scalars['ID']['output'];
  duration: Scalars['UnsignedInt']['output'];
  favorite?: Maybe<Scalars['Boolean']['output']>;
  price: Scalars['UnsignedInt']['output'];
  priceFirstVisit: Scalars['UnsignedInt']['output'];
  showcase?: Maybe<SpecialityShowcase>;
  specialityTemplate: SpecialityTemplate;
  userId: Scalars['ID']['output'];
};

export type SpecialityInput = {
  duration: Scalars['UnsignedInt']['input'];
  price: Scalars['UnsignedInt']['input'];
  priceFirstVisit: Scalars['UnsignedInt']['input'];
  specialityTemplate: Scalars['ID']['input'];
};

export type SpecialityResults = {
  __typename?: 'SpecialityResults';
  nodes: Array<Speciality>;
  pageInfo: PageInfo;
};

export type SpecialitySettings = {
  __typename?: 'SpecialitySettings';
  favoriteInPresenceSpeciality?: Maybe<Scalars['ID']['output']>;
  favoriteOnlineSpeciality?: Maybe<Scalars['ID']['output']>;
};

export type SpecialitySettingsInput = {
  favoriteInPresenceSpeciality?: InputMaybe<Scalars['ID']['input']>;
  favoriteOnlineSpeciality?: InputMaybe<Scalars['ID']['input']>;
};

export enum SpecialityShowcase {
  Booking = 'BOOKING',
  Everywhere = 'EVERYWHERE',
  Ssn = 'SSN',
  SsnAgenda = 'SSN_AGENDA'
}

export type SpecialityTemplate = Node & {
  __typename?: 'SpecialityTemplate';
  _id: Scalars['ID']['output'];
  actionToClose?: Maybe<ActionToClose>;
  channels: Array<ReservationChannel>;
  doctorStep: DoctorStepOptions;
  duration: Scalars['UnsignedInt']['output'];
  enablesForDoctorsWithPartners: Array<Partner>;
  group?: Maybe<Scalars['String']['output']>;
  isPriceSettable: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  macroSpeciality: Array<MacroSpeciality>;
  name: Scalars['String']['output'];
  owner?: Maybe<Scalars['ID']['output']>;
  partners: Array<Partner>;
  showOnSpecialitiesList: Scalars['Boolean']['output'];
  standardPrice: Scalars['UnsignedInt']['output'];
  symptomsStep: SymptomsStepOptions;
  /** Configuration for reservation flow */
  timeSlot: TimeSlotType;
};

export type SpecialityTemplateReservation = Node & {
  __typename?: 'SpecialityTemplateReservation';
  _id: Scalars['ID']['output'];
  actionToClose?: Maybe<ActionToClose>;
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Specialization = {
  __typename?: 'Specialization';
  detail?: Maybe<SpecializationDetail>;
  doctor?: Maybe<SpecializationDoctor>;
  favorite?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
};

export type SpecializationDetail = {
  __typename?: 'SpecializationDetail';
  _id?: Maybe<Scalars['ID']['output']>;
  channels?: Maybe<Array<Scalars['String']['output']>>;
  service?: Maybe<Scalars['String']['output']>;
  specialization?: Maybe<Scalars['String']['output']>;
};

export type SpecializationDoctor = Node & {
  __typename?: 'SpecializationDoctor';
  _id: Scalars['ID']['output'];
  sex?: Maybe<Sex>;
};

export enum SpecificAvkDrugEnum {
  Acenocoumarol = 'ACENOCOUMAROL',
  Warfarin = 'WARFARIN'
}

export enum SpecificNaoDoacEnum {
  Apixaban = 'APIXABAN',
  Dabigatran = 'DABIGATRAN',
  Edoxaban = 'EDOXABAN',
  Rivaroxaban = 'RIVAROXABAN'
}

export type StartCallResult = {
  __typename?: 'StartCallResult';
  videoSessionId: Scalars['String']['output'];
};

export type StartTranscriptionInput = {
  audioFileUrl?: InputMaybe<Scalars['String']['input']>;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  patientInfo?: InputMaybe<PatientInfoInput>;
  visitDate?: InputMaybe<Scalars['String']['input']>;
};

export type StringArrayInput = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StringArrayParam = Node & UserParamInterface & {
  __typename?: 'StringArrayParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: StringArrayPayload;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type StringArrayPayload = {
  __typename?: 'StringArrayPayload';
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type StringArrayPayloadRequired = {
  __typename?: 'StringArrayPayloadRequired';
  values: Array<Scalars['String']['output']>;
};

export type StringInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type StringParam = Node & UserParamInterface & {
  __typename?: 'StringParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: StringPayload;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type StringPayload = {
  __typename?: 'StringPayload';
  value?: Maybe<Scalars['String']['output']>;
};

export type StringPlusDateArrayInput = {
  values?: InputMaybe<Array<StringPlusDateInput>>;
};

export type StringPlusDateArrayParam = Node & UserParamInterface & {
  __typename?: 'StringPlusDateArrayParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: StringPlusDatePayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type StringPlusDateInput = {
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type StringPlusDatePayload = {
  __typename?: 'StringPlusDatePayload';
  date?: Maybe<Scalars['Timestamp']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type StringPlusDatePayloadArray = {
  __typename?: 'StringPlusDatePayloadArray';
  values?: Maybe<Array<StringPlusDatePayload>>;
};

export type StringPlusNumberArrayInput = {
  values?: InputMaybe<Array<StringPlusNumberInput>>;
};

export type StringPlusNumberArrayParam = Node & UserParamInterface & {
  __typename?: 'StringPlusNumberArrayParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: StringPlusNumberPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type StringPlusNumberInput = {
  number?: InputMaybe<Scalars['UnsignedInt']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type StringPlusNumberPayload = {
  __typename?: 'StringPlusNumberPayload';
  number?: Maybe<Scalars['UnsignedInt']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type StringPlusNumberPayloadArray = {
  __typename?: 'StringPlusNumberPayloadArray';
  values?: Maybe<Array<StringPlusNumberPayload>>;
};

export type StripeCancelIntentResponse = {
  __typename?: 'StripeCancelIntentResponse';
  paymentIntent: Scalars['String']['output'];
};

export type StripeDiscountPreview = {
  __typename?: 'StripeDiscountPreview';
  couponId?: Maybe<Scalars['String']['output']>;
  couponNotValid: Scalars['Boolean']['output'];
  totalAmount: Scalars['Int']['output'];
};

export type StripeIntentResponse = {
  __typename?: 'StripeIntentResponse';
  clientSecret?: Maybe<Scalars['String']['output']>;
  paymentIntent?: Maybe<Scalars['String']['output']>;
};

export type StripeIntentResult = {
  __typename?: 'StripeIntentResult';
  clientSecret?: Maybe<Scalars['String']['output']>;
  couponId?: Maybe<Scalars['String']['output']>;
  couponNotValid?: Maybe<Scalars['Boolean']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
};

export type StructuredAddress = {
  __typename?: 'StructuredAddress';
  /**
   * @example
   * "96100" if it was Siracusa
   */
  cap?: Maybe<Scalars['String']['output']>;
  /**
   * ISTAT defined City Code
   * @link https://dait.interno.gov.it/territorio-e-autonomie-locali/sut/elenco_codici_comuni.php
   */
  cityCode: Scalars['String']['output'];
  /**
   * Country Code in standard ISO 3 characters code.
   * @example
   * ITA, FRA, USA, SPA, ...
   */
  countryCode: Scalars['String']['output'];
  /** Used to point out that this is the main address of a User. Hopefully we can phase this out in the near future. */
  default?: Maybe<Scalars['Boolean']['output']>;
  /**
   * District Code corresponding to first integer number of the three
   * digit in the ISTAT City Code.
   *
   * @example
   * Milano City Code = 015146
   * Milano District Code = 15
   *
   * @see cityCode
   * @link https://dait.interno.gov.it/territorio-e-autonomie-locali/sut/elenco_codici_comuni.php
   */
  districtCode: Scalars['String']['output'];
  importedFromFreenet?: Maybe<Scalars['Boolean']['output']>;
  /** Geolocalization latitude and longitude in GeoJSON format */
  location?: Maybe<Geolocalization>;
  /** Street number like: via roma, 8. The "via roma" part. Sometimes might include the whole "via roma, 8" */
  street: Scalars['String']['output'];
  /** Street number like: via roma, 8. The "8" part. */
  streetNumber?: Maybe<Scalars['String']['output']>;
};

export type StructuredAddressInput = {
  cap?: InputMaybe<Scalars['String']['input']>;
  cityCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  default?: InputMaybe<Scalars['Boolean']['input']>;
  districtCode: Scalars['String']['input'];
  geoloc?: InputMaybe<GeolocInput>;
  street: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

export type StructuredAddressInputWithSurname = {
  cap?: InputMaybe<Scalars['String']['input']>;
  cityCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  default?: InputMaybe<Scalars['Boolean']['input']>;
  districtCode: Scalars['String']['input'];
  geoloc?: InputMaybe<GeolocInput>;
  street: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type StructuredAddressWithSurname = {
  __typename?: 'StructuredAddressWithSurname';
  cap?: Maybe<Scalars['String']['output']>;
  cityCode: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  default?: Maybe<Scalars['Boolean']['output']>;
  districtCode: Scalars['String']['output'];
  location?: Maybe<Geolocalization>;
  street: Scalars['String']['output'];
  streetNumber?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type StructuredPosology = {
  __typename?: 'StructuredPosology';
  durationMeasure?: Maybe<DrugDurationMeasures>;
  durationValue?: Maybe<Scalars['Float']['output']>;
  methodOfAdministration?: Maybe<MethodsOfAdministration>;
  routeOfAdministration?: Maybe<RoutesOfAdministration>;
  timeMeasure?: Maybe<DrugTimeMeasures>;
  timeValue?: Maybe<Scalars['Float']['output']>;
  unitMeasure?: Maybe<DrugUnitMeasures>;
  unitValue?: Maybe<Scalars['Float']['output']>;
};

export type StructuredPosologyInput = {
  durationMeasure?: InputMaybe<DrugDurationMeasures>;
  durationValue?: InputMaybe<Scalars['Float']['input']>;
  methodOfAdministration?: InputMaybe<MethodsOfAdministration>;
  routeOfAdministration?: InputMaybe<RoutesOfAdministration>;
  timeMeasure?: InputMaybe<DrugTimeMeasures>;
  timeValue?: InputMaybe<Scalars['Float']['input']>;
  unitMeasure?: InputMaybe<DrugUnitMeasures>;
  unitValue?: InputMaybe<Scalars['Float']['input']>;
};

export type StrutturaCreazione = {
  __typename?: 'StrutturaCreazione';
  descrizioneEnte?: Maybe<Scalars['String']['output']>;
  descrizionePresidio?: Maybe<Scalars['String']['output']>;
  descrizioneUnitaOperativaClinica?: Maybe<Scalars['String']['output']>;
  idEnte?: Maybe<Scalars['String']['output']>;
  idPresidio?: Maybe<Scalars['String']['output']>;
  idUnitaOperativaClinica?: Maybe<Scalars['String']['output']>;
};

export enum StudentVerificationStatus {
  Blocked = 'BLOCKED',
  NotVerified = 'NOT_VERIFIED',
  Verified = 'VERIFIED'
}

export type Subscription = {
  __typename?: 'Subscription';
  calendarEventUpdated: CalendarEventUpdated;
  chatUpdate: Chat;
  dataExportRequestUpdated: DataExportRequest;
  dataImportRequestProgress: DataImportRequestProgressPayload;
  deletedMedicalReportV2: MedicalReportV2;
  drugReservationAccepted: DrugReservation;
  drugReservationsCompleted: Array<DrugReservation>;
  feedbackUpdated: FeedbackUpdatedResponse;
  newChat: Chat;
  newDrugReservation: DrugReservation;
  newMedicalReportV2: MedicalReportV2;
  newMessage: ChatMessage;
  newPatientRequest: PatientRequestInstance;
  newWorkgroupPatientRequest: PatientRequestInstance;
  notificationUpdate?: Maybe<Notification>;
  patientRequestCompleted: PatientRequestInstance;
  patientRequestReverted: PatientRequestInstance;
  prescriptionArchived?: Maybe<Array<Prescription>>;
  prescriptionCreated?: Maybe<Array<Prescription>>;
  prescriptionProcessed?: Maybe<Array<Prescription>>;
  reservationUpdated: ReservationUpdated;
  transcriptionUpdate: TranscriptionJob;
  updatedMedicalReport: MedicalReportV2;
  workgroupPatientRequestCompleted: PatientRequestInstance;
  workgroupPatientRequestReverted: PatientRequestInstance;
};


export type SubscriptionTranscriptionUpdateArgs = {
  jobId: Scalars['ID']['input'];
};

export enum SubscriptionPeriodType {
  Month = 'month',
  Year = 'year'
}

export enum SubscriptionPlan {
  Connect = 'Connect',
  Healthline = 'Healthline',
  Premium = 'Premium',
  Smart = 'Smart'
}

export type SubscriptionPlanInput = {
  activationDate?: InputMaybe<Scalars['Timestamp']['input']>;
  expirationDate?: InputMaybe<Scalars['Timestamp']['input']>;
  planTypeDuration?: InputMaybe<PlanTypeDuration>;
  subscriptionPlan?: InputMaybe<SubscriptionPlan>;
};

export type SubscriptionPlanUser = Node & {
  __typename?: 'SubscriptionPlanUser';
  _id: Scalars['ID']['output'];
  activationDate?: Maybe<Scalars['Timestamp']['output']>;
  billingAddress?: Maybe<StructuredAddress>;
  expirationDate: Scalars['Timestamp']['output'];
  invoices?: Maybe<Array<Invoice>>;
  isInGoodStanding?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<Scalars['String']['output']>;
  planTypeDuration: PlanTypeDuration;
  stripeData?: Maybe<SubscriptionPlanUserStripeData>;
  subscriptionPlan: SubscriptionPlan;
  user: User;
};

export type SubscriptionPlanUserStripeData = {
  __typename?: 'SubscriptionPlanUserStripeData';
  billingCycleAnchor?: Maybe<Scalars['Timestamp']['output']>;
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['Timestamp']['output']>;
  currentPeriodEnd: Scalars['Timestamp']['output'];
  customerId: Scalars['String']['output'];
  defaultPaymentMethodId: Scalars['String']['output'];
  discount?: Maybe<SubscriptionPlanUserStripeDataDiscount>;
  latestInvoiceId: Scalars['String']['output'];
  pec?: Maybe<Scalars['String']['output']>;
  planPrice?: Maybe<Scalars['Float']['output']>;
  priceIds: Array<Scalars['String']['output']>;
  recurringInterval?: Maybe<Scalars['String']['output']>;
  recurringIntervalCount?: Maybe<Scalars['Float']['output']>;
  sdiCode?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionPlanUserStripeDataDiscount = {
  __typename?: 'SubscriptionPlanUserStripeDataDiscount';
  amountOff?: Maybe<Scalars['Float']['output']>;
  couponId: Scalars['String']['output'];
  duration: Scalars['String']['output'];
  durationInMonths?: Maybe<Scalars['Float']['output']>;
  end?: Maybe<Scalars['Timestamp']['output']>;
  percentOff?: Maybe<Scalars['Float']['output']>;
  start: Scalars['Timestamp']['output'];
};

export type SubscriptionPlanUserStripeDataInput = {
  cancelAtPeriodEnd: Scalars['Boolean']['input'];
  canceledAt?: InputMaybe<Scalars['Timestamp']['input']>;
  currentPeriodEnd: Scalars['Timestamp']['input'];
  customerId: Scalars['String']['input'];
  defaultPaymentMethodId: Scalars['String']['input'];
  latestInvoiceId: Scalars['String']['input'];
  priceIds: Array<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};

export enum Substitutability {
  Altro = 'ALTRO',
  Art15 = 'ART15',
  DifficoltaDiAssunzione = 'DIFFICOLTA_DI_ASSUNZIONE',
  Ipersensibilita = 'IPERSENSIBILITA',
  Sostituibile = 'SOSTITUIBILE',
  TerapiaComplessa = 'TERAPIA_COMPLESSA'
}

export type SurgicalProceduresInput = {
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  surgicalProcedure?: InputMaybe<Scalars['String']['input']>;
};

export type SurgicalProceduresInputArray = {
  values?: InputMaybe<Array<SurgicalProceduresInput>>;
};

export type SurgicalProceduresParam = Node & UserParamInterface & {
  __typename?: 'SurgicalProceduresParam';
  _id: Scalars['ID']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: SurgicalProceduresPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type SurgicalProceduresPayload = {
  __typename?: 'SurgicalProceduresPayload';
  date?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  surgicalProcedure?: Maybe<SissValue>;
};

export type SurgicalProceduresPayloadArray = {
  __typename?: 'SurgicalProceduresPayloadArray';
  values?: Maybe<Array<SurgicalProceduresPayload>>;
};

export enum SymptomsStepOptions {
  Description = 'DESCRIPTION',
  DescriptionAndSelect = 'DESCRIPTION_AND_SELECT',
  None = 'NONE'
}

export type Tag = Node & {
  __typename?: 'Tag';
  _id: Scalars['ID']['output'];
  color: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  user: Scalars['ID']['output'];
};

export type TagInput = {
  color: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type TantoSvagoFields = {
  __typename?: 'TantoSvagoFields';
  apiHeaders: Scalars['Object']['output'];
  callbackUrl?: Maybe<Scalars['String']['output']>;
  contactText?: Maybe<Scalars['String']['output']>;
  endpointAsyncConfirmOrderUrl: Scalars['String']['output'];
  endpointAsyncOrderUrl: Scalars['String']['output'];
  endpointAsyncOrderWithPaymentGatewayUrl: Scalars['String']['output'];
  endpointDiscountCodeValidationUrl: Scalars['String']['output'];
  endpointSyncOrderUrl: Scalars['String']['output'];
  logoImageUrl?: Maybe<Scalars['String']['output']>;
  paymentTypes: Scalars['String']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  projectCode?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  userInfo: UserInfo;
};

export type TantoSvagoOrderRequest = {
  itemDescription: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  paymentType: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  reservationInfo: InclinicCreateReservationInput;
  sso: Scalars['String']['input'];
};

export type TemplateCertificateOptions = {
  __typename?: 'TemplateCertificateOptions';
  content: Scalars['String']['output'];
  date: Scalars['Timestamp']['output'];
  fields?: Maybe<CertificateTemplateFieldsValues>;
  template?: Maybe<CertificateTemplate>;
};

export type TemplateCertificateOptionsInput = {
  content: Scalars['String']['input'];
  date: Scalars['Timestamp']['input'];
  fields?: InputMaybe<CertificateTemplateFieldsValuesInput>;
  template?: InputMaybe<Scalars['ID']['input']>;
};

export enum TherapeuticCategoryEnum {
  Dpp4I = 'DPP4I',
  GipGlp1Ra = 'GIP_GLP1_RA',
  Glp1Ra = 'GLP1_RA',
  Sglt2I = 'SGLT2I',
  Sglt2IDpp4I = 'SGLT2I_DPP4I',
  Sglt2IGipGlp1Ra = 'SGLT2I_GIP_GLP1_RA',
  Sglt2IGlp1Ra = 'SGLT2I_GLP1_RA'
}

export type TherapeuticPlan = Node & {
  __typename?: 'TherapeuticPlan';
  _id: Scalars['ID']['output'];
  aicDrugs?: Maybe<Array<TherapeuticPlanDrug>>;
  argument?: Maybe<Scalars['String']['output']>;
  atcDrugs?: Maybe<Array<TherapeuticPlanDrug>>;
  canceled?: Maybe<Scalars['Boolean']['output']>;
  createdBy?: Maybe<User>;
  documents?: Maybe<Array<Document>>;
  endDate: Scalars['Timestamp']['output'];
  importId?: Maybe<Scalars['ID']['output']>;
  imported?: Maybe<Scalars['Boolean']['output']>;
  isContinuous?: Maybe<Scalars['Boolean']['output']>;
  patient: User;
  privacyDoctorId?: Maybe<User>;
  protocolNumber?: Maybe<Scalars['String']['output']>;
  requestParams?: Maybe<RequestParamsType>;
  startDate: Scalars['Timestamp']['output'];
  type?: Maybe<TherapeuticPlanType>;
};

export type TherapeuticPlanAifa97Evaluation = {
  __typename?: 'TherapeuticPlanAifa97Evaluation';
  CHA2DS2VAScScore: Scalars['UnsignedInt']['output'];
  GFR: Scalars['Float']['output'];
  Hb: Scalars['Float']['output'];
  doseDecreaseReason?: Maybe<Scalars['String']['output']>;
  followUpDate: Scalars['Int']['output'];
  haemorrhagicRiskFactor: Array<HemorragicRiskFactors>;
  otherHaemorrhagicRiskFactor?: Maybe<Scalars['String']['output']>;
  plasmCreatinin: Scalars['Float']['output'];
  posology?: Maybe<PosologyNaoDoacEnum>;
  specificAVK?: Maybe<SpecificAvkDrugEnum>;
  specificNaoDoac?: Maybe<SpecificNaoDoacEnum>;
  targetINR?: Maybe<Scalars['Float']['output']>;
  therapyProposal?: Maybe<TherapyProposalEnum>;
};

export type TherapeuticPlanAifa97EvaluationInput = {
  CHA2DS2VAScScore: Scalars['Int']['input'];
  GFR: Scalars['Float']['input'];
  Hb: Scalars['Float']['input'];
  doseDecreaseReason?: InputMaybe<Scalars['String']['input']>;
  followUpDate: Scalars['Int']['input'];
  haemorrhagicRiskFactor: Array<HemorragicRiskFactors>;
  otherHaemorrhagicRiskFactor?: InputMaybe<Scalars['String']['input']>;
  plasmCreatinin: Scalars['Float']['input'];
  posology?: InputMaybe<PosologyNaoDoacEnum>;
  specificAVK?: InputMaybe<SpecificAvkDrugEnum>;
  specificNaoDoac?: InputMaybe<SpecificNaoDoacEnum>;
  targetINR?: InputMaybe<Scalars['Float']['input']>;
  therapyProposal?: InputMaybe<TherapyProposalEnum>;
};

export type TherapeuticPlanAifa97FollowUp = {
  __typename?: 'TherapeuticPlanAifa97FollowUp';
  GFR: Scalars['Float']['output'];
  bleedingEvents: Scalars['Boolean']['output'];
  bleedingEventsReason?: Maybe<Scalars['String']['output']>;
  doseDecreaseReason?: Maybe<Scalars['String']['output']>;
  followUpDate: Scalars['Int']['output'];
  hasSideEffects: Scalars['Boolean']['output'];
  hospitalAdmission: Scalars['Boolean']['output'];
  hospitalAdmissionReason?: Maybe<Scalars['String']['output']>;
  irregularDrugIntake: Scalars['Boolean']['output'];
  irregularDrugIntakeReason?: Maybe<Scalars['String']['output']>;
  isTherapyConfirmed: Scalars['Boolean']['output'];
  modificationOfOtherTherapies: Scalars['Boolean']['output'];
  modificationOfOtherTherapiesReason?: Maybe<Scalars['String']['output']>;
  otherExams?: Maybe<Scalars['String']['output']>;
  plasmCreatinin: Scalars['Float']['output'];
  posology?: Maybe<PosologyNaoDoacEnum>;
  sideEffectsDescription?: Maybe<Scalars['String']['output']>;
  specificAVK?: Maybe<SpecificAvkDrugEnum>;
  specificNaoDoac?: Maybe<SpecificNaoDoacEnum>;
  targetINR?: Maybe<Scalars['Float']['output']>;
  therapyProposal?: Maybe<TherapyProposalEnum>;
};

export type TherapeuticPlanAifa97FollowUpInput = {
  GFR: Scalars['Float']['input'];
  bleedingEvents: Scalars['Boolean']['input'];
  bleedingEventsReason?: InputMaybe<Scalars['String']['input']>;
  doseDecreaseReason?: InputMaybe<Scalars['String']['input']>;
  followUpDate: Scalars['Int']['input'];
  hasSideEffects: Scalars['Boolean']['input'];
  hospitalAdmission: Scalars['Boolean']['input'];
  hospitalAdmissionReason?: InputMaybe<Scalars['String']['input']>;
  irregularDrugIntake: Scalars['Boolean']['input'];
  irregularDrugIntakeReason?: InputMaybe<Scalars['String']['input']>;
  isTherapyConfirmed: Scalars['Boolean']['input'];
  modificationOfOtherTherapies: Scalars['Boolean']['input'];
  modificationOfOtherTherapiesReason?: InputMaybe<Scalars['String']['input']>;
  otherExams?: InputMaybe<Scalars['String']['input']>;
  plasmCreatinin: Scalars['Float']['input'];
  posology?: InputMaybe<PosologyNaoDoacEnum>;
  sideEffectsDescription?: InputMaybe<Scalars['String']['input']>;
  specificAVK?: InputMaybe<SpecificAvkDrugEnum>;
  specificNaoDoac?: InputMaybe<SpecificNaoDoacEnum>;
  targetINR?: InputMaybe<Scalars['Float']['input']>;
  therapyProposal?: InputMaybe<TherapyProposalEnum>;
};

export type TherapeuticPlanAifa100Evaluation = {
  __typename?: 'TherapeuticPlanAifa100Evaluation';
  HbA1c: Scalars['Float']['output'];
  HbA1cTarget: Scalars['Float']['output'];
  albuminuria: AlbuminuriaEnum;
  drugs: Array<Aifa100Drug>;
  eGFR: Scalars['Float']['output'];
  followUpDate: Scalars['Int']['output'];
  hasMissedGlycemicTarget: Scalars['Boolean']['output'];
  height: Scalars['Float']['output'];
  otherAntiDiabeteTherapy?: Maybe<Scalars['String']['output']>;
  otherTherapyReason?: Maybe<Scalars['String']['output']>;
  therapeuticCategory?: Maybe<TherapeuticCategoryEnum>;
  therapyReasons?: Maybe<Array<TherapeuticStrategyAifa100>>;
  usesMetformin: Scalars['Boolean']['output'];
  weight: Scalars['Float']['output'];
};

export type TherapeuticPlanAifa100EvaluationInput = {
  HbA1c: Scalars['Float']['input'];
  HbA1cTarget: Scalars['Float']['input'];
  albuminuria: AlbuminuriaEnum;
  drugs: Array<Aifa100DrugInput>;
  eGFR: Scalars['Float']['input'];
  followUpDate: Scalars['Int']['input'];
  hasMissedGlycemicTarget: Scalars['Boolean']['input'];
  height: Scalars['Float']['input'];
  otherAntiDiabeteTherapy?: InputMaybe<Scalars['String']['input']>;
  otherTherapyReason?: InputMaybe<Scalars['String']['input']>;
  therapeuticCategory?: InputMaybe<TherapeuticCategoryEnum>;
  therapyReasons?: InputMaybe<Array<TherapeuticStrategyAifa100>>;
  usesMetformin: Scalars['Boolean']['input'];
  weight: Scalars['Float']['input'];
};

export type TherapeuticPlanAifa100FollowUp = {
  __typename?: 'TherapeuticPlanAifa100FollowUp';
  HbA1c: Scalars['Float']['output'];
  HbA1cTarget: Scalars['Float']['output'];
  albuminuria: AlbuminuriaEnum;
  drugs: Array<Aifa100Drug>;
  eGFR: Scalars['Float']['output'];
  followUpDate: Scalars['Int']['output'];
  hasSideEffects: Scalars['Boolean']['output'];
  height: Scalars['Float']['output'];
  isRenewalOfPaperPT: Scalars['Boolean']['output'];
  isTherapyConfirmed: Scalars['Boolean']['output'];
  ongoingTherapyDescription: Scalars['String']['output'];
  otherAntiDiabeteTherapy?: Maybe<Scalars['String']['output']>;
  otherTherapyReason?: Maybe<Scalars['String']['output']>;
  sideEffectsDescription?: Maybe<Scalars['String']['output']>;
  therapeuticCategory?: Maybe<TherapeuticCategoryEnum>;
  therapyReasons?: Maybe<Array<TherapeuticStrategyAifa100>>;
  weight: Scalars['Float']['output'];
};

export type TherapeuticPlanAifa100FollowUpInput = {
  HbA1c: Scalars['Float']['input'];
  HbA1cTarget: Scalars['Float']['input'];
  albuminuria: AlbuminuriaEnum;
  drugs: Array<Aifa100DrugInput>;
  eGFR: Scalars['Float']['input'];
  followUpDate: Scalars['Int']['input'];
  hasSideEffects: Scalars['Boolean']['input'];
  height: Scalars['Float']['input'];
  isRenewalOfPaperPT: Scalars['Boolean']['input'];
  isTherapyConfirmed: Scalars['Boolean']['input'];
  ongoingTherapyDescription: Scalars['String']['input'];
  otherAntiDiabeteTherapy?: InputMaybe<Scalars['String']['input']>;
  otherTherapyReason?: InputMaybe<Scalars['String']['input']>;
  sideEffectsDescription?: InputMaybe<Scalars['String']['input']>;
  therapeuticCategory?: InputMaybe<TherapeuticCategoryEnum>;
  therapyReasons?: InputMaybe<Array<TherapeuticStrategyAifa100>>;
  weight: Scalars['Float']['input'];
};

export type TherapeuticPlanDrug = {
  __typename?: 'TherapeuticPlanDrug';
  atcCode?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  posology: Scalars['String']['output'];
};

export type TherapeuticPlanDrugInput = {
  atcCode?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  posology: Scalars['String']['input'];
};

export type TherapeuticPlanPaxlovid = {
  __typename?: 'TherapeuticPlanPaxlovid';
  SARSCOV2TestPositive: Scalars['Boolean']['output'];
  SARSCOV2TestPositiveDate: Scalars['Float']['output'];
  acceptsAvoidingPregnancy?: Maybe<Scalars['Boolean']['output']>;
  acceptsContraceptive?: Maybe<Scalars['Boolean']['output']>;
  drugInteractionsVerified: Scalars['Boolean']['output'];
  eGFR: Scalars['Float']['output'];
  familyDoctorPhone?: Maybe<Scalars['String']['output']>;
  familyDoctorTaxCode?: Maybe<Scalars['String']['output']>;
  hasRiskFactors: Scalars['Boolean']['output'];
  hasSymptoms: Scalars['Boolean']['output'];
  isAdult: Scalars['Boolean']['output'];
  isFollowup: Scalars['Boolean']['output'];
  isHospitalized: Scalars['Boolean']['output'];
  isNotPregnant?: Maybe<Scalars['Boolean']['output']>;
  isWoman: Scalars['Boolean']['output'];
  patientPhoneNumber?: Maybe<Scalars['String']['output']>;
  riskFactorsList: Array<CovidRiskFactors>;
  weight: Scalars['Float']['output'];
  withLiverImpairment: Scalars['Boolean']['output'];
  withOxygenTherapy: Scalars['Boolean']['output'];
  withRenalImpairment: Scalars['Boolean']['output'];
};

export type TherapeuticPlanPaxlovidInput = {
  SARSCOV2TestPositive: Scalars['Boolean']['input'];
  SARSCOV2TestPositiveDate: Scalars['Float']['input'];
  acceptsAvoidingPregnancy?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsContraceptive?: InputMaybe<Scalars['Boolean']['input']>;
  drugInteractionsVerified: Scalars['Boolean']['input'];
  eGFR: Scalars['Float']['input'];
  familyDoctorPhone?: InputMaybe<Scalars['String']['input']>;
  familyDoctorTaxCode?: InputMaybe<Scalars['String']['input']>;
  hasRiskFactors: Scalars['Boolean']['input'];
  hasSymptoms: Scalars['Boolean']['input'];
  isAdult: Scalars['Boolean']['input'];
  isFollowup: Scalars['Boolean']['input'];
  isHospitalized: Scalars['Boolean']['input'];
  isNotPregnant?: InputMaybe<Scalars['Boolean']['input']>;
  isWoman: Scalars['Boolean']['input'];
  patientPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  riskFactorsList: Array<CovidRiskFactors>;
  weight: Scalars['Float']['input'];
  withLiverImpairment: Scalars['Boolean']['input'];
  withOxygenTherapy: Scalars['Boolean']['input'];
  withRenalImpairment: Scalars['Boolean']['input'];
};

export enum TherapeuticPlanType {
  Aifa_97 = 'AIFA_97',
  Aifa_99 = 'AIFA_99',
  Aifa_100 = 'AIFA_100',
  AusiliDiabetici = 'AUSILI_DIABETICI',
  DavinciManual = 'DAVINCI_MANUAL',
  OssigenoTerapia = 'OSSIGENO_TERAPIA',
  Paxlovid = 'PAXLOVID',
  Ranolazina = 'RANOLAZINA',
  Trimbow = 'TRIMBOW'
}

export enum TherapeuticStrategyAifa100 {
  ChronicKidneyDisease = 'CHRONIC_KIDNEY_DISEASE',
  FailedIndividualGlycemicGoals = 'FAILED_INDIVIDUAL_GLYCEMIC_GOALS',
  HeartFailure = 'HEART_FAILURE',
  HighCardiovascularRisk = 'HIGH_CARDIOVASCULAR_RISK',
  IntoleranceToSglt2IAndGlp1Ra = 'INTOLERANCE_TO_SGLT2I_AND_GLP1RA',
  Other = 'OTHER',
  SecondaryCardiovascularPrevention = 'SECONDARY_CARDIOVASCULAR_PREVENTION'
}

export enum TherapyAifa99Enum {
  Laba = 'LABA',
  Labaics = 'LABAICS',
  Labaicslama = 'LABAICSLAMA',
  Labalama = 'LABALAMA',
  Lama = 'LAMA',
  Other = 'OTHER'
}

export enum TherapyProposalEnum {
  Avk = 'AVK',
  Naodoac = 'NAODOAC'
}

export type Time = {
  __typename?: 'Time';
  hh?: Maybe<Scalars['Int']['output']>;
  mm?: Maybe<Scalars['Int']['output']>;
  timezone?: Maybe<Scalars['Timezone']['output']>;
};

export enum TimeSlotType {
  Any = 'ANY',
  Asap = 'ASAP',
  ChoiceTwoSlot = 'CHOICE_TWO_SLOT',
  SlotChoice = 'SLOT_CHOICE'
}

export enum TokenType {
  Oauth2AccessToken = 'OAUTH2_ACCESS_TOKEN',
  Oauth2RefreshToken = 'OAUTH2_REFRESH_TOKEN',
  RedPrescription = 'RED_PRESCRIPTION',
  WhitePrescription = 'WHITE_PRESCRIPTION'
}

export type TotalByMonth = {
  __typename?: 'TotalByMonth';
  month: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
  totalWithVat: Scalars['Float']['output'];
};

export type TranscriptionDiary = {
  __typename?: 'TranscriptionDiary';
  internalNotes?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<TranscriptionMetadata>;
  patientNotes?: Maybe<Scalars['String']['output']>;
  rawTranscription: Scalars['String']['output'];
};

export type TranscriptionDiaryInput = {
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<TranscriptionMetadataInput>;
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  patientNotes?: InputMaybe<Scalars['String']['input']>;
  rawTranscription: Scalars['String']['input'];
  saveEmailToPatient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TranscriptionJob = {
  __typename?: 'TranscriptionJob';
  createdAt?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<MedicalTranscriptionOutput>;
  status: TranscriptionJobStatus;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type TranscriptionJobCreateResponse = {
  __typename?: 'TranscriptionJobCreateResponse';
  estimatedCompletionTime?: Maybe<Scalars['Int']['output']>;
  jobId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export enum TranscriptionJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export type TranscriptionListItem = {
  __typename?: 'TranscriptionListItem';
  createdAt: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  hasResult: Scalars['Boolean']['output'];
  jobId: Scalars['ID']['output'];
  modifiedAt: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type TranscriptionListResponse = {
  __typename?: 'TranscriptionListResponse';
  total: Scalars['Int']['output'];
  transcriptions: Array<TranscriptionListItem>;
};

export type TranscriptionMetadata = {
  __typename?: 'TranscriptionMetadata';
  patientInfo?: Maybe<PatientInfo>;
  transcriptionConfidence?: Maybe<Scalars['Float']['output']>;
  visitDateTime?: Maybe<Scalars['String']['output']>;
  visitDuration?: Maybe<Scalars['Int']['output']>;
};

export type TranscriptionMetadataInput = {
  patientHasBeenNotified?: InputMaybe<Scalars['Boolean']['input']>;
  transcriptionConfidence?: InputMaybe<Scalars['Float']['input']>;
  visitDateTime?: InputMaybe<Scalars['String']['input']>;
  visitDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type TransportDataAddress = {
  __typename?: 'TransportDataAddress';
  cap?: Maybe<Scalars['String']['output']>;
  cityCode: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  districtCode: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  streetNumber?: Maybe<Scalars['String']['output']>;
  structureCode?: Maybe<Scalars['String']['output']>;
  type: TransportDataCoded;
};

export type TransportDataAddressInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  cap?: InputMaybe<Scalars['String']['input']>;
  cityCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  districtCode: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  structureCode?: InputMaybe<Scalars['String']['input']>;
  type: TransportDataCodedInput;
};

export type TransportDataCoded = {
  __typename?: 'TransportDataCoded';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type TransportDataCodedInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
};

export type TransportPrescription = BasicPrescription & Node & {
  __typename?: 'TransportPrescription';
  _id: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy?: Maybe<User>;
  creationMode: CreationMode;
  darkeningReason?: Maybe<DarkeningReason>;
  date: Scalars['Timestamp']['output'];
  doctorData?: Maybe<DoctorData>;
  downgradeReasons?: Maybe<Array<DowngradeReasons>>;
  enlistingIdPai?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  exceptions?: Maybe<Array<Exceptions>>;
  exemption?: Maybe<Exemption>;
  exemptionForPrint?: Maybe<Scalars['String']['output']>;
  flagOther?: Maybe<Scalars['Boolean']['output']>;
  incomeSelfCertificationNumber?: Maybe<Scalars['String']['output']>;
  iupCode?: Maybe<Scalars['String']['output']>;
  mefCode?: Maybe<Scalars['String']['output']>;
  owner: User;
  paiLotNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  patient: User;
  personalDataSiss?: Maybe<PersonalDataSiss>;
  pinNrbe?: Maybe<Scalars['String']['output']>;
  prescriptionCode?: Maybe<Scalars['String']['output']>;
  prescriptionTransportData?: Maybe<PrescriptionTransportData>;
  printPdf?: Maybe<Document>;
  processingDate?: Maybe<Scalars['Timestamp']['output']>;
  progressiveNumber: Scalars['UnsignedInt']['output'];
  regionalCodedMotivation?: Maybe<OptionType>;
  regionalCommunication?: Maybe<Array<Maybe<PrescriptionRegionalCommunication>>>;
  regionalOptions?: Maybe<PrescriptionRegionalOptions>;
  regionalStatus?: Maybe<RegionalPrescriptionStatus>;
  relatedRequests?: Maybe<Array<PatientRequestInstance>>;
  showPatientInformation?: Maybe<ShowPatientInformation>;
  sissCounterPai?: Maybe<Scalars['String']['output']>;
  /** @deprecated use regionalStatus */
  sissPrescriptionStatus?: Maybe<SissPrescriptionStatus>;
  status: PrescriptionStatus;
  suggested?: Maybe<Scalars['Boolean']['output']>;
  suggestedCode?: Maybe<Scalars['String']['output']>;
  therapeuticPlanCode?: Maybe<Scalars['String']['output']>;
  type: PrescriptionType;
  urgency?: Maybe<Scalars['Boolean']['output']>;
  withdrawalData?: Maybe<Array<WithdrawalData>>;
};

export type TriageAiConfig = {
  __typename?: 'TriageAiConfig';
  enabled: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
};

export enum TriageAiConfigType {
  Healthline = 'HEALTHLINE',
  Mmg = 'MMG'
}

export enum Trigger {
  MessageAdded = 'MESSAGE_ADDED'
}

export enum TypeOfAccess {
  Altro = 'ALTRO',
  Primo = 'PRIMO'
}

export type UniqueOutpatientServiceOutcome = {
  __typename?: 'UniqueOutpatientServiceOutcome';
  name: Scalars['String']['output'];
  parameters: Array<ParameterLoincAndName>;
  serviceExamCode?: Maybe<Scalars['String']['output']>;
  serviceLoincCode?: Maybe<Scalars['String']['output']>;
};

export type UniqueOutpatientServiceOutcomesResult = {
  __typename?: 'UniqueOutpatientServiceOutcomesResult';
  outpatientServiceOutcomes?: Maybe<Array<UniqueOutpatientServiceOutcome>>;
};

export type UnreadFeedbacksResponse = {
  __typename?: 'UnreadFeedbacksResponse';
  IDEAS: Scalars['Boolean']['output'];
  OPEN: Scalars['Boolean']['output'];
  RESOLVED: Scalars['Boolean']['output'];
};

export type UnreadPatientRequestInput = {
  doctorId?: InputMaybe<Scalars['String']['input']>;
  tabs?: InputMaybe<Array<PatientRequestTab>>;
};

/** @deprecated Use PatientsForMmgResponse instead */
export type UnverifiedPatient = {
  __typename?: 'UnverifiedPatient';
  createdAt: Scalars['Date']['output'];
  emails: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phones: Array<PatientPhone>;
  surname: Scalars['String']['output'];
  taxCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

/** @deprecated Use PatientsForMmgPagedResponse instead */
export type UnverifiedPatientsPagedResponse = {
  __typename?: 'UnverifiedPatientsPagedResponse';
  count: Scalars['Int']['output'];
  results: Array<UnverifiedPatient>;
};

export type UpcomingReservation = {
  __typename?: 'UpcomingReservation';
  doctor?: Maybe<UpcomingReservationDoctor>;
  reservationDate?: Maybe<Scalars['Timestamp']['output']>;
  specialityTemplateName?: Maybe<Scalars['String']['output']>;
};

export type UpcomingReservationDoctor = {
  __typename?: 'UpcomingReservationDoctor';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type UpdateAnamnesisInput = {
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBillingInput = {
  auth?: InputMaybe<RegionalSystemLogin>;
  billing: BillingInput;
  id: Scalars['ID']['input'];
};

export type UpdateBillingItemTemplateInput = {
  billing: BillingItemTemplateInput;
  id: Scalars['ID']['input'];
};

export type UpdateBlacklistEntryInput = {
  _id: Scalars['ID']['input'];
  areas: Array<BlacklistArea>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCalendarEventResult = {
  __typename?: 'UpdateCalendarEventResult';
  calendarEvent: CalendarEvent;
};

export type UpdateCalendarEventResults = {
  __typename?: 'UpdateCalendarEventResults';
  calendarEvents: Array<CalendarEvent>;
};

export type UpdateCertificateTemplateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChatInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  doctorIdToRemove?: InputMaybe<Scalars['ID']['input']>;
  healthlineState?: InputMaybe<HealthlineState>;
};

export type UpdateChatResult = {
  __typename?: 'UpdateChatResult';
  chat: Chat;
};

export type UpdateClinicGroupInput = {
  _id: Scalars['ID']['input'];
  address?: InputMaybe<StructuredAddressInput>;
  availablePayments?: InputMaybe<Array<InclinicPayment>>;
  iban?: InputMaybe<Scalars['String']['input']>;
  inclinicFee?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<License>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<Scalars['ID']['input']>>;
  showOnPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  showOnSearch?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ClinicType>;
};

export type UpdateClinicWorkgroupInput = {
  _id: Scalars['ID']['input'];
  address?: InputMaybe<StructuredAddressInput>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  color: WorkgroupColor;
  description?: InputMaybe<Scalars['String']['input']>;
  doctorsToShowForSpecialities?: InputMaybe<Array<Scalars['ID']['input']>>;
  domiciliaryCare?: InputMaybe<Scalars['Boolean']['input']>;
  emails?: InputMaybe<Array<Scalars['EmailAddress']['input']>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['URL']['input']>>>;
  inclinicSlug?: InputMaybe<Scalars['String']['input']>;
  isWorkgroupHiddenInApp?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<Array<OpeningHoursInput>>;
  operators?: InputMaybe<Array<Scalars['ID']['input']>>;
  phones?: InputMaybe<Array<Scalars['PhoneNumber']['input']>>;
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type UpdateLinkedUsersRelationshipsPayload = {
  id: Scalars['ID']['input'];
  isMainUserAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  isMainUserCaregiver?: InputMaybe<Scalars['Boolean']['input']>;
  relationshipType: RelationshipType;
};

export type UpdateMedicalInstructionInput = {
  active: Scalars['Boolean']['input'];
  afterAttachment?: InputMaybe<Scalars['Upload']['input']>;
  afterText?: InputMaybe<Scalars['String']['input']>;
  beforeAttachment?: InputMaybe<Scalars['Upload']['input']>;
  beforeText?: InputMaybe<Scalars['String']['input']>;
  medicalInstructionId: Scalars['ID']['input'];
  removeAfterAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  removeBeforeAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  specialityTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};

export type UpdateMedicalReportV2Input = {
  attributes?: InputMaybe<Array<OptionTypeInput>>;
  creationDate?: InputMaybe<Scalars['Timestamp']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  followUp?: InputMaybe<MedicalReportsFollowUp>;
  id: Scalars['String']['input'];
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  interpretation?: InputMaybe<OutpatientServiceOutcomeInterpretation>;
  isTranscribedByAI?: InputMaybe<Scalars['Boolean']['input']>;
  reportName?: InputMaybe<Scalars['String']['input']>;
  sharedNotes?: InputMaybe<Scalars['String']['input']>;
  textualDiagnosis?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyWorkgroupInput = {
  _id: Scalars['ID']['input'];
  address?: InputMaybe<StructuredAddressInput>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operators?: InputMaybe<Array<Scalars['ID']['input']>>;
  phones?: InputMaybe<Array<InputMaybe<Scalars['PhoneNumber']['input']>>>;
};

export type UpdatePatientMedicalDeviceInput = {
  _id: Scalars['ID']['input'];
  deviceCategory?: InputMaybe<Scalars['String']['input']>;
  deviceDescription?: InputMaybe<Scalars['String']['input']>;
  devicePlantDate?: InputMaybe<Scalars['Timestamp']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePatientSummaryInput = {
  citizenConsent?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientSummaryId: Scalars['ID']['input'];
  selectedParams?: InputMaybe<SelectedUserParamsInput>;
  specialLaws?: InputMaybe<Array<ReasonForObscuration>>;
  summaryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  voluntaryObscuration?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePatientSummaryResult = {
  __typename?: 'UpdatePatientSummaryResult';
  patientSummary: PatientSummary;
};

export type UpdateRegionalSystemCredentialsResponse = {
  __typename?: 'UpdateRegionalSystemCredentialsResponse';
  regionalSystemCredentials?: Maybe<Array<Maybe<RegionalSystemCredentialsTypes>>>;
};

export type UpdateReservationsInBulkInput = {
  billingPrice?: InputMaybe<Scalars['Int']['input']>;
  deleteMotivation?: InputMaybe<Scalars['String']['input']>;
  reservationId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReservationStatus>;
};

export type UpdateSpecialityInput = {
  /** This value is expressed as seconds */
  allowBookingAfter?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** This value is expressed as seconds */
  denyBookingAfter?: InputMaybe<Scalars['UnsignedInt']['input']>;
  duration: Scalars['UnsignedInt']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  price: Scalars['UnsignedInt']['input'];
  priceFirstVisit: Scalars['UnsignedInt']['input'];
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  showcase: SpecialityShowcase;
  showcaseToRemove?: InputMaybe<SpecialityShowcase>;
  specialityTemplate: Scalars['ID']['input'];
};

export type UpdateSubscriptionPlanUserInput = {
  activationDate?: InputMaybe<Scalars['Timestamp']['input']>;
  expirationDate?: InputMaybe<Scalars['Timestamp']['input']>;
  planTypeDuration?: InputMaybe<PlanTypeDuration>;
  stripeData?: InputMaybe<SubscriptionPlanUserStripeDataInput>;
  subscriptionPlan?: InputMaybe<SubscriptionPlan>;
  subscriptionPlanUserId: Scalars['ObjectId']['input'];
};

export type UpdateSubscriptionPlanUserResponse = {
  __typename?: 'UpdateSubscriptionPlanUserResponse';
  clientSecret: Scalars['String']['output'];
  paymentIntent: Scalars['String']['output'];
};

export type UpdateTherapeuticPlanInput = {
  aicDrugs?: InputMaybe<Array<TherapeuticPlanDrugInput>>;
  atcDrugs?: InputMaybe<Array<TherapeuticPlanDrugInput>>;
  documents?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  isContinuous?: InputMaybe<Scalars['Boolean']['input']>;
  protocolNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UpdateVaccinationResponse = {
  __typename?: 'UpdateVaccinationResponse';
  id: Scalars['ID']['output'];
};

export type UploadDocumentInput = {
  category: DocumentCategory;
  file: Scalars['Upload']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  reservationId?: InputMaybe<Scalars['ID']['input']>;
  sharedWith?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UploadDocumentResponse = {
  __typename?: 'UploadDocumentResponse';
  document: Document;
};

export type UploadDocumentsResponse = {
  __typename?: 'UploadDocumentsResponse';
  documents?: Maybe<Array<Document>>;
};

export type UploadIdentityDocumentResponse = {
  __typename?: 'UploadIdentityDocumentResponse';
  document: Document;
};

export type User = Node & {
  __typename?: 'User';
  _id: Scalars['ID']['output'];
  ageGroup?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** doctor field */
  aslCode?: Maybe<Scalars['String']['output']>;
  /**
   * doctor field
   * @deprecated Use aslCode
   */
  atsName?: Maybe<Ats>;
  autoAcceptSettings?: Maybe<AutoAcceptSettings>;
  /** @deprecated UserSettings moved out User */
  availabilityNote?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** doctor Field */
  billingAddress?: Maybe<StructuredAddress>;
  /** doctor Field - Intestazione/firma per fatture elettroniche */
  billingInvoiceHeader?: Maybe<Scalars['String']['output']>;
  biography?: Maybe<Scalars['String']['output']>;
  birth?: Maybe<Birth>;
  /** Branding config based on user company (appName, shortName, logoUrl) */
  branding?: Maybe<BrandingConfig>;
  /** admin field */
  canAdminEditUsers?: Maybe<Scalars['Boolean']['output']>;
  /** patient field - Verified caregivers assisting this user (from AssistedUser where user=this user and verified=VERIFIED). */
  caregivers?: Maybe<Array<User>>;
  /** @deprecated UserSettings moved out User */
  chatSettings?: Maybe<ChatSettings>;
  /** doctor field */
  company?: Maybe<Company>;
  complete?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated UserSettings moved out User */
  consents?: Maybe<Array<Consent>>;
  /** patient Field */
  creditCards?: Maybe<Array<CreditCard>>;
  /** patient Filed */
  diaryMonitorings?: Maybe<Array<DiaryMonitoring>>;
  /** patient field - information of doctor in Siss system */
  doctorDataSiss?: Maybe<DoctorDataSiss>;
  /** doctor field */
  doctorType?: Maybe<DoctorType>;
  doctors: Array<UserDoctor>;
  documents?: Maybe<Array<Maybe<Document>>>;
  domicileAddress?: Maybe<StructuredAddress>;
  emails?: Maybe<Array<Scalars['EmailAddress']['output']>>;
  exemptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** patient Filed */
  familyDoctor?: Maybe<User>;
  foreignAndSeafarinOptions?: Maybe<ForeignAndSeafarin>;
  /** patient identifiers on Freenet */
  freenetIds?: Maybe<Array<FreenetId>>;
  fullName: Scalars['String']['output'];
  hasApp: Scalars['Boolean']['output'];
  hasAuth?: Maybe<Scalars['Boolean']['output']>;
  hasClinic?: Maybe<Scalars['Boolean']['output']>;
  hasWorkgroup?: Maybe<Scalars['Boolean']['output']>;
  /** doctor Field */
  healthProtectionAgency?: Maybe<Scalars['String']['output']>;
  healthlineDoctor?: Maybe<Scalars['Boolean']['output']>;
  homeAddress?: Maybe<StructuredAddress>;
  /** doctor Field */
  iban?: Maybe<Scalars['String']['output']>;
  isChronicPatient?: Maybe<Scalars['Boolean']['output']>;
  /** admin field */
  isGlobalAdmin?: Maybe<Scalars['Boolean']['output']>;
  isPatientHidden?: Maybe<Scalars['Boolean']['output']>;
  languageApp?: Maybe<LanguageApp>;
  languages?: Maybe<Array<Maybe<Language>>>;
  lastAccessInfo?: Maybe<LastUserAccessInfo>;
  /** patient field - Start date of the last PAI for this patient */
  lastPaiStartDate?: Maybe<Scalars['Timestamp']['output']>;
  latestUserParams?: Maybe<LatestUserParams>;
  /** doctor Field */
  macroSpeciality?: Maybe<Array<MacroSpeciality>>;
  mfaEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** doctor Field */
  nationalMedicineBoard?: Maybe<NationalMedicineBoard>;
  /** @deprecated UserSettings moved out User */
  newsletterEnable?: Maybe<Scalars['Boolean']['output']>;
  numIdentPers?: Maybe<Scalars['String']['output']>;
  /**
   * doctor Field
   * @deprecated Use studios
   */
  officeAddress?: Maybe<StructuredAddress>;
  /** doctor field */
  paiCoop?: Maybe<PaiCoop>;
  /** doctor field */
  paiCoopCode?: Maybe<Scalars['String']['output']>;
  partners: Array<Partner>;
  patientAdditionalInfo?: Maybe<PatientAdditionalInfo>;
  /** @deprecated UserSettings moved out User */
  patientRequestSettings?: Maybe<PatientRequestSettings>;
  personalData?: Maybe<PersonalDataType>;
  /** patient field - Data of user in Siss system */
  personalDataSiss?: Maybe<PersonalDataSiss>;
  phones?: Maybe<Array<PhoneUser>>;
  /** doctor field */
  pmgEnabled?: Maybe<Scalars['Boolean']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  principalClinic?: Maybe<Scalars['ID']['output']>;
  /** @deprecated UserSettings moved out User */
  privacyDavinci?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated UserSettings moved out User */
  privacyPartner?: Maybe<Scalars['Boolean']['output']>;
  regime: PatientRegime;
  region: Region;
  /** doctor field */
  regionalCode?: Maybe<Scalars['String']['output']>;
  /** patient field - Emails imported from regional system */
  regionalEmails?: Maybe<Array<Scalars['EmailAddress']['output']>>;
  /** doctor field */
  regionalSystemCredentials?: Maybe<Array<Maybe<RegionalSystemCredentialsTypes>>>;
  /** patient Filed */
  relationship?: Maybe<UserDoctor>;
  residenceAddress?: Maybe<StructuredAddress>;
  role: Role;
  sentInvitationToDownloadApp?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated UserSettings moved out User */
  settings?: Maybe<Settings>;
  sex?: Maybe<Sex>;
  signUpAt?: Maybe<Scalars['Long']['output']>;
  sissConsent?: Maybe<Scalars['Boolean']['output']>;
  /** patient field */
  sissEnlisting?: Maybe<SissEnlisting>;
  sissOAuth2?: Maybe<SissoAuth2Object>;
  /** doctor Field */
  specialities?: Maybe<Array<Speciality>>;
  /** @deprecated Stamp is enabled by default */
  stampDisabled?: Maybe<Scalars['Boolean']['output']>;
  stampFooter?: Maybe<Scalars['String']['output']>;
  stampHeader?: Maybe<Scalars['String']['output']>;
  statisticsLevel?: Maybe<Scalars['Int']['output']>;
  /** doctor Field */
  stripeAccountVerified?: Maybe<Scalars['Boolean']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeToken?: Maybe<Scalars['String']['output']>;
  /** doctor Field */
  studios?: Maybe<Array<UserLocation>>;
  subscriptionPlanUser?: Maybe<SubscriptionPlanUser>;
  subscriptionPlanUsers: Array<SubscriptionPlanUser>;
  surname: Scalars['String']['output'];
  taxCode?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['Timezone']['output']>;
  /** doctor Field */
  userSettings?: Maybe<UserSettings>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  /** doctor field */
  virtualCareEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated UserSettings moved out User */
  welcomeSmsSettings?: Maybe<WelcomeSmsSettings>;
};

export type UserAppInfo = {
  __typename?: 'UserAppInfo';
  hasApp?: Maybe<Scalars['Boolean']['output']>;
  isAppInvitationSent?: Maybe<Scalars['Boolean']['output']>;
  lastUserAccess?: Maybe<Scalars['Timestamp']['output']>;
};

export type UserBasic = Node & {
  __typename?: 'UserBasic';
  _id: Scalars['ID']['output'];
  consents?: Maybe<Array<Consent>>;
  emails?: Maybe<Array<Scalars['EmailAddress']['output']>>;
  fullName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partners: Array<Partner>;
  patientRequestSettings?: Maybe<PatientRequestSettings>;
  phones?: Maybe<Array<PhoneUser>>;
  role: Role;
  surname: Scalars['String']['output'];
};

export type UserDoctor = {
  __typename?: 'UserDoctor';
  archived: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  careEndDate?: Maybe<Scalars['Timestamp']['output']>;
  careStartDate?: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['ObjectId']['output'];
  createdFromFreenet?: Maybe<Scalars['Boolean']['output']>;
  deadAt?: Maybe<Scalars['Timestamp']['output']>;
  doctorFullName?: Maybe<Scalars['String']['output']>;
  doctorId: Scalars['ObjectId']['output'];
  familyDoctor: Scalars['Boolean']['output'];
  ignoreRegionalEmails?: Maybe<Scalars['Boolean']['output']>;
  ignoreRegionalPhones?: Maybe<Scalars['Boolean']['output']>;
  revokedAt?: Maybe<Scalars['Timestamp']['output']>;
  temporaryEndAt?: Maybe<Scalars['Timestamp']['output']>;
  temporaryStartAt?: Maybe<Scalars['Timestamp']['output']>;
  type: UserDoctorRelationship;
  updatedAt: Scalars['Timestamp']['output'];
  updatedBy: Scalars['ObjectId']['output'];
};

export type UserDoctorInput = {
  archived: Scalars['Boolean']['input'];
  careEndDate?: InputMaybe<Scalars['Timestamp']['input']>;
  careStartDate?: InputMaybe<Scalars['Timestamp']['input']>;
  createdFromFreenet?: InputMaybe<Scalars['Boolean']['input']>;
  deadAt?: InputMaybe<Scalars['Timestamp']['input']>;
  doctorId: Scalars['ObjectId']['input'];
  familyDoctor?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreRegionalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreRegionalPhones?: InputMaybe<Scalars['Boolean']['input']>;
  revokedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  temporaryEndAt?: InputMaybe<Scalars['Timestamp']['input']>;
  temporaryStartAt?: InputMaybe<Scalars['Timestamp']['input']>;
  type: UserDoctorRelationship;
};

export enum UserDoctorRelationship {
  Private = 'PRIVATE',
  SsnActive = 'SSN_ACTIVE',
  SsnDead = 'SSN_DEAD',
  SsnRevoked = 'SSN_REVOKED',
  SsnTemporary = 'SSN_TEMPORARY'
}

export type UserFeatureState = Node & {
  __typename?: 'UserFeatureState';
  _id: Scalars['ID']['output'];
  medicalReports?: Maybe<UserFeatureStateMedicalReports>;
  user: User;
};

export type UserFeatureStateMedicalReports = {
  __typename?: 'UserFeatureStateMedicalReports';
  isBatchDownloadPending?: Maybe<Scalars['Boolean']['output']>;
  lastBatchDownloadDate?: Maybe<Scalars['Timestamp']['output']>;
};

export type UserFeatureStateMedicalReportsInput = {
  isBatchDownloadPending?: InputMaybe<Scalars['Boolean']['input']>;
  lastBatchDownloadDate?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum UserInclinicPayment {
  Deferred = 'DEFERRED',
  Online = 'ONLINE',
  Onlywithcoupon = 'ONLYWITHCOUPON',
  Onsite = 'ONSITE'
}

export type UserInfo = {
  __typename?: 'UserInfo';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type UserLocation = Node & {
  __typename?: 'UserLocation';
  _id: Scalars['ID']['output'];
  cap: Scalars['String']['output'];
  cityCode: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  districtCode: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  street: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  type: LocationType;
  user: User;
};

export type UserLocationInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  cap: Scalars['String']['input'];
  cityCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  districtCode: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  street: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  type: LocationType;
};

export type UserLocationResult = {
  __typename?: 'UserLocationResult';
  location: UserLocation;
};

export enum UserOrigin {
  Davinci = 'DAVINCI',
  Freenet = 'FREENET',
  Inclinic = 'INCLINIC',
  TantoSvago = 'TANTO_SVAGO',
  Unisalute = 'UNISALUTE',
  VirtualCare = 'VIRTUAL_CARE'
}

export type UserParam = AllergiesParam | AppleEcgParam | BooleanParam | CeliacDiseaseIssuesArrayParam | DeviceParam | DrugsParam | ExemptionsParam | FertilityParam | IntolerancesArrayParam | MethodologiesParam | MoriskyScaleParam | MotorCapacityParam | NumberParam | OutpatientServicesParam | PregnanciesParam | ProfessionsParam | ProsthesisParam | StringArrayParam | StringParam | StringPlusDateArrayParam | StringPlusNumberArrayParam | SurgicalProceduresParam | VaccinationsParam;

export type UserParamInterface = {
  _id: Scalars['ID']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type UserParamsInput = {
  allergies?: InputMaybe<AllergiesInputArray>;
  appleEcg?: InputMaybe<AppleEcgInput>;
  bloodDonor?: InputMaybe<BooleanInput>;
  celiacDiseaseIssues?: InputMaybe<CeliacDiseaseIssuesArrayInput>;
  chronicDrugs?: InputMaybe<DrugParamInputArray>;
  diabetesEverDiagnosed?: InputMaybe<BooleanInput>;
  facilitiesPreferences?: InputMaybe<StringArrayInput>;
  fertility?: InputMaybe<FertilityInput>;
  highGlycemicLevel?: InputMaybe<BooleanInput>;
  intolerances?: InputMaybe<IntolerancesArrayInput>;
  lifestyleNotes?: InputMaybe<StringInput>;
  manualExemptions?: InputMaybe<ExemptionsInputArray>;
  methodologies?: InputMaybe<MethodologiesInputArray>;
  missingOrgans?: InputMaybe<StringPlusDateArrayInput>;
  noDeclaredAllergies?: InputMaybe<BooleanInput>;
  ordinaryDrugs?: InputMaybe<DrugParamInputArray>;
  ordinaryPrescribedOutpatientServices?: InputMaybe<OutpatientServiceInputArray>;
  pastVaccinations?: InputMaybe<VaccinationsInputArray>;
  postIt?: InputMaybe<StringInput>;
  pregnancies?: InputMaybe<PregnanciesInputArray>;
  prescribedOutpatientServices?: InputMaybe<OutpatientServiceInputArray>;
  pressureDrugsEverUsed?: InputMaybe<BooleanInput>;
  professions?: InputMaybe<ProfessionsInputArray>;
  prosthesis?: InputMaybe<ProsthesisInputArray>;
  signs?: InputMaybe<StringArrayInput>;
  surgicalProcedures?: InputMaybe<SurgicalProceduresInputArray>;
  transplants?: InputMaybe<StringPlusDateArrayInput>;
  vaccinations?: InputMaybe<VaccinationsInputArray>;
};

export type UserSettings = Node & {
  __typename?: 'UserSettings';
  _id: Scalars['ID']['output'];
  agendaSettings?: Maybe<AgendaSettings>;
  availabilityNote?: Maybe<Scalars['String']['output']>;
  chatSettings?: Maybe<ChatSettings>;
  communicationSettings?: Maybe<CommunicationSettings>;
  consents?: Maybe<Array<Consent>>;
  inappWidgetSettings?: Maybe<InappWidgetSettings>;
  medicalDocumentSettings?: Maybe<MedicalDocumentSettings>;
  newsletter?: Maybe<EnabledSetting>;
  patientRequestSettings?: Maybe<PatientRequestSettings>;
  privacyDavinci?: Maybe<EnabledSetting>;
  privacyPartner?: Maybe<EnabledSetting>;
  pushNotificationSettings?: Maybe<PushNotificationSettings>;
  reservations?: Maybe<ReservationsSettings>;
  sendCertificatePdfEmailSettings?: Maybe<SendPdfEmailSettings>;
  sendPrescriptionPdfEmailSettings?: Maybe<SendPdfEmailSettings>;
  settings?: Maybe<Settings>;
  specialitySettings?: Maybe<SpecialitySettings>;
  user: User;
  welcomeSmsSettings?: Maybe<WelcomeSmsSettings>;
};

export type UserSettingsInput = {
  agendaSettings?: InputMaybe<AgendaSettingsInput>;
  chatSettings?: InputMaybe<ChatSettingsInput>;
  communicationSettings?: InputMaybe<CommunicationSettingsInput>;
  connectEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  consents?: InputMaybe<Array<ConsentInput>>;
  drugInteractionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  inappWidgetSettings?: InputMaybe<InappWidgetSettingsInput>;
  nonPayingUser?: InputMaybe<Scalars['Boolean']['input']>;
  paiCentralEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  prescriptionsRequestsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationSettings?: InputMaybe<PushNotificationSettingsInput>;
  sissCloudEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  studentVerificationStatus?: InputMaybe<StudentVerificationStatus>;
  telemonitoringCentralEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserToken = {
  __typename?: 'UserToken';
  tokens: Array<Scalars['String']['output']>;
  usersIds: Array<Scalars['ID']['output']>;
};

export type UserbackFeedback = {
  __typename?: 'UserbackFeedback';
  comments: Array<UserbackFeedbackComment>;
  createdAt: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  feedbackId: Scalars['String']['output'];
  feedbackType: UserbackFeedbackType;
  lastComment: UserbackFeedbackComment;
  readByUser: Scalars['Boolean']['output'];
  status: UserbackFeedbackStatus;
  title?: Maybe<Scalars['String']['output']>;
};

export type UserbackFeedbackComment = {
  __typename?: 'UserbackFeedbackComment';
  attachment?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum UserbackFeedbackStatus {
  AssignedToDev = 'ASSIGNED_TO_DEV',
  InTriage = 'IN_TRIAGE',
  Open = 'OPEN',
  Resolved = 'RESOLVED',
  WaitingForUserFeedback = 'WAITING_FOR_USER_FEEDBACK'
}

export enum UserbackFeedbackType {
  Bug = 'BUG',
  Idea = 'IDEA'
}

export type UsersResult = ComplexQueryReturn & {
  __typename?: 'UsersResult';
  nodes?: Maybe<Array<User>>;
  pageInfo: PageInfo;
};

export type Vaccination = Node & {
  __typename?: 'Vaccination';
  _id: Scalars['ID']['output'];
  deliveryRegime?: Maybe<DeliveryRegime>;
  doctor: User;
  dosage?: Maybe<Dosage>;
  freeSomministrationMotivation?: Maybe<Scalars['String']['output']>;
  istatCode?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  patient: User;
  pregnancyStatus?: Maybe<VaccinationPregnancyStatus>;
  previousInfection?: Maybe<PreviousInfection>;
  reaction?: Maybe<Scalars['String']['output']>;
  riskCategory?: Maybe<RiskCategory>;
  riskCondition?: Maybe<RiskCondition>;
  somministrationDate?: Maybe<Scalars['Timestamp']['output']>;
  somministrationMethod?: Maybe<SomministrationMethod>;
  somministrationMotivation?: Maybe<SomministrationMotivation>;
  somministrationPlace?: Maybe<SomministrationPlace>;
  somministrationSite?: Maybe<SomministrationSite>;
  vaccinationStatus: VaccinationStatus;
  vaccine?: Maybe<Vaccine>;
  vaccineLot?: Maybe<VaccineLot>;
};

export type VaccinationInput = {
  deliveryRegime?: InputMaybe<DeliveryRegimeInput>;
  doctorId: Scalars['ID']['input'];
  dosage?: InputMaybe<DosageInput>;
  firstPositivityDate?: InputMaybe<Scalars['Timestamp']['input']>;
  freeSomministrationMotivation?: InputMaybe<Scalars['String']['input']>;
  istatCode?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  pregnancyStatus?: InputMaybe<VaccinationPregnancyStatusInput>;
  previousInfection?: InputMaybe<PreviousInfectionInput>;
  reaction?: InputMaybe<Scalars['String']['input']>;
  riskCategory?: InputMaybe<RiskCategoryInput>;
  riskCondition?: InputMaybe<RiskConditionInput>;
  somministrationDate?: InputMaybe<Scalars['Timestamp']['input']>;
  somministrationMethod?: InputMaybe<SomministrationMethodInput>;
  somministrationMotivation?: InputMaybe<SomministrationMotivationInput>;
  somministrationPlace?: InputMaybe<SomministrationPlaceInput>;
  somministrationSite?: InputMaybe<SomministrationSiteInput>;
  vaccinationStatus: VaccinationStatus;
  vaccine?: InputMaybe<VaccineInput>;
  vaccineLot?: InputMaybe<VaccineLotInput>;
};

export type VaccinationPregnancyStatus = {
  __typename?: 'VaccinationPregnancyStatus';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type VaccinationPregnancyStatusInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export enum VaccinationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type VaccinationsInput = {
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  periodicity?: InputMaybe<Scalars['UnsignedInt']['input']>;
  text: Scalars['String']['input'];
};

export type VaccinationsInputArray = {
  values?: InputMaybe<Array<VaccinationsInput>>;
};

export type VaccinationsParam = Node & UserParamInterface & {
  __typename?: 'VaccinationsParam';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  date: Scalars['Timestamp']['output'];
  hasThrownAlert: Scalars['Boolean']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateBy?: Maybe<User>;
  payload: VaccinationsPayloadArray;
  user: Scalars['ID']['output'];
  userParamName: Scalars['String']['output'];
};

export type VaccinationsPayload = {
  __typename?: 'VaccinationsPayload';
  date?: Maybe<Scalars['Timestamp']['output']>;
  periodicity?: Maybe<Scalars['UnsignedInt']['output']>;
  text: Scalars['String']['output'];
};

export type VaccinationsPayloadArray = {
  __typename?: 'VaccinationsPayloadArray';
  values?: Maybe<Array<VaccinationsPayload>>;
};

export type VaccinationsResult = ComplexQueryReturn & {
  __typename?: 'VaccinationsResult';
  nodes: Array<Vaccination>;
  pageInfo: PageInfo;
};

export type Vaccine = {
  __typename?: 'Vaccine';
  drugAicCode?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['String']['output'];
  linkedLot?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  region: Region;
  startDate?: Maybe<Scalars['Timestamp']['output']>;
  type: VaccineType;
};

export type VaccineInput = {
  drugAicCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  region: Region;
  type: VaccineType;
};

export type VaccineLot = {
  __typename?: 'VaccineLot';
  expirationDate: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VaccineLotInput = {
  expirationDate: Scalars['Timestamp']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Vaccination lot with expiration date for PSS. */
export type VaccineLotPayload = {
  __typename?: 'VaccineLotPayload';
  expirationDate: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Vaccination lot input with expiration date for PSS. */
export type VaccineLotPayloadInput = {
  expirationDate: Scalars['Timestamp']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum VaccineType {
  Covid = 'COVID',
  FluShot = 'FLU_SHOT',
  Other = 'OTHER',
  Pneumococcus = 'PNEUMOCOCCUS'
}

export type ValidateTaxCodesForBulkWorkgroupAddResult = {
  __typename?: 'ValidateTaxCodesForBulkWorkgroupAddResult';
  notFoundTaxCodes: Array<Scalars['String']['output']>;
  validUsers: Array<ValidatedUserForBulkWorkgroupAdd>;
};

export type ValidatedUserForBulkWorkgroupAdd = {
  __typename?: 'ValidatedUserForBulkWorkgroupAdd';
  fullName: Scalars['String']['output'];
  taxCode: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type VerificaArruolabilitaParseSissResult = {
  __typename?: 'VerificaArruolabilitaParseSissResult';
  patient: User;
  userParam?: Maybe<Array<PatientProblem>>;
};

export enum VerificationStatusEnlistingEnum {
  Arruolabile = 'ARRUOLABILE',
  Arruolato = 'ARRUOLATO',
  Prenotato = 'PRENOTATO'
}

export enum VerifiedAuth {
  AutomaticVerified = 'AUTOMATIC_VERIFIED',
  NotVerified = 'NOT_VERIFIED',
  Verified = 'VERIFIED'
}

export enum VerifiedMode {
  Spid = 'SPID'
}

export type VerifyCredentialsResult = {
  __typename?: 'VerifyCredentialsResult';
  success: Scalars['Boolean']['output'];
};

export type VerifyOtpResult = {
  __typename?: 'VerifyOtpResult';
  auth?: Maybe<Authentication>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  temporary?: Maybe<Scalars['Boolean']['output']>;
  token: Scalars['String']['output'];
  tokenExpiration?: Maybe<Scalars['Int']['output']>;
  usage: OtpUsage;
  user?: Maybe<User>;
};

export enum VerifyType {
  RefreshToken = 'REFRESH_TOKEN',
  Relationship = 'RELATIONSHIP',
  Reservation = 'RESERVATION',
  SimpleLogin = 'SIMPLE_LOGIN',
  VerificationUsername = 'VERIFICATION_USERNAME'
}

export type Video = {
  __typename?: 'Video';
  url: Scalars['String']['output'];
};

export type VideocallLog = Node & {
  __typename?: 'VideocallLog';
  _id: Scalars['ID']['output'];
  chat?: Maybe<Chat>;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  log: Scalars['String']['output'];
  reservation?: Maybe<Reservation>;
  type: VideocallLogType;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
  user?: Maybe<User>;
  videoSessionId?: Maybe<Scalars['String']['output']>;
};

export enum VideocallLogType {
  CallIn = 'CALL_IN',
  CallOut = 'CALL_OUT',
  Error = 'ERROR'
}

export enum VirtualCareAddOnType {
  Videoconsulti = 'videoconsulti'
}

export type VirtualCarePlanDetailed = {
  __typename?: 'VirtualCarePlanDetailed';
  _id: Scalars['ID']['output'];
  addOns?: Maybe<AddOns>;
  customer?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  originalPricing?: Maybe<VirtualCarePlanPrice>;
  pricing: VirtualCarePlanPrice;
  promoCode?: Maybe<Scalars['String']['output']>;
  trial?: Maybe<Scalars['Int']['output']>;
};

export type VirtualCarePlanPrice = {
  __typename?: 'VirtualCarePlanPrice';
  annual?: Maybe<VirtualCarePlanPriceDetail>;
  monthly?: Maybe<VirtualCarePlanPriceDetail>;
};

export type VirtualCarePlanPriceDetail = {
  __typename?: 'VirtualCarePlanPriceDetail';
  active?: Maybe<Scalars['Boolean']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  recurring?: Maybe<VirtualCarePlanRecurring>;
  tiers?: Maybe<Array<Maybe<VirtualCareSubscriptionTiers>>>;
  tiers_mode?: Maybe<Scalars['String']['output']>;
  unit_amount?: Maybe<Scalars['Int']['output']>;
};

export type VirtualCarePlanRecurring = {
  __typename?: 'VirtualCarePlanRecurring';
  interval: Scalars['String']['output'];
  interval_count: Scalars['Int']['output'];
};

export type VirtualCarePlanSubscriber = {
  __typename?: 'VirtualCarePlanSubscriber';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  surname: Scalars['String']['output'];
  taxCode: Scalars['String']['output'];
};

export enum VirtualCareSubscriptionCancelReason {
  AppNotWorking = 'APP_NOT_WORKING',
  Custom = 'CUSTOM',
  FreeTrialEnded = 'FREE_TRIAL_ENDED',
  HighPrice = 'HIGH_PRICE',
  NotSatisfying = 'NOT_SATISFYING',
  NoIntesa = 'NO_INTESA'
}

export type VirtualCareSubscriptionCard = {
  __typename?: 'VirtualCareSubscriptionCard';
  brand?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type VirtualCareSubscriptionDefaultPaymentMethod = {
  __typename?: 'VirtualCareSubscriptionDefaultPaymentMethod';
  card?: Maybe<VirtualCareSubscriptionCard>;
  id?: Maybe<Scalars['String']['output']>;
};

export type VirtualCareSubscriptionDetailed = {
  __typename?: 'VirtualCareSubscriptionDetailed';
  cancel_at?: Maybe<Scalars['Timestamp']['output']>;
  cancel_at_period_end: Scalars['Boolean']['output'];
  created: Scalars['Timestamp']['output'];
  current_period_end: Scalars['Timestamp']['output'];
  customer: Scalars['String']['output'];
  default_payment_method?: Maybe<VirtualCareSubscriptionDefaultPaymentMethod>;
  id: Scalars['String']['output'];
  latest_invoice?: Maybe<VirtualCareSubscriptionLatestInvoice>;
  price?: Maybe<VirtualCarePlanPriceDetail>;
  status: Scalars['String']['output'];
  subscriber?: Maybe<VirtualCarePlanSubscriber>;
  trial_end?: Maybe<Scalars['Timestamp']['output']>;
  usageRecords?: Maybe<Array<Maybe<VirtualCareSubscriptionUsageRecord>>>;
  virtualCarePlan?: Maybe<VirtualCarePlanDetailed>;
};

export type VirtualCareSubscriptionLatestInvoice = {
  __typename?: 'VirtualCareSubscriptionLatestInvoice';
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoice_pdf?: Maybe<Scalars['String']['output']>;
};

export enum VirtualCareSubscriptionStatus {
  Active = 'ACTIVE',
  Complete = 'COMPLETE',
  Deleted = 'DELETED',
  Incomplete = 'INCOMPLETE'
}

export type VirtualCareSubscriptionTiers = {
  __typename?: 'VirtualCareSubscriptionTiers';
  unit_amount?: Maybe<Scalars['Int']['output']>;
  up_to?: Maybe<Scalars['Int']['output']>;
};

export type VirtualCareSubscriptionUsageRecord = {
  __typename?: 'VirtualCareSubscriptionUsageRecord';
  type: Scalars['String']['output'];
  used: Scalars['Int']['output'];
};

export type VirtualCareUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  secondName: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
};

export type VirtualcareCreateReservationInput = {
  availabilitySlotId: Scalars['String']['input'];
  bookingInformations: BookingInformations;
  couponInformations?: InputMaybe<CouponInput>;
  doctorId?: InputMaybe<Scalars['String']['input']>;
  homeVisitInformations: HomeVisitInput;
  isVideoConsultation: Scalars['Boolean']['input'];
  onBehalfOfInformations: OnBehalfOfInput;
  originalPrice: Scalars['Int']['input'];
  payedPrice: Scalars['Int']['input'];
  payment: UserInclinicPayment;
  paymentGateway: PaymentGateway;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  reservationOrigin: ReservationOrigin;
  specialityTemplateId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  userNewsletterEnabled: Scalars['Boolean']['input'];
  userPhone: Scalars['String']['input'];
  userSurname: Scalars['String']['input'];
  userTaxCode: Scalars['String']['input'];
  workgroupId?: InputMaybe<Scalars['String']['input']>;
};

export enum VisitType {
  HomeVisit = 'HOME_VISIT',
  OutpatientVisit = 'OUTPATIENT_VISIT'
}

export type VisualizzaTestoRefertoResult = {
  __typename?: 'VisualizzaTestoRefertoResult';
  sissReport: SissReport;
};

export type WelcomeSmsSettings = {
  __typename?: 'WelcomeSmsSettings';
  autoMessage?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type WelcomeSmsSettingsByDoctorOrPatientInput = {
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type WelcomeSmsSettingsByDoctorOrPatientPayload = {
  __typename?: 'WelcomeSmsSettingsByDoctorOrPatientPayload';
  doctor?: Maybe<User>;
  welcomeSmsSettings?: Maybe<WelcomeSmsSettings>;
};

export type WelcomeSmsSettingsInput = {
  autoMessage?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WithdrawalData = {
  __typename?: 'WithdrawalData';
  codicePrestazione: Scalars['String']['output'];
  tipoAmbulatorio: Scalars['String']['output'];
};

export type Workgroup = Node & {
  __typename?: 'Workgroup';
  _id: Scalars['ID']['output'];
  address?: Maybe<StructuredAddress>;
  /** @deprecated use StructuredAddress */
  cap?: Maybe<Scalars['String']['output']>;
  /** @deprecated use StructuredAddress */
  city?: Maybe<Scalars['String']['output']>;
  /** @deprecated use StructuredAddress */
  cityCode?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<ClinicGroup>;
  color: WorkgroupColor;
  /** @deprecated use StructuredAddress */
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  coordinators: Array<User>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use StructuredAddress */
  district?: Maybe<Scalars['String']['output']>;
  /** @deprecated use StructuredAddress */
  districtCode?: Maybe<Scalars['String']['output']>;
  doctorsToShowForSpecialities?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  domiciliaryCare?: Maybe<Scalars['Boolean']['output']>;
  emails: Array<Scalars['EmailAddress']['output']>;
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  inclinicSlug?: Maybe<Scalars['String']['output']>;
  isWorkgroupHiddenInAgenda?: Maybe<Scalars['Boolean']['output']>;
  isWorkgroupHiddenInApp?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  openingHours?: Maybe<Array<OpeningHours>>;
  operators: Array<User>;
  owners: Array<User>;
  /** @deprecated use owners and operators */
  partecipants: Array<User>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  phones: Array<Scalars['PhoneNumber']['output']>;
  /** @deprecated use StructuredAddress */
  region?: Maybe<Region>;
  rolesPermissions?: Maybe<RolesPermissions>;
  /** @deprecated use inclinicSlug */
  slug?: Maybe<Scalars['String']['output']>;
  specializations?: Maybe<Array<Specialization>>;
  type: WorkgroupType;
  website?: Maybe<Scalars['URL']['output']>;
};

export type WorkgroupAgendaView = {
  __typename?: 'WorkgroupAgendaView';
  _id: Scalars['ID']['output'];
  addressLabel?: Maybe<Scalars['String']['output']>;
  color: WorkgroupColor;
  displayName?: Maybe<Scalars['String']['output']>;
  isWorkgroupHiddenInAgenda?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export enum WorkgroupColor {
  Brandblue = 'BRANDBLUE',
  Cyan = 'CYAN',
  Green = 'GREEN',
  Indigo = 'INDIGO',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Rose = 'ROSE',
  Sapphire = 'SAPPHIRE',
  Teal = 'TEAL',
  Yellow = 'YELLOW'
}

export type WorkgroupImpersonationOperator = {
  __typename?: 'WorkgroupImpersonationOperator';
  _id: Scalars['ID']['output'];
  avatarUrl?: Maybe<Scalars['URL']['output']>;
  fullName: Scalars['String']['output'];
  role: Role;
  subscriptionPlanUser?: Maybe<SubscriptionPlanUser>;
  userSettings?: Maybe<UserSettings>;
};

export type WorkgroupImpersonationView = {
  __typename?: 'WorkgroupImpersonationView';
  operators: Array<WorkgroupImpersonationOperator>;
  workgroupId: Scalars['ID']['output'];
  workgroupName: Scalars['String']['output'];
};

export type WorkgroupManagementView = {
  __typename?: 'WorkgroupManagementView';
  _id: Scalars['ID']['output'];
  coordinators: Array<WorkgroupOperatorBasic>;
  displayName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operators: Array<WorkgroupOperatorBasic>;
  rolesPermissions?: Maybe<RolesPermissions>;
  type: WorkgroupType;
};

export type WorkgroupOperatorBasic = {
  __typename?: 'WorkgroupOperatorBasic';
  _id: Scalars['ID']['output'];
  avatarUrl?: Maybe<Scalars['URL']['output']>;
  fullName: Scalars['String']['output'];
  role: Role;
  userSettings?: Maybe<UserSettings>;
};

export type WorkgroupPatientsTabs = {
  __typename?: 'WorkgroupPatientsTabs';
  groupMedicineWorkgroups: Array<WorkgroupTab>;
  networkMedicineWorkgroups: Array<WorkgroupTab>;
};

export type WorkgroupResult = ComplexQueryReturn & {
  __typename?: 'WorkgroupResult';
  nodes?: Maybe<Array<Workgroup>>;
  pageInfo: PageInfo;
};

export type WorkgroupSlot = {
  __typename?: 'WorkgroupSlot';
  doctors?: Maybe<Array<Maybe<DoctorSlots>>>;
  workgroup?: Maybe<Workgroup>;
};

export type WorkgroupTab = {
  __typename?: 'WorkgroupTab';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export enum WorkgroupType {
  GroupMedicine = 'GROUP_MEDICINE',
  NetworkMedicine = 'NETWORK_MEDICINE'
}

export type WorkgroupsResult = ComplexQueryReturn & {
  __typename?: 'WorkgroupsResult';
  nodes?: Maybe<Array<Workgroup>>;
  pageInfo: PageInfo;
};

export type BasicStructuredAddressFragment = { __typename?: 'StructuredAddress', cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null };

export type SpecialityTemplateBasicFragment = { __typename?: 'SpecialityTemplate', _id: string, showOnSpecialitiesList: boolean, name: string, channels: Array<ReservationChannel>, macroSpeciality: Array<MacroSpeciality>, duration: number, owner?: string | null, label?: string | null };

export type SpecialityBasicFragment = { __typename?: 'Speciality', _id: string, price: number, duration: number, userId: string, specialityTemplate: { __typename?: 'SpecialityTemplate', _id: string, showOnSpecialitiesList: boolean, name: string, channels: Array<ReservationChannel>, macroSpeciality: Array<MacroSpeciality>, duration: number, owner?: string | null, label?: string | null } };

export type LoggedUserDataFragment = { __typename?: 'User', _id: string, fullName: string, name: string, surname: string, emails?: Array<string> | null, role: Role, availabilityNote?: string | null, macroSpeciality?: Array<MacroSpeciality> | null, iban?: string | null, stripeToken?: string | null, avatarUrl?: string | null, newsletterEnable?: boolean | null, sex?: Sex | null, signUpAt?: number | null, atsName?: Ats | null, aslCode?: string | null, regionalCode?: string | null, taxCode?: string | null, languageApp?: LanguageApp | null, biography?: string | null, vatNumber?: string | null, timezone?: unknown | null, complete?: boolean | null, stripeAccountVerified?: boolean | null, region: Region, regime: PatientRegime, prefix?: string | null, principalClinic?: string | null, hasApp: boolean, hasWorkgroup?: boolean | null, healthlineDoctor?: boolean | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, specialities?: Array<{ __typename?: 'Speciality', _id: string, price: number, duration: number, userId: string, specialityTemplate: { __typename?: 'SpecialityTemplate', _id: string, showOnSpecialitiesList: boolean, name: string, channels: Array<ReservationChannel>, macroSpeciality: Array<MacroSpeciality>, duration: number, owner?: string | null, label?: string | null } }> | null, partners: Array<{ __typename?: 'Partner', _id: string, name: string, logoUrl?: string | null, siteUrl?: string | null }>, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, officeAddress?: { __typename?: 'StructuredAddress', cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, studios?: Array<{ __typename?: 'UserLocation', _id: string, street: string, streetNumber: string, cityCode: string, districtCode: string, countryCode: string, cap: string, label?: string | null, phone?: string | null, type: LocationType }> | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, welcomeSmsSettings?: { __typename?: 'WelcomeSmsSettings', enabled?: boolean | null, autoMessage?: string | null } | null, subscriptionPlanUser?: { __typename?: 'SubscriptionPlanUser', _id: string, expirationDate: number, subscriptionPlan: SubscriptionPlan } | null, userSettings?: { __typename?: 'UserSettings', settings?: { __typename?: 'Settings', paiMillewinConnected?: boolean | null, telemonitoringCentralEnabled?: boolean | null, connectEnabled?: boolean | null, paiCentralEnabled?: boolean | null, studentVerificationStatus?: StudentVerificationStatus | null, nonPayingUser?: boolean | null, prescriptionsRequestsEnabled?: boolean | null, drugInteractionsEnabled?: boolean | null, stampDisabled?: boolean | null } | null, specialitySettings?: { __typename?: 'SpecialitySettings', favoriteInPresenceSpeciality?: string | null, favoriteOnlineSpeciality?: string | null } | null } | null };

export type LoginQueryVariables = Exact<{
  username: Scalars['Username']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginQueryResult = { __typename?: 'Query', login: { __typename?: 'AuthData', token: string, tokenExpiration: number, user: { __typename?: 'User', _id: string, fullName: string, name: string, surname: string, emails?: Array<string> | null, role: Role, availabilityNote?: string | null, macroSpeciality?: Array<MacroSpeciality> | null, iban?: string | null, stripeToken?: string | null, avatarUrl?: string | null, newsletterEnable?: boolean | null, sex?: Sex | null, signUpAt?: number | null, atsName?: Ats | null, aslCode?: string | null, regionalCode?: string | null, taxCode?: string | null, languageApp?: LanguageApp | null, biography?: string | null, vatNumber?: string | null, timezone?: unknown | null, complete?: boolean | null, stripeAccountVerified?: boolean | null, region: Region, regime: PatientRegime, prefix?: string | null, principalClinic?: string | null, hasApp: boolean, hasWorkgroup?: boolean | null, healthlineDoctor?: boolean | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, specialities?: Array<{ __typename?: 'Speciality', _id: string, price: number, duration: number, userId: string, specialityTemplate: { __typename?: 'SpecialityTemplate', _id: string, showOnSpecialitiesList: boolean, name: string, channels: Array<ReservationChannel>, macroSpeciality: Array<MacroSpeciality>, duration: number, owner?: string | null, label?: string | null } }> | null, partners: Array<{ __typename?: 'Partner', _id: string, name: string, logoUrl?: string | null, siteUrl?: string | null }>, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, officeAddress?: { __typename?: 'StructuredAddress', cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, studios?: Array<{ __typename?: 'UserLocation', _id: string, street: string, streetNumber: string, cityCode: string, districtCode: string, countryCode: string, cap: string, label?: string | null, phone?: string | null, type: LocationType }> | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, welcomeSmsSettings?: { __typename?: 'WelcomeSmsSettings', enabled?: boolean | null, autoMessage?: string | null } | null, subscriptionPlanUser?: { __typename?: 'SubscriptionPlanUser', _id: string, expirationDate: number, subscriptionPlan: SubscriptionPlan } | null, userSettings?: { __typename?: 'UserSettings', settings?: { __typename?: 'Settings', paiMillewinConnected?: boolean | null, telemonitoringCentralEnabled?: boolean | null, connectEnabled?: boolean | null, paiCentralEnabled?: boolean | null, studentVerificationStatus?: StudentVerificationStatus | null, nonPayingUser?: boolean | null, prescriptionsRequestsEnabled?: boolean | null, drugInteractionsEnabled?: boolean | null, stampDisabled?: boolean | null } | null, specialitySettings?: { __typename?: 'SpecialitySettings', favoriteInPresenceSpeciality?: string | null, favoriteOnlineSpeciality?: string | null } | null } | null }, auth: { __typename?: 'Authentication', verified: VerifiedAuth, _id: string } } };

export type UserExistsQueryVariables = Exact<{
  taxCode: Scalars['String']['input'];
}>;


export type UserExistsQueryResult = { __typename?: 'Query', userExists?: { __typename?: 'UserBasic', _id: string, name: string, surname: string } | null };

export type DeleteUserAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserAdminMutationResult = { __typename?: 'Mutation', deleteUserAdmin: { __typename?: 'User', _id: string } };

export type CreateUserMutationVariables = Exact<{
  name: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
  role: Role;
  birthDate?: InputMaybe<Scalars['Timestamp']['input']>;
  region: Region;
  macroSpeciality?: InputMaybe<MacroSpeciality>;
}>;


export type CreateUserMutationResult = { __typename?: 'Mutation', createUser: { __typename?: 'User', _id: string, name: string, surname: string } };

export type DeleteClinicGroupMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
}>;


export type DeleteClinicGroupMutationResult = { __typename?: 'Mutation', deleteClinicGroup: { __typename?: 'ClinicGroup', _id: string } };

export type UserAdminFragment = { __typename?: 'User', _id: string, role: Role, fullName: string, name: string, surname: string, avatarUrl?: string | null, emails?: Array<string> | null, signUpAt?: number | null, macroSpeciality?: Array<MacroSpeciality> | null, atsName?: Ats | null, aslCode?: string | null, regionalCode?: string | null, region: Region, regime: PatientRegime, hasApp: boolean, healthlineDoctor?: boolean | null, taxCode?: string | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, userSettings?: { __typename?: 'UserSettings', settings?: { __typename?: 'Settings', paiMillewinConnected?: boolean | null, telemonitoringCentralEnabled?: boolean | null, connectEnabled?: boolean | null, paiCentralEnabled?: boolean | null, studentVerificationStatus?: StudentVerificationStatus | null, nonPayingUser?: boolean | null } | null, chatSettings?: { __typename?: 'ChatSettings', enabled?: boolean | null, autoMessage?: string | null } | null } | null, subscriptionPlanUser?: { __typename?: 'SubscriptionPlanUser', _id: string, expirationDate: number, subscriptionPlan: SubscriptionPlan, activationDate?: number | null } | null };

export type UsersForAdminQueryVariables = Exact<{
  roles: Array<Role> | Role;
  partnersIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  input: ComplexQueryInput;
}>;


export type UsersForAdminQueryResult = { __typename?: 'Query', usersForAdmin?: { __typename?: 'UsersResult', pageInfo: { __typename?: 'PageInfo', count: number }, nodes?: Array<{ __typename?: 'User', _id: string, role: Role, fullName: string, name: string, surname: string, avatarUrl?: string | null, emails?: Array<string> | null, signUpAt?: number | null, macroSpeciality?: Array<MacroSpeciality> | null, atsName?: Ats | null, aslCode?: string | null, regionalCode?: string | null, region: Region, regime: PatientRegime, hasApp: boolean, healthlineDoctor?: boolean | null, taxCode?: string | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, userSettings?: { __typename?: 'UserSettings', settings?: { __typename?: 'Settings', paiMillewinConnected?: boolean | null, telemonitoringCentralEnabled?: boolean | null, connectEnabled?: boolean | null, paiCentralEnabled?: boolean | null, studentVerificationStatus?: StudentVerificationStatus | null, nonPayingUser?: boolean | null } | null, chatSettings?: { __typename?: 'ChatSettings', enabled?: boolean | null, autoMessage?: string | null } | null } | null, subscriptionPlanUser?: { __typename?: 'SubscriptionPlanUser', _id: string, expirationDate: number, subscriptionPlan: SubscriptionPlan, activationDate?: number | null } | null }> | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQueryResult = { __typename?: 'Query', me: { __typename?: 'User', _id: string, fullName: string, name: string, surname: string, emails?: Array<string> | null, role: Role, availabilityNote?: string | null, macroSpeciality?: Array<MacroSpeciality> | null, iban?: string | null, stripeToken?: string | null, avatarUrl?: string | null, newsletterEnable?: boolean | null, sex?: Sex | null, signUpAt?: number | null, atsName?: Ats | null, aslCode?: string | null, regionalCode?: string | null, taxCode?: string | null, languageApp?: LanguageApp | null, biography?: string | null, vatNumber?: string | null, timezone?: unknown | null, complete?: boolean | null, stripeAccountVerified?: boolean | null, region: Region, regime: PatientRegime, prefix?: string | null, principalClinic?: string | null, hasApp: boolean, hasWorkgroup?: boolean | null, healthlineDoctor?: boolean | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, specialities?: Array<{ __typename?: 'Speciality', _id: string, price: number, duration: number, userId: string, specialityTemplate: { __typename?: 'SpecialityTemplate', _id: string, showOnSpecialitiesList: boolean, name: string, channels: Array<ReservationChannel>, macroSpeciality: Array<MacroSpeciality>, duration: number, owner?: string | null, label?: string | null } }> | null, partners: Array<{ __typename?: 'Partner', _id: string, name: string, logoUrl?: string | null, siteUrl?: string | null }>, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, officeAddress?: { __typename?: 'StructuredAddress', cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, studios?: Array<{ __typename?: 'UserLocation', _id: string, street: string, streetNumber: string, cityCode: string, districtCode: string, countryCode: string, cap: string, label?: string | null, phone?: string | null, type: LocationType }> | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, welcomeSmsSettings?: { __typename?: 'WelcomeSmsSettings', enabled?: boolean | null, autoMessage?: string | null } | null, subscriptionPlanUser?: { __typename?: 'SubscriptionPlanUser', _id: string, expirationDate: number, subscriptionPlan: SubscriptionPlan } | null, userSettings?: { __typename?: 'UserSettings', settings?: { __typename?: 'Settings', paiMillewinConnected?: boolean | null, telemonitoringCentralEnabled?: boolean | null, connectEnabled?: boolean | null, paiCentralEnabled?: boolean | null, studentVerificationStatus?: StudentVerificationStatus | null, nonPayingUser?: boolean | null, prescriptionsRequestsEnabled?: boolean | null, drugInteractionsEnabled?: boolean | null, stampDisabled?: boolean | null } | null, specialitySettings?: { __typename?: 'SpecialitySettings', favoriteInPresenceSpeciality?: string | null, favoriteOnlineSpeciality?: string | null } | null } | null } };

export type ClinicsForAdminQueryVariables = Exact<{
  input: ComplexQueryInput;
}>;


export type ClinicsForAdminQueryResult = { __typename?: 'Query', clinicsForAdmin: Array<{ __typename?: 'ClinicGroup', _id: string, name: string, type?: ClinicType | null, availablePayments?: Array<InclinicPayment> | null, owners: Array<{ __typename?: 'User', _id: string, role: Role, fullName: string, name: string, surname: string, avatarUrl?: string | null, emails?: Array<string> | null, signUpAt?: number | null, macroSpeciality?: Array<MacroSpeciality> | null, atsName?: Ats | null, aslCode?: string | null, regionalCode?: string | null, region: Region, regime: PatientRegime, hasApp: boolean, healthlineDoctor?: boolean | null, taxCode?: string | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, userSettings?: { __typename?: 'UserSettings', settings?: { __typename?: 'Settings', paiMillewinConnected?: boolean | null, telemonitoringCentralEnabled?: boolean | null, connectEnabled?: boolean | null, paiCentralEnabled?: boolean | null, studentVerificationStatus?: StudentVerificationStatus | null, nonPayingUser?: boolean | null } | null, chatSettings?: { __typename?: 'ChatSettings', enabled?: boolean | null, autoMessage?: string | null } | null } | null, subscriptionPlanUser?: { __typename?: 'SubscriptionPlanUser', _id: string, expirationDate: number, subscriptionPlan: SubscriptionPlan, activationDate?: number | null } | null }>, ambulatories: Array<{ __typename?: 'Workgroup', _id: string, name: string }> }> };

export type CreateClinicWorkgroupMutationVariables = Exact<{
  workgroup: CreateClinicWorkgroupInput;
}>;


export type CreateClinicWorkgroupMutationResult = { __typename?: 'Mutation', createClinicWorkgroup: { __typename?: 'Workgroup', _id: string } };

export type DeleteWorkgroupMutationVariables = Exact<{
  workgroupID: Scalars['String']['input'];
}>;


export type DeleteWorkgroupMutationResult = { __typename?: 'Mutation', deleteWorkgroup: { __typename?: 'Workgroup', _id: string, name: string } };

export type WorkgroupsForAdminQueryVariables = Exact<{
  input: ComplexQueryInput;
}>;


export type WorkgroupsForAdminQueryResult = { __typename?: 'Query', workgroupsForAdmin?: { __typename?: 'WorkgroupsResult', nodes?: Array<{ __typename?: 'Workgroup', _id: string, name: string, description?: string | null, color: WorkgroupColor, phone?: string | null, website?: string | null, emails: Array<string>, phones: Array<string>, inclinicSlug?: string | null, clinic?: { __typename?: 'ClinicGroup', _id: string, name: string } | null, address?: { __typename?: 'StructuredAddress', cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, operators: Array<{ __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, role: Role, regime: PatientRegime, hasApp: boolean }> }> | null, pageInfo: { __typename?: 'PageInfo', count: number, currentPage: number } } | null };

export type WorkgroupsForAdminBasicFragment = { __typename?: 'Workgroup', _id: string, name: string, description?: string | null, color: WorkgroupColor, phone?: string | null, website?: string | null, emails: Array<string>, phones: Array<string>, inclinicSlug?: string | null, clinic?: { __typename?: 'ClinicGroup', _id: string, name: string } | null, address?: { __typename?: 'StructuredAddress', cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, operators: Array<{ __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, role: Role, regime: PatientRegime, hasApp: boolean }> };

export type UserBasicInWorkgroupsForAdminFragment = { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, role: Role, regime: PatientRegime, hasApp: boolean };

export type SignupV2MutationVariables = Exact<{
  username: Scalars['Username']['input'];
  name: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  nationalMedicineBoardNumber?: InputMaybe<Scalars['String']['input']>;
  nationalMedicineBoardPlace?: InputMaybe<Scalars['String']['input']>;
  ats?: InputMaybe<Scalars['ID']['input']>;
  officeAddress?: InputMaybe<StructuredAddressInput>;
  partner?: InputMaybe<Scalars['String']['input']>;
  macroSpeciality?: InputMaybe<MacroSpeciality>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  role: Role;
  birthCity?: InputMaybe<Scalars['String']['input']>;
  taxCode: Scalars['String']['input'];
  newsletterEnable?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPartner?: InputMaybe<Scalars['Boolean']['input']>;
  privacyDavinci?: InputMaybe<Scalars['Boolean']['input']>;
  region: Region;
}>;


export type SignupV2MutationResult = { __typename?: 'Mutation', signupV2: { __typename?: 'AuthData', token: string, tokenExpiration: number, user: { __typename?: 'User', _id: string, fullName: string, name: string, surname: string, emails?: Array<string> | null, role: Role, availabilityNote?: string | null, macroSpeciality?: Array<MacroSpeciality> | null, iban?: string | null, stripeToken?: string | null, avatarUrl?: string | null, newsletterEnable?: boolean | null, sex?: Sex | null, signUpAt?: number | null, atsName?: Ats | null, aslCode?: string | null, regionalCode?: string | null, taxCode?: string | null, languageApp?: LanguageApp | null, biography?: string | null, vatNumber?: string | null, timezone?: unknown | null, complete?: boolean | null, stripeAccountVerified?: boolean | null, region: Region, regime: PatientRegime, prefix?: string | null, principalClinic?: string | null, hasApp: boolean, hasWorkgroup?: boolean | null, healthlineDoctor?: boolean | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, specialities?: Array<{ __typename?: 'Speciality', _id: string, price: number, duration: number, userId: string, specialityTemplate: { __typename?: 'SpecialityTemplate', _id: string, showOnSpecialitiesList: boolean, name: string, channels: Array<ReservationChannel>, macroSpeciality: Array<MacroSpeciality>, duration: number, owner?: string | null, label?: string | null } }> | null, partners: Array<{ __typename?: 'Partner', _id: string, name: string, logoUrl?: string | null, siteUrl?: string | null }>, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, officeAddress?: { __typename?: 'StructuredAddress', cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, studios?: Array<{ __typename?: 'UserLocation', _id: string, street: string, streetNumber: string, cityCode: string, districtCode: string, countryCode: string, cap: string, label?: string | null, phone?: string | null, type: LocationType }> | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, welcomeSmsSettings?: { __typename?: 'WelcomeSmsSettings', enabled?: boolean | null, autoMessage?: string | null } | null, subscriptionPlanUser?: { __typename?: 'SubscriptionPlanUser', _id: string, expirationDate: number, subscriptionPlan: SubscriptionPlan } | null, userSettings?: { __typename?: 'UserSettings', settings?: { __typename?: 'Settings', paiMillewinConnected?: boolean | null, telemonitoringCentralEnabled?: boolean | null, connectEnabled?: boolean | null, paiCentralEnabled?: boolean | null, studentVerificationStatus?: StudentVerificationStatus | null, nonPayingUser?: boolean | null, prescriptionsRequestsEnabled?: boolean | null, drugInteractionsEnabled?: boolean | null, stampDisabled?: boolean | null } | null, specialitySettings?: { __typename?: 'SpecialitySettings', favoriteInPresenceSpeciality?: string | null, favoriteOnlineSpeciality?: string | null } | null } | null }, auth: { __typename?: 'Authentication', verified: VerifiedAuth } } };

export type CreateOrUpdateSpecialityMutationVariables = Exact<{
  input: CreateSpecialityInput;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateOrUpdateSpecialityMutationResult = { __typename?: 'Mutation', createOrUpdateSpeciality: { __typename?: 'Speciality', _id: string, price: number, duration: number, userId: string, specialityTemplate: { __typename?: 'SpecialityTemplate', _id: string, showOnSpecialitiesList: boolean, name: string, channels: Array<ReservationChannel>, macroSpeciality: Array<MacroSpeciality>, duration: number, owner?: string | null, label?: string | null } } };

export type AddAvailabilityMutationVariables = Exact<{
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  newSlot: SlotInput;
  recurringWeeks?: InputMaybe<Scalars['Int']['input']>;
  allSpecialityTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  specialityTemplates?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  isAvailableToMyPatient: Scalars['Boolean']['input'];
  isAvailableToWorkgroupPatient?: InputMaybe<Scalars['Boolean']['input']>;
  workgroup?: InputMaybe<Scalars['ID']['input']>;
  alternateWeeks: Scalars['Boolean']['input'];
}>;


export type AddAvailabilityMutationResult = { __typename?: 'Mutation', addAvailability?: Array<{ __typename?: 'Slot', start: number, end: number, duration?: number | null, recurringId?: string | null, allSpecialityTemplates?: boolean | null, isAvailableToMyPatient: boolean, isAvailableToWorkgroupPatient?: boolean | null, specialityTemplates?: Array<{ __typename?: 'SpecialityTemplate', _id: string, showOnSpecialitiesList: boolean, name: string, channels: Array<ReservationChannel>, macroSpeciality: Array<MacroSpeciality>, duration: number, owner?: string | null, label?: string | null } | null> | null, workgroup?: { __typename?: 'Workgroup', _id: string, name: string, phones: Array<string>, color: WorkgroupColor, address?: { __typename?: 'StructuredAddress', street: string, cap?: string | null, cityCode: string, districtCode: string } | null } | null }> | null };

export type WorkgroupBasicFragment = { __typename?: 'Workgroup', _id: string, name: string, phones: Array<string>, color: WorkgroupColor, address?: { __typename?: 'StructuredAddress', street: string, cap?: string | null, cityCode: string, districtCode: string } | null };

export type CreateClinicGroupMutationVariables = Exact<{
  clinicGroup: AddClinicGroupInput;
}>;


export type CreateClinicGroupMutationResult = { __typename?: 'Mutation', createClinicGroup: { __typename?: 'ClinicGroup', _id: string } };

export type UserBasicFragment = { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null };

export type AddPatientMutationVariables = Exact<{
  phones?: InputMaybe<Array<PhonesInput> | PhonesInput>;
  emails?: InputMaybe<Array<Scalars['EmailAddress']['input']> | Scalars['EmailAddress']['input']>;
  name: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  taxCode?: InputMaybe<Scalars['TaxCode']['input']>;
  regime: PatientRegime;
  homeAddress?: InputMaybe<StructuredAddressInput>;
  sex?: InputMaybe<Sex>;
  listName?: InputMaybe<RelationshipPatientList>;
  isFamilyDoctor?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeSmsSettings?: InputMaybe<WelcomeSmsSettingsInput>;
  numIdentPers?: InputMaybe<Scalars['String']['input']>;
  foreignAndSeafarinOptions?: InputMaybe<ForeignAndSeafarinInput>;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddPatientMutationResult = { __typename?: 'Mutation', addPatient: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null } };

export type ReservationExtendedFragment = { __typename?: 'Reservation', _id: string, reservationOrigin?: ReservationOrigin | null, status: ReservationStatus, startTime?: number | null, channel: ReservationChannel, description?: string | null, price: number, duration?: number | null, videoSessionId?: string | null, createdAt: number, viewers?: Array<string> | null, workgroupId?: string | null, phone?: string | null, doctor?: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null } | null, patient: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null }, specialityTemplate: { __typename?: 'SpecialityTemplateReservation', _id: string, name: string, actionToClose?: ActionToClose | null, label?: string | null }, owner?: { __typename?: 'User', _id: string, role: Role } | null, additionalInformation?: { __typename?: 'AdditionalInformation', patientName?: string | null, patientSurname?: string | null, patientBirth?: number | null, patientBirthCity?: string | null, patientBirthDistrict?: string | null, patientSex?: Sex | null, patientTaxCode?: string | null, chronicPatient?: boolean | null, note?: string | null, createRelationshipWithDoctor?: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null } | null } | null, report?: { __typename?: 'Report', notes?: string | null, description?: string | null } | null, onBehalfOf?: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null } | null };

export type BookReservationMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Timestamp']['input']>;
  duration?: InputMaybe<Scalars['UnsignedInt']['input']>;
  channel: ReservationChannel;
  description?: InputMaybe<Scalars['String']['input']>;
  specialityTemplateId: Scalars['ID']['input'];
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingSurname?: InputMaybe<Scalars['String']['input']>;
  billingTaxCode?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingCap?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingDistrict?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['UnsignedInt']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  chronicPatient?: InputMaybe<Scalars['Boolean']['input']>;
  patientBirth?: InputMaybe<Scalars['Timestamp']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  patientSurname?: InputMaybe<Scalars['String']['input']>;
  patientBirthCity?: InputMaybe<Scalars['String']['input']>;
  patientBirthDistrict?: InputMaybe<Scalars['String']['input']>;
  patientSex?: InputMaybe<Sex>;
  createRelationshipWithDoctor?: InputMaybe<Scalars['ID']['input']>;
  patientTaxCode?: InputMaybe<Scalars['String']['input']>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  viewers?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  workgroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BookReservationMutationResult = { __typename?: 'Mutation', bookReservationV2: { __typename?: 'BookReservationResult', reservation: { __typename?: 'Reservation', _id: string, reservationOrigin?: ReservationOrigin | null, status: ReservationStatus, startTime?: number | null, channel: ReservationChannel, description?: string | null, price: number, duration?: number | null, videoSessionId?: string | null, createdAt: number, viewers?: Array<string> | null, workgroupId?: string | null, phone?: string | null, doctor?: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null } | null, patient: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null }, specialityTemplate: { __typename?: 'SpecialityTemplateReservation', _id: string, name: string, actionToClose?: ActionToClose | null, label?: string | null }, owner?: { __typename?: 'User', _id: string, role: Role } | null, additionalInformation?: { __typename?: 'AdditionalInformation', patientName?: string | null, patientSurname?: string | null, patientBirth?: number | null, patientBirthCity?: string | null, patientBirthDistrict?: string | null, patientSex?: Sex | null, patientTaxCode?: string | null, chronicPatient?: boolean | null, note?: string | null, createRelationshipWithDoctor?: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null } | null } | null, report?: { __typename?: 'Report', notes?: string | null, description?: string | null } | null, onBehalfOf?: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null } | null }, paymentTransaction?: Array<{ __typename?: 'PaymentTransaction', _id: string, status: PaymentStatus, token?: string | null, amount: number, redirectUrl?: string | null, paymentGateway: PaymentGateway } | null> | null } };

export type MyReservationsQueryVariables = Exact<{
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  input: ComplexQueryInput;
  type: ReservationType;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  specialityTemplateId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MyReservationsQueryResult = { __typename?: 'Query', myReservationsV2: { __typename?: 'ReservationsResult', nodes?: Array<{ __typename?: 'Reservation', _id: string, reservationOrigin?: ReservationOrigin | null, status: ReservationStatus, startTime?: number | null, channel: ReservationChannel, description?: string | null, price: number, duration?: number | null, viewers?: Array<string> | null, workgroupId?: string | null, createdAt: number, phone?: string | null, patient: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null }, specialityTemplate: { __typename?: 'SpecialityTemplateReservation', _id: string, name: string, actionToClose?: ActionToClose | null, label?: string | null }, owner?: { __typename?: 'User', _id: string, role: Role } | null, additionalInformation?: { __typename?: 'AdditionalInformation', patientName?: string | null, patientSurname?: string | null, patientTaxCode?: string | null, note?: string | null } | null, workgroup?: { __typename?: 'Workgroup', name: string, address?: { __typename?: 'StructuredAddress', street: string, cityCode: string, districtCode: string, streetNumber?: string | null, cap?: string | null } | null } | null, report?: { __typename?: 'Report', notes?: string | null, description?: string | null, documents?: Array<{ __typename?: 'Document', _id: string, label?: string | null, name: string, category: DocumentCategory, url: string, mimeType: string, createdAt: number, uploadedBy?: { __typename?: 'User', _id: string, fullName: string } | null }> | null } | null, onBehalfOf?: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', count: number, currentPage: number } } };

export type MyReservationsQueryBasicFragment = { __typename?: 'Reservation', _id: string, reservationOrigin?: ReservationOrigin | null, status: ReservationStatus, startTime?: number | null, channel: ReservationChannel, description?: string | null, price: number, duration?: number | null, viewers?: Array<string> | null, workgroupId?: string | null, createdAt: number, phone?: string | null, patient: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null }, specialityTemplate: { __typename?: 'SpecialityTemplateReservation', _id: string, name: string, actionToClose?: ActionToClose | null, label?: string | null }, owner?: { __typename?: 'User', _id: string, role: Role } | null, additionalInformation?: { __typename?: 'AdditionalInformation', patientName?: string | null, patientSurname?: string | null, patientTaxCode?: string | null, note?: string | null } | null, workgroup?: { __typename?: 'Workgroup', name: string, address?: { __typename?: 'StructuredAddress', street: string, cityCode: string, districtCode: string, streetNumber?: string | null, cap?: string | null } | null } | null, report?: { __typename?: 'Report', notes?: string | null, description?: string | null, documents?: Array<{ __typename?: 'Document', _id: string, label?: string | null, name: string, category: DocumentCategory, url: string, mimeType: string, createdAt: number, uploadedBy?: { __typename?: 'User', _id: string, fullName: string } | null }> | null } | null, onBehalfOf?: { __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null } | null };

export type ReservationWorkgroupBasicFragment = { __typename?: 'Workgroup', name: string, address?: { __typename?: 'StructuredAddress', street: string, cityCode: string, districtCode: string, streetNumber?: string | null, cap?: string | null } | null };

export type DocumentBasicFragment = { __typename?: 'Document', _id: string, label?: string | null, name: string, category: DocumentCategory, url: string, mimeType: string, createdAt: number, uploadedBy?: { __typename?: 'User', _id: string, fullName: string } | null };

export type AcceptReservationMutationVariables = Exact<{
  reservationId: Scalars['ID']['input'];
}>;


export type AcceptReservationMutationResult = { __typename?: 'Mutation', acceptReservation: { __typename?: 'Reservation', _id: string, status: ReservationStatus, channel: ReservationChannel } };

export type ClinicOwnedByMyselfQueryVariables = Exact<{ [key: string]: never; }>;


export type ClinicOwnedByMyselfQueryResult = { __typename?: 'Query', clinicOwnedByMyself?: { __typename?: 'ClinicGroup', _id: string, name: string, logoUrl?: string | null, ambulatories: Array<{ __typename?: 'Workgroup', description?: string | null, _id: string, name: string, emails: Array<string>, phones: Array<string>, website?: string | null, color: WorkgroupColor, doctorsToShowForSpecialities?: Array<string | null> | null, operators: Array<{ __typename?: 'User', _id: string, name: string, surname: string, fullName: string, avatarUrl?: string | null, sex?: Sex | null, signUpAt?: number | null, taxCode?: string | null, ageGroup?: Array<string | null> | null, biography?: string | null, emails?: Array<string> | null, macroSpeciality?: Array<MacroSpeciality> | null, role: Role, regime: PatientRegime, hasApp: boolean, aslCode?: string | null, birth?: { __typename?: 'Birth', country?: string | null, city?: string | null, date?: number | null } | null, familyDoctor?: { __typename?: 'User', _id: string, fullName: string } | null, phones?: Array<{ __typename?: 'PhoneUser', label: string, phone: string, primary: boolean }> | null, homeAddress?: { __typename?: 'StructuredAddress', default?: boolean | null, cityCode: string, countryCode: string, districtCode: string, street: string, cap?: string | null, streetNumber?: string | null } | null, nationalMedicineBoard?: { __typename?: 'NationalMedicineBoard', registrationNumber?: string | null, place?: string | null } | null, billingAddress?: { __typename?: 'StructuredAddress', cityCode: string } | null }>, openingHours?: Array<{ __typename?: 'OpeningHours', day: DayOfWeek, openhours: Array<{ __typename?: 'OpenFromTo', from: number, to: number }> }> | null, address?: { __typename?: 'StructuredAddress', cap?: string | null, cityCode: string, countryCode: string, districtCode: string, street: string, streetNumber?: string | null } | null }> } | null };

export type MeFieldsFragment = { __typename?: 'User', _id: string, name: string, surname: string, taxCode?: string | null, emails?: Array<string> | null, phones?: Array<{ __typename?: 'PhoneUser', phone: string }> | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQueryResult = { __typename?: 'Query', me: { __typename?: 'User', _id: string, name: string, surname: string, taxCode?: string | null, emails?: Array<string> | null, phones?: Array<{ __typename?: 'PhoneUser', phone: string }> | null } };

export type CompleteReservationDeferredPaymentMutationVariables = Exact<{
  input: CompleteReservationDeferredPaymentInput;
}>;


export type CompleteReservationDeferredPaymentMutationResult = { __typename?: 'Mutation', completeReservationDeferredPayment: { __typename?: 'CompleteReservationDeferredPaymentResult', result: boolean, error?: { __typename?: 'InclinicError', message?: string | null } | null } };

export type GetAmbulatoryByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAmbulatoryByIdQueryResult = { __typename?: 'Query', getAmbulatoryById: { __typename?: 'Workgroup', name: string, cap?: string | null, city?: string | null, cityCode?: string | null, districtCode?: string | null, domiciliaryCare?: boolean | null, doctorsToShowForSpecialities?: Array<string | null> | null, address?: { __typename?: 'StructuredAddress', street: string, cap?: string | null, cityCode: string } | null, clinic?: { __typename?: 'ClinicGroup', name: string, availablePayments?: Array<InclinicPayment> | null } | null } };

export type GetReservationBySecretQueryVariables = Exact<{
  secret: Scalars['String']['input'];
}>;


export type GetReservationBySecretQueryResult = { __typename?: 'Query', getReservationBySecret?: { __typename?: 'Reservation', reservationOrigin?: ReservationOrigin | null, reservationCode?: string | null, reservationSecret?: string | null, startTime?: number | null, workgroupId?: string | null, _id: string, videoSessionId?: string | null, patient: { __typename?: 'User', name: string, surname: string, taxCode?: string | null, emails?: Array<string> | null }, paymentTransactions?: Array<{ __typename?: 'PaymentTransaction', status: PaymentStatus, amount: number, paymentGateway: PaymentGateway } | null> | null, homeVisit?: { __typename?: 'HomeVisit', district?: string | null, city?: string | null, address?: string | null, cap?: string | null } | null, onBehalfOf?: { __typename?: 'User', name: string, surname: string, taxCode?: string | null } | null, specialityTemplate: { __typename?: 'SpecialityTemplateReservation', _id: string }, doctor?: { __typename?: 'User', _id: string, name: string, surname: string } | null } | null };

export type GetSpecialityTemplateByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSpecialityTemplateByIdQueryResult = { __typename?: 'Query', getSpecialityTemplateById: { __typename?: 'SpecialityTemplate', _id: string, standardPrice: number, timeSlot: TimeSlotType, channels: Array<ReservationChannel>, label?: string | null, macroSpeciality: Array<MacroSpeciality> } };

export type CreatePaymentIntentQueryVariables = Exact<{
  specialityTemplateId: Scalars['ID']['input'];
  stripeConnectedId: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  reservationStart?: InputMaybe<Scalars['Timestamp']['input']>;
}>;


export type CreatePaymentIntentQueryResult = { __typename?: 'Query', createPaymentIntent: { __typename?: 'StripeIntentResponse', clientSecret?: string | null, paymentIntent?: string | null } };

export const SpecialityTemplateBasic = gql`
    fragment SpecialityTemplateBasic on SpecialityTemplate {
  _id
  showOnSpecialitiesList
  name
  channels
  macroSpeciality
  duration
  owner
  label
}
    `;
export const SpecialityBasic = gql`
    fragment SpecialityBasic on Speciality {
  _id
  price
  specialityTemplate {
    ...SpecialityTemplateBasic
  }
  duration
  userId
}
    `;
export const BasicStructuredAddress = gql`
    fragment BasicStructuredAddress on StructuredAddress {
  cityCode
  countryCode
  districtCode
  street
  cap
  streetNumber
}
    `;
export const LoggedUserData = gql`
    fragment LoggedUserData on User {
  _id
  fullName
  name
  surname
  phones {
    label
    phone
    primary
  }
  emails
  role
  availabilityNote
  macroSpeciality
  specialities {
    ...SpecialityBasic
  }
  partners {
    _id
    name
    logoUrl
    siteUrl
  }
  iban
  stripeToken
  avatarUrl
  newsletterEnable
  sex
  billingAddress {
    ...BasicStructuredAddress
  }
  officeAddress {
    ...BasicStructuredAddress
  }
  studios {
    _id
    street
    streetNumber
    cityCode
    districtCode
    countryCode
    cap
    label
    phone
    type
  }
  signUpAt
  nationalMedicineBoard {
    registrationNumber
    place
  }
  birth {
    country
    city
    date
  }
  atsName
  aslCode
  regionalCode
  taxCode
  sex
  languageApp
  biography
  vatNumber
  timezone
  avatarUrl
  complete
  stripeAccountVerified
  region
  regime
  prefix
  principalClinic
  hasApp
  welcomeSmsSettings {
    enabled
    autoMessage
  }
  hasWorkgroup
  subscriptionPlanUser {
    _id
    expirationDate
    subscriptionPlan
  }
  healthlineDoctor
  userSettings {
    settings {
      paiMillewinConnected
      telemonitoringCentralEnabled
      connectEnabled
      paiCentralEnabled
      studentVerificationStatus
      nonPayingUser
      prescriptionsRequestsEnabled
      drugInteractionsEnabled
      stampDisabled
    }
    specialitySettings {
      favoriteInPresenceSpeciality
      favoriteOnlineSpeciality
    }
  }
}
    `;
export const UserAdmin = gql`
    fragment UserAdmin on User {
  _id
  role
  fullName
  name
  surname
  avatarUrl
  phones {
    label
    phone
    primary
  }
  emails
  signUpAt
  nationalMedicineBoard {
    registrationNumber
    place
  }
  macroSpeciality
  atsName
  aslCode
  regionalCode
  region
  userSettings {
    settings {
      paiMillewinConnected
      telemonitoringCentralEnabled
      connectEnabled
      paiCentralEnabled
      studentVerificationStatus
      nonPayingUser
    }
    chatSettings {
      enabled
      autoMessage
    }
  }
  regime
  hasApp
  subscriptionPlanUser {
    _id
    expirationDate
    subscriptionPlan
    activationDate
  }
  healthlineDoctor
  taxCode
}
    `;
export const UserBasicInWorkgroupsForAdmin = gql`
    fragment UserBasicInWorkgroupsForAdmin on User {
  _id
  name
  surname
  fullName
  avatarUrl
  role
  regime
  hasApp
}
    `;
export const WorkgroupsForAdminBasic = gql`
    fragment WorkgroupsForAdminBasic on Workgroup {
  _id
  name
  description
  color
  clinic {
    _id
    name
  }
  address {
    ...BasicStructuredAddress
  }
  phone
  operators {
    ...UserBasicInWorkgroupsForAdmin
  }
  website
  emails
  phones
  inclinicSlug
}
    `;
export const WorkgroupBasic = gql`
    fragment WorkgroupBasic on Workgroup {
  _id
  address {
    street
    cap
    cityCode
    districtCode
  }
  name
  phones
  color
}
    `;
export const UserBasic = gql`
    fragment UserBasic on User {
  _id
  name
  surname
  fullName
  avatarUrl
  sex
  birth {
    country
    city
    date
  }
  signUpAt
  taxCode
  ageGroup
  biography
  familyDoctor {
    _id
    fullName
  }
  phones {
    label
    phone
    primary
  }
  homeAddress {
    ...BasicStructuredAddress
    default
  }
  nationalMedicineBoard {
    registrationNumber
    place
  }
  emails
  macroSpeciality
  role
  regime
  hasApp
  billingAddress {
    cityCode
  }
  aslCode
}
    `;
export const ReservationExtended = gql`
    fragment ReservationExtended on Reservation {
  _id
  reservationOrigin
  status
  doctor {
    ...UserBasic
  }
  patient {
    ...UserBasic
  }
  specialityTemplate {
    _id
    name
    actionToClose
    label
  }
  startTime
  channel
  description
  price
  duration
  owner {
    _id
    role
  }
  additionalInformation {
    patientName
    patientSurname
    patientBirth
    patientBirthCity
    patientBirthDistrict
    patientSex
    patientTaxCode
    chronicPatient
    createRelationshipWithDoctor {
      ...UserBasic
    }
    note
  }
  videoSessionId
  duration
  report {
    notes
    description
  }
  createdAt
  viewers
  workgroupId
  onBehalfOf {
    ...UserBasic
  }
  phone
}
    `;
export const ReservationWorkgroupBasic = gql`
    fragment ReservationWorkgroupBasic on Workgroup {
  name
  address {
    street
    cityCode
    districtCode
    streetNumber
    cap
  }
}
    `;
export const DocumentBasic = gql`
    fragment DocumentBasic on Document {
  _id
  label
  name
  category
  url
  mimeType
  uploadedBy {
    _id
    fullName
  }
  createdAt
}
    `;
export const MyReservationsQueryBasic = gql`
    fragment MyReservationsQueryBasic on Reservation {
  _id
  reservationOrigin
  status
  patient {
    ...UserBasic
  }
  specialityTemplate {
    _id
    name
    actionToClose
    label
  }
  startTime
  channel
  description
  price
  duration
  owner {
    _id
    role
  }
  additionalInformation {
    patientName
    patientSurname
    patientTaxCode
    note
  }
  viewers
  workgroupId
  workgroup {
    ...ReservationWorkgroupBasic
  }
  report {
    notes
    description
    documents {
      ...DocumentBasic
    }
  }
  createdAt
  onBehalfOf {
    ...UserBasic
  }
  phone
}
    `;
export const MeFields = gql`
    fragment MeFields on User {
  _id
  name
  surname
  taxCode
  emails
  phones {
    phone
  }
}
    `;
export const Login = gql`
    query login($username: Username!, $password: String!) {
  login(username: $username, password: $password) {
    token
    tokenExpiration
    user {
      ...LoggedUserData
    }
    auth {
      verified
      _id
    }
  }
}
    ${LoggedUserData}
${SpecialityBasic}
${SpecialityTemplateBasic}
${BasicStructuredAddress}`;
export const UserExists = gql`
    query userExists($taxCode: String!) {
  userExists(taxCode: $taxCode) {
    _id
    name
    surname
  }
}
    `;
export const DeleteUserAdmin = gql`
    mutation deleteUserAdmin($id: ID!) {
  deleteUserAdmin(id: $id) {
    _id
  }
}
    `;
export const CreateUser = gql`
    mutation createUser($name: String!, $surname: String!, $taxCode: String!, $role: Role!, $birthDate: Timestamp, $region: Region!, $macroSpeciality: MacroSpeciality) {
  createUser(
    name: $name
    surname: $surname
    taxCode: $taxCode
    role: $role
    birthDate: $birthDate
    region: $region
    macroSpeciality: $macroSpeciality
  ) {
    _id
    name
    surname
  }
}
    `;
export const DeleteClinicGroup = gql`
    mutation deleteClinicGroup($clinicGroupId: ID!) {
  deleteClinicGroup(clinicGroupId: $clinicGroupId) {
    _id
  }
}
    `;
export const UsersForAdmin = gql`
    query usersForAdmin($roles: [Role!]!, $partnersIds: [ID!], $input: ComplexQueryInput!) {
  usersForAdmin(roles: $roles, partnersIds: $partnersIds, input: $input) {
    pageInfo {
      count
    }
    nodes {
      ...UserAdmin
    }
  }
}
    ${UserAdmin}`;
export const Me = gql`
    query me {
  me {
    ...LoggedUserData
  }
}
    ${LoggedUserData}
${SpecialityBasic}
${SpecialityTemplateBasic}
${BasicStructuredAddress}`;
export const ClinicsForAdmin = gql`
    query clinicsForAdmin($input: ComplexQueryInput!) {
  clinicsForAdmin(input: $input) {
    _id
    name
    owners {
      ...UserAdmin
    }
    type
    availablePayments
    ambulatories {
      _id
      name
    }
  }
}
    ${UserAdmin}`;
export const CreateClinicWorkgroup = gql`
    mutation createClinicWorkgroup($workgroup: CreateClinicWorkgroupInput!) {
  createClinicWorkgroup(workgroup: $workgroup) {
    _id
  }
}
    `;
export const DeleteWorkgroup = gql`
    mutation deleteWorkgroup($workgroupID: String!) {
  deleteWorkgroup(workgroupID: $workgroupID) {
    _id
    name
  }
}
    `;
export const WorkgroupsForAdmin = gql`
    query workgroupsForAdmin($input: ComplexQueryInput!) {
  workgroupsForAdmin(input: $input) {
    nodes {
      ...WorkgroupsForAdminBasic
    }
    pageInfo {
      count
      currentPage
    }
  }
}
    ${WorkgroupsForAdminBasic}
${BasicStructuredAddress}
${UserBasicInWorkgroupsForAdmin}`;
export const SignupV2 = gql`
    mutation signupV2($username: Username!, $name: String!, $surname: String!, $password: String, $nationalMedicineBoardNumber: String, $nationalMedicineBoardPlace: String, $ats: ID, $officeAddress: StructuredAddressInput, $partner: String, $macroSpeciality: MacroSpeciality, $phone: PhoneNumber, $role: Role!, $birthCity: String, $taxCode: String!, $newsletterEnable: Boolean, $privacyPartner: Boolean, $privacyDavinci: Boolean, $region: Region!) {
  signupV2(
    username: $username
    name: $name
    surname: $surname
    password: $password
    phone: $phone
    role: $role
    nationalMedicineBoardNumber: $nationalMedicineBoardNumber
    nationalMedicineBoardPlace: $nationalMedicineBoardPlace
    ats: $ats
    officeAddress: $officeAddress
    partner: $partner
    macroSpeciality: $macroSpeciality
    birthCity: $birthCity
    taxCode: $taxCode
    newsletterEnable: $newsletterEnable
    privacyPartner: $privacyPartner
    privacyDavinci: $privacyDavinci
    region: $region
  ) {
    user {
      ...LoggedUserData
    }
    token
    tokenExpiration
    auth {
      verified
    }
  }
}
    ${LoggedUserData}
${SpecialityBasic}
${SpecialityTemplateBasic}
${BasicStructuredAddress}`;
export const CreateOrUpdateSpeciality = gql`
    mutation createOrUpdateSpeciality($input: CreateSpecialityInput!, $doctorId: ID) {
  createOrUpdateSpeciality(input: $input, doctorId: $doctorId) {
    ...SpecialityBasic
  }
}
    ${SpecialityBasic}
${SpecialityTemplateBasic}`;
export const AddAvailability = gql`
    mutation addAvailability($doctorId: ID, $newSlot: SlotInput!, $recurringWeeks: Int, $allSpecialityTemplates: Boolean, $specialityTemplates: [ID!], $isAvailableToMyPatient: Boolean!, $isAvailableToWorkgroupPatient: Boolean, $workgroup: ID, $alternateWeeks: Boolean!) {
  addAvailability(
    doctorId: $doctorId
    isAvailableToMyPatient: $isAvailableToMyPatient
    isAvailableToWorkgroupPatient: $isAvailableToWorkgroupPatient
    newSlot: $newSlot
    recurringWeeks: $recurringWeeks
    allSpecialityTemplates: $allSpecialityTemplates
    specialityTemplates: $specialityTemplates
    workgroup: $workgroup
    alternateWeeks: $alternateWeeks
  ) {
    start
    end
    duration
    recurringId
    specialityTemplates {
      ...SpecialityTemplateBasic
    }
    allSpecialityTemplates
    isAvailableToMyPatient
    isAvailableToWorkgroupPatient
    workgroup {
      ...WorkgroupBasic
    }
  }
}
    ${SpecialityTemplateBasic}
${WorkgroupBasic}`;
export const CreateClinicGroup = gql`
    mutation createClinicGroup($clinicGroup: AddClinicGroupInput!) {
  createClinicGroup(clinicGroup: $clinicGroup) {
    _id
  }
}
    `;
export const AddPatient = gql`
    mutation addPatient($phones: [PhonesInput!], $emails: [EmailAddress!], $name: String!, $surname: String!, $taxCode: TaxCode, $regime: PatientRegime!, $homeAddress: StructuredAddressInput, $sex: Sex, $listName: RelationshipPatientList, $isFamilyDoctor: Boolean, $welcomeSmsSettings: WelcomeSmsSettingsInput, $numIdentPers: String, $foreignAndSeafarinOptions: ForeignAndSeafarinInput, $doctorId: ID) {
  addPatient(
    phones: $phones
    emails: $emails
    name: $name
    surname: $surname
    taxCode: $taxCode
    regime: $regime
    homeAddress: $homeAddress
    sex: $sex
    listName: $listName
    isFamilyDoctor: $isFamilyDoctor
    welcomeSmsSettings: $welcomeSmsSettings
    numIdentPers: $numIdentPers
    foreignAndSeafarinOptions: $foreignAndSeafarinOptions
    doctorId: $doctorId
  ) {
    ...UserBasic
  }
}
    ${UserBasic}
${BasicStructuredAddress}`;
export const BookReservation = gql`
    mutation bookReservation($patientId: ID!, $doctorId: ID, $startTime: Timestamp, $duration: UnsignedInt, $channel: ReservationChannel!, $description: String, $specialityTemplateId: ID!, $billingName: String, $billingSurname: String, $billingTaxCode: String, $billingAddress: String, $billingCap: String, $billingCity: String, $billingDistrict: String, $billingCountry: String, $price: UnsignedInt!, $note: String, $chronicPatient: Boolean, $patientBirth: Timestamp, $patientName: String, $patientSurname: String, $patientBirthCity: String, $patientBirthDistrict: String, $patientSex: Sex, $createRelationshipWithDoctor: ID, $patientTaxCode: String, $coupon: String, $viewers: [ID!], $workgroupId: ID) {
  bookReservationV2(
    patientId: $patientId
    doctorId: $doctorId
    startTime: $startTime
    duration: $duration
    channel: $channel
    description: $description
    specialityTemplateId: $specialityTemplateId
    billingName: $billingName
    billingSurname: $billingSurname
    billingTaxCode: $billingTaxCode
    billingAddress: $billingAddress
    billingCap: $billingCap
    billingCity: $billingCity
    billingDistrict: $billingDistrict
    billingCountry: $billingCountry
    price: $price
    note: $note
    chronicPatient: $chronicPatient
    patientBirth: $patientBirth
    patientName: $patientName
    patientSurname: $patientSurname
    patientBirthCity: $patientBirthCity
    patientBirthDistrict: $patientBirthDistrict
    patientSex: $patientSex
    createRelationshipWithDoctor: $createRelationshipWithDoctor
    patientTaxCode: $patientTaxCode
    coupon: $coupon
    viewers: $viewers
    workgroupId: $workgroupId
  ) {
    reservation {
      ...ReservationExtended
    }
    paymentTransaction {
      _id
      status
      token
      amount
      redirectUrl
      paymentGateway
    }
  }
}
    ${ReservationExtended}
${UserBasic}
${BasicStructuredAddress}`;
export const MyReservations = gql`
    query myReservations($doctorId: ID, $input: ComplexQueryInput!, $type: ReservationType!, $startDate: Timestamp, $endDate: Timestamp, $specialityTemplateId: ID) {
  myReservationsV2(
    doctorId: $doctorId
    input: $input
    type: $type
    startDate: $startDate
    endDate: $endDate
    specialityTemplateId: $specialityTemplateId
  ) {
    nodes {
      ...MyReservationsQueryBasic
    }
    pageInfo {
      count
      currentPage
    }
  }
}
    ${MyReservationsQueryBasic}
${UserBasic}
${BasicStructuredAddress}
${ReservationWorkgroupBasic}
${DocumentBasic}`;
export const AcceptReservation = gql`
    mutation acceptReservation($reservationId: ID!) {
  acceptReservation(reservationId: $reservationId) {
    _id
    status
    channel
  }
}
    `;
export const ClinicOwnedByMyself = gql`
    query clinicOwnedByMyself {
  clinicOwnedByMyself {
    _id
    name
    logoUrl
    ambulatories {
      description
      _id
      name
      operators {
        ...UserBasic
      }
      emails
      phones
      website
      openingHours {
        day
        openhours {
          from
          to
        }
      }
      color
      address {
        cap
        cityCode
        countryCode
        districtCode
        street
        streetNumber
      }
      doctorsToShowForSpecialities
    }
  }
}
    ${UserBasic}
${BasicStructuredAddress}`;
export const GetMe = gql`
    query GetMe {
  me {
    ...MeFields
  }
}
    ${MeFields}`;
export const CompleteReservationDeferredPayment = gql`
    mutation CompleteReservationDeferredPayment($input: CompleteReservationDeferredPaymentInput!) {
  completeReservationDeferredPayment(input: $input) {
    result
    error {
      message
    }
  }
}
    `;
export const GetAmbulatoryById = gql`
    query GetAmbulatoryById($id: ID!) {
  getAmbulatoryById(id: $id) {
    name
    address {
      street
      cap
      cityCode
    }
    cap
    city
    cityCode
    districtCode
    clinic {
      name
      availablePayments
    }
    domiciliaryCare
    doctorsToShowForSpecialities
  }
}
    `;
export const GetReservationBySecret = gql`
    query GetReservationBySecret($secret: String!) {
  getReservationBySecret(secret: $secret) {
    reservationOrigin
    reservationCode
    reservationSecret
    startTime
    patient {
      name
      surname
      taxCode
      emails
    }
    paymentTransactions {
      status
      amount
      paymentGateway
    }
    homeVisit {
      district
      city
      address
      cap
    }
    onBehalfOf {
      name
      surname
      taxCode
    }
    workgroupId
    specialityTemplate {
      _id
    }
    doctor {
      _id
      name
      surname
    }
    _id
    videoSessionId
  }
}
    `;
export const GetSpecialityTemplateById = gql`
    query GetSpecialityTemplateById($id: ID!) {
  getSpecialityTemplateById(id: $id) {
    _id
    standardPrice
    timeSlot
    channels
    label
    macroSpeciality
  }
}
    `;
export const CreatePaymentIntent = gql`
    query createPaymentIntent($specialityTemplateId: ID!, $stripeConnectedId: String!, $couponCode: String, $userName: String, $reservationStart: Timestamp) {
  createPaymentIntent(
    specialityTemplateId: $specialityTemplateId
    stripeConnectedId: $stripeConnectedId
    couponCode: $couponCode
    userName: $userName
    reservationStart: $reservationStart
  ) {
    clientSecret
    paymentIntent
  }
}
    `;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AcceptedRelatedObjectTypes": [
      "DataExportRequest",
      "DiaryMonitoring",
      "DrugReservation",
      "NullableNodeType",
      "Relationship",
      "Reservation",
      "User",
      "UserbackFeedback"
    ],
    "AmbulatoryTestCategory": [
      "CovidTestCategory"
    ],
    "AmbulatoryTestStatus": [
      "CovidTestStatus"
    ],
    "BasicPrescription": [
      "DrugsPrescription",
      "FreePrescription",
      "HospitalizationPrescription",
      "OutpatientServicesPrescription",
      "TransportPrescription"
    ],
    "ComplexQueryReturn": [
      "AmbulatoryTestsResult",
      "AnamnesesResult",
      "AssistedUsersReturn",
      "AuthLogsReturn",
      "AuthUsersReturn",
      "AuthenticationsReturn",
      "BlacklistEntriesResult",
      "ChatMessageReturn",
      "CommunicationsResult",
      "CronJobs",
      "DataExportRequests",
      "DataImportRequests",
      "DiseasesReturn",
      "DocumentsResult",
      "DrugReservationsResult",
      "DrugstoresResult",
      "GetInvoicesReturn",
      "HospitalAdmissionFormsResult",
      "LifestyleInformationsResult",
      "MeasurementsResult",
      "MedicalReportsReturn",
      "MedicalReportsV2Return",
      "MyChatsV2Result",
      "MyPaisReturn",
      "MyPatientsResult",
      "MyTagsResult",
      "NpsFeedbacksResult",
      "OutpatientServiceParameterReturn",
      "OutpatientServicesReturn",
      "PaiPatientsResult",
      "PatientCertificatesResult",
      "PatientSummariesResult",
      "RegionalAddressesResult",
      "RelationshipsResult",
      "ReservationsResult",
      "SissValuesResult",
      "UsersResult",
      "VaccinationsResult",
      "WorkgroupResult",
      "WorkgroupsResult"
    ],
    "ConflictingInvoice": [
      "Invoice",
      "InvoiceOnlyId"
    ],
    "DataExportRequestResult": [
      "DataExportRequestResultError",
      "DataExportRequestResultProcessing",
      "DataExportRequestResultSuccess"
    ],
    "Node": [
      "AllergiesParam",
      "AmbulatoryTest",
      "Anamnesis",
      "AppleEcgParam",
      "AssistedUser",
      "AssistedUserDashboard",
      "AuthLog",
      "Authentication",
      "AuthenticationDashboard",
      "BlacklistEntry",
      "BooleanParam",
      "CalendarEvent",
      "CeliacDiseaseIssuesArrayParam",
      "Certificate",
      "CertificateTemplate",
      "Chat",
      "ChatMessage",
      "Communication",
      "Coupon",
      "CronJob",
      "DataExportRequest",
      "DataImportRequest",
      "DataMigration",
      "DeviceParam",
      "Diary",
      "DiaryLog",
      "DiaryMonitoring",
      "DoctorAvailabilities",
      "Document",
      "DrugReservation",
      "DrugsParam",
      "DrugsPrescription",
      "DrugsRequest",
      "Drugstore",
      "ExemptionsParam",
      "FertilityParam",
      "FreeDrugsRequest",
      "FreePrescription",
      "FreeServicesRequest",
      "FreenetAuthProvider",
      "FreenetAuthUser",
      "HospitalAdmissionForm",
      "HospitalizationPrescription",
      "IntolerancesArrayParam",
      "LastUserAccessInfo",
      "Lead",
      "LifestyleInformation",
      "Measurement",
      "MedicalInstruction",
      "MedicalReport",
      "MedicalReportV2",
      "MethodologiesParam",
      "MoriskyScaleParam",
      "MotorCapacityParam",
      "Notification",
      "NpsFeedback",
      "NullableNodeType",
      "NumberParam",
      "OutpatientService",
      "OutpatientServiceGroup",
      "OutpatientServiceOutcome",
      "OutpatientServiceParameter",
      "OutpatientServicesParam",
      "OutpatientServicesPrescription",
      "Owner",
      "Pai",
      "PaiOutpatientService",
      "Partner",
      "PartnerCode",
      "PatientMedicalDevice",
      "PatientProblem",
      "PatientSummary",
      "PaymentTransaction",
      "PregnanciesParam",
      "PrescriptionReservation",
      "ProfessionsParam",
      "ProsthesisParam",
      "PublicUser",
      "QuickAnswer",
      "RegionalAddress",
      "Relationship",
      "Relative",
      "Reservation",
      "ServicesRequest",
      "SignupRequest",
      "SissValue",
      "SpecialityTemplate",
      "SpecialityTemplateReservation",
      "SpecializationDoctor",
      "StringArrayParam",
      "StringParam",
      "StringPlusDateArrayParam",
      "StringPlusNumberArrayParam",
      "SubscriptionPlanUser",
      "SurgicalProceduresParam",
      "Tag",
      "TherapeuticPlan",
      "TransportPrescription",
      "User",
      "UserBasic",
      "UserFeatureState",
      "UserLocation",
      "UserSettings",
      "Vaccination",
      "VaccinationsParam",
      "VideocallLog",
      "Workgroup"
    ],
    "PatientRequestInstance": [
      "DrugsRequest",
      "FreeDrugsRequest",
      "FreeServicesRequest",
      "ServicesRequest"
    ],
    "PatientRequestInterface": [
      "DrugsRequest",
      "FreeDrugsRequest",
      "FreeServicesRequest",
      "ServicesRequest"
    ],
    "Prescription": [
      "DrugsPrescription",
      "FreePrescription",
      "HospitalizationPrescription",
      "OutpatientServicesPrescription",
      "TransportPrescription"
    ],
    "RequestParamsType": [
      "TherapeuticPlanAifa97Evaluation",
      "TherapeuticPlanAifa97FollowUp",
      "TherapeuticPlanAifa100Evaluation",
      "TherapeuticPlanAifa100FollowUp",
      "TherapeuticPlanPaxlovid"
    ],
    "SelectedParamBase": [
      "SelectedAllergy",
      "SelectedCeliacDiseaseIssue",
      "SelectedDrug",
      "SelectedExemption",
      "SelectedIntolerance",
      "SelectedMedicalDevice",
      "SelectedMissingOrgan",
      "SelectedMotorCapacity",
      "SelectedPregnancy",
      "SelectedProblem",
      "SelectedProfession",
      "SelectedProsthesis",
      "SelectedService",
      "SelectedStringParam",
      "SelectedSurgicalProcedure",
      "SelectedTransplant"
    ],
    "UserParam": [
      "AllergiesParam",
      "AppleEcgParam",
      "BooleanParam",
      "CeliacDiseaseIssuesArrayParam",
      "DeviceParam",
      "DrugsParam",
      "ExemptionsParam",
      "FertilityParam",
      "IntolerancesArrayParam",
      "MethodologiesParam",
      "MoriskyScaleParam",
      "MotorCapacityParam",
      "NumberParam",
      "OutpatientServicesParam",
      "PregnanciesParam",
      "ProfessionsParam",
      "ProsthesisParam",
      "StringArrayParam",
      "StringParam",
      "StringPlusDateArrayParam",
      "StringPlusNumberArrayParam",
      "SurgicalProceduresParam",
      "VaccinationsParam"
    ],
    "UserParamInterface": [
      "AllergiesParam",
      "AppleEcgParam",
      "BooleanParam",
      "CeliacDiseaseIssuesArrayParam",
      "DeviceParam",
      "DrugsParam",
      "ExemptionsParam",
      "FertilityParam",
      "IntolerancesArrayParam",
      "MethodologiesParam",
      "MoriskyScaleParam",
      "MotorCapacityParam",
      "NumberParam",
      "OutpatientServicesParam",
      "PregnanciesParam",
      "ProfessionsParam",
      "ProsthesisParam",
      "StringArrayParam",
      "StringParam",
      "StringPlusDateArrayParam",
      "StringPlusNumberArrayParam",
      "SurgicalProceduresParam",
      "VaccinationsParam"
    ]
  }
};
      export default result;
    
export const SpecialityTemplateBasicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityTemplateBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialityTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnSpecialitiesList"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]} as unknown as DocumentNode<SpecialityTemplateBasicFragment, unknown>;
export const SpecialityBasicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Speciality"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"specialityTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpecialityTemplateBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityTemplateBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialityTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnSpecialitiesList"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]} as unknown as DocumentNode<SpecialityBasicFragment, unknown>;
export const BasicStructuredAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}}]} as unknown as DocumentNode<BasicStructuredAddressFragment, unknown>;
export const LoggedUserDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoggedUserData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityNote"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"specialities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpecialityBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"siteUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"stripeToken"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterEnable"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"officeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"atsName"}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}},{"kind":"Field","name":{"kind":"Name","value":"regionalCode"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"languageApp"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"complete"}},{"kind":"Field","name":{"kind":"Name","value":"stripeAccountVerified"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"principalClinic"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeSmsSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoMessage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkgroup"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlanUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthlineDoctor"}},{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paiMillewinConnected"}},{"kind":"Field","name":{"kind":"Name","value":"telemonitoringCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"connectEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"paiCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"studentVerificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"nonPayingUser"}},{"kind":"Field","name":{"kind":"Name","value":"prescriptionsRequestsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"drugInteractionsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"stampDisabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialitySettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoriteInPresenceSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteOnlineSpeciality"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityTemplateBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialityTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnSpecialitiesList"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Speciality"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"specialityTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpecialityTemplateBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}}]} as unknown as DocumentNode<LoggedUserDataFragment, unknown>;
export const UserAdminFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAdmin"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"atsName"}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}},{"kind":"Field","name":{"kind":"Name","value":"regionalCode"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paiMillewinConnected"}},{"kind":"Field","name":{"kind":"Name","value":"telemonitoringCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"connectEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"paiCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"studentVerificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"nonPayingUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chatSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoMessage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlanUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}},{"kind":"Field","name":{"kind":"Name","value":"activationDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthlineDoctor"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}}]}}]} as unknown as DocumentNode<UserAdminFragment, unknown>;
export const UserBasicInWorkgroupsForAdminFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBasicInWorkgroupsForAdmin"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}}]}}]} as unknown as DocumentNode<UserBasicInWorkgroupsForAdminFragment, unknown>;
export const WorkgroupsForAdminBasicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkgroupsForAdminBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workgroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"clinic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"operators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasicInWorkgroupsForAdmin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"phones"}},{"kind":"Field","name":{"kind":"Name","value":"inclinicSlug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBasicInWorkgroupsForAdmin"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}}]}}]} as unknown as DocumentNode<WorkgroupsForAdminBasicFragment, unknown>;
export const WorkgroupBasicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkgroupBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workgroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phones"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<WorkgroupBasicFragment, unknown>;
export const UserBasicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"familyDoctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}}]} as unknown as DocumentNode<UserBasicFragment, unknown>;
export const ReservationExtendedFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservationExtended"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reservation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"doctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialityTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"actionToClose"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"patientSurname"}},{"kind":"Field","name":{"kind":"Name","value":"patientBirth"}},{"kind":"Field","name":{"kind":"Name","value":"patientBirthCity"}},{"kind":"Field","name":{"kind":"Name","value":"patientBirthDistrict"}},{"kind":"Field","name":{"kind":"Name","value":"patientSex"}},{"kind":"Field","name":{"kind":"Name","value":"patientTaxCode"}},{"kind":"Field","name":{"kind":"Name","value":"chronicPatient"}},{"kind":"Field","name":{"kind":"Name","value":"createRelationshipWithDoctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"viewers"}},{"kind":"Field","name":{"kind":"Name","value":"workgroupId"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"familyDoctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}}]}}]} as unknown as DocumentNode<ReservationExtendedFragment, unknown>;
export const ReservationWorkgroupBasicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservationWorkgroupBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workgroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}}]}}]}}]} as unknown as DocumentNode<ReservationWorkgroupBasicFragment, unknown>;
export const DocumentBasicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<DocumentBasicFragment, unknown>;
export const MyReservationsQueryBasicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyReservationsQueryBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reservation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialityTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"actionToClose"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"patientSurname"}},{"kind":"Field","name":{"kind":"Name","value":"patientTaxCode"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewers"}},{"kind":"Field","name":{"kind":"Name","value":"workgroupId"}},{"kind":"Field","name":{"kind":"Name","value":"workgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReservationWorkgroupBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentBasic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"familyDoctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservationWorkgroupBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workgroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<MyReservationsQueryBasicFragment, unknown>;
export const MeFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]} as unknown as DocumentNode<MeFieldsFragment, unknown>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Username"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"tokenExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoggedUserData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"auth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityTemplateBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialityTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnSpecialitiesList"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Speciality"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"specialityTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpecialityTemplateBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoggedUserData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityNote"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"specialities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpecialityBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"siteUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"stripeToken"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterEnable"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"officeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"atsName"}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}},{"kind":"Field","name":{"kind":"Name","value":"regionalCode"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"languageApp"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"complete"}},{"kind":"Field","name":{"kind":"Name","value":"stripeAccountVerified"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"principalClinic"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeSmsSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoMessage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkgroup"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlanUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthlineDoctor"}},{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paiMillewinConnected"}},{"kind":"Field","name":{"kind":"Name","value":"telemonitoringCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"connectEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"paiCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"studentVerificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"nonPayingUser"}},{"kind":"Field","name":{"kind":"Name","value":"prescriptionsRequestsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"drugInteractionsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"stampDisabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialitySettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoriteInPresenceSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteOnlineSpeciality"}}]}}]}}]}}]} as unknown as DocumentNode<LoginQueryResult, LoginQueryVariables>;
export const UserExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taxCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userExists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taxCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taxCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}}]}}]}}]} as unknown as DocumentNode<UserExistsQueryResult, UserExistsQueryVariables>;
export const DeleteUserAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteUserAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<DeleteUserAdminMutationResult, DeleteUserAdminMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taxCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"birthDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Timestamp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"region"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Region"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"macroSpeciality"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MacroSpeciality"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"surname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surname"}}},{"kind":"Argument","name":{"kind":"Name","value":"taxCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taxCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}},{"kind":"Argument","name":{"kind":"Name","value":"birthDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"birthDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"region"},"value":{"kind":"Variable","name":{"kind":"Name","value":"region"}}},{"kind":"Argument","name":{"kind":"Name","value":"macroSpeciality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"macroSpeciality"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutationResult, CreateUserMutationVariables>;
export const DeleteClinicGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteClinicGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clinicGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteClinicGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clinicGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<DeleteClinicGroupMutationResult, DeleteClinicGroupMutationVariables>;
export const UsersForAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersForAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roles"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnersIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ComplexQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersForAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"roles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roles"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnersIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnersIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAdmin"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAdmin"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"atsName"}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}},{"kind":"Field","name":{"kind":"Name","value":"regionalCode"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paiMillewinConnected"}},{"kind":"Field","name":{"kind":"Name","value":"telemonitoringCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"connectEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"paiCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"studentVerificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"nonPayingUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chatSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoMessage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlanUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}},{"kind":"Field","name":{"kind":"Name","value":"activationDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthlineDoctor"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}}]}}]} as unknown as DocumentNode<UsersForAdminQueryResult, UsersForAdminQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoggedUserData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityTemplateBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialityTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnSpecialitiesList"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Speciality"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"specialityTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpecialityTemplateBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoggedUserData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityNote"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"specialities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpecialityBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"siteUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"stripeToken"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterEnable"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"officeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"atsName"}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}},{"kind":"Field","name":{"kind":"Name","value":"regionalCode"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"languageApp"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"complete"}},{"kind":"Field","name":{"kind":"Name","value":"stripeAccountVerified"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"principalClinic"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeSmsSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoMessage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkgroup"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlanUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthlineDoctor"}},{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paiMillewinConnected"}},{"kind":"Field","name":{"kind":"Name","value":"telemonitoringCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"connectEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"paiCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"studentVerificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"nonPayingUser"}},{"kind":"Field","name":{"kind":"Name","value":"prescriptionsRequestsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"drugInteractionsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"stampDisabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialitySettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoriteInPresenceSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteOnlineSpeciality"}}]}}]}}]}}]} as unknown as DocumentNode<MeQueryResult, MeQueryVariables>;
export const ClinicsForAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clinicsForAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ComplexQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clinicsForAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAdmin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"availablePayments"}},{"kind":"Field","name":{"kind":"Name","value":"ambulatories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAdmin"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"atsName"}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}},{"kind":"Field","name":{"kind":"Name","value":"regionalCode"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paiMillewinConnected"}},{"kind":"Field","name":{"kind":"Name","value":"telemonitoringCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"connectEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"paiCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"studentVerificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"nonPayingUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chatSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoMessage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlanUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}},{"kind":"Field","name":{"kind":"Name","value":"activationDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthlineDoctor"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}}]}}]} as unknown as DocumentNode<ClinicsForAdminQueryResult, ClinicsForAdminQueryVariables>;
export const CreateClinicWorkgroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createClinicWorkgroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workgroup"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateClinicWorkgroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createClinicWorkgroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workgroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workgroup"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<CreateClinicWorkgroupMutationResult, CreateClinicWorkgroupMutationVariables>;
export const DeleteWorkgroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteWorkgroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workgroupID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteWorkgroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workgroupID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workgroupID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteWorkgroupMutationResult, DeleteWorkgroupMutationVariables>;
export const WorkgroupsForAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"workgroupsForAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ComplexQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workgroupsForAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkgroupsForAdminBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBasicInWorkgroupsForAdmin"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkgroupsForAdminBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workgroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"clinic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"operators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasicInWorkgroupsForAdmin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"phones"}},{"kind":"Field","name":{"kind":"Name","value":"inclinicSlug"}}]}}]} as unknown as DocumentNode<WorkgroupsForAdminQueryResult, WorkgroupsForAdminQueryVariables>;
export const SignupV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"signupV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Username"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nationalMedicineBoardNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nationalMedicineBoardPlace"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ats"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"officeAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddressInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partner"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"macroSpeciality"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MacroSpeciality"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneNumber"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"birthCity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taxCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsletterEnable"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"privacyPartner"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"privacyDavinci"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"region"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Region"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signupV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"surname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surname"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}},{"kind":"Argument","name":{"kind":"Name","value":"nationalMedicineBoardNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nationalMedicineBoardNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"nationalMedicineBoardPlace"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nationalMedicineBoardPlace"}}},{"kind":"Argument","name":{"kind":"Name","value":"ats"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ats"}}},{"kind":"Argument","name":{"kind":"Name","value":"officeAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"officeAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"partner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partner"}}},{"kind":"Argument","name":{"kind":"Name","value":"macroSpeciality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"macroSpeciality"}}},{"kind":"Argument","name":{"kind":"Name","value":"birthCity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"birthCity"}}},{"kind":"Argument","name":{"kind":"Name","value":"taxCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taxCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsletterEnable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsletterEnable"}}},{"kind":"Argument","name":{"kind":"Name","value":"privacyPartner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"privacyPartner"}}},{"kind":"Argument","name":{"kind":"Name","value":"privacyDavinci"},"value":{"kind":"Variable","name":{"kind":"Name","value":"privacyDavinci"}}},{"kind":"Argument","name":{"kind":"Name","value":"region"},"value":{"kind":"Variable","name":{"kind":"Name","value":"region"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoggedUserData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"tokenExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"auth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityTemplateBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialityTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnSpecialitiesList"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Speciality"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"specialityTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpecialityTemplateBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoggedUserData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityNote"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"specialities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpecialityBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"siteUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"stripeToken"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterEnable"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"officeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"atsName"}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}},{"kind":"Field","name":{"kind":"Name","value":"regionalCode"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"languageApp"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"complete"}},{"kind":"Field","name":{"kind":"Name","value":"stripeAccountVerified"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"principalClinic"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeSmsSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"autoMessage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkgroup"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlanUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthlineDoctor"}},{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paiMillewinConnected"}},{"kind":"Field","name":{"kind":"Name","value":"telemonitoringCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"connectEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"paiCentralEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"studentVerificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"nonPayingUser"}},{"kind":"Field","name":{"kind":"Name","value":"prescriptionsRequestsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"drugInteractionsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"stampDisabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialitySettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoriteInPresenceSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteOnlineSpeciality"}}]}}]}}]}}]} as unknown as DocumentNode<SignupV2MutationResult, SignupV2MutationVariables>;
export const CreateOrUpdateSpecialityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOrUpdateSpeciality"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSpecialityInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrUpdateSpeciality"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"doctorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpecialityBasic"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityTemplateBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialityTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnSpecialitiesList"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Speciality"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"specialityTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpecialityTemplateBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]} as unknown as DocumentNode<CreateOrUpdateSpecialityMutationResult, CreateOrUpdateSpecialityMutationVariables>;
export const AddAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newSlot"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SlotInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recurringWeeks"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allSpecialityTemplates"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"specialityTemplates"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isAvailableToMyPatient"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isAvailableToWorkgroupPatient"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workgroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alternateWeeks"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"doctorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isAvailableToMyPatient"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isAvailableToMyPatient"}}},{"kind":"Argument","name":{"kind":"Name","value":"isAvailableToWorkgroupPatient"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isAvailableToWorkgroupPatient"}}},{"kind":"Argument","name":{"kind":"Name","value":"newSlot"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newSlot"}}},{"kind":"Argument","name":{"kind":"Name","value":"recurringWeeks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recurringWeeks"}}},{"kind":"Argument","name":{"kind":"Name","value":"allSpecialityTemplates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allSpecialityTemplates"}}},{"kind":"Argument","name":{"kind":"Name","value":"specialityTemplates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"specialityTemplates"}}},{"kind":"Argument","name":{"kind":"Name","value":"workgroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workgroup"}}},{"kind":"Argument","name":{"kind":"Name","value":"alternateWeeks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alternateWeeks"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"recurringId"}},{"kind":"Field","name":{"kind":"Name","value":"specialityTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpecialityTemplateBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allSpecialityTemplates"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableToMyPatient"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableToWorkgroupPatient"}},{"kind":"Field","name":{"kind":"Name","value":"workgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkgroupBasic"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpecialityTemplateBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialityTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"showOnSpecialitiesList"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkgroupBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workgroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phones"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<AddAvailabilityMutationResult, AddAvailabilityMutationVariables>;
export const CreateClinicGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createClinicGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clinicGroup"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddClinicGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createClinicGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clinicGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicGroup"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<CreateClinicGroupMutationResult, CreateClinicGroupMutationVariables>;
export const AddPatientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addPatient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phones"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhonesInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emails"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailAddress"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taxCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaxCode"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"regime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientRegime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"homeAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddressInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sex"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Sex"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RelationshipPatientList"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFamilyDoctor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"welcomeSmsSettings"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WelcomeSmsSettingsInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numIdentPers"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"foreignAndSeafarinOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ForeignAndSeafarinInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPatient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phones"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phones"}}},{"kind":"Argument","name":{"kind":"Name","value":"emails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emails"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"surname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surname"}}},{"kind":"Argument","name":{"kind":"Name","value":"taxCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taxCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"regime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"regime"}}},{"kind":"Argument","name":{"kind":"Name","value":"homeAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"homeAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"sex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sex"}}},{"kind":"Argument","name":{"kind":"Name","value":"listName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listName"}}},{"kind":"Argument","name":{"kind":"Name","value":"isFamilyDoctor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFamilyDoctor"}}},{"kind":"Argument","name":{"kind":"Name","value":"welcomeSmsSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"welcomeSmsSettings"}}},{"kind":"Argument","name":{"kind":"Name","value":"numIdentPers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numIdentPers"}}},{"kind":"Argument","name":{"kind":"Name","value":"foreignAndSeafarinOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"foreignAndSeafarinOptions"}}},{"kind":"Argument","name":{"kind":"Name","value":"doctorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"familyDoctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}}]}}]} as unknown as DocumentNode<AddPatientMutationResult, AddPatientMutationVariables>;
export const BookReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bookReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Timestamp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UnsignedInt"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReservationChannel"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"specialityTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingSurname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingTaxCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingCap"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingCity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingDistrict"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingCountry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnsignedInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chronicPatient"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientBirth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Timestamp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientSurname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientBirthCity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientBirthDistrict"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientSex"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Sex"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createRelationshipWithDoctor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientTaxCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coupon"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"viewers"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workgroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookReservationV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"patientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"doctorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}}},{"kind":"Argument","name":{"kind":"Name","value":"duration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duration"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"specialityTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"specialityTemplateId"}}},{"kind":"Argument","name":{"kind":"Name","value":"billingName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingName"}}},{"kind":"Argument","name":{"kind":"Name","value":"billingSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"billingTaxCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingTaxCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"billingAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"billingCap"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingCap"}}},{"kind":"Argument","name":{"kind":"Name","value":"billingCity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingCity"}}},{"kind":"Argument","name":{"kind":"Name","value":"billingDistrict"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingDistrict"}}},{"kind":"Argument","name":{"kind":"Name","value":"billingCountry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingCountry"}}},{"kind":"Argument","name":{"kind":"Name","value":"price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price"}}},{"kind":"Argument","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}},{"kind":"Argument","name":{"kind":"Name","value":"chronicPatient"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chronicPatient"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientBirth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientBirth"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientName"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientBirthCity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientBirthCity"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientBirthDistrict"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientBirthDistrict"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientSex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientSex"}}},{"kind":"Argument","name":{"kind":"Name","value":"createRelationshipWithDoctor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createRelationshipWithDoctor"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientTaxCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientTaxCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"coupon"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coupon"}}},{"kind":"Argument","name":{"kind":"Name","value":"viewers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"viewers"}}},{"kind":"Argument","name":{"kind":"Name","value":"workgroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workgroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReservationExtended"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"paymentGateway"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"familyDoctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservationExtended"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reservation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"doctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialityTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"actionToClose"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"patientSurname"}},{"kind":"Field","name":{"kind":"Name","value":"patientBirth"}},{"kind":"Field","name":{"kind":"Name","value":"patientBirthCity"}},{"kind":"Field","name":{"kind":"Name","value":"patientBirthDistrict"}},{"kind":"Field","name":{"kind":"Name","value":"patientSex"}},{"kind":"Field","name":{"kind":"Name","value":"patientTaxCode"}},{"kind":"Field","name":{"kind":"Name","value":"chronicPatient"}},{"kind":"Field","name":{"kind":"Name","value":"createRelationshipWithDoctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"viewers"}},{"kind":"Field","name":{"kind":"Name","value":"workgroupId"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]} as unknown as DocumentNode<BookReservationMutationResult, BookReservationMutationVariables>;
export const MyReservationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"myReservations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ComplexQueryInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReservationType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Timestamp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Timestamp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"specialityTemplateId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myReservationsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"doctorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"specialityTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"specialityTemplateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyReservationsQueryBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"familyDoctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservationWorkgroupBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Workgroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyReservationsQueryBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reservation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialityTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"actionToClose"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"patientSurname"}},{"kind":"Field","name":{"kind":"Name","value":"patientTaxCode"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewers"}},{"kind":"Field","name":{"kind":"Name","value":"workgroupId"}},{"kind":"Field","name":{"kind":"Name","value":"workgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReservationWorkgroupBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentBasic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]} as unknown as DocumentNode<MyReservationsQueryResult, MyReservationsQueryVariables>;
export const AcceptReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"acceptReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptReservation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reservationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}}]}}]}}]} as unknown as DocumentNode<AcceptReservationMutationResult, AcceptReservationMutationVariables>;
export const ClinicOwnedByMyselfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clinicOwnedByMyself"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clinicOwnedByMyself"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"ambulatories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"operators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"phones"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"openhours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doctorsToShowForSpecialities"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicStructuredAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StructuredAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signUpAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"familyDoctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicStructuredAddress"}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationalMedicineBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"regime"}},{"kind":"Field","name":{"kind":"Name","value":"hasApp"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aslCode"}}]}}]} as unknown as DocumentNode<ClinicOwnedByMyselfQueryResult, ClinicOwnedByMyselfQueryVariables>;
export const GetMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]} as unknown as DocumentNode<GetMeQueryResult, GetMeQueryVariables>;
export const CompleteReservationDeferredPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteReservationDeferredPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteReservationDeferredPaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeReservationDeferredPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CompleteReservationDeferredPaymentMutationResult, CompleteReservationDeferredPaymentMutationVariables>;
export const GetAmbulatoryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAmbulatoryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAmbulatoryById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"clinic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"availablePayments"}}]}},{"kind":"Field","name":{"kind":"Name","value":"domiciliaryCare"}},{"kind":"Field","name":{"kind":"Name","value":"doctorsToShowForSpecialities"}}]}}]}}]} as unknown as DocumentNode<GetAmbulatoryByIdQueryResult, GetAmbulatoryByIdQueryVariables>;
export const GetReservationBySecretDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReservationBySecret"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"secret"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReservationBySecret"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"secret"},"value":{"kind":"Variable","name":{"kind":"Name","value":"secret"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservationOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"reservationCode"}},{"kind":"Field","name":{"kind":"Name","value":"reservationSecret"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentGateway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workgroupId"}},{"kind":"Field","name":{"kind":"Name","value":"specialityTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"videoSessionId"}}]}}]}}]} as unknown as DocumentNode<GetReservationBySecretQueryResult, GetReservationBySecretQueryVariables>;
export const GetSpecialityTemplateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpecialityTemplateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSpecialityTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"standardPrice"}},{"kind":"Field","name":{"kind":"Name","value":"timeSlot"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}}]}}]}}]} as unknown as DocumentNode<GetSpecialityTemplateByIdQueryResult, GetSpecialityTemplateByIdQueryVariables>;
export const CreatePaymentIntentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"createPaymentIntent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"specialityTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stripeConnectedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reservationStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Timestamp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPaymentIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"specialityTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"specialityTemplateId"}}},{"kind":"Argument","name":{"kind":"Name","value":"stripeConnectedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stripeConnectedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"couponCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"userName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userName"}}},{"kind":"Argument","name":{"kind":"Name","value":"reservationStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reservationStart"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntent"}}]}}]}}]} as unknown as DocumentNode<CreatePaymentIntentQueryResult, CreatePaymentIntentQueryVariables>;